function RandomToken() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    var data = s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
    return data;
}
function ShortId() {
    function s4() { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1); }
    var data = s4() + s4();
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"; // We make sure the ID starts with a letter. That way we ca use them as valid IDs.
    possible = possible.charAt(Math.floor(Math.random() * possible.length));
    return possible + data;
}

function ConvertMessageToGPTLine$$1(message) {
    var type;
    if (message.from && message.from.type) {
        if (message.from.type === SenderOrRecipientType.BotUser) {
            type = 'User';
        }
        else if (message.from.type === SenderOrRecipientType.Bot) {
            type = 'Bot';
        }
        else if (message.from.type === SenderOrRecipientType.Agent) {
            type = 'Agent';
        }
    }
    if (!type) {
        return '';
    }
    if (message.type === MessageType.Text) {
        var payload = message.payload;
        return type + ': ' + payload.text + '\n';
    }
    else if (message.type === MessageType.Buttons) {
        var payload = message.payload;
        if (message.from && message.from.type && message.actionTaken) {
            var action = payload.actions.find(function (a) {
                return message && message.actionTaken ? a.id === message.actionTaken.target : false;
            });
            if (action) {
                return type + ': ' + action.text + '\n';
            }
        }
    }
    else if (message.type === MessageType.TakeoverEvent) {
        var payload = message.payload;
        if (payload.type === TakeoverEventType.TAKEOVER_STARTED) {
            return 'Bot: Chat has been transferred to back to agent ' + payload.name + ' bot\n';
        }
        else {
            return 'Bot: Chat has been transferred to back to the ' + payload.name + ' bot\n';
        }
    }
    else if (message.type === MessageType.ActionTaken) {
        var payload = message.payload;
        if (payload && payload.actionTaken && payload.actionTaken.data) {
            var data = payload.actionTaken.data;
            if (data[StoreVars.StoreName]) {
                return 'User: I select store ' + data[StoreVars.StoreName] + '\n';
            }
            if (data['name']) {
                return 'User: I select unit ' + data['name'] + '\n';
            }
        }
    }
    return '';
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

var ArrayHelper = /** @class */ (function () {
    function ArrayHelper() {
    }
    // Helper for string arrays in botUser.variables
    ArrayHelper.getSet = function (array, toLower) {
        if (toLower === void 0) { toLower = false; }
        var valuesString = array || '';
        if (toLower) {
            valuesString = valuesString.toLowerCase();
        }
        var set = new Set(valuesString
            .split(',')
            .map(function (v) {
            return v.trim();
        })
            .filter(function (v) { return v.length > 0; }));
        return set;
    };
    ArrayHelper.stringify = function (set) {
        var e_1, _a;
        var arrayString = '';
        var iterator = set.values();
        try {
            for (var iterator_1 = __values(iterator), iterator_1_1 = iterator_1.next(); !iterator_1_1.done; iterator_1_1 = iterator_1.next()) {
                var item = iterator_1_1.value;
                arrayString += item + ',';
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (iterator_1_1 && !iterator_1_1.done && (_a = iterator_1.return)) _a.call(iterator_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        arrayString = arrayString.slice(0, -1);
        return arrayString;
    };
    ArrayHelper.clear = function (_) {
        return '';
    };
    ArrayHelper.add = function (array, variables) {
        var arraySet = ArrayHelper.getSet(array);
        var valuesToAdd = variables.split(',').map(function (v) { return v.trim(); });
        valuesToAdd.forEach(function (v) { return arraySet.add(v); });
        return ArrayHelper.stringify(arraySet);
    };
    ArrayHelper.remove = function (array, variables) {
        var arraySet = ArrayHelper.getSet(array);
        var valuesToAdd = variables.split(',').map(function (v) { return v.trim(); });
        valuesToAdd.forEach(function (v) { return arraySet.delete(v); });
        return ArrayHelper.stringify(arraySet);
    };
    ArrayHelper.has = function (array, variables) {
        var arraySet = ArrayHelper.getSet(array, true);
        var valuesToAdd = variables
            .toLowerCase()
            .split(',')
            .map(function (v) { return v.trim(); })
            .filter(function (v) { return v.length > 0; });
        if (valuesToAdd.length === 0) {
            return false;
        }
        //Check to see that it is lower case on compare
        var has = true;
        valuesToAdd.forEach(function (v) {
            if (!arraySet.has(v)) {
                has = false;
            }
        });
        return has;
    };
    ArrayHelper.getCount = function (array) {
        var arraySet = ArrayHelper.getSet(array, false);
        return (arraySet === null || arraySet === void 0 ? void 0 : arraySet.size) || 0;
    };
    return ArrayHelper;
}());

var EmbedConfigForBot = function (bot) {
    var config = DefaultEmbedConfig({});
    config.botId = bot.id;
    config.headerText = 'Chat with <b>' + bot.get('name') + '</b>';
    config.dotText = 'Chat with <b>' + bot.get('name') + '</b>';
    return config;
};
function DefaultEmbedConfig(config) {
    var defaultConfig = {
        botId: '',
        language: 'en',
        startOnQuest: undefined,
        position: 'bottom-right',
        startConversationClosed: false,
        startOpen: false,
        loadPastMessages: false,
        avatarURL: 'https://swivl-uploads-production.s3.amazonaws.com/54f85f16d7d3583e4dc880367ff9fdae_avatar.png',
        showAvatarInHeader: false,
        showAvatarWithTimestamp: true,
        headerText: 'Chat with <b>My Bot</b>',
        dotText: 'Questions?',
        linkTarget: '_blank',
        primaryFont: "'Poppins', sans-serif;",
        secondaryFont: "'Poppins', sans-serif;",
        loadPastMessagesColor: '#DAD3D0',
        loadPastMessagesHoverColor: '#C3BCB9',
        loadPastMessagesActiveColor: '#A8A4A2',
        loadPastMessagesSpinnerFill: '#f67902',
        headerBackground: '#ffffff',
        headerColor: '#000000',
        bodyBackground: '#FFFFFF',
        userBubbleBackground: '#ECECEC',
        userBubbleColor: '#000000',
        botBubbleBackground: '#ECECEC',
        botBubbleColor: '#000000',
        timestampColor: '#949494',
        formBackground: '#FFFFFF',
        formColor: '#000000',
        linkColor: '#f67902',
        linkHoverColor: '#e92200',
        sendButtonBackground: '#f67902',
        sendButtonColor: '#FFFFFF',
        sendButtonHoverBackground: '#e92200',
        sendButtonHoverColor: '#FFFFFF',
        sendButtonActiveBackground: '#F67902',
        sendButtonActiveColor: '#FFFFFF',
        primaryButtonBackground: '#f67902',
        primaryButtonColor: '#FFFFFF',
        primaryButtonHoverBackground: '#e92200',
        primaryButtonHoverColor: '#FFFFFF',
        primaryButtonActiveBackground: '#F67902',
        primaryButtonActiveColor: '#FFFFFF',
        secondaryButtonBackground: '#f67902',
        secondaryButtonColor: '#FFFFFF',
        secondaryButtonHoverBackground: '#e92200',
        secondaryButtonHoverColor: '#FFFFFF',
        secondaryButtonActiveBackground: '#F67902',
        secondaryButtonActiveColor: '#FFFFFF',
        tertiaryButtonBackground: '#f67902',
        tertiaryButtonColor: '#FFFFFF',
        tertiaryButtonHoverBackground: '#e92200',
        tertiaryButtonHoverColor: '#FFFFFF',
        tertiaryButtonActiveBackground: '#F67902',
        tertiaryButtonActiveColor: '#FFFFFF',
        showAvatar: true,
        collapsedStyle: 'dot'
    };
    for (var key in defaultConfig) {
        if (defaultConfig.hasOwnProperty(key) && !config[key]) {
            config[key] = defaultConfig[key];
        }
    }
    return config;
}
function hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            a: 1
        }
        : null;
}
function elementCSS(prefix, baseName, background, color) {
    return (prefix +
        ' ' +
        baseName +
        ' { \n   background: ' +
        background +
        ';\n   color: ' +
        color +
        ';\n }\n\n');
}
function buttonCSS(prefix, baseName, background, color, hoverBackground, hoverColor, activeBackground, activeColor) {
    var css = '';
    var name = prefix + ' ' + baseName;
    css += name + ' { \n   background: ' + background + ';\n   color: ' + color + ';\n }\n';
    css +=
        name +
            ':hover, ' +
            name +
            '.hover  { \n   background: ' +
            hoverBackground +
            ';\n   color: ' +
            hoverColor +
            ';\n }\n';
    css +=
        name +
            ':active, ' +
            name +
            '.active { \n   background: ' +
            activeBackground +
            ';\n   color: ' +
            activeColor +
            ';\n }\n\n';
    return css;
}
function linkCSS(prefix, baseName, color, hoverColor, activeColor) {
    var css = '';
    css += prefix + ' ' + baseName + ' { \n   color: ' + color + ';\n }\n';
    css += prefix + ' ' + baseName + ':hover { \n   color: ' + hoverColor + ';\n }\n';
    css += prefix + ' ' + baseName + ':active { \n   color: ' + activeColor + ';\n }\n\n';
    return css;
}
function EmbedCSS(config, prefixVar) {
    var prefix = typeof prefixVar != 'undefined' ? prefixVar : '';
    var defaultConfig = DefaultEmbedConfig({});
    var css = '\n';
    if (config.primaryFont) {
        css += prefix + ' .swivl-mainFont { \n   font-family: ' + config.primaryFont + ';\n }\n\n';
    }
    else {
        css +=
            prefix + ' .swivl-mainFont { \n   font-family: ' + defaultConfig.primaryFont + ';\n }\n\n';
    }
    if (config.secondaryFont) {
        css +=
            prefix + ' .swivl-secondaryFont { \n   font-family: ' + config.secondaryFont + ';\n }\n\n';
    }
    else {
        css +=
            prefix +
                ' .swivl-secondaryFont { \n   font-family: ' +
                defaultConfig.secondaryFont +
                ';\n }\n\n';
    }
    if (config.headerBackground && config.headerColor) {
        css += elementCSS(prefix, '.swivl-header', config.headerBackground, config.headerColor);
    }
    else {
        css += elementCSS(prefix, '.swivl-header', defaultConfig.headerBackground, defaultConfig.headerColor);
    }
    if (config.loadPastMessagesColor &&
        config.loadPastMessagesHoverColor &&
        config.loadPastMessagesActiveColor) {
        css +=
            prefix +
                ' .swivl-loadPastMessages        { \n   color: ' +
                config.loadPastMessagesColor +
                ';\n  }\n';
        css +=
            prefix +
                ' .swivl-loadPastMessages:hover  { \n   color: ' +
                config.loadPastMessagesHoverColor +
                ';\n }\n';
        css +=
            prefix +
                ' .swivl-loadPastMessages:active { \n   color: ' +
                config.loadPastMessagesActiveColor +
                ';\n }\n\n';
    }
    else {
        css +=
            prefix +
                ' .swivl-loadPastMessages        { \n   color: ' +
                defaultConfig.loadPastMessagesColor +
                ';\n  }\n';
        css +=
            prefix +
                ' .swivl-loadPastMessages:hover  { \n   color: ' +
                defaultConfig.loadPastMessagesHoverColor +
                ';\n }\n';
        css +=
            prefix +
                ' .swivl-loadPastMessages:active { \n   color: ' +
                defaultConfig.loadPastMessagesActiveColor +
                ';\n }\n\n';
    }
    if (config.loadPastMessagesSpinnerFill) {
        css +=
            prefix +
                ' .swivl-loadingPastMessagesSpinner { \n   fill: ' +
                config.loadPastMessagesSpinnerFill +
                ';\n }\n\n';
        css +=
            prefix +
                ' .swivl-loadingPastMessages { \n   color: ' +
                config.loadPastMessagesSpinnerFill +
                ';\n }\n\n';
    }
    else {
        css +=
            prefix +
                ' .swivl-loadingPastMessagesSpinner { \n   fill: ' +
                defaultConfig.loadPastMessagesSpinnerFill +
                ';\n }\n\n';
        css +=
            prefix +
                ' .swivl-loadingPastMessages { \n   color: ' +
                defaultConfig.loadPastMessagesSpinnerFill +
                ';\n }\n\n';
    }
    // We need to set the gradients to the body color for Carousels.
    var bodyColor = config.bodyBackground ? config.bodyBackground : defaultConfig.bodyBackground;
    var bodyRGBA = hexToRgb(bodyColor);
    var opaqueBody = 'rgba(' + bodyRGBA.r + ', ' + bodyRGBA.g + ',' + bodyRGBA.b + ',1)';
    var transparentBody = 'rgba(' + bodyRGBA.r + ', ' + bodyRGBA.g + ',' + bodyRGBA.b + ',0)';
    css += prefix + ' .swivl-body { \n   background: ' + opaqueBody + ';\n }\n\n';
    css +=
        prefix +
            ' .swivl-gradientLeft { \n   background: ' +
            bodyColor +
            ';\n  background: linear-gradient(90deg, ' +
            opaqueBody +
            ' 0%, ' +
            transparentBody +
            ' 100%);\n }\n\n';
    css +=
        prefix +
            ' .swivl-gradientRight { \n   background: ' +
            bodyColor +
            ';\n  background: linear-gradient(90deg, ' +
            transparentBody +
            ' 0%, ' +
            opaqueBody +
            ' 100%);\n }\n\n';
    if (config.userBubbleBackground && config.userBubbleColor) {
        css += elementCSS(prefix, '.swivl-userBubble', config.userBubbleBackground, config.userBubbleColor);
    }
    else {
        css += elementCSS(prefix, '.swivl-userBubble', defaultConfig.userBubbleBackground, defaultConfig.userBubbleColor);
    }
    if (config.botBubbleBackground && config.botBubbleColor) {
        css += elementCSS(prefix, '.swivl-botBubble', config.botBubbleBackground, config.botBubbleColor);
    }
    else {
        css += elementCSS(prefix, '.swivl-botBubble', defaultConfig.botBubbleBackground, defaultConfig.botBubbleColor);
    }
    if (config.timestampColor) {
        css += prefix + ' .swivl-timestamp { \n   color: ' + config.timestampColor + ';\n }\n\n';
    }
    else {
        css += prefix + ' .swivl-timestamp { \n   color: ' + defaultConfig.timestampColor + ';\n }\n\n';
    }
    if (config.formBackground && config.formColor) {
        css += elementCSS(prefix, '.swivl-form', config.formBackground, config.formColor);
    }
    else {
        css += elementCSS(prefix, '.swivl-form', defaultConfig.formBackground, defaultConfig.formColor);
    }
    if (config.formBackground) {
        css +=
            prefix + ' .swivl-mainBackground { \n   background: ' + config.formBackground + ';\n }\n\n';
    }
    //SEND BUTTON
    if (config.sendButtonBackground &&
        config.sendButtonColor &&
        config.sendButtonHoverColor &&
        config.sendButtonHoverBackground &&
        config.sendButtonActiveColor &&
        config.sendButtonActiveBackground) {
        css += buttonCSS(prefix, '.swivl-sendButton', config.sendButtonBackground, config.sendButtonColor, config.sendButtonHoverBackground, config.sendButtonHoverColor, config.sendButtonActiveBackground, config.sendButtonActiveColor);
    }
    else {
        css += buttonCSS(prefix, '.swivl-sendButton', defaultConfig.sendButtonBackground, defaultConfig.sendButtonColor, defaultConfig.sendButtonHoverBackground, defaultConfig.sendButtonHoverColor, defaultConfig.sendButtonActiveBackground, defaultConfig.sendButtonActiveColor);
    }
    //MAIN BUTTON
    if (config.primaryButtonBackground &&
        config.primaryButtonColor &&
        config.primaryButtonHoverColor &&
        config.primaryButtonHoverBackground &&
        config.primaryButtonActiveColor &&
        config.primaryButtonActiveBackground) {
        css += buttonCSS(prefix, '.swivl-primaryButton', config.primaryButtonBackground, config.primaryButtonColor, config.primaryButtonHoverBackground, config.primaryButtonHoverColor, config.primaryButtonActiveBackground, config.primaryButtonActiveColor);
        css +=
            prefix +
                ' .swivl-svgButton svg        { \n   fill: ' +
                config.primaryButtonBackground +
                ';\n  }\n';
        css +=
            prefix +
                ' .swivl-svgButton:hover svg  { \n   fill: ' +
                config.primaryButtonHoverBackground +
                ';\n }\n';
        css +=
            prefix +
                ' .swivl-svgButton:active svg { \n   fill: ' +
                config.primaryButtonActiveBackground +
                ';\n }\n\n';
        css +=
            prefix +
                ' .swivl-svgButton.hover svg  { \n   fill: ' +
                config.primaryButtonHoverBackground +
                ';\n }\n';
        css +=
            prefix +
                ' .swivl-svgButton.active svg { \n   fill: ' +
                config.primaryButtonActiveBackground +
                ';\n }\n\n';
        css += prefix + " .swivl-fillPrimary          { fill: " + config.primaryButtonBackground + "       ;}\n";
        css += prefix + " .swivl-fillPrimary:hover    { fill: " + config.primaryButtonHoverBackground + "  ;}\n";
        css += prefix + " .swivl-fillPrimary:active   { fill: " + config.primaryButtonActiveBackground + " ;}\n";
        css += prefix + " .swivl-fillPrimary.hover    { fill: " + config.primaryButtonHoverBackground + "  ;}\n";
        css += prefix + " .swivl-fillPrimary.active   { fill: " + config.primaryButtonActiveBackground + " ;}\n";
        css += prefix + " .swivl-fillPrimary.disabled { fill: " + config.primaryButtonActiveBackground + " ;}\n";
        css += prefix + " .swivl-primaryBorderHover:hover    { border-color: " + config.primaryButtonBackground + "  ;}\n";
        css += prefix + " .swivl-primaryBorderHover:active   { border-color: " + config.primaryButtonBackground + " ;}\n";
        css += prefix + " .swivl-primaryBackgroundHover:hover    { background-color: " + config.primaryButtonHoverBackground + "  ;}\n";
        css += prefix + " .swivl-primaryBackgroundHover:active   { background-color: " + config.primaryButtonActiveBackground + " ;}\n";
        css += prefix + " .swivl-primaryTextHover:hover    { color: " + config.primaryButtonHoverColor + "  ;}\n";
        css += prefix + " .swivl-primaryTextHover:active   { color: " + config.primaryButtonActiveColor + " ;}\n";
        css += prefix + " .swivl-disabled   { filter: saturate(20%) opacity(35%) }\n";
    }
    else {
        css += linkCSS(prefix, '.swivl-linkContainer a', defaultConfig.primaryButtonBackground, defaultConfig.primaryButtonHoverBackground, defaultConfig.primaryButtonActiveBackground);
        css += buttonCSS(prefix, '.swivl-linkColorBackground', defaultConfig.linkColor, '#FFF', defaultConfig.linkHoverColor, '#FFF', defaultConfig.linkHoverColor, '#FFF');
        css += buttonCSS(prefix, '.swivl-primaryButton', defaultConfig.primaryButtonBackground, defaultConfig.primaryButtonColor, defaultConfig.primaryButtonHoverBackground, defaultConfig.primaryButtonHoverColor, defaultConfig.primaryButtonActiveBackground, defaultConfig.primaryButtonActiveColor);
        css +=
            prefix +
                ' .swivl-svgButton svg        { \n   fill: ' +
                defaultConfig.primaryButtonBackground +
                ';\n  }\n';
        css +=
            prefix +
                ' .swivl-svgButton:hover svg  { \n   fill: ' +
                defaultConfig.primaryButtonHoverBackground +
                ';\n }\n';
        css +=
            prefix +
                ' .swivl-svgButton:active svg { \n   fill: ' +
                defaultConfig.primaryButtonActiveBackground +
                ';\n }\n\n';
    }
    //SECONDARY BUTTON
    if (config.secondaryButtonBackground &&
        config.secondaryButtonColor &&
        config.secondaryButtonHoverColor &&
        config.secondaryButtonHoverBackground &&
        config.secondaryButtonActiveColor &&
        config.secondaryButtonActiveBackground) {
        css += buttonCSS(prefix, '.swivl-secondaryButton', config.secondaryButtonBackground, config.secondaryButtonColor, config.secondaryButtonHoverBackground, config.secondaryButtonHoverColor, config.secondaryButtonActiveBackground, config.secondaryButtonActiveColor);
    }
    else {
        css += buttonCSS(prefix, '.swivl-secondaryButton', defaultConfig.secondaryButtonBackground, defaultConfig.secondaryButtonColor, defaultConfig.secondaryButtonHoverBackground, defaultConfig.secondaryButtonHoverColor, defaultConfig.secondaryButtonActiveBackground, defaultConfig.secondaryButtonActiveColor);
    }
    //TERTIARY BUTTON
    if (config.tertiaryButtonBackground &&
        config.tertiaryButtonColor &&
        config.tertiaryButtonHoverColor &&
        config.tertiaryButtonHoverBackground &&
        config.tertiaryButtonActiveColor &&
        config.tertiaryButtonActiveBackground) {
        css += buttonCSS(prefix, '.swivl-tertiaryButton', config.tertiaryButtonBackground, config.tertiaryButtonColor, config.tertiaryButtonHoverBackground, config.tertiaryButtonHoverColor, config.tertiaryButtonActiveBackground, config.tertiaryButtonActiveColor);
    }
    else {
        css += buttonCSS(prefix, '.swivl-tertiaryButton', defaultConfig.tertiaryButtonBackground, defaultConfig.tertiaryButtonColor, defaultConfig.tertiaryButtonHoverBackground, defaultConfig.tertiaryButtonHoverColor, defaultConfig.tertiaryButtonActiveBackground, defaultConfig.tertiaryButtonActiveColor);
    }
    if (config.linkColor && config.linkHoverColor) {
        css += linkCSS(prefix, '.swivl-linkContainer a', config.linkColor, config.linkHoverColor, config.linkHoverColor);
        css += buttonCSS(prefix, '.swivl-linkColorBackground', config.linkColor, '#FFF', config.linkHoverColor, '#FFF', config.linkHoverColor, '#FFF');
    }
    else {
        css += linkCSS(prefix, '.swivl-linkContainer a', defaultConfig.linkColor, defaultConfig.linkHoverColor, defaultConfig.linkHoverColor);
        css += buttonCSS(prefix, '.swivl-linkColorBackground', defaultConfig.linkColor, '#FFF', defaultConfig.linkHoverColor, '#FFF', defaultConfig.linkHoverColor, '#FFF');
    }
    return css;
}

function isAuth(auth) {
    return (auth !== undefined &&
        auth.botUserId !== undefined &&
        auth.type !== undefined &&
        auth.botId !== undefined &&
        auth.token !== undefined);
}

function createBaseMessage(type, payload, to, from) {
    var message = {
        id: ShortId(),
        type: type,
        created: new Date().getTime(),
        payload: payload
    };
    if (to) {
        message.to = to;
    }
    if (from) {
        message.from = from;
    }
    return message;
}
function createAuthMessage(to, from, botId, botUserId, type, token) {
    return createBaseMessage(MessageType.Auth, { botId: botId, botUserId: botUserId, type: type, token: token }, to, from);
}
function createActionTaken(type, target, data) {
    return { type: type, target: target, data: data };
}
function createActionTakenMessage(to, from, messageId, actionTaken) {
    return createBaseMessage(MessageType.ActionTaken, { messageId: messageId, actionTaken: actionTaken }, to, from);
}
function createButtonsMessage(to, from, actions, botId) {
    return createBaseMessage(MessageType.Buttons, { actions: actions }, to, from);
}
function createCreateUserAndStartConversationMessage(botId, startOnQuest, preloadVariables) {
    var payload = { botId: botId };
    if (startOnQuest) {
        payload.startOnQuest = startOnQuest;
    }
    if (preloadVariables) {
        payload.preloadVariables = preloadVariables;
    }
    return createBaseMessage(MessageType.CreateUserAndStartConversation, payload);
}
function createStartConversationMessage(to, from, botId, startOnQuest, preloadVariables) {
    var payload = { botId: botId };
    if (startOnQuest) {
        payload.startOnQuest = startOnQuest;
    }
    if (preloadVariables) {
        payload.preloadVariables = preloadVariables;
    }
    return createBaseMessage(MessageType.StartConversation, payload, to, from);
}
function createTakeoverEventMessage(to, from, type, name, avatarURL) {
    return createBaseMessage(MessageType.TakeoverEvent, { type: type, name: name, avatarURL: avatarURL }, to, from);
}
function createTextMessage(to, from, text, openLinksInNewTab) {
    return createBaseMessage(MessageType.Text, { text: text, openLinksInNewTab: openLinksInNewTab }, to, from);
}
function createTypingMessage(to, from, action) {
    return createBaseMessage(MessageType.Typing, { action: action }, to, from);
}

function isCarouselPayloadCard(payload) {
    if (payload === undefined ||
        payload.id === undefined ||
        payload.actions === undefined) {
        return false;
    }
    var actions = payload.actions;
    for (var i = 0; i < actions.length; i++) {
        if (!isActionInterface(actions[i])) {
            return false;
        }
    }
    return true;
}
function isCarouselPayload(payload) {
    if (payload === undefined || payload.cards === undefined) {
        return false;
    }
    var cards = payload.cards;
    for (var i = 0; i < cards.length; i++) {
        if (!isCarouselPayloadCard(cards[i])) {
            return false;
        }
    }
    return true;
}
function createCarouselPayloadCard(id, actions, mediaURL, title, description) {
    return {
        id: id,
        mediaURL: mediaURL,
        title: title,
        description: description,
        actions: actions
    };
}
function createCarouselMessage(to, from, cards) {
    return createBaseMessage(MessageType.Carousel, { cards: cards }, to, from);
}

var MediaPayloadMediaType;
(function (MediaPayloadMediaType) {
    MediaPayloadMediaType["Image"] = "image";
    MediaPayloadMediaType["Video"] = "video";
})(MediaPayloadMediaType || (MediaPayloadMediaType = {}));
function isMediaPayload(payload) {
    return (payload !== undefined &&
        payload.mediaURL !== undefined &&
        payload.mediaType !== undefined &&
        (payload.mediaType === MediaPayloadMediaType.Image ||
            payload.mediaType === MediaPayloadMediaType.Video));
}
function createMediaMessage(to, from, mediaType, mediaURL) {
    return createBaseMessage(MessageType.Media, { mediaType: mediaType, mediaURL: mediaURL }, to, from);
}

function isMultiSelectPayload(payload) {
    return payload !== undefined && payload.actions !== undefined;
}
function createMultiSelectMessage(to, from, actions) {
    return createBaseMessage(MessageType.MultiSelect, { actions: actions }, to, from);
}

var CommandPayloadCommandType;
(function (CommandPayloadCommandType) {
    CommandPayloadCommandType["NavigateTo"] = "navigateTo";
    CommandPayloadCommandType["LoadPastMessages"] = "loadPastMessages";
    CommandPayloadCommandType["ClearMessages"] = "clearMessages";
    CommandPayloadCommandType["Analytics"] = "analytics";
    CommandPayloadCommandType["Custom"] = "custom";
    CommandPayloadCommandType["ScrollElement"] = "scrollElement";
    CommandPayloadCommandType["ReplaceText"] = "replaceText";
    CommandPayloadCommandType["ReplaceImage"] = "replaceImage";
    CommandPayloadCommandType["OpenOrClose"] = "openOrClose";
})(CommandPayloadCommandType || (CommandPayloadCommandType = {}));
function isCommandPayload(payload) {
    return (payload !== undefined &&
        payload.type !== undefined &&
        Object.values(CommandPayloadCommandType).includes(payload.type));
}
function createCommandMessage(to, from, type, payload) {
    return createBaseMessage(MessageType.Command, { type: type, payload: payload }, to, from);
}

var MilesToMeters = {
    Miles_1: 1609.34,
    Miles_5: 8046.72,
    Miles_10: 16093.4,
    Miles_15: 24140.2,
    Miles_25: 40233.6,
    Miles_50: 80467.2,
    Miles_100: 160934
};
function isLocationPickerPayload(payload) {
    return payload !== undefined && payload.locations !== undefined;
}
function createLocationPickerMessage(to, from, locations, currentZip, searchRadiusInMeters, canChangeZip) {
    var payload = {
        locations: locations,
        locationSelected: false,
        searchedZipCodes: []
    };
    if (currentZip) {
        payload.currentZip = currentZip;
        payload.searchedZipCodes.push(currentZip);
    }
    if (canChangeZip) {
        payload.canChangeZip = canChangeZip;
    }
    if (searchRadiusInMeters) {
        payload.searchRadiusInMeters = searchRadiusInMeters;
    }
    return createBaseMessage(MessageType.LocationPicker, payload, to, from);
}

function isSpacePickerPayload(payload) {
    return payload !== undefined && payload.spaces !== undefined;
}
function createSpacePickerMessage(to, from, spaces, params, location) {
    var payload = {
        spaces: spaces,
        params: params,
        location: location,
        selectedSpace: undefined
    };
    return createBaseMessage(MessageType.SpacePicker, payload, to, from);
}

var ProfileCollectStatus;
(function (ProfileCollectStatus) {
    ProfileCollectStatus["PENDING"] = "PENDING";
    ProfileCollectStatus["SAVED"] = "SAVED";
    ProfileCollectStatus["CANCELED"] = "CANCELED";
})(ProfileCollectStatus || (ProfileCollectStatus = {}));
function isProfileCollectPayload(payload) {
    return payload !== undefined && payload.items !== undefined;
}
function createProfileCollectMessage(to, from, items, actionButtonText, status, countryCodes) {
    return createBaseMessage(MessageType.ProfileCollect, {
        items: items,
        actionButtonText: actionButtonText,
        status: status,
        countryCodes: countryCodes
    }, to, from);
}

function isAuthPayload(payload) {
    return isAuth(payload);
}
/**
Actions are possibile actions. ActionTaken are the response to an action.
 */
var ActionType;
(function (ActionType) {
    ActionType["URL"] = "url";
    ActionType["URLinNewTab"] = "url_in_new_tab";
    ActionType["Plain"] = "plain";
})(ActionType || (ActionType = {}));
function isActionType(type) {
    return Object.values(ActionType).includes(type);
}
function isActionInterface(obj) {
    if (!(obj !== undefined)) {
        return false;
    }
    if (obj.type === undefined) {
        return false;
    }
    if ((obj.type === ActionType.URL ||
        obj.type === ActionType.URLinNewTab) &&
        !(obj.url !== undefined)) {
        return false;
    }
    return (obj !== undefined &&
        obj.id !== undefined &&
        obj.type !== undefined &&
        obj.text !== undefined &&
        isActionType(obj.type));
}
function isActionTakenPayload(payload) {
    return (payload !== undefined &&
        payload.messageId !== undefined &&
        payload.actionTaken !== undefined &&
        isActionTaken(payload.actionTaken));
}
function isButtonsPayload(payload) {
    return payload !== undefined && payload.actions !== undefined;
}
function isCreateUserAndStartConversationPayload(payload) {
    return (payload !== undefined &&
        payload.botId !== undefined);
}
function isStartConversationPayload(payload) {
    return payload !== undefined && payload.botId !== undefined;
}
var TakeoverEventType;
(function (TakeoverEventType) {
    TakeoverEventType["TAKEOVER_STARTED"] = "Started";
    TakeoverEventType["TAKEOVER_ENDED"] = "Ended";
})(TakeoverEventType || (TakeoverEventType = {}));
function isTakeoverEventPayload(payload) {
    return (payload !== undefined &&
        payload.type !== undefined &&
        (payload.type === TakeoverEventType.TAKEOVER_STARTED ||
            payload.type === TakeoverEventType.TAKEOVER_ENDED) &&
        payload.name !== undefined &&
        payload.avatarURL !== undefined);
}
function isTextPayload(payload) {
    return payload !== undefined && payload.text !== undefined;
}
var TypingPayloadActionType;
(function (TypingPayloadActionType) {
    TypingPayloadActionType["Started"] = "Started";
    TypingPayloadActionType["Ended"] = "Ended";
})(TypingPayloadActionType || (TypingPayloadActionType = {}));
function isTypingPayload(payload) {
    return (payload !== undefined &&
        payload.action !== undefined &&
        (payload.action == TypingPayloadActionType.Started ||
            payload.action == TypingPayloadActionType.Ended));
}
function isValidMessagePayload(type, payload) {
    switch (type) {
        case MessageType.ActionTaken: {
            return isActionTakenPayload(payload);
            break;
        }
        case MessageType.Auth: {
            return isAuthPayload(payload);
            break;
        }
        case MessageType.Buttons: {
            return isButtonsPayload(payload);
            break;
        }
        case MessageType.CreateUserAndStartConversation: {
            return isCreateUserAndStartConversationPayload(payload);
            break;
        }
        case MessageType.StartConversation: {
            return isStartConversationPayload(payload);
            break;
        }
        case MessageType.Text: {
            return isTextPayload(payload);
            break;
        }
        case MessageType.Typing: {
            return isTypingPayload(payload);
            break;
        }
        case MessageType.TakeoverEvent: {
            return isTakeoverEventPayload(payload);
            break;
        }
        case MessageType.Carousel: {
            return isCarouselPayload(payload);
            break;
        }
        case MessageType.Command: {
            return isCommandPayload(payload);
            break;
        }
        case MessageType.Media: {
            return isMediaPayload(payload);
            break;
        }
        case MessageType.MultiSelect: {
            return isMultiSelectPayload(payload);
            break;
        }
        case MessageType.LocationPicker: {
            return isLocationPickerPayload(payload);
            break;
        }
        case MessageType.SpacePicker: {
            return isSpacePickerPayload(payload);
            break;
        }
        case MessageType.ProfileCollect: {
            return isProfileCollectPayload(payload);
            break;
        }
        default: {
            console.warn('No Validation For Message Payload  Type', type);
            return false;
            break;
        }
    }
}

var MessageType;
(function (MessageType) {
    MessageType["Auth"] = "Auth";
    MessageType["Buttons"] = "Buttons";
    MessageType["CreateUserAndStartConversation"] = "CreateUserAndStartConversation";
    MessageType["StartConversation"] = "StartConversation";
    MessageType["Text"] = "Text";
    MessageType["ActionTaken"] = "ActionTaken";
    MessageType["Typing"] = "Typing";
    MessageType["TakeoverEvent"] = "TakeoverEvent";
    MessageType["Carousel"] = "Carousel";
    MessageType["MultiSelect"] = "MultiSelect";
    MessageType["ProfileCollect"] = "ProfileCollect";
    MessageType["Media"] = "Media";
    MessageType["Command"] = "Command";
    MessageType["LocationPicker"] = "LocationPicker";
    MessageType["SpacePicker"] = "Space Picker";
    MessageType["Voice"] = "Voice";
})(MessageType || (MessageType = {}));
var invisibleMessageTypes = [
    MessageType.Auth,
    MessageType.CreateUserAndStartConversation,
    MessageType.StartConversation,
    MessageType.ActionTaken,
    MessageType.Typing,
    MessageType.Command
];
function isMessageInvisibile(message) {
    return invisibleMessageTypes.includes(message.type);
}
function isMessageType(type) {
    return Object.values(MessageType).includes(type);
}
var SenderOrRecipientType;
(function (SenderOrRecipientType) {
    SenderOrRecipientType["Bot"] = "bot";
    SenderOrRecipientType["BotUser"] = "botUser";
    SenderOrRecipientType["Agent"] = "agent";
})(SenderOrRecipientType || (SenderOrRecipientType = {}));
function isSenderOrRecipientType(type) {
    return Object.values(SenderOrRecipientType).includes(type);
}
function isSenderOrRecipient(sOrR) {
    return (sOrR !== undefined &&
        sOrR.id !== undefined &&
        sOrR.type !== undefined &&
        isSenderOrRecipientType(sOrR.type));
}
// We might want to subclass the message interface for all the different types of messages. That would let us
// have a constant type safe then we wouldn't have to create 500000 || statments and also maybe than I can just
// Have one simple interface and not even make it a class. Or do I want different classes? I'm not sure...
var ActionTakenType;
(function (ActionTakenType) {
    ActionTakenType["Selected"] = "selected";
    ActionTakenType["OptionsSelected"] = "options_selected";
    ActionTakenType["URLSelected"] = "url_selected";
    ActionTakenType["Other"] = "other";
})(ActionTakenType || (ActionTakenType = {}));
function isActionTakenType(type) {
    return Object.values(ActionTakenType).includes(type);
}
function isActionTaken(actionTaken) {
    return (actionTaken !== undefined &&
        actionTaken.type !== undefined &&
        isActionTakenType(actionTaken.type));
}
// export function isValidPayload(message:any) {
//   let isValid
//   switch (message.type) {
//     case MessageType.ActionTaken: {
//       isValid = isActionTakenPayload(message.payload)
//       break
//     }
//     case MessageType.Auth: {
//       isValid = isAuthPayload(message.payload)
//       break
//     }
//     case MessageType.Buttons: {
//       isValid = isButtonsPayload(message.payload)
//       break
//     }
//     case MessageType.CreateUserAndStartConversation: {
//       isValid = isCreateUserAndStartConversationPayload(message.payload)
//       break
//     }
//     case MessageType.StartConversation: {
//       isValid = isStartConversationPayload(message.payload)
//       break
//     }
//     case MessageType.Text: {
//       isValid = isTextPayload(message.payload)
//       break
//     }
//     case MessageType.Typing: {
//       isValid = isTypingPayload(message.payload)
//       break
//     }
//     case MessageType.TakeoverEvent: {
//       isValid = isTakeoverEventPayload(message.payload)
//       break
//     }
//     case MessageType.Carousel: {
//       isValid = isCarouselPayload(message.payload)
//       break
//     }
//     case MessageType.Command: {
//       isValid = isCommandPayload(message.payload)
//       break
//     }
//     case MessageType.Media: {
//       isValid = isMediaPayload(message.payload)
//       break
//     }
//     case MessageType.MultiSelect: {
//       isValid = isMultiSelectPayload(message.payload)
//       break
//     }
//     case MessageType.LocationPicker: {
//       isValid = isLocationPickerPayload(message.payload)
//       break
//     }
//     case MessageType.SpacePicker: {
//       isValid = isSpacePickerPayload(message.payload)
//       break
//     }
//   }
//     return isValid;
// }
function isMessage(message) {
    if (message == undefined) {
        return false;
    }
    if (!message.type || !message.payload) {
        console.warn('No Validation For Message Payload', message);
        return false;
    }
    if (message.type == MessageType.CreateUserAndStartConversation) {
        return (message.id !== undefined &&
            message.type !== undefined &&
            message.payload !== undefined &&
            isCreateUserAndStartConversationPayload(message.payload));
    }
    var isValid = isValidMessagePayload(message.type, message.payload);
    // switch (message.type) {
    //   case MessageType.ActionTaken: {
    //     isValid = isActionTakenPayload(message.payload)
    //     break
    //   }
    //   case MessageType.Auth: {
    //     isValid = isAuthPayload(message.payload)
    //     break
    //   }
    //   case MessageType.Buttons: {
    //     isValid = isButtonsPayload(message.payload)
    //     break
    //   }
    //   case MessageType.CreateUserAndStartConversation: {
    //     isValid = isCreateUserAndStartConversationPayload(message.payload)
    //     break
    //   }
    //   case MessageType.StartConversation: {
    //     isValid = isStartConversationPayload(message.payload)
    //     break
    //   }
    //   case MessageType.Text: {
    //     isValid = isTextPayload(message.payload)
    //     break
    //   }
    //   case MessageType.Typing: {
    //     isValid = isTypingPayload(message.payload)
    //     break
    //   }
    //   case MessageType.TakeoverEvent: {
    //     isValid = isTakeoverEventPayload(message.payload)
    //     break
    //   }
    //   case MessageType.Carousel: {
    //     isValid = isCarouselPayload(message.payload)
    //     break
    //   }
    //   case MessageType.Command: {
    //     isValid = isCommandPayload(message.payload)
    //     break
    //   }
    //   case MessageType.Media: {
    //     isValid = isMediaPayload(message.payload)
    //     break
    //   }
    //   case MessageType.MultiSelect: {
    //     isValid = isMultiSelectPayload(message.payload)
    //     break
    //   }
    //   case MessageType.LocationPicker: {
    //     isValid = isLocationPickerPayload(message.payload)
    //     break
    //   }
    //   case MessageType.SpacePicker: {
    //     isValid = isSpacePickerPayload(message.payload)
    //     break
    //   }
    //   default: {
    //     console.warn('No Validation For Message Payload  Type', message.type)
    //     return false
    //     break
    //   }
    // }
    if (!isValid) {
        console.warn('Invalide message', message.type);
        return false;
    }
    return (message.id !== undefined &&
        message.to !== undefined &&
        isSenderOrRecipient(message.to) &&
        message.from !== undefined &&
        isSenderOrRecipient(message.from) &&
        message.type !== undefined &&
        isMessageType(message.type));
}

function isFrame(frame) {
    if (frame !== undefined &&
        frame.message !== undefined &&
        frame.message.payload !== undefined &&
        frame.message.type !== undefined &&
        frame.message.type === MessageType.CreateUserAndStartConversation) {
        return frame.message.payload.botId !== undefined;
    }
    return (frame !== undefined &&
        frame.auth !== undefined &&
        isAuth(frame.auth) &&
        frame.message !== undefined &&
        isMessage(frame.message));
}

function createVoiceMessage(to, from, payload) {
    return createBaseMessage(MessageType.Voice, payload, to, from);
}

var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(name, statusCode, message) {
        var _this = _super.call(this, message) || this;
        _this.isAPIError = true;
        _this.name = name;
        _this.statusCode = statusCode;
        _this.status = statusCode;
        if (typeof message === 'string') {
            _this.message = message;
        }
        return _this;
    }
    return ApiError;
}(Error));
function CreateSuccessMessage(message) {
    if (message) {
        return { status: 'success', message: message };
    }
    return { status: 'success' };
}

var PromptType;
(function (PromptType) {
    PromptType["AUTO_COMPLETE"] = "auto_complete";
    PromptType["SUMMARY"] = "summary";
    PromptType["REVIEW_REPLY"] = "review_reply";
    PromptType["NORMAL"] = "normal";
})(PromptType || (PromptType = {}));
var PromptStackItemType;
(function (PromptStackItemType) {
    PromptStackItemType["PROMPT"] = "prompt";
    PromptStackItemType["TEXT"] = "text";
    PromptStackItemType["PREVIOUS_MESSAGES"] = "previous_messages";
})(PromptStackItemType || (PromptStackItemType = {}));

var ConversationQueryType;
(function (ConversationQueryType) {
    ConversationQueryType["RECENT"] = "recent";
    ConversationQueryType["NOT_ARCHIVED"] = "not-archived";
    ConversationQueryType["ARCHIVED"] = "archived";
})(ConversationQueryType || (ConversationQueryType = {}));

var SpaceVars;
(function (SpaceVars) {
    SpaceVars["SpaceId"] = "SpaceId";
    SpaceVars["SpaceName"] = "SpaceName";
    SpaceVars["SpaceDimensions"] = "SpaceDimensions";
    SpaceVars["SpaceRate"] = "SpaceRate";
    SpaceVars["SpaceHasClimateControl"] = "SpaceHasClimateControl";
    SpaceVars["SpaceIsInside"] = "SpaceIsInside";
    SpaceVars["SpaceHasPower"] = "SpaceHasPower";
    SpaceVars["SpaceFloor"] = "SpaceFloor";
    SpaceVars["SpaceIsParking"] = "SpaceIsParking";
    SpaceVars["SpaceIsDriveUp"] = "SpaceIsDriveUp";
    SpaceVars["SpaceHasElevatorAccess"] = "SpaceHasElevatorAccess";
    SpaceVars["SpaceHasAlarm"] = "SpaceHasAlarm";
    SpaceVars["SpaceFeatures"] = "SpaceFeatures";
})(SpaceVars || (SpaceVars = {}));

var _a, _b;
var UserVars;
(function (UserVars) {
    UserVars["User_Id"] = "userId";
    UserVars["User_Name"] = "Entity personName";
    UserVars["User_Email"] = "Entity email";
    UserVars["User_Phone"] = "Entity phonenumber";
    UserVars["User_AddressLine1"] = "UserAddressLine1";
    UserVars["User_AddressLine2"] = "UserAddressLine2";
    UserVars["User_City"] = "UserCity";
    UserVars["User_State"] = "UserState";
    UserVars["User_Zip"] = "UserZip";
    UserVars["User_CountryCode"] = "UserCountryCode";
    UserVars["User_EntityCity"] = "User_EntityCity";
    UserVars["User_EntityState"] = "User_EntityState";
    UserVars["User_EntityDate"] = "User_EntityDate";
    UserVars["User_EntityTime"] = "User_EntityTime";
    UserVars["User_EntityNumber"] = "User_EntityNumber";
    UserVars["User_LastIntent"] = "UserLastIntent";
    UserVars["User_AccountStatus"] = "UserAccountStatus";
    UserVars["User_AccountPaymentStatus"] = "UserAccountPaymentStatus";
    UserVars["User_HasCompletedProfile"] = "UserHasCompletedProfile";
    UserVars["User_HasConfirmedProfile"] = "UserHasConfirmedProfile";
    UserVars["User_HasShortProfile"] = "User_HasShortProfile";
    UserVars["User_AnsweringMachine"] = "UserAnsweringMachine";
    UserVars["User_Persona"] = "UserPersona";
    UserVars["User_HasUnhandled"] = "UserHasUnhandled";
    UserVars["User_AccountType"] = "UserAccountType";
    UserVars["User_WantsToStoreVehicle"] = "UserWantsToStoreVehicle";
    UserVars["User_WantToShopByPrice"] = "UserWantToShopByPrice";
    UserVars["User_FilterFeatures"] = "UserFilterFeatures";
    UserVars["User_FilterSize"] = "UserFilterSize";
    UserVars["User_FMSLeadStatus"] = "UserLeadStatus";
    UserVars["User_EmailType"] = "UserEmailType";
    UserVars["User_EmailReceiptType"] = "UserEmailReceiptType";
    UserVars["User_TenantId"] = "UserTenantId";
    UserVars["User_CRMId"] = "UserCRMId";
    UserVars["User_CRMStatus"] = "UserCRMStatus";
    UserVars["User_LastAgentName"] = "UserLastAgentName";
    //User_Lead_hasSentEmailReceipt is a 1 if it email receipt has already been sent to improve duplicate leads
    UserVars["User_Lead_hasSentEmailReceipt"] = "UserLeadhasSentEmailReceipt";
    //User_Lead_hasSentToFMS is a 1 if it has been sent to FMS to improve duplicate leads
    UserVars["User_Lead_hasSentToFMS"] = "UserLeadhasSentToFMS";
    //User Review Variables
    UserVars["User_Review_NPSScore"] = "UserReviewNPSScore";
    UserVars["User_Review_NPSFeedback"] = "UserReviewNPSFeedback";
    UserVars["User_Review_NPSTopic"] = "UserReviewNPSTopic";
    UserVars["User_UnitNumber"] = "UserUnitNumber";
    UserVars["User_UnitSize"] = "UserUnitSize";
    UserVars["User_UnitFeatures"] = "UserUnitFeatures";
    //FMS Variables
    UserVars["User_AccessCode"] = "UserAccessCode";
    UserVars["User_PaymentDueDate"] = "UserPaymentDueDate";
    UserVars["User_AutoPayEnabled"] = "UserAutoPayEnabled";
    UserVars["User_DaysPastDue"] = "UserDaysPastDue";
    UserVars["User_AccountBalance"] = "User_AccountBalance";
    //1.5 Variables
    UserVars["User_TemporaryFMSID"] = "UserTemporaryFMSID";
    UserVars["User_Review_NPSPersona"] = "UserReviewFeedbackPersona";
    UserVars["User_hasSeen_FeatureMenu"] = "UserhasSeenFeatureMenu";
    UserVars["User_hasSeen_InventoryMenu"] = "UserhasSeenInventoryMenu";
    UserVars["User_hasSeen_AnythingElseMenu"] = "UserhasSeenAnythingElseMenu";
    UserVars["User_hasSeen_CostMenu"] = "UserhasSeenCostMenu";
    UserVars["User_hasSeen_ContactMenu"] = "UserhasSeenContactMenu";
    UserVars["User_hasSeen_SizeMenu"] = "UserhasSeenSizeMenu";
    UserVars["User_hasSeen_ProblemMenu"] = "UserhasSeenProblemMenu";
    UserVars["User_hasSeen_AccountMenu"] = "UserhasSeenAccountMenu";
    UserVars["User_hasSeen_ChangeAccountMenu"] = "UserhasSeenChangeAccountMenu";
    UserVars["User_hasSeen_AccountLoginMenu"] = "UserhasSeenAccountLoginMenu";
    UserVars["User_hasSeen_PurchaseProcessMenu"] = "UserhasSeenPurchaseProcessMenu";
    UserVars["User_hasSeen_LeaseTermsMenu"] = "UserhasSeenLeaseTermsMenu";
    UserVars["User_hasSeen_MoveMenu"] = "UserhasSeenMoveMenu";
    UserVars["User_Notes"] = "UserNotes";
    //1.6 Variables
    UserVars["User_hasSeen_GSPotentialMenu"] = "UserhasSeenGSPotentialMenu";
    UserVars["User_hasSeen_GSExistingMenu"] = "UserhasSeenGSExistingMenu";
    UserVars["User_FMS_Error"] = "UserFMSError";
    //1.7 Variables
    UserVars["User_hasSeen_SMSDisclaimer"] = "UserhasSeenSMSDisclaimer";
    UserVars["User_CronReceiptType"] = "UserCronReceiptType";
    UserVars["User_AfterNavigate_Holder"] = "UserAfterNavigateHolder";
    UserVars["User_ProfileCollect_Holder"] = "UserProfileCollectHolder";
    UserVars["User_PreviousChannel_Holder"] = "UserPreviousChannelHolder";
    UserVars["User_WantToSearchAnotherStore"] = "User_WantToSearchAnotherStore";
    UserVars["User_hasProvidedFeedback"] = "User_hasProvidedFeedback";
    UserVars["User_isUpdatingProfile"] = "User_isUpdatingProfile";
    UserVars["User_selectedStoreFromSMS"] = "User_selectedStoreFromSMS";
    //2.1 Variables
    UserVars["UserinAbandonedCartWorkflow"] = "UserinAbandonedCartWorkflow";
    UserVars["UserInterruptedProfileCollect"] = "UserInterruptedProfileCollect";
    UserVars["UserReferredBy"] = "UserReferredBy";
    UserVars["UserReferredByName"] = "UserReferredByName";
    UserVars["User_SentimentScore"] = "User_SentimentScore";
    UserVars["User_Sentiment"] = "User_Sentiment";
})(UserVars || (UserVars = {}));
/* ---------------
STORE VARIABLES
-----------------*/
var StoreVars;
(function (StoreVars) {
    StoreVars["StoreLocationNumber"] = "StoreLocationNumber";
    StoreVars["StoreFMSIntegrationId"] = "StoreFMSIntegrationId";
    StoreVars["StoreGoogleReviewURL"] = "StoreGoogleReviewURL";
    StoreVars["StoreName"] = "StoreName";
    StoreVars["StoreId"] = "StoreId";
    StoreVars["StoreFMSType"] = "StoreFMSType";
    StoreVars["StoreCountryCode"] = "StoreCountryCode";
    StoreVars["StoreClimateControlDisplayName"] = "StoreClimateControlDisplayName";
    StoreVars["StoreFirstFloorDisplayName"] = "StoreFirstFloorDisplayName";
    StoreVars["StoreUpperLevelDisplayName"] = "StoreUpperLevelDisplayName";
    StoreVars["StoreInsuranceDisplayName"] = "StoreInsuranceDisplayName";
    StoreVars["StoreHasElevator"] = "StoreHasElevator";
    StoreVars["StoreHasWineStorage"] = "StoreHasWineStorage";
    StoreVars["StoreGooglePlaceId"] = "StoreGooglePlaceId";
    StoreVars["StoreGoogleAccountAndLocationName"] = "StoreGoogleAccountAndLocationName";
    StoreVars["StoreHasBoatStorage"] = "StoreHasBoatStorage";
    StoreVars["StoreBrandId"] = "StoreBrandId";
    StoreVars["StoreOnlyShowUnitDimensions"] = "StoreOnlyShowUnitDimensions";
    StoreVars["StoreAddressLine1"] = "StoreAddressLine1";
    StoreVars["StoreCity"] = "StoreCity";
    StoreVars["StoreState"] = "StoreState";
    StoreVars["StorePostalCode"] = "StorePostalCode";
    StoreVars["StorePhoneNumber"] = "StorePhoneNumber";
    StoreVars["StorePayByPhoneNumber"] = "StorePayByPhoneNumber";
    StoreVars["StoreAfterHoursPhoneNumber"] = "StoreAfterHoursPhoneNumber";
    StoreVars["StoreEmail"] = "StoreEmail";
    StoreVars["StoreDMName"] = "StoreDMName";
    StoreVars["StoreDMEmail"] = "StoreDMEmail";
    StoreVars["StoreWebsiteUrl"] = "StoreWebsiteUrl";
    StoreVars["StoreUrlLookupPattern"] = "StoreUrlLookupPattern";
    StoreVars["StorePhotoURL"] = "StorePhotoURL";
    StoreVars["StoreWalletPassURL"] = "StoreWalletPassURL";
    StoreVars["StorePaymentURL"] = "StorePaymentURL";
    StoreVars["StoreMapURL"] = "StoreMapURL";
    StoreVars["StoreOfficeHours"] = "StoreOfficeHours";
    StoreVars["StoreAccessHours"] = "StoreAccessHours";
    StoreVars["StoreCallCenterHours"] = "StoreCallCenterHours";
    StoreVars["StorePaymentOptions"] = "StorePaymentOptions";
    StoreVars["StoreRVStorage"] = "StoreRVStorage";
    StoreVars["StoreSmallVehicleStorage"] = "StoreSmallVehicleStorage";
    StoreVars["StoreTrailerStorage"] = "StoreTrailerStorage";
    StoreVars["StoreDeliveriesAccepted"] = "StoreDeliveriesAccepted";
    StoreVars["StoreVideoSurveillance"] = "StoreVideoSurveillance";
    StoreVars["StoreSecurityAmenities"] = "StoreSecurityAmenities";
    StoreVars["StoreDriveUpUnits"] = "StoreDriveUpUnits";
    StoreVars["StoreClimateControlledUnits"] = "StoreClimateControlledUnits";
    StoreVars["StoreHeatedUnits"] = "StoreHeatedUnits";
    StoreVars["StoreOfficeSpace"] = "StoreOfficeSpace";
    StoreVars["StoreConferenceRoom"] = "StoreConferenceRoom";
    StoreVars["StoreTruckRentals"] = "StoreTruckRentals";
    StoreVars["StoreTwentyFourHourAccess"] = "StoreTwentyFourHourAccess";
    StoreVars["StoreLockersAvailable"] = "StoreLockersAvailable";
    StoreVars["StoreLockTypes"] = "StoreLockTypes";
    StoreVars["StoreTruckTypes"] = "StoreTruckTypes";
    StoreVars["StoreParkingType"] = "StoreParkingType";
    StoreVars["StoreLoadingAreaType"] = "StoreLoadingAreaType";
    StoreVars["StoreLeadUnitId"] = "StoreLeadUnitId";
    StoreVars["StoreAppointmentAvailable"] = "StoreAppointmentAvailable";
    StoreVars["StoreSpotLocationSlug"] = "StoreSpotLocationSlug";
    StoreVars["StoreSpotLinkSlug"] = "StoreSpotLinkSlug";
})(StoreVars || (StoreVars = {}));
//TODO: Make a function to generate these.
var DefaultBotVariables = (_a = {},
    _a[UserVars.User_Name] = {
        id: UserVars.User_Name,
        name: 'User - Name',
        protected: true
    },
    _a[UserVars.User_Email] = {
        id: UserVars.User_Email,
        name: 'User - Email',
        protected: true
    },
    _a[UserVars.User_Phone] = {
        id: UserVars.User_Phone,
        name: 'User - Phone Number',
        protected: true
    },
    _a[UserVars.User_AddressLine1] = {
        id: UserVars.User_AddressLine1,
        name: 'User - Address Line 1',
        protected: true
    },
    _a[UserVars.User_AddressLine2] = {
        id: UserVars.User_AddressLine2,
        name: 'User - Address Line 2',
        protected: true
    },
    _a[UserVars.User_City] = { id: UserVars.User_City, name: 'User - City', protected: true },
    _a[UserVars.User_State] = { id: UserVars.User_State, name: 'User - State', protected: true },
    _a[UserVars.User_Zip] = { id: UserVars.User_Zip, name: 'User - Zip', protected: true },
    _a[UserVars.User_LastIntent] = {
        id: UserVars.User_LastIntent,
        name: 'User - Last Intent',
        protected: true
    },
    _a[UserVars.User_CountryCode] = {
        id: UserVars.User_CountryCode,
        name: 'User - Country Code',
        protected: true
    },
    _a[UserVars.User_HasCompletedProfile] = {
        id: UserVars.User_HasCompletedProfile,
        name: 'User - Has Completed Profile?',
        protected: true
    },
    _a[UserVars.User_HasConfirmedProfile] = {
        id: UserVars.User_HasConfirmedProfile,
        name: 'User - Has Confirmed Profile',
        protected: true
    },
    _a[UserVars.User_HasShortProfile] = {
        id: UserVars.User_HasShortProfile,
        name: 'User - Has Short Profile',
        protected: true
    },
    _a[UserVars.User_AnsweringMachine] = {
        id: UserVars.User_AnsweringMachine,
        name: 'User - Answering Machine',
        protected: true
    },
    _a[UserVars.User_Persona] = {
        id: UserVars.User_Persona,
        name: 'User - Persona',
        protected: true
    },
    _a[UserVars.User_HasUnhandled] = {
        id: UserVars.User_HasUnhandled,
        name: 'User - Has Unhandled',
        protected: true
    },
    _a[UserVars.User_AccountType] = {
        id: UserVars.User_AccountType,
        name: 'User - Account Type',
        protected: true
    },
    _a[UserVars.User_CRMId] = {
        id: UserVars.User_CRMId,
        name: 'User - CRM Id',
        protected: true
    },
    _a[UserVars.User_CRMStatus] = {
        id: UserVars.User_CRMStatus,
        name: 'User - CRM Status',
        protected: true
    },
    _a[UserVars.User_LastAgentName] = {
        id: UserVars.User_LastAgentName,
        name: 'User - Last Agent Name',
        protected: true
    },
    _a[UserVars.User_Lead_hasSentEmailReceipt] = {
        id: UserVars.User_Lead_hasSentEmailReceipt,
        name: 'User - Lead Has Sent Email Receipt',
        protected: true
    },
    _a[UserVars.User_Lead_hasSentToFMS] = {
        id: UserVars.User_Lead_hasSentToFMS,
        name: 'User - Lead Has Sent To FMS',
        protected: true
    },
    _a[UserVars.User_Review_NPSScore] = {
        id: UserVars.User_Review_NPSScore,
        name: 'User - Review NPS Score',
        protected: true
    },
    _a[UserVars.User_Review_NPSFeedback] = {
        id: UserVars.User_Review_NPSFeedback,
        name: 'User - Review NPS Feedback',
        protected: true
    },
    _a[UserVars.User_Review_NPSTopic] = {
        id: UserVars.User_Review_NPSTopic,
        name: 'User - Review NPS Topic',
        protected: true
    },
    _a[UserVars.User_TemporaryFMSID] = {
        id: UserVars.User_TemporaryFMSID,
        name: 'User - Temporary FMS ID',
        protected: true
    },
    _a[UserVars.User_Review_NPSPersona] = {
        id: UserVars.User_Review_NPSPersona,
        name: 'User - Review NPS Persona',
        protected: true
    },
    _a[UserVars.User_hasSeen_FeatureMenu] = {
        id: UserVars.User_hasSeen_FeatureMenu,
        name: 'User - hasSeen Feature Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_InventoryMenu] = {
        id: UserVars.User_hasSeen_InventoryMenu,
        name: 'User - hasSeen Inventory Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_AnythingElseMenu] = {
        id: UserVars.User_hasSeen_AnythingElseMenu,
        name: 'User - hasSeen AnythingElse Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_CostMenu] = {
        id: UserVars.User_hasSeen_CostMenu,
        name: 'User - hasSeen Cost Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_ContactMenu] = {
        id: UserVars.User_hasSeen_ContactMenu,
        name: 'User - hasSeen Contact Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_SizeMenu] = {
        id: UserVars.User_hasSeen_SizeMenu,
        name: 'User - hasSeen Size Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_ProblemMenu] = {
        id: UserVars.User_hasSeen_ProblemMenu,
        name: 'User - hasSeen Problem Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_AccountMenu] = {
        id: UserVars.User_hasSeen_AccountMenu,
        name: 'User - hasSeen Account Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_ChangeAccountMenu] = {
        id: UserVars.User_hasSeen_ChangeAccountMenu,
        name: 'User - hasSeen ChangeAccount Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_AccountLoginMenu] = {
        id: UserVars.User_hasSeen_AccountLoginMenu,
        name: 'User - hasSeen AccountLogin Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_PurchaseProcessMenu] = {
        id: UserVars.User_hasSeen_PurchaseProcessMenu,
        name: 'User - hasSeen PurchaseProcess Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_LeaseTermsMenu] = {
        id: UserVars.User_hasSeen_LeaseTermsMenu,
        name: 'User - hasSeen LeaseTerms Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_MoveMenu] = {
        id: UserVars.User_hasSeen_MoveMenu,
        name: 'User - hasSeen Move Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_GSExistingMenu] = {
        id: UserVars.User_hasSeen_GSExistingMenu,
        name: 'User - hasSeen GSExisting Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_GSPotentialMenu] = {
        id: UserVars.User_hasSeen_GSPotentialMenu,
        name: 'User - hasSeen GSPotential Menu',
        protected: true
    },
    _a[UserVars.User_hasSeen_SMSDisclaimer] = {
        id: UserVars.User_hasSeen_SMSDisclaimer,
        name: 'User - hasSeen SMS Disclaimer',
        protected: true
    },
    _a[UserVars.User_CronReceiptType] = {
        id: UserVars.User_CronReceiptType,
        name: 'User - Cron Receipt Type',
        protected: true
    },
    _a[UserVars.User_AfterNavigate_Holder] = {
        id: UserVars.User_AfterNavigate_Holder,
        name: 'User - After Navigate Holder',
        protected: true
    },
    _a[UserVars.User_ProfileCollect_Holder] = {
        id: UserVars.User_ProfileCollect_Holder,
        name: 'User - Profile Collect Holder',
        protected: true
    },
    _a[UserVars.User_PreviousChannel_Holder] = {
        id: UserVars.User_PreviousChannel_Holder,
        name: 'User - Previous Channel Holder',
        protected: true
    },
    _a[UserVars.User_WantToSearchAnotherStore] = {
        id: UserVars.User_WantToSearchAnotherStore,
        name: 'User - Wants to Search Another Store',
        protected: true
    },
    _a[UserVars.User_hasProvidedFeedback] = {
        id: UserVars.User_hasProvidedFeedback,
        name: 'User - Has Provided Feedback',
        protected: true
    },
    _a[UserVars.User_isUpdatingProfile] = {
        id: UserVars.User_isUpdatingProfile,
        name: 'User - Is Updating Profile',
        protected: true
    },
    _a[UserVars.User_selectedStoreFromSMS] = {
        id: UserVars.User_selectedStoreFromSMS,
        name: 'User - Selected Store From SMS',
        protected: true
    },
    _a[UserVars.UserinAbandonedCartWorkflow] = {
        id: UserVars.UserinAbandonedCartWorkflow,
        name: 'User - In Abandoned Cart Workflow',
        protected: true
    },
    _a[UserVars.UserInterruptedProfileCollect] = {
        id: UserVars.UserInterruptedProfileCollect,
        name: 'User - Interrupted Profile Collect',
        protected: true
    },
    _a);
var StorageVars = (_b = {},
    // StoreLocationNumber: { id: 'StoreLocationNumber', name: 'Store - Location Number',  protected: true }
    _b[UserVars.User_TenantId] = {
        id: UserVars.User_TenantId,
        name: 'User - Tenant Id',
        protected: true
    },
    _b[UserVars.User_FMS_Error] = {
        id: UserVars.User_FMS_Error,
        name: 'User - FMS Error',
        protected: true
    },
    _b[UserVars.User_FMSLeadStatus] = {
        id: UserVars.User_FMSLeadStatus,
        name: 'User - FMS Lead Status',
        protected: true
    },
    _b[UserVars.User_EmailType] = {
        id: UserVars.User_EmailType,
        name: 'User - Email Type',
        protected: true
    },
    _b[UserVars.User_EmailReceiptType] = {
        id: UserVars.User_EmailReceiptType,
        name: 'User - Email Receipt Type',
        protected: true
    },
    _b[UserVars.User_CronReceiptType] = {
        id: UserVars.User_CronReceiptType,
        name: 'User - Cron Receipt Type',
        protected: true
    },
    _b[UserVars.User_AccessCode] = {
        id: UserVars.User_AccessCode,
        name: 'User - Access Code',
        protected: true
    },
    _b[UserVars.User_AccountStatus] = {
        id: UserVars.User_AccountStatus,
        name: 'User - Account Status',
        protected: true
    },
    _b[UserVars.User_AccountPaymentStatus] = {
        id: UserVars.User_AccountPaymentStatus,
        name: 'User - Account Payment Status',
        protected: true
    },
    _b[UserVars.User_PaymentDueDate] = {
        id: UserVars.User_PaymentDueDate,
        name: 'User - Payment Due Date',
        protected: true
    },
    _b[UserVars.User_AutoPayEnabled] = {
        id: UserVars.User_AutoPayEnabled,
        name: 'User - Auto Pay Enabled',
        protected: true
    },
    _b[UserVars.User_DaysPastDue] = {
        id: UserVars.User_DaysPastDue,
        name: 'User - Days Past Due',
        protected: true
    },
    _b[UserVars.User_WantsToStoreVehicle] = {
        id: UserVars.User_WantsToStoreVehicle,
        name: 'User - Wants to Store Vehicle?',
        protected: true
    },
    _b[UserVars.User_WantToShopByPrice] = {
        id: UserVars.User_WantToShopByPrice,
        name: 'User - Wants to Shop by Price?',
        protected: true
    },
    _b[UserVars.User_FilterFeatures] = {
        id: UserVars.User_FilterFeatures,
        name: 'User - Filter Features',
        protected: true
    },
    _b[UserVars.User_FilterSize] = {
        id: UserVars.User_FilterSize,
        name: 'User - Filter Size',
        protected: true
    },
    _b[UserVars.User_Notes] = {
        id: UserVars.User_Notes,
        name: 'User - Notes',
        protected: true
    },
    _b[UserVars.User_UnitNumber] = {
        id: UserVars.User_UnitNumber,
        name: 'User - Unit Number',
        protected: true
    },
    _b[UserVars.User_UnitSize] = {
        id: UserVars.User_UnitSize,
        name: 'User - Unit Size',
        protected: true
    },
    _b[UserVars.User_UnitFeatures] = {
        id: UserVars.User_UnitFeatures,
        name: 'User - Unit Features',
        protected: true
    },
    _b[UserVars.User_AccountBalance] = {
        id: UserVars.User_AccountBalance,
        name: 'User - Account Balance',
        protected: true
    },
    _b[UserVars.User_EntityCity] = {
        id: UserVars.User_EntityCity,
        name: 'User - Entity City',
        protected: true
    },
    _b[UserVars.User_EntityState] = {
        id: UserVars.User_EntityState,
        name: 'User - Entity State',
        protected: true
    },
    _b[UserVars.User_EntityDate] = {
        id: UserVars.User_EntityDate,
        name: 'User - Entity Date',
        protected: true
    },
    _b[UserVars.User_EntityTime] = {
        id: UserVars.User_EntityTime,
        name: 'User - Entity Time',
        protected: true
    },
    _b[UserVars.User_EntityNumber] = {
        id: UserVars.User_EntityNumber,
        name: 'User - Entity Time',
        protected: true
    },
    _b[StoreVars.StoreLocationNumber] = {
        id: StoreVars.StoreLocationNumber,
        name: 'Store - Location Number',
        protected: true
    },
    _b[StoreVars.StoreId] = {
        id: StoreVars.StoreId,
        name: 'Store - FMS Facility Id',
        protected: true
    },
    _b[StoreVars.StoreFMSIntegrationId] = {
        id: StoreVars.StoreFMSIntegrationId,
        name: 'Store - FMS Integration Id',
        protected: true
    },
    _b[StoreVars.StoreFMSType] = {
        id: StoreVars.StoreFMSType,
        name: 'Store - FMS Type',
        protected: true
    },
    _b[StoreVars.StoreName] = {
        id: StoreVars.StoreName,
        name: 'Store - Name',
        protected: true
    },
    _b[StoreVars.StoreAddressLine1] = {
        id: StoreVars.StoreAddressLine1,
        name: 'Store - Address Line 1',
        protected: true
    },
    _b[StoreVars.StoreCity] = {
        id: StoreVars.StoreCity,
        name: 'Store - City',
        protected: true
    },
    _b[StoreVars.StoreState] = {
        id: StoreVars.StoreState,
        name: 'Store - State',
        protected: true
    },
    _b[StoreVars.StorePostalCode] = {
        id: StoreVars.StorePostalCode,
        name: 'Store - Postal Code',
        protected: true
    },
    _b[StoreVars.StorePhoneNumber] = {
        id: StoreVars.StorePhoneNumber,
        name: 'Store - Phone Number',
        protected: true
    },
    _b[StoreVars.StorePayByPhoneNumber] = {
        id: StoreVars.StorePayByPhoneNumber,
        name: 'Store - Pay by Phone Number',
        protected: true
    },
    _b[StoreVars.StoreAfterHoursPhoneNumber] = {
        id: StoreVars.StoreAfterHoursPhoneNumber,
        name: 'Store - After Hours Phone Number',
        protected: true
    },
    _b[StoreVars.StoreEmail] = {
        id: StoreVars.StoreEmail,
        name: 'Store - Email',
        protected: true
    },
    _b[StoreVars.StoreDMName] = {
        id: StoreVars.StoreDMName,
        name: 'Store - DM Name',
        protected: true
    },
    _b[StoreVars.StoreDMEmail] = {
        id: StoreVars.StoreDMEmail,
        name: 'Store - DM Email',
        protected: true
    },
    _b[StoreVars.StoreWebsiteUrl] = {
        id: StoreVars.StoreWebsiteUrl,
        name: 'Store - Location URL',
        protected: true
    },
    _b[StoreVars.StoreUrlLookupPattern] = {
        id: StoreVars.StoreUrlLookupPattern,
        name: 'Store - URL Lookup Pattern',
        protected: true
    },
    _b[StoreVars.StorePhotoURL] = {
        id: StoreVars.StorePhotoURL,
        name: 'Store - Photo URL',
        protected: true
    },
    _b[StoreVars.StoreWalletPassURL] = {
        id: StoreVars.StoreWalletPassURL,
        name: 'Store - Wallet URL',
        protected: true
    },
    _b[StoreVars.StorePaymentURL] = {
        id: StoreVars.StorePaymentURL,
        name: 'Store - Payment URL',
        protected: true
    },
    _b[StoreVars.StoreMapURL] = {
        id: StoreVars.StoreMapURL,
        name: 'Store - Map URL',
        protected: true
    },
    _b[StoreVars.StoreOfficeHours] = {
        id: StoreVars.StoreOfficeHours,
        name: 'Store - Office Hours',
        protected: true
    },
    _b[StoreVars.StoreAccessHours] = {
        id: StoreVars.StoreAccessHours,
        name: 'Store - Access Hours',
        protected: true
    },
    _b[StoreVars.StoreCallCenterHours] = {
        id: StoreVars.StoreCallCenterHours,
        name: 'Store - Call Center Hours',
        protected: true
    },
    _b[StoreVars.StorePaymentOptions] = {
        id: StoreVars.StorePaymentOptions,
        name: 'Store - Payment Options',
        protected: true
    },
    _b[StoreVars.StoreRVStorage] = {
        id: StoreVars.StoreRVStorage,
        name: 'Store - RV Storage',
        protected: true
    },
    _b[StoreVars.StoreSmallVehicleStorage] = {
        id: StoreVars.StoreSmallVehicleStorage,
        name: 'Store - Small Vehicle Storage',
        protected: true
    },
    _b[StoreVars.StoreTrailerStorage] = {
        id: StoreVars.StoreTrailerStorage,
        name: 'Store - Trailer Storage',
        protected: true
    },
    _b[StoreVars.StoreDeliveriesAccepted] = {
        id: StoreVars.StoreDeliveriesAccepted,
        name: 'Store - Deliveries Accepted',
        protected: true
    },
    _b[StoreVars.StoreVideoSurveillance] = {
        id: StoreVars.StoreVideoSurveillance,
        name: 'Store - Video Surveillance',
        protected: true
    },
    _b[StoreVars.StoreSecurityAmenities] = {
        id: StoreVars.StoreSecurityAmenities,
        name: 'Store - Security Amenities',
        protected: true
    },
    _b[StoreVars.StoreDriveUpUnits] = {
        id: StoreVars.StoreDriveUpUnits,
        name: 'Store - Drive-Up Units',
        protected: true
    },
    _b[StoreVars.StoreClimateControlledUnits] = {
        id: StoreVars.StoreClimateControlledUnits,
        name: 'Store - Climate Controlled Units',
        protected: true
    },
    _b[StoreVars.StoreHeatedUnits] = {
        id: StoreVars.StoreHeatedUnits,
        name: 'Store - Heated Units',
        protected: true
    },
    _b[StoreVars.StoreOfficeSpace] = {
        id: StoreVars.StoreOfficeSpace,
        name: 'Store - Office Space',
        protected: true
    },
    _b[StoreVars.StoreConferenceRoom] = {
        id: StoreVars.StoreConferenceRoom,
        name: 'Store - Conference Room',
        protected: true
    },
    _b[StoreVars.StoreTruckRentals] = {
        id: StoreVars.StoreTruckRentals,
        name: 'Store - Truck Rentals',
        protected: true
    },
    _b[StoreVars.StoreTwentyFourHourAccess] = {
        id: StoreVars.StoreTwentyFourHourAccess,
        name: 'Store - 24 Hour Access',
        protected: true
    },
    _b[StoreVars.StoreLockersAvailable] = {
        id: StoreVars.StoreLockersAvailable,
        name: 'Store - Lockers Available',
        protected: true
    },
    _b[StoreVars.StoreLockTypes] = {
        id: StoreVars.StoreLockTypes,
        name: 'Store - Lock Type',
        protected: true
    },
    _b[StoreVars.StoreTruckTypes] = {
        id: StoreVars.StoreTruckTypes,
        name: 'Store - Truck Type',
        protected: true
    },
    _b[StoreVars.StoreParkingType] = {
        id: StoreVars.StoreParkingType,
        name: 'Store - Parking Type',
        protected: true
    },
    _b[StoreVars.StoreLoadingAreaType] = {
        id: StoreVars.StoreLoadingAreaType,
        name: 'Store - Loading Area Type',
        protected: true
    },
    _b[StoreVars.StoreLeadUnitId] = {
        id: StoreVars.StoreLeadUnitId,
        name: 'Store - Lead Unit Id',
        protected: true
    },
    _b[StoreVars.StoreAppointmentAvailable] = {
        id: StoreVars.StoreAppointmentAvailable,
        name: 'Store - Appointment Available',
        protected: true
    },
    _b[StoreVars.StoreGoogleReviewURL] = {
        id: StoreVars.StoreGoogleReviewURL,
        name: 'Store - Google Review URL',
        protected: true
    },
    _b[StoreVars.StoreClimateControlDisplayName] = {
        id: StoreVars.StoreClimateControlDisplayName,
        name: 'Store - Climate Control Display Name',
        protected: true
    },
    _b[StoreVars.StoreFirstFloorDisplayName] = {
        id: StoreVars.StoreFirstFloorDisplayName,
        name: 'Store - First Floor Display Name',
        protected: true
    },
    _b[StoreVars.StoreUpperLevelDisplayName] = {
        id: StoreVars.StoreUpperLevelDisplayName,
        name: 'Store - Upper Level Display Name',
        protected: true
    },
    _b[StoreVars.StoreInsuranceDisplayName] = {
        id: StoreVars.StoreInsuranceDisplayName,
        name: 'Store - Insurance Display Name ',
        protected: true
    },
    _b[StoreVars.StoreHasElevator] = {
        id: StoreVars.StoreHasElevator,
        name: 'Store - Has Elevator',
        protected: true
    },
    _b[StoreVars.StoreHasWineStorage] = {
        id: StoreVars.StoreHasWineStorage,
        name: 'Store - Has Wine Storage',
        protected: true
    },
    _b[StoreVars.StoreGooglePlaceId] = {
        id: StoreVars.StoreGooglePlaceId,
        name: 'Store - Google Place Id',
        protected: true
    },
    _b[StoreVars.StoreGoogleAccountAndLocationName] = {
        id: StoreVars.StoreGoogleAccountAndLocationName,
        name: 'Store - Google Account and Location Name',
        protected: true
    },
    _b[StoreVars.StoreHasBoatStorage] = {
        id: StoreVars.StoreHasBoatStorage,
        name: 'Store - Has Boat Storage',
        protected: true
    },
    _b[StoreVars.StoreBrandId] = {
        id: StoreVars.StoreBrandId,
        name: 'Store - Brand Id',
        protected: true
    },
    _b[StoreVars.StoreCountryCode] = {
        id: StoreVars.StoreCountryCode,
        name: 'Store - Country Code',
        protected: true
    },
    _b[StoreVars.StoreOnlyShowUnitDimensions] = {
        id: StoreVars.StoreOnlyShowUnitDimensions,
        name: 'Store - Only Show Unit Dimensions',
        protected: true
    },
    _b[StoreVars.StoreSpotLocationSlug] = {
        id: StoreVars.StoreSpotLocationSlug,
        name: 'Store - Spot Location Slug',
        protected: true
    },
    _b[StoreVars.StoreSpotLinkSlug] = {
        id: StoreVars.StoreSpotLinkSlug,
        name: 'Store - Spot Link Slug',
        protected: true
    },
    /*
     ******   ***** ACE
     *        *   *
     ******   *****
     *   *
     ******   *
     */
    _b[SpaceVars.SpaceId] = { id: SpaceVars.SpaceId, name: 'Space - Id', protected: true },
    _b[SpaceVars.SpaceName] = { id: SpaceVars.SpaceName, name: 'Space - Name', protected: true },
    _b[SpaceVars.SpaceDimensions] = {
        id: SpaceVars.SpaceDimensions,
        name: 'Space - Dimensions',
        protected: true
    },
    _b[SpaceVars.SpaceRate] = { id: SpaceVars.SpaceRate, name: 'Space - Rate', protected: true },
    _b[SpaceVars.SpaceHasClimateControl] = {
        id: SpaceVars.SpaceHasClimateControl,
        name: 'Space - Climate Controlled',
        protected: true
    },
    _b[SpaceVars.SpaceIsInside] = {
        id: SpaceVars.SpaceIsInside,
        name: 'Space - Indoor',
        protected: true
    },
    _b[SpaceVars.SpaceHasPower] = {
        id: SpaceVars.SpaceHasPower,
        name: 'Space - Has Power',
        protected: true
    },
    _b[SpaceVars.SpaceFloor] = {
        id: SpaceVars.SpaceFloor,
        name: 'Space - Floor #',
        protected: true
    },
    _b[SpaceVars.SpaceIsParking] = {
        id: SpaceVars.SpaceIsParking,
        name: 'Space - Is Parking',
        protected: true
    },
    _b[SpaceVars.SpaceIsDriveUp] = {
        id: SpaceVars.SpaceIsDriveUp,
        name: 'Space - Drive Up',
        protected: true
    },
    _b[SpaceVars.SpaceHasElevatorAccess] = {
        id: SpaceVars.SpaceHasElevatorAccess,
        name: 'Space - Has Elevator Access',
        protected: true
    },
    _b[SpaceVars.SpaceHasAlarm] = {
        id: SpaceVars.SpaceHasAlarm,
        name: 'Space - Has Alarm',
        protected: true
    },
    _b[SpaceVars.SpaceFeatures] = {
        id: SpaceVars.SpaceFeatures,
        name: 'Space - Features',
        protected: true
    }
// [SpaceVars.SpaceHasVideoSurveillance]: {
//   id: SpaceVars.SpaceHasVideoSurveillance,
//   name: 'Space - Video Surveillance',
//   protected: true
// },
// [SpaceVars.SpaceHasInteriorLight]: {
//   id: SpaceVars.SpaceHasInteriorLight,
//   name: 'Space - Has Interior Light',
//   protected: true
// }
,
    _b);

var EscalationPlatform;
(function (EscalationPlatform) {
    EscalationPlatform["SWIVL"] = "swivl";
    EscalationPlatform["TEAMS"] = "teams";
    EscalationPlatform["SLACK"] = "slack";
})(EscalationPlatform || (EscalationPlatform = {}));
var EscalationStatus;
(function (EscalationStatus) {
    EscalationStatus["PENDING"] = "pending";
    EscalationStatus["ASSIGNED"] = "assigned";
    EscalationStatus["ACTIVE"] = "active";
    EscalationStatus["HANDLED"] = "handled";
    // MISSED   = "missed", // This means agents were tried but none found
    // IGNORED  = "ignored",
    // UNAVAILABLE = "unavailable",
    // OUTSIDE_HOURS = "outside of hours",
    // OPT_OUT = "opt out",
    EscalationStatus["TIMED_OUT"] = "timed out";
    EscalationStatus["OUTSIDE_HOURS"] = "outside of hours";
    EscalationStatus["NO_AGENT_AVAILABLE"] = "no agent available";
    EscalationStatus["USER_IS_BLOCKED"] = "user is blocked";
})(EscalationStatus || (EscalationStatus = {}));
var EscalationErrorType;
(function (EscalationErrorType) {
    EscalationErrorType["TIMED_OUT"] = "timed out";
    EscalationErrorType["REASSIGNED"] = "reassigned";
    EscalationErrorType["UNKNOWN"] = "unknown";
})(EscalationErrorType || (EscalationErrorType = {}));
var EscalationHistoryEvent;
(function (EscalationHistoryEvent) {
    EscalationHistoryEvent["CREATED"] = "CREATED";
    EscalationHistoryEvent["AGENT_INITIATED"] = "agent initiated";
    EscalationHistoryEvent["AVAILABLE_AGENTS_LOOKED_UP"] = "available agents looked up";
    EscalationHistoryEvent["ASSIGNED_TO_AGENT"] = "assigned to agent";
    EscalationHistoryEvent["AGENT_ACCEPTED"] = "agent accepted";
    EscalationHistoryEvent["AGENT_REJECT"] = "agent reject";
    EscalationHistoryEvent["AGENT_MISSED"] = "agent missed";
    EscalationHistoryEvent["CONVERSATION_ENDED"] = "conversation ended";
    EscalationHistoryEvent["TIMED_OUT"] = "timed out";
    EscalationHistoryEvent["NO_AGENT_AVAILABLE"] = "no agent available";
    EscalationHistoryEvent["OUTSIDE_HOURS"] = "outside hours";
    EscalationHistoryEvent["USER_IS_BLOCKED"] = "user is blocked";
})(EscalationHistoryEvent || (EscalationHistoryEvent = {}));
var EscalationSlackMessageType;
(function (EscalationSlackMessageType) {
    EscalationSlackMessageType["CHANNEL"] = "channel";
    EscalationSlackMessageType["AGENT"] = "agent";
})(EscalationSlackMessageType || (EscalationSlackMessageType = {}));

var TrainingState;
(function (TrainingState) {
    TrainingState["LOADING"] = "LOADING";
    TrainingState["DIRTY"] = "DIRTY";
    TrainingState["UNTRAINED"] = "UNTRAINED";
    TrainingState["UNPUBLISHED"] = "UNPUBLISHED";
    TrainingState["TRAINING"] = "TRAINING";
    TrainingState["TRAINED"] = "TRAINED";
    TrainingState["ERROR"] = "ERROR";
    TrainingState["FAILED"] = "FAILED";
    TrainingState["PUBLISHING"] = "PUBLISHING";
    TrainingState["PUBLISHED"] = "PUBLISHED";
})(TrainingState || (TrainingState = {}));

/**
 * @module botbuilder-dialogs
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Simple tokenizer that breaks on spaces and punctuation.
 *
 * @param text The input text.
 * @param _locale Optional, identifies the locale of the input text.
 * @returns A list of tokens.
 * @remarks
 * The only normalization done is to lowercase the tokens. Developers can wrap this tokenizer with
 * their own function to perform additional normalization like [stemming](https://github.com/words/stemmer).
 *
 * ```JavaScript
 * const { recognizeChoices, defaultTokenizer } = require('botbuilder-choices');
 * const stemmer = require('stemmer');
 *
 * function customTokenizer(text, locale) {
 *    const tokens = defaultTokenizer(text, locale);
 *    tokens.forEach((t) => {
 *        t.normalized = stemmer(t.normalized);
 *    });
 *    return tokens;
 * }
 *
 * const choices = ['red', 'green', 'blue'];
 * const utterance = context.activity.text;
 * const results = recognizeChoices(utterance, choices, { tokenizer: customTokenizer });
 * ```
 */
function stringTokenizer(text) {
    // Custom swivl one to get the good stuff
    return defaultTokenizer(text).map(function (t) { return t.text; });
}
function defaultTokenizer(text, _locale) {
    var tokens = [];
    var token;
    function appendToken(end) {
        if (token) {
            token.end = end;
            token.normalized = token.text.toLowerCase();
            tokens.push(token);
            token = undefined;
        }
    }
    // Parse text
    var length = text ? text.length : 0;
    var i = 0;
    while (i < length) {
        // Get both the UNICODE value of the current character and the complete character itself
        // which can potentially be multiple segments.
        var codePoint = text.codePointAt(i) || text.charCodeAt(i);
        var chr = String.fromCodePoint(codePoint);
        // Process current character
        if (isBreakingChar(codePoint)) {
            // Character is in Unicode Plane 0 and is in an excluded block
            appendToken(i - 1);
        }
        else if (codePoint > 0xffff) {
            // Character is in a Supplementary Unicode Plane. This is where emoji live so
            // we're going to just break each character in this range out as its own token.
            appendToken(i - 1);
            tokens.push({
                start: i,
                end: i + (chr.length - 1),
                text: chr,
                normalized: chr,
                index: i
            });
        }
        else if (!token) {
            // Start a new token
            token = { start: i, text: chr };
        }
        else {
            // Add on to current token
            token.text += chr;
        }
        i += chr.length;
    }
    appendToken(length - 1);
    return tokens;
}
/**
 * @private
 * @param codePoint number of character
 */
function isBreakingChar(codePoint) {
    return (isBetween(codePoint, 0x0000, 0x002f) ||
        isBetween(codePoint, 0x003a, 0x0040) ||
        isBetween(codePoint, 0x005b, 0x0060) ||
        isBetween(codePoint, 0x007b, 0x00bf) ||
        isBetween(codePoint, 0x02b9, 0x036f) ||
        isBetween(codePoint, 0x2000, 0x2bff) ||
        isBetween(codePoint, 0x2e00, 0x2e7f));
}
/**
 * @private
 * @param value number value
 * @param from low range
 * @param to high range
 */
function isBetween(value, from, to) {
    return value >= from && value <= to;
}

var UserTakeoverChannel;
(function (UserTakeoverChannel) {
    UserTakeoverChannel["SMS"] = "SMS";
    UserTakeoverChannel["Web"] = "Web";
})(UserTakeoverChannel || (UserTakeoverChannel = {}));

var ServerEnvironment;
(function (ServerEnvironment) {
    ServerEnvironment["STAGING"] = "staging";
    ServerEnvironment["PRODUCTION"] = "production";
    ServerEnvironment["TEST"] = "test";
})(ServerEnvironment || (ServerEnvironment = {}));
/*
  The ServerContext refers to different complete enviorments.
  This includes different DB, servers, etc.

  It will not have a staging as staging mimics production.
*/
var ServerContext;
(function (ServerContext) {
    // DEV = 'dev',
    ServerContext["PROD"] = "prod";
    // LOCAL = 'local',
    ServerContext["FUTURE"] = "future";
    // TEST = 'test'
})(ServerContext || (ServerContext = {}));

// For some reason it really wants me to export from here? Not sure why. I tried putting it in the shared file but it failed.
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Saturday"] = "Saturday";
    DayOfWeek["Sunday"] = "Sunday";
})(DayOfWeek || (DayOfWeek = {}));
var HourOfDay;
(function (HourOfDay) {
    HourOfDay["HOUR_00_00"] = "00:00";
    HourOfDay["HOUR_00_30"] = "00:30";
    HourOfDay["HOUR_01_00"] = "01:00";
    HourOfDay["HOUR_01_30"] = "01:30";
    HourOfDay["HOUR_02_00"] = "02:00";
    HourOfDay["HOUR_02_30"] = "02:30";
    HourOfDay["HOUR_03_00"] = "03:00";
    HourOfDay["HOUR_03_30"] = "03:30";
    HourOfDay["HOUR_04_00"] = "04:00";
    HourOfDay["HOUR_04_30"] = "04:30";
    HourOfDay["HOUR_05_00"] = "05:00";
    HourOfDay["HOUR_05_30"] = "05:30";
    HourOfDay["HOUR_06_00"] = "06:00";
    HourOfDay["HOUR_06_30"] = "06:30";
    HourOfDay["HOUR_07_00"] = "07:00";
    HourOfDay["HOUR_07_30"] = "07:30";
    HourOfDay["HOUR_08_00"] = "08:00";
    HourOfDay["HOUR_08_30"] = "08:30";
    HourOfDay["HOUR_09_00"] = "09:00";
    HourOfDay["HOUR_09_30"] = "09:30";
    HourOfDay["HOUR_10_00"] = "10:00";
    HourOfDay["HOUR_10_30"] = "10:30";
    HourOfDay["HOUR_11_00"] = "11:00";
    HourOfDay["HOUR_11_30"] = "11:30";
    HourOfDay["HOUR_12_00"] = "12:00";
    HourOfDay["HOUR_12_30"] = "12:30";
    HourOfDay["HOUR_13_00"] = "13:00";
    HourOfDay["HOUR_13_30"] = "13:30";
    HourOfDay["HOUR_14_00"] = "14:00";
    HourOfDay["HOUR_14_30"] = "14:30";
    HourOfDay["HOUR_15_00"] = "15:00";
    HourOfDay["HOUR_15_30"] = "15:30";
    HourOfDay["HOUR_16_00"] = "16:00";
    HourOfDay["HOUR_16_30"] = "16:30";
    HourOfDay["HOUR_17_00"] = "17:00";
    HourOfDay["HOUR_17_30"] = "17:30";
    HourOfDay["HOUR_18_00"] = "18:00";
    HourOfDay["HOUR_18_30"] = "18:30";
    HourOfDay["HOUR_19_00"] = "19:00";
    HourOfDay["HOUR_19_30"] = "19:30";
    HourOfDay["HOUR_20_00"] = "20:00";
    HourOfDay["HOUR_20_30"] = "20:30";
    HourOfDay["HOUR_21_00"] = "21:00";
    HourOfDay["HOUR_21_30"] = "21:30";
    HourOfDay["HOUR_22_00"] = "22:00";
    HourOfDay["HOUR_22_30"] = "22:30";
    HourOfDay["HOUR_23_00"] = "23:00";
    HourOfDay["HOUR_23_30"] = "23:30";
})(HourOfDay || (HourOfDay = {}));

var SMSGroupAnalyticsEventType;
(function (SMSGroupAnalyticsEventType) {
    SMSGroupAnalyticsEventType["AddedViaQuest"] = "Added via Quest";
    SMSGroupAnalyticsEventType["RemovedViaQuest"] = "Removed via Quest";
    SMSGroupAnalyticsEventType["AddedManually"] = "Added Manually";
    SMSGroupAnalyticsEventType["RemovedManually"] = "Removed Manually";
    SMSGroupAnalyticsEventType["SMSSent"] = "SMS Sent";
    SMSGroupAnalyticsEventType["CampaignSent"] = "Campaign Sent";
    SMSGroupAnalyticsEventType["GroupActivated"] = "Group Activated";
    SMSGroupAnalyticsEventType["GroupDeactivated"] = "Group Deactivated";
})(SMSGroupAnalyticsEventType || (SMSGroupAnalyticsEventType = {}));

var SMSGroupType;
(function (SMSGroupType) {
    SMSGroupType["SCHEDULED"] = "scheduled";
    SMSGroupType["INTERVAL"] = "interval";
})(SMSGroupType || (SMSGroupType = {}));

var _a$1;
var FMSType;
(function (FMSType) {
    FMSType["SiteLink"] = "SiteLink";
    FMSType["SSM"] = "SSM";
    FMSType["SSMCloud"] = "SSMCloud";
    FMSType["StorEdge"] = "StorEdge";
    FMSType["Tenant"] = "Tenant";
    FMSType["StorageMart"] = "StorageMart";
    FMSType["DoorSwap"] = "DoorSwap";
    FMSType["StorageCommander"] = "StorageCommander";
    FMSType["Storage360"] = "Storage360";
})(FMSType || (FMSType = {}));
var SpaceType;
(function (SpaceType) {
    SpaceType["STORAGE_UNIT"] = "storage unit";
    SpaceType["PARKING"] = "parking";
    SpaceType["RV_PARKING"] = "rv parking";
})(SpaceType || (SpaceType = {}));
// export enum SpaceFeatureName { // This is deprecated!
//   IsParking = 'IsParking',
//   Indoor = 'Indoor',
//   Power = 'Power',
//   Alarm = 'Alarm',
//   ClimateControl = 'ClimateControl',
//   FirstFloor = 'FirstFloor',
//   DriveUp = 'DriveUp',
//   UpperLevel = 'UpperLevel',
//   ElevatorAccess = 'ElevatorAccess'
// }
var SpaceFeature;
(function (SpaceFeature) {
    SpaceFeature["STORAGE_UNIT"] = "storage unit";
    SpaceFeature["PARKING"] = "parking";
    SpaceFeature["RV_PARKING"] = "rv parking";
    SpaceFeature["COMMERCIAL_WAREHOUSE"] = "commercial warehouse";
    SpaceFeature["BOAT_PARKING"] = "boat parking";
    SpaceFeature["LOCKER"] = "locker";
    SpaceFeature["CLIMATE_CONTROL"] = "climate control";
    SpaceFeature["OFFICE_SPACE"] = "office space";
    SpaceFeature["FIRST_FLOOR"] = "first floor";
    SpaceFeature["UNPAVED"] = "unpaved";
    SpaceFeature["PAVED"] = "paved";
    SpaceFeature["COVERED"] = "covered";
    SpaceFeature["ENCLOSED"] = "enclosed";
    SpaceFeature["PULL_THRU"] = "pull thru";
    SpaceFeature["HEATED"] = "heated";
    SpaceFeature["UPPER_LEVEL"] = "upper level";
    SpaceFeature["INSIDE"] = "inside";
    SpaceFeature["DRIVE_UP"] = "drive up";
    SpaceFeature["ELEVATOR_ACCESS"] = "elevator access";
    SpaceFeature["ALARM"] = "alarm";
    SpaceFeature["POWER"] = "power";
    SpaceFeature["WINE_STORAGE"] = "wine storage";
    SpaceFeature["GUN_STORAGE"] = "gun storage";
    SpaceFeature["SAFETY_DEPOSIT_BOX"] = "safety deposit box";
    SpaceFeature["UPPER_STACK"] = "upper stack";
    SpaceFeature["LOWER_STACK"] = "lower stack";
})(SpaceFeature || (SpaceFeature = {}));
var SpaceTags = [
    // These are things we display as tags
    SpaceFeature.CLIMATE_CONTROL,
    SpaceFeature.BOAT_PARKING,
    SpaceFeature.LOCKER,
    SpaceFeature.COMMERCIAL_WAREHOUSE,
    SpaceFeature.OFFICE_SPACE,
    SpaceFeature.FIRST_FLOOR,
    SpaceFeature.UNPAVED,
    SpaceFeature.PAVED,
    SpaceFeature.COVERED,
    SpaceFeature.ENCLOSED,
    SpaceFeature.PULL_THRU,
    SpaceFeature.HEATED,
    SpaceFeature.UPPER_LEVEL,
    SpaceFeature.INSIDE,
    SpaceFeature.DRIVE_UP,
    SpaceFeature.ELEVATOR_ACCESS,
    SpaceFeature.ALARM,
    SpaceFeature.POWER,
    SpaceFeature.WINE_STORAGE,
    SpaceFeature.SAFETY_DEPOSIT_BOX,
    SpaceFeature.UPPER_STACK,
    SpaceFeature.LOWER_STACK
];
var DefaultSpacePickerFeatureDisplayNames = (_a$1 = {},
    // [SpaceFeatureName.IsParking]: 'Parking',
    // [SpaceFeatureName.Indoor]: 'Indoor',
    // [SpaceFeatureName.Power]: 'Power',
    // [SpaceFeatureName.Alarm]: 'Alarm',
    // [SpaceFeatureName.ClimateControl]: 'Climate Control',
    // [SpaceFeatureName.FirstFloor]: 'First Floor',
    // [SpaceFeatureName.DriveUp]: 'Drive Up',
    // [SpaceFeatureName.UpperLevel]: 'Upper Level',
    // [SpaceFeatureName.ElevatorAccess]: 'Elevator Access',
    _a$1[SpaceFeature.OFFICE_SPACE] = 'Office Space',
    _a$1[SpaceFeature.COMMERCIAL_WAREHOUSE] = 'Commercial Warehouse',
    _a$1[SpaceFeature.BOAT_PARKING] = 'Boat Parking',
    _a$1[SpaceFeature.LOCKER] = 'Locker',
    _a$1[SpaceFeature.STORAGE_UNIT] = 'Storage Unit',
    _a$1[SpaceFeature.PARKING] = 'Parking',
    _a$1[SpaceFeature.RV_PARKING] = 'RV Parking',
    _a$1[SpaceFeature.CLIMATE_CONTROL] = 'Climate Control',
    _a$1[SpaceFeature.FIRST_FLOOR] = 'First Floor',
    _a$1[SpaceFeature.UNPAVED] = 'Unpaved',
    _a$1[SpaceFeature.PAVED] = 'Paved',
    _a$1[SpaceFeature.COVERED] = 'Covered',
    _a$1[SpaceFeature.ENCLOSED] = 'Enclosed',
    _a$1[SpaceFeature.PULL_THRU] = 'Pull Thru',
    _a$1[SpaceFeature.HEATED] = 'Heated',
    _a$1[SpaceFeature.UPPER_LEVEL] = 'Upper Level',
    _a$1[SpaceFeature.INSIDE] = 'Inside',
    _a$1[SpaceFeature.DRIVE_UP] = 'Drive Up',
    _a$1[SpaceFeature.ELEVATOR_ACCESS] = 'Elevator Access',
    _a$1[SpaceFeature.ALARM] = 'Alarm',
    _a$1[SpaceFeature.POWER] = 'Power',
    _a$1[SpaceFeature.WINE_STORAGE] = 'Alarm',
    _a$1[SpaceFeature.GUN_STORAGE] = 'Gun Storage',
    _a$1[SpaceFeature.SAFETY_DEPOSIT_BOX] = 'Power',
    _a$1[SpaceFeature.UPPER_STACK] = 'Upper Stack',
    _a$1[SpaceFeature.LOWER_STACK] = 'Lower Stack',
    _a$1);
function SpaceInterfaceToSpaceVariables(_space) {
    var _a;
    var space = __assign({}, _space) || {};
    for (var key in space) {
        if (Object.prototype.hasOwnProperty.call(space, key)) {
            space[key] = String(space[key]);
        }
    }
    return _a = {},
        _a[SpaceVars.SpaceId] = space.id,
        _a[SpaceVars.SpaceName] = space.name || '',
        _a[SpaceVars.SpaceDimensions] = space.dimensions || '',
        _a[SpaceVars.SpaceRate] = space.costLow || space.costHigh || '',
        _a[SpaceVars.SpaceHasClimateControl] = space.hasClimateControl || space.features.includes(SpaceFeature.CLIMATE_CONTROL) ? '1' : '0',
        _a[SpaceVars.SpaceIsInside] = space.isInside || space.features.includes(SpaceFeature.INSIDE) ? '1' : '0',
        _a[SpaceVars.SpaceHasPower] = space.hasPower || space.features.includes(SpaceFeature.POWER) ? '1' : '0',
        _a[SpaceVars.SpaceFloor] = String(space.floor),
        _a[SpaceVars.SpaceIsParking] = space.isParking || space.features.includes(SpaceFeature.PARKING) ? '1' : '0',
        _a[SpaceVars.SpaceIsDriveUp] = space.isDriveUp || space.features.includes(SpaceFeature.DRIVE_UP) ? '1' : '0',
        _a[SpaceVars.SpaceHasElevatorAccess] = space.hasElevatorAccess || space.features.includes(SpaceFeature.ELEVATOR_ACCESS) ? '1' : '0',
        _a[SpaceVars.SpaceHasAlarm] = space.hasAlarm || space.features.includes(SpaceFeature.ALARM) ? '1' : '0',
        _a[SpaceVars.SpaceFeatures] = space.features && space.features.constructor === Array ? space.features.join(',') : '',
        _a;
}
function SpaceVariablesToSpaceInterface(variables) {
    var features = variables[SpaceVars.SpaceFeatures]
        ? variables[SpaceVars.SpaceFeatures].split(',')
        : [];
    return {
        id: variables[SpaceVars.SpaceId] || '',
        name: variables[SpaceVars.SpaceName] || '',
        dimensions: variables[SpaceVars.SpaceDimensions] || '',
        costLow: String(variables[SpaceVars.SpaceRate]) || '',
        costHigh: String(variables[SpaceVars.SpaceRate]) || '',
        hasClimateControl: variables[SpaceVars.SpaceHasClimateControl] === '1' ||
            features.includes(SpaceFeature.CLIMATE_CONTROL),
        isInside: variables[SpaceVars.SpaceIsInside] === '1' || features.includes(SpaceFeature.INSIDE),
        hasPower: variables[SpaceVars.SpaceHasPower] === '1' || features.includes(SpaceFeature.POWER),
        floor: Number(variables[SpaceVars.SpaceFloor] || '0'),
        isParking: variables[SpaceVars.SpaceIsParking] === '1' || features.includes(SpaceFeature.PARKING),
        isDriveUp: variables[SpaceVars.SpaceIsDriveUp] === '1' || features.includes(SpaceFeature.DRIVE_UP),
        hasElevatorAccess: variables[SpaceVars.SpaceHasElevatorAccess] === '1' ||
            features.includes(SpaceFeature.ELEVATOR_ACCESS),
        hasAlarm: variables[SpaceVars.SpaceHasAlarm] === '1' || features.includes(SpaceFeature.ALARM),
        type: variables[SpaceVars.SpaceIsParking] === '1' ? SpaceType.PARKING : SpaceType.STORAGE_UNIT,
        features: variables[SpaceVars.SpaceFeatures] ? features : []
    };
}
var AccessCodeRequestResponseStatus;
(function (AccessCodeRequestResponseStatus) {
    AccessCodeRequestResponseStatus["SUCCESS"] = "success";
    AccessCodeRequestResponseStatus["FAILURE"] = "failure";
    AccessCodeRequestResponseStatus["MISSING_PARAMS"] = "missing params";
})(AccessCodeRequestResponseStatus || (AccessCodeRequestResponseStatus = {}));
var TenantAccountStatus;
(function (TenantAccountStatus) {
    TenantAccountStatus["ACTIVE"] = "active";
    TenantAccountStatus["PAST_DUE"] = "past due";
    TenantAccountStatus["INACTIVE"] = "inactive";
    TenantAccountStatus["UNKNOWN"] = "unknown";
})(TenantAccountStatus || (TenantAccountStatus = {}));
var TenantAccountPaymentStatus;
(function (TenantAccountPaymentStatus) {
    TenantAccountPaymentStatus["PAST_DUE"] = "past due";
    TenantAccountPaymentStatus["UNKNOWN"] = "unknown";
})(TenantAccountPaymentStatus || (TenantAccountPaymentStatus = {}));
var GetTenantResponseStatus;
(function (GetTenantResponseStatus) {
    GetTenantResponseStatus["SUCCESS"] = "success";
    GetTenantResponseStatus["FAILURE"] = "failure";
    GetTenantResponseStatus["MISSING_PARAMS"] = "missing params";
    GetTenantResponseStatus["MULTIPLE_TENANTS"] = "multiple tenants";
    GetTenantResponseStatus["NOT_FOUND"] = "not found";
})(GetTenantResponseStatus || (GetTenantResponseStatus = {}));
var FMSCreateLeadStatus;
(function (FMSCreateLeadStatus) {
    FMSCreateLeadStatus["SUCCESS"] = "success";
    FMSCreateLeadStatus["FAILURE"] = "failure";
    FMSCreateLeadStatus["DUPLICATE"] = "duplicate";
})(FMSCreateLeadStatus || (FMSCreateLeadStatus = {}));

var TaskStatus;
(function (TaskStatus) {
    TaskStatus["PENDING"] = "pending";
    TaskStatus["STARTED"] = "started";
    TaskStatus["COMPLETED"] = "completed";
    TaskStatus["FAILED"] = "failed";
})(TaskStatus || (TaskStatus = {}));

var StoreFinderTableType;
(function (StoreFinderTableType) {
    StoreFinderTableType["Normal"] = "normal";
    StoreFinderTableType["StoreFinder"] = "store finder";
})(StoreFinderTableType || (StoreFinderTableType = {}));
var StoreFinderTableColumnType;
(function (StoreFinderTableColumnType) {
    StoreFinderTableColumnType["Text"] = "text";
    StoreFinderTableColumnType["Boolean"] = "boolean";
    StoreFinderTableColumnType["StoreFinder"] = "store finder";
    StoreFinderTableColumnType["GoogleLocation"] = "google location";
    StoreFinderTableColumnType["CountryCode"] = "country code";
})(StoreFinderTableColumnType || (StoreFinderTableColumnType = {}));
/*
THESE ARE REDUNDANT AND CAN BE REPLACED ONCE FUTURE IS LAUNCHED

*/
var LookupTableType;
(function (LookupTableType) {
    LookupTableType["Normal"] = "normal";
    LookupTableType["StoreFinder"] = "store finder";
})(LookupTableType || (LookupTableType = {}));
var LookupTableColumnType;
(function (LookupTableColumnType) {
    LookupTableColumnType["Text"] = "text";
    LookupTableColumnType["Boolean"] = "boolean";
    LookupTableColumnType["StoreFinder"] = "store finder";
    LookupTableColumnType["GoogleLocation"] = "google location";
})(LookupTableColumnType || (LookupTableColumnType = {}));

var CRMLiteRowStatus;
(function (CRMLiteRowStatus) {
    CRMLiteRowStatus["Pending"] = "Pending";
    CRMLiteRowStatus["InProgress"] = "In Progress";
    CRMLiteRowStatus["Completed"] = "Completed";
    CRMLiteRowStatus["OnHold"] = "On Hold";
    CRMLiteRowStatus["CallBack"] = "Call Back";
})(CRMLiteRowStatus || (CRMLiteRowStatus = {}));

/**
 * This interface represents a user and ther interactions within the system.
 */

var BotVariables;
(function (BotVariables) {
    BotVariables["Bot_Has_Completed_Quick_Start"] = "Bot_Has_Completed_Quick_Start";
    BotVariables["Bot_Operator_Email"] = "Bot_Operator_Email";
    BotVariables["Bot_Operator_Name"] = "Bot_Operator_Name";
    BotVariables["Bot_Operator_Phone"] = "Bot_Operator_Phone";
    BotVariables["Bot_Operator_Website"] = "Bot_Operator_Website";
    BotVariables["Bot_Operator_24HourAccess"] = "Bot_Operator_24HourAccess";
    BotVariables["Bot_Operator_AboutStorageCompanyURL"] = "Bot_Operator_AboutStorageCompanyURL";
    BotVariables["Bot_Operator_Access_GateCode1"] = "Bot_Operator_Access_GateCode1";
    BotVariables["Bot_Operator_Access_GateCode2"] = "Bot_Operator_Access_GateCode2";
    BotVariables["Bot_Operator_Access_GateCode3"] = "Bot_Operator_Access_GateCode3";
    BotVariables["Bot_Operator_Access_GateCode3_Enabled"] = "Bot_Operator_Access_GateCode3_Enabled";
    BotVariables["Bot_Operator_Access_GateCodeIntegration"] = "Bot_Operator_Access_GateCodeIntegration";
    BotVariables["Bot_Operator_AccountLoginPage"] = "Bot_Operator_AccountLoginPage";
    BotVariables["Bot_Operator_AccountLoginURL"] = "Bot_Operator_AccountLoginURL";
    BotVariables["Bot_Operator_Account_PayBill1"] = "Bot_Operator_Account_PayBill1";
    BotVariables["Bot_Operator_Account_PayBill2"] = "Bot_Operator_Account_PayBill2";
    BotVariables["Bot_Operator_Account_PayBill2_Enabled"] = "Bot_Operator_Account_PayBill2_Enabled";
    BotVariables["Bot_Operator_Account_PayBill3"] = "Bot_Operator_Account_PayBill3";
    BotVariables["Bot_Operator_Account_PayBill3_Enabled"] = "Bot_Operator_Account_PayBill3_Enabled";
    BotVariables["Bot_Operator_Account_AutoPay1"] = "Bot_Operator_Account_AutoPay1";
    BotVariables["Bot_Operator_Account_AutoPay2"] = "Bot_Operator_Account_AutoPay2";
    BotVariables["Bot_Operator_Account_AutoPay2_Enabled"] = "Bot_Operator_Account_AutoPay2_Enabled";
    BotVariables["Bot_Operator_Account_CreateLogin1"] = "Bot_Operator_Account_CreateLogin1";
    BotVariables["Bot_Operator_Account_CreateLogin2"] = "Bot_Operator_Account_CreateLogin2";
    BotVariables["Bot_Operator_Account_CreateLogin2_Enabled"] = "Bot_Operator_Account_CreateLogin2_Enabled";
    BotVariables["Bot_Operator_Account_DebtCredit1"] = "Bot_Operator_Account_DebtCredit1";
    BotVariables["Bot_Operator_Account_DebtCredit2"] = "Bot_Operator_Account_DebtCredit2";
    BotVariables["Bot_Operator_Account_DebtCredit2_Enabled"] = "Bot_Operator_Account_DebtCredit2_Enabled";
    BotVariables["Bot_Operator_Account_ForgotUsername1"] = "Bot_Operator_Account_ForgotUsername1";
    BotVariables["Bot_Operator_Account_ForgotUsername2"] = "Bot_Operator_Account_ForgotUsername2";
    BotVariables["Bot_Operator_Account_ForgotUsername2_Enabled"] = "Bot_Operator_Account_ForgotUsername2_Enabled";
    BotVariables["Bot_Operator_Account_GracePeriod1"] = "Bot_Operator_Account_GracePeriod1";
    BotVariables["Bot_Operator_Account_GracePeriod2"] = "Bot_Operator_Account_GracePeriod2";
    BotVariables["Bot_Operator_Account_GracePeriod2_Enabled"] = "Bot_Operator_Account_GracePeriod2_Enabled";
    BotVariables["Bot_Operator_Account_Reservation1"] = "Bot_Operator_Account_Reservation1";
    BotVariables["Bot_Operator_Account_Reservation2"] = "Bot_Operator_Account_Reservation2";
    BotVariables["Bot_Operator_Account_Reservation2_Enabled"] = "Bot_Operator_Account_Reservation2_Enabled";
    BotVariables["Bot_Operator_Account_ResetPassword1"] = "Bot_Operator_Account_ResetPassword1";
    BotVariables["Bot_Operator_Account_ResetPassword2"] = "Bot_Operator_Account_ResetPassword2";
    BotVariables["Bot_Operator_Account_ResetPassword2_Enabled"] = "Bot_Operator_Account_ResetPassword2_Enabled";
    BotVariables["Bot_Operator_Account_UpdateBillingInformation1"] = "Bot_Operator_Account_UpdateBillingInformation1";
    BotVariables["Bot_Operator_Account_UpdateBillingInformation2"] = "Bot_Operator_Account_UpdateBillingInformation2";
    BotVariables["Bot_Operator_Account_UpdateBillingInformation2_Enabled"] = "Bot_Operator_Account_UpdateBillingInformation2_Enabled";
    BotVariables["Bot_Operator_Account_UpdateBillingInformation3"] = "Bot_Operator_Account_UpdateBillingInformation3";
    BotVariables["Bot_Operator_Account_UpdateBillingInformation3_Enabled"] = "Bot_Operator_Account_UpdateBillingInformation3_Enabled";
    BotVariables["Bot_Operator_Account_UpdateContactInformation1"] = "Bot_Operator_Account_UpdateContactInformation1";
    BotVariables["Bot_Operator_Account_UpdateContactInformation2"] = "Bot_Operator_Account_UpdateContactInformation2";
    BotVariables["Bot_Operator_Account_UpdateContactInformation2_Enabled"] = "Bot_Operator_Account_UpdateContactInformation2_Enabled";
    BotVariables["Bot_Operator_Account_PastDue1"] = "Bot_Operator_Account_PastDue1";
    BotVariables["Bot_Operator_Account_PastDue2"] = "Bot_Operator_Account_PastDue2";
    BotVariables["Bot_Operator_Account_PastDue2_Enabled"] = "Bot_Operator_Account_PastDue2_Enabled";
    BotVariables["Bot_Operator_AfterHoursAccess"] = "Bot_Operator_AfterHoursAccess";
    BotVariables["Bot_Operator_AfterHoursEmergencyPhone"] = "Bot_Operator_AfterHoursEmergencyPhone";
    BotVariables["Bot_Operator_Appointment"] = "Bot_Operator_Appointment";
    BotVariables["Bot_Operator_Auctions"] = "Bot_Operator_Auctions";
    BotVariables["Bot_Operator_BotName"] = "Bot_Operator_BotName";
    BotVariables["Bot_Operator_BusinessStorage"] = "Bot_Operator_BusinessStorage";
    BotVariables["Bot_Operator_CareerURL"] = "Bot_Operator_CareerURL";
    BotVariables["Bot_Operator_CareersURL"] = "Bot_Operator_CareersURL";
    BotVariables["Bot_Operator_ChangeDueDate1"] = "Bot_Operator_ChangeDueDate1";
    BotVariables["Bot_Operator_ChangeDueDate2"] = "Bot_Operator_ChangeDueDate2";
    BotVariables["Bot_Operator_ChangeDueDate2_Enabled"] = "Bot_Operator_ChangeDueDate2_Enabled";
    BotVariables["Bot_Operator_ChangeDueDate3"] = "Bot_Operator_ChangeDueDate3";
    BotVariables["Bot_Operator_ChangeDueDate4"] = "Bot_Operator_ChangeDueDate4";
    BotVariables["Bot_Operator_ChangeDueDate4_Enabled"] = "Bot_Operator_ChangeDueDate4_Enabled";
    BotVariables["Bot_Operator_ChangeDueDate5"] = "Bot_Operator_ChangeDueDate5";
    BotVariables["Bot_Operator_ChangeDueDate6"] = "Bot_Operator_ChangeDueDate6";
    BotVariables["Bot_Operator_ChangeDueDate6_Enabled"] = "Bot_Operator_ChangeDueDate6_Enabled";
    BotVariables["Bot_Operator_ChangeDueDate7"] = "Bot_Operator_ChangeDueDate7";
    BotVariables["Bot_Operator_ChangeDueDate8"] = "Bot_Operator_ChangeDueDate8";
    BotVariables["Bot_Operator_ChangeDueDate8_Enabled"] = "Bot_Operator_ChangeDueDate8_Enabled";
    BotVariables["Bot_Operator_ChangeDueDate"] = "Bot_Operator_ChangeDueDate";
    BotVariables["Bot_Operator_ClimateControlName"] = "Bot_Operator_ClimateControlName";
    BotVariables["Bot_Operator_Cost_AdminFee1"] = "Bot_Operator_Cost_AdminFee1";
    BotVariables["Bot_Operator_Cost_AdminFee2"] = "Bot_Operator_Cost_AdminFee2";
    BotVariables["Bot_Operator_Cost_AdminFee2_Enabled"] = "Bot_Operator_Cost_AdminFee2_Enabled";
    BotVariables["Bot_Operator_Cost_Insurance1"] = "Bot_Operator_Cost_Insurance1";
    BotVariables["Bot_Operator_Cost_LateFee1"] = "Bot_Operator_Cost_LateFee1";
    BotVariables["Bot_Operator_Cost_LateFee2"] = "Bot_Operator_Cost_LateFee2";
    BotVariables["Bot_Operator_Cost_LateFee2_Enabled"] = "Bot_Operator_Cost_LateFee2_Enabled";
    BotVariables["Bot_Operator_Cost_RateIncrease1"] = "Bot_Operator_Cost_RateIncrease1";
    BotVariables["Bot_Operator_Cost_RateIncrease2"] = "Bot_Operator_Cost_RateIncrease2";
    BotVariables["Bot_Operator_Cost_RateIncrease2_Enabled"] = "Bot_Operator_Cost_RateIncrease2_Enabled";
    BotVariables["Bot_Operator_Cost_WebRates1"] = "Bot_Operator_Cost_WebRates1";
    BotVariables["Bot_Operator_Cost_WebRates2"] = "Bot_Operator_Cost_WebRates2";
    BotVariables["Bot_Operator_Cost_WebRates2_Enabled"] = "Bot_Operator_Cost_WebRates2_Enabled";
    BotVariables["Bot_Operator_CoveredVehicleStorage"] = "Bot_Operator_CoveredVehicleStorage";
    BotVariables["Bot_Operator_DeliveriesAccepted"] = "Bot_Operator_DeliveriesAccepted";
    BotVariables["Bot_Operator_DiscountCodeDescription"] = "Bot_Operator_DiscountCodeDescription";
    BotVariables["Bot_Operator_DiscountCodeDisplayName"] = "Bot_Operator_DiscountCodeDisplayName";
    BotVariables["Bot_Operator_DiscountCode"] = "Bot_Operator_DiscountCode";
    BotVariables["Bot_Operator_Discount_CustomDisplayName"] = "Bot_Operator_Discount_CustomDisplayName";
    BotVariables["Bot_Operator_Discount_Custom"] = "Bot_Operator_Discount_Custom";
    BotVariables["Bot_Operator_Discount_LongTerm"] = "Bot_Operator_Discount_LongTerm";
    BotVariables["Bot_Operator_Discount_Military"] = "Bot_Operator_Discount_Military";
    BotVariables["Bot_Operator_Discount_Senior"] = "Bot_Operator_Discount_Senior";
    BotVariables["Bot_Operator_Discount_Student"] = "Bot_Operator_Discount_Student";
    BotVariables["Bot_Operator_Dollies"] = "Bot_Operator_Dollies";
    BotVariables["Bot_Operator_Dumpster"] = "Bot_Operator_Dumpster";
    BotVariables["Bot_Operator_Elevators"] = "Bot_Operator_Elevators";
    BotVariables["Bot_Operator_Franchise"] = "Bot_Operator_Franchise";
    BotVariables["Bot_Operator_IndoorVehicleStorage"] = "Bot_Operator_IndoorVehicleStorage";
    BotVariables["Bot_Operator_InsuranceDisplayName"] = "Bot_Operator_InsuranceDisplayName";
    BotVariables["Bot_Operator_InsuranceURL"] = "Bot_Operator_InsuranceURL";
    BotVariables["Bot_Operator_InsuranceWebsiteURL"] = "Bot_Operator_InsuranceWebsiteURL";
    BotVariables["Bot_Operator_InventoryCarousel"] = "Bot_Operator_InventoryCarousel";
    BotVariables["Bot_Operator_Lease_Cancellation1"] = "Bot_Operator_Lease_Cancellation1";
    BotVariables["Bot_Operator_Lease_Cancellation2"] = "Bot_Operator_Lease_Cancellation2";
    BotVariables["Bot_Operator_Lease_Cancellation3"] = "Bot_Operator_Lease_Cancellation3";
    BotVariables["Bot_Operator_Lease_Cancellation3_Enabled"] = "Bot_Operator_Lease_Cancellation3_Enabled";
    BotVariables["Bot_Operator_Lease_Claim1"] = "Bot_Operator_Lease_Claim1";
    BotVariables["Bot_Operator_Lease_Claim2"] = "Bot_Operator_Lease_Claim2";
    BotVariables["Bot_Operator_Lease_Claim2_Enabled"] = "Bot_Operator_Lease_Claim2_Enabled";
    BotVariables["Bot_Operator_Lease_ContractLengths1"] = "Bot_Operator_Lease_ContractLengths1";
    BotVariables["Bot_Operator_Lease_ContractLengths2"] = "Bot_Operator_Lease_ContractLengths2";
    BotVariables["Bot_Operator_Lease_ContractLengths3"] = "Bot_Operator_Lease_ContractLengths3";
    BotVariables["Bot_Operator_Lease_ContractLengths3_Enabled"] = "Bot_Operator_Lease_ContractLengths3_Enabled";
    BotVariables["Bot_Operator_Lease_ContractLengths4"] = "Bot_Operator_Lease_ContractLengths4";
    BotVariables["Bot_Operator_Lease_ContractLengths4_Enabled"] = "Bot_Operator_Lease_ContractLengths4_Enabled";
    BotVariables["Bot_Operator_Lease_Covid"] = "Bot_Operator_Lease_Covid";
    BotVariables["Bot_Operator_Lease_CutLocks"] = "Bot_Operator_Lease_CutLocks";
    BotVariables["Bot_Operator_Lease_FacilityAccess1"] = "Bot_Operator_Lease_FacilityAccess1";
    BotVariables["Bot_Operator_Lease_FacilityAccess2"] = "Bot_Operator_Lease_FacilityAccess2";
    BotVariables["Bot_Operator_Lease_Insurance1"] = "Bot_Operator_Lease_Insurance1";
    BotVariables["Bot_Operator_Lease_Insurance2"] = "Bot_Operator_Lease_Insurance2";
    BotVariables["Bot_Operator_Lease_Insurance3"] = "Bot_Operator_Lease_Insurance3";
    BotVariables["Bot_Operator_Lease_LiveInUnit1"] = "Bot_Operator_Lease_LiveInUnit1";
    BotVariables["Bot_Operator_Lease_LiveInUnit2"] = "Bot_Operator_Lease_LiveInUnit2";
    BotVariables["Bot_Operator_Lease_LiveInUnit2_Enabled"] = "Bot_Operator_Lease_LiveInUnit2_Enabled";
    BotVariables["Bot_Operator_Lease_MoveOutPolicy1"] = "Bot_Operator_Lease_MoveOutPolicy1";
    BotVariables["Bot_Operator_Lease_MoveOutPolicy2"] = "Bot_Operator_Lease_MoveOutPolicy2";
    BotVariables["Bot_Operator_Lease_MoveOutPolicy3"] = "Bot_Operator_Lease_MoveOutPolicy3";
    BotVariables["Bot_Operator_Lease_MoveOutPolicy3_Enabled"] = "Bot_Operator_Lease_MoveOutPolicy3_Enabled";
    BotVariables["Bot_Operator_Lease_Overlock1"] = "Bot_Operator_Lease_Overlock1";
    BotVariables["Bot_Operator_Lease_Overlock2"] = "Bot_Operator_Lease_Overlock2";
    BotVariables["Bot_Operator_Lease_Overlock3"] = "Bot_Operator_Lease_Overlock3";
    BotVariables["Bot_Operator_Lease_Overlock3_Enabled"] = "Bot_Operator_Lease_Overlock3_Enabled";
    BotVariables["Bot_Operator_Lease_Pricing1"] = "Bot_Operator_Lease_Pricing1";
    BotVariables["Bot_Operator_Lease_Pricing2"] = "Bot_Operator_Lease_Pricing2";
    BotVariables["Bot_Operator_Lease_Pricing2_Enabled"] = "Bot_Operator_Lease_Pricing2_Enabled";
    BotVariables["Bot_Operator_Lease_Pricing3"] = "Bot_Operator_Lease_Pricing3";
    BotVariables["Bot_Operator_Lease_Pricing3_Enabled"] = "Bot_Operator_Lease_Pricing3_Enabled";
    BotVariables["Bot_Operator_Lease_Prorate1"] = "Bot_Operator_Lease_Prorate1";
    BotVariables["Bot_Operator_Lease_Prorate2"] = "Bot_Operator_Lease_Prorate2";
    BotVariables["Bot_Operator_Lease_Prorate2_Enabled"] = "Bot_Operator_Lease_Prorate2_Enabled";
    BotVariables["Bot_Operator_Lease_Refunds1"] = "Bot_Operator_Lease_Refunds1";
    BotVariables["Bot_Operator_Lease_Refunds2"] = "Bot_Operator_Lease_Refunds2";
    BotVariables["Bot_Operator_Lease_Refunds2_Enabled"] = "Bot_Operator_Lease_Refunds2_Enabled";
    BotVariables["Bot_Operator_Lease_StorableItems1"] = "Bot_Operator_Lease_StorableItems1";
    BotVariables["Bot_Operator_Lease_StorableItems2"] = "Bot_Operator_Lease_StorableItems2";
    BotVariables["Bot_Operator_Lease_StorableItems2_Enabled"] = "Bot_Operator_Lease_StorableItems2_Enabled";
    BotVariables["Bot_Operator_Lease_StorableItems3"] = "Bot_Operator_Lease_StorableItems3";
    BotVariables["Bot_Operator_Lease_StorableItems3_Enabled"] = "Bot_Operator_Lease_StorableItems3_Enabled";
    BotVariables["Bot_Operator_Lease_UnitTransfer1"] = "Bot_Operator_Lease_UnitTransfer1";
    BotVariables["Bot_Operator_Lease_UnitTransfer2"] = "Bot_Operator_Lease_UnitTransfer2";
    BotVariables["Bot_Operator_Lease_UnitTransfer2_Enabled"] = "Bot_Operator_Lease_UnitTransfer2_Enabled";
    BotVariables["Bot_Operator_LiveChat"] = "Bot_Operator_LiveChat";
    BotVariables["Bot_Operator_Lockers"] = "Bot_Operator_Lockers";
    BotVariables["Bot_Operator_Account_CancelService1"] = "Bot_Operator_Account_CancelService1";
    BotVariables["Bot_Operator_Account_CancelService2"] = "Bot_Operator_Account_CancelService2";
    BotVariables["Bot_Operator_Account_CancelService2_Enabled"] = "Bot_Operator_Account_CancelService2_Enabled";
    BotVariables["Bot_Operator_Move_Dolly1"] = "Bot_Operator_Move_Dolly1";
    BotVariables["Bot_Operator_Move_Dolly2"] = "Bot_Operator_Move_Dolly2";
    BotVariables["Bot_Operator_Move_Dolly2_Enabled"] = "Bot_Operator_Move_Dolly2_Enabled";
    BotVariables["Bot_Operator_Move_KeyAccessLock1"] = "Bot_Operator_Move_KeyAccessLock1";
    BotVariables["Bot_Operator_Move_KeyAccessLock2"] = "Bot_Operator_Move_KeyAccessLock2";
    BotVariables["Bot_Operator_Move_MovingSupplies1"] = "Bot_Operator_Move_MovingSupplies1";
    BotVariables["Bot_Operator_Move_MovingSupplies2"] = "Bot_Operator_Move_MovingSupplies2";
    BotVariables["Bot_Operator_Move_MovingSupplies2_Enabled"] = "Bot_Operator_Move_MovingSupplies2_Enabled";
    BotVariables["Bot_Operator_Move_MovingTruck1"] = "Bot_Operator_Move_MovingTruck1";
    BotVariables["Bot_Operator_Move_MovingTruck2"] = "Bot_Operator_Move_MovingTruck2";
    BotVariables["Bot_Operator_Move_MovingTruck2_Enabled"] = "Bot_Operator_Move_MovingTruck2_Enabled";
    BotVariables["Bot_Operator_Move_Tour1"] = "Bot_Operator_Move_Tour1";
    BotVariables["Bot_Operator_MovingServices"] = "Bot_Operator_MovingServices";
    BotVariables["Bot_Operator_MovingTruck"] = "Bot_Operator_MovingTruck";
    BotVariables["Bot_Operator_Notary"] = "Bot_Operator_Notary";
    BotVariables["Bot_Operator_OutdoorVehicleStorage"] = "Bot_Operator_OutdoorVehicleStorage";
    BotVariables["Bot_Operator_OutdoorVehicleStorage1"] = "Bot_Operator_OutdoorVehicleStorage1";
    //Bot_Operator_OutsideBusiness_FollowUpHRs =              "Bot_Operator_OutsideBusiness_FollowUpHRs",
    BotVariables["Bot_Operator_PackingSupplies"] = "Bot_Operator_PackingSupplies";
    BotVariables["Bot_Operator_PayOnlineURL"] = "Bot_Operator_PayOnlineURL";
    BotVariables["Bot_Operator_PayOnline"] = "Bot_Operator_PayOnline";
    BotVariables["Bot_Operator_PayByPhoneNumber"] = "Bot_Operator_PayByPhoneNumber";
    BotVariables["Bot_Operator_PreferredContactMethod"] = "Bot_Operator_PreferredContactMethod";
    BotVariables["Bot_Operator_ProblemResolutionChannel"] = "Bot_Operator_ProblemResolutionChannel";
    BotVariables["Bot_Operator_Problem_BillingDispute1"] = "Bot_Operator_Problem_BillingDispute1";
    BotVariables["Bot_Operator_Problem_BillingDispute2"] = "Bot_Operator_Problem_BillingDispute2";
    BotVariables["Bot_Operator_Problem_BillingDispute2_Enabled"] = "Bot_Operator_Problem_BillingDispute2_Enabled";
    BotVariables["Bot_Operator_Problem_DamagedItems1"] = "Bot_Operator_Problem_DamagedItems1";
    BotVariables["Bot_Operator_Problem_DamagedItems2"] = "Bot_Operator_Problem_DamagedItems2";
    BotVariables["Bot_Operator_Problem_DamagedItems2_Enabled"] = "Bot_Operator_Problem_DamagedItems2_Enabled";
    BotVariables["Bot_Operator_Problem_Emergency1"] = "Bot_Operator_Problem_Emergency1";
    BotVariables["Bot_Operator_Problem_Emergency2"] = "Bot_Operator_Problem_Emergency2";
    BotVariables["Bot_Operator_Problem_Emergency2_Enabled"] = "Bot_Operator_Problem_Emergency2_Enabled";
    BotVariables["Bot_Operator_Problem_GetOut1"] = "Bot_Operator_Problem_GetOut1";
    BotVariables["Bot_Operator_Problem_GetOut2"] = "Bot_Operator_Problem_GetOut2";
    BotVariables["Bot_Operator_Problem_GetOut2_Enabled"] = "Bot_Operator_Problem_GetOut2_Enabled";
    BotVariables["Bot_Operator_Problem_Theft1"] = "Bot_Operator_Problem_Theft1";
    BotVariables["Bot_Operator_Problem_Theft2"] = "Bot_Operator_Problem_Theft2";
    BotVariables["Bot_Operator_Problem_Theft2_Enabled"] = "Bot_Operator_Problem_Theft2_Enabled";
    BotVariables["Bot_Operator_Problem_WebIssue1"] = "Bot_Operator_Problem_WebIssue1";
    BotVariables["Bot_Operator_Problem_WebIssue2"] = "Bot_Operator_Problem_WebIssue2";
    BotVariables["Bot_Operator_Problem_WebIssue2_Enabled"] = "Bot_Operator_Problem_WebIssue2_Enabled";
    BotVariables["Bot_Operator_Problem_LostKey1"] = "Bot_Operator_Problem_LostKey1";
    BotVariables["Bot_Operator_Problem_LostKey2"] = "Bot_Operator_Problem_LostKey2";
    BotVariables["Bot_Operator_Problem_LostKey2_Enabled"] = "Bot_Operator_Problem_LostKey2_Enabled";
    BotVariables["Bot_Operator_Purchase_Franchise1"] = "Bot_Operator_Purchase_Franchise1";
    BotVariables["Bot_Operator_Purchase_Franchise2"] = "Bot_Operator_Purchase_Franchise2";
    BotVariables["Bot_Operator_Purchase_Franchise2_Enabled"] = "Bot_Operator_Purchase_Franchise2_Enabled";
    BotVariables["Bot_Operator_Purchase_Identification1"] = "Bot_Operator_Purchase_Identification1";
    BotVariables["Bot_Operator_Purchase_MonthlyPayments1"] = "Bot_Operator_Purchase_MonthlyPayments1";
    BotVariables["Bot_Operator_Purchase_MonthlyPayments2"] = "Bot_Operator_Purchase_MonthlyPayments2";
    BotVariables["Bot_Operator_Purchase_MonthlyPayments2_Enabled"] = "Bot_Operator_Purchase_MonthlyPayments2_Enabled";
    BotVariables["Bot_Operator_Purchase_PayOnline1"] = "Bot_Operator_Purchase_PayOnline1";
    BotVariables["Bot_Operator_Purchase_PayOnline2"] = "Bot_Operator_Purchase_PayOnline2";
    BotVariables["Bot_Operator_Purchase_PayOnline2_Enabled"] = "Bot_Operator_Purchase_PayOnline2_Enabled";
    BotVariables["Bot_Operator_Purchase_PaymentOptions1"] = "Bot_Operator_Purchase_PaymentOptions1";
    BotVariables["Bot_Operator_Purchase_PaymentOptions2"] = "Bot_Operator_Purchase_PaymentOptions2";
    BotVariables["Bot_Operator_Purchase_PaymentOptions2_Enabled"] = "Bot_Operator_Purchase_PaymentOptions2_Enabled";
    BotVariables["Bot_Operator_SizeVisualsURL"] = "Bot_Operator_SizeVisualsURL";
    BotVariables["Bot_Operator_StandardCeilingHeight"] = "Bot_Operator_StandardCeilingHeight";
    BotVariables["Bot_Operator_URLFormatLocations"] = "Bot_Operator_URLFormatLocations";
    BotVariables["Bot_Operator_VehicleStorageGuidelines1"] = "Bot_Operator_VehicleStorageGuidelines1";
    BotVariables["Bot_Operator_VehicleStorageGuidelines2"] = "Bot_Operator_VehicleStorageGuidelines2";
    BotVariables["Bot_Operator_VehicleStorageGuidelines3"] = "Bot_Operator_VehicleStorageGuidelines3";
    BotVariables["Bot_Operator_VehicleStorageGuidelines3_Enabled"] = "Bot_Operator_VehicleStorageGuidelines3_Enabled";
    BotVariables["Bot_Operator_VehicleStorageGuidelines4"] = "Bot_Operator_VehicleStorageGuidelines4";
    BotVariables["Bot_Operator_VehicleStorageGuidelines4_Enabled"] = "Bot_Operator_VehicleStorageGuidelines4_Enabled";
    BotVariables["Bot_Operator_swivlCRM"] = "Bot_Operator_swivlCRM";
    //Bot_Store_ElectricityInUnit =                           "Bot_Store_ElectricityInUnit", //DELETE ME IF 1.7 works
    //Bot_Store_Elevator =                                    "Bot_Store_Elevator",//DELETE ME IF 1.7 works
    //Bot_Store_Internet =                                    "Bot_Store_Internet",//DELETE ME IF 1.7 works
    //Bot_Store_Shelving =                                    "Bot_Store_Shelving",//DELETE ME IF 1.7 works
    BotVariables["Bot_Operator_ClimateControlLowValue"] = "Bot_Operator_ClimateControlLowValue";
    BotVariables["Bot_Operator_ClimateControlHighValue"] = "Bot_Operator_ClimateControlHighValue";
    BotVariables["Bot_Operator_ClimateControl"] = "Bot_Operator_ClimateControl";
    BotVariables["Bot_Operator_HumidityControl"] = "Bot_Operator_HumidityControl";
    BotVariables["Bot_Operator_HumidityControlLowValue"] = "Bot_Operator_HumidityControlLowValue";
    BotVariables["Bot_Operator_HumidityControlHighValue"] = "Bot_Operator_HumidityControlHighValue";
    BotVariables["Bot_Operator_Feature_Security1"] = "Bot_Operator_Feature_Security1";
    BotVariables["Bot_Operator_Feature_MaintenancePest1"] = "Bot_Operator_Feature_MaintenancePest1";
    BotVariables["Bot_Operator_Feature_MaintenancePest2"] = "Bot_Operator_Feature_MaintenancePest2";
    BotVariables["Bot_Operator_Feature_MaintenancePest2_Enabled"] = "Bot_Operator_Feature_MaintenancePest2_Enabled";
    BotVariables["Bot_Operator_Feature_Lights1"] = "Bot_Operator_Feature_Lights1";
    BotVariables["Bot_Operator_Feature_Auction1"] = "Bot_Operator_Feature_Auction1";
    BotVariables["Bot_Operator_Auctions_URL"] = "Bot_Operator_Auctions_URL";
    BotVariables["Bot_Operator_ExtraLargeUnit"] = "Bot_Operator_ExtraLargeUnit";
    BotVariables["Bot_Operator_FMS"] = "Bot_Operator_FMS";
    BotVariables["Bot_Operator_WhichFMS"] = "Bot_Operator_WhichFMS";
    BotVariables["Bot_Operator_OutdoorParking1"] = "Bot_Operator_OutdoorParking1";
    BotVariables["Bot_Operator_Lease_HoldUnit1"] = "Bot_Operator_Lease_HoldUnit1";
    BotVariables["Bot_Operator_Lease_HoldUnit2"] = "Bot_Operator_Lease_HoldUnit2";
    BotVariables["Bot_Operator_Lease_HoldUnit2_Enabled"] = "Bot_Operator_Lease_HoldUnit2_Enabled";
    BotVariables["Bot_Operator_Lease_WorkIn1"] = "Bot_Operator_Lease_WorkIn1";
    BotVariables["Bot_Operator_Lease_WorkIn2"] = "Bot_Operator_Lease_WorkIn2";
    BotVariables["Bot_Operator_Lease_WorkIn2_Enabled"] = "Bot_Operator_Lease_WorkIn2_Enabled";
    BotVariables["Bot_Operator_Lease_LateFeeAmount"] = "Bot_Operator_Lease_LateFeeAmount";
    BotVariables["Bot_Operator_Lease_AdminFeeAmount"] = "Bot_Operator_Lease_AdminFeeAmount";
    BotVariables["Bot_Operator_Feature_HasRecycle"] = "Bot_Operator_Feature_HasRecycle";
    BotVariables["Bot_Operator_Recycle_URL"] = "Bot_Operator_Recycle_URL";
    BotVariables["Bot_Operator_swivl_SendLeadEmail"] = "Bot_Operator_swivl_SendLeadEmail";
    BotVariables["Bot_Operator_swivl_LeadEmailList"] = "Bot_Operator_swivl_LeadEmailList";
    BotVariables["Bot_Operator_swivl_CodaDocID"] = "Bot_Operator_swivl_CodaDocID";
    BotVariables["Bot_Operator_swivl_CodaTableID"] = "Bot_Operator_swivl_CodaTableID";
    BotVariables["Bot_Operator_TwoUnhandledBeforeEscalation"] = "Bot_Operator_TwoUnhandledBeforeEscalation";
    /* -------------------------
        New For 1.3
    ------------------------- */
    BotVariables["Bot_Operator_WelcomeLeadCollect"] = "Bot_Operator_WelcomeLeadCollect";
    BotVariables["Bot_Operator_HasPreferredContactMethod"] = "Bot_Operator_HasPreferredContactMethod";
    BotVariables["Bot_Operator_Feature_WonAuction1"] = "Bot_Operator_Feature_WonAuction1";
    BotVariables["Bot_Operator_Feature_WonAuction2"] = "Bot_Operator_Feature_WonAuction2";
    BotVariables["Bot_Operator_Feature_WonAuction2_Enabled"] = "Bot_Operator_Feature_WonAuction2_Enabled";
    /* -------------------------
        Voice Workflow Variables
    ------------------------- */
    BotVariables["Bot_Operator_swivl_HasVoice"] = "Bot_Operator_swivl_HasVoice";
    BotVariables["Bot_Operator_Voice_SalesForward"] = "Bot_Operator_Voice_SalesForward";
    BotVariables["Bot_Operator_Voice_ServiceForward"] = "Bot_Operator_Voice_ServiceForward";
    BotVariables["Bot_Operator_Voice_SendPayBillText"] = "Bot_Operator_Voice_SendPayBillText";
    BotVariables["Bot_Operator_Voice_PayBillText_Message"] = "Bot_Operator_Voice_PayBillText_Message";
    BotVariables["Bot_Operator_Voice_SendAfterHoursSalesText"] = "Bot_Operator_Voice_SendAfterHoursSalesText";
    BotVariables["Bot_Operator_Voice_AfterHoursSalesText_Message1"] = "Bot_Operator_Voice_AfterHoursSalesText_Message1";
    BotVariables["Bot_Operator_Voice_AfterHoursSalesText_Message2"] = "Bot_Operator_Voice_AfterHoursSalesText_Message2";
    BotVariables["Bot_Operator_Voice_isDuringBusinesHours"] = "Bot_Operator_Voice_isDuringBusinesHours";
    BotVariables["Bot_Operator_Voice_isLiveEscalationsAvailable"] = "Bot_Operator_Voice_isLiveEscalationsAvailable";
    BotVariables["Bot_Operator_Voice_isCallForward_TTH"] = "Bot_Operator_Voice_isCallForward_TTH";
    BotVariables["Bot_Operator_Voice_isCallForward_GHA"] = "Bot_Operator_Voice_isCallForward_GHA";
    BotVariables["Bot_Operator_Voice_isCallForward_USF"] = "Bot_Operator_Voice_isCallForward_USF";
    BotVariables["Bot_Operator_Voice_isCallForward_USS"] = "Bot_Operator_Voice_isCallForward_USS";
    BotVariables["Bot_Operator_Voice_isCallForward_UC"] = "Bot_Operator_Voice_isCallForward_UC";
    BotVariables["Bot_Operator_Voice_isCallForward_UPP"] = "Bot_Operator_Voice_isCallForward_UPP";
    BotVariables["Bot_Operator_Voice_isCallForward_MA"] = "Bot_Operator_Voice_isCallForward_MA";
    BotVariables["Bot_Operator_Voice_isCallForward_Hours"] = "Bot_Operator_Voice_isCallForward_Hours";
    BotVariables["Bot_Operator_Voice_isCallForward_RAP"] = "Bot_Operator_Voice_isCallForward_RAP";
    BotVariables["Bot_Operator_Voice_isCallForward_Inventory"] = "Bot_Operator_Voice_isCallForward_Inventory";
    BotVariables["Bot_Operator_Voice_isCallForward_Discount"] = "Bot_Operator_Voice_isCallForward_Discount";
    BotVariables["Bot_Operator_Voice_isCallForward_UMP"] = "Bot_Operator_Voice_isCallForward_UMP";
    BotVariables["Bot_Operator_Voice_isCallForward_Location"] = "Bot_Operator_Voice_isCallForward_Location";
    BotVariables["Bot_Operator_Voice_isCallForward_ULT"] = "Bot_Operator_Voice_isCallForward_ULT";
    BotVariables["Bot_Operator_Voice_ForwardNumber_TTH"] = "Bot_Operator_Voice_ForwardNumber_TTH";
    BotVariables["Bot_Operator_Voice_ForwardNumber_GHA"] = "Bot_Operator_Voice_ForwardNumber_GHA";
    BotVariables["Bot_Operator_Voice_ForwardNumber_USF"] = "Bot_Operator_Voice_ForwardNumber_USF";
    BotVariables["Bot_Operator_Voice_ForwardNumber_USS"] = "Bot_Operator_Voice_ForwardNumber_USS";
    BotVariables["Bot_Operator_Voice_ForwardNumber_UC"] = "Bot_Operator_Voice_ForwardNumber_UC";
    BotVariables["Bot_Operator_Voice_ForwardNumber_UPP"] = "Bot_Operator_Voice_ForwardNumber_UPP";
    BotVariables["Bot_Operator_Voice_ForwardNumber_MA"] = "Bot_Operator_Voice_ForwardNumber_MA";
    BotVariables["Bot_Operator_Voice_ForwardNumber_Hours"] = "Bot_Operator_Voice_ForwardNumber_Hours";
    BotVariables["Bot_Operator_Voice_ForwardNumber_RAP"] = "Bot_Operator_Voice_ForwardNumber_RAP";
    BotVariables["Bot_Operator_Voice_ForwardNumber_Inventory"] = "Bot_Operator_Voice_ForwardNumber_Inventory";
    BotVariables["Bot_Operator_Voice_ForwardNumber_Discount"] = "Bot_Operator_Voice_ForwardNumber_Discount";
    BotVariables["Bot_Operator_Voice_ForwardNumber_UMP"] = "Bot_Operator_Voice_ForwardNumber_UMP";
    BotVariables["Bot_Operator_Voice_ForwardNumber_Location"] = "Bot_Operator_Voice_ForwardNumber_Location";
    BotVariables["Bot_Operator_Voice_ForwardNumber_ULT"] = "Bot_Operator_Voice_ForwardNumber_ULT";
    BotVariables["Bot_User_Voice_IsProfileSet"] = "Bot_User_Voice_IsProfileSet";
    BotVariables["Bot_Operator_Admin_ZipCollectQuestSlug"] = "Bot_Operator_Admin_ZipCollectQuestSlug";
    BotVariables["Bot_Operator_Voice_Problem_GetOut"] = "Bot_Operator_Voice_Problem_GetOut";
    BotVariables["Bot_Operator_Voice_Problem_BillingIssue"] = "Bot_Operator_Voice_Problem_BillingIssue";
    BotVariables["Bot_Operator_Voice_Problem_Emergency"] = "Bot_Operator_Voice_Problem_Emergency";
    BotVariables["Bot_Operator_Voice_Problem_LostKey"] = "Bot_Operator_Voice_Problem_LostKey";
    BotVariables["Bot_Operator_Voice_Problem_Theft"] = "Bot_Operator_Voice_Problem_Theft";
    BotVariables["Bot_Operator_Voice_Problem_WebIssue"] = "Bot_Operator_Voice_Problem_WebIssue";
    BotVariables["Bot_Operator_Voice_Problem_DamageItem"] = "Bot_Operator_Voice_Problem_DamageItem";
    BotVariables["Bot_Operator_Voice_Account_CRUDInformation"] = "Bot_Operator_Voice_Account_CRUDInformation";
    BotVariables["Bot_Operator_Voice_Account_Cancel"] = "Bot_Operator_Voice_Account_Cancel";
    BotVariables["Bot_Operator_Voice_Account_PayBill"] = "Bot_Operator_Voice_Account_PayBill";
    BotVariables["Bot_Operator_Voice_Access_GateCode"] = "Bot_Operator_Voice_Access_GateCode";
    BotVariables["Bot_Operator_Voice_Lease_Pricing"] = "Bot_Operator_Voice_Lease_Pricing";
    BotVariables["Bot_Operator_Voice_Lease_StorableItems"] = "Bot_Operator_Voice_Lease_StorableItems";
    BotVariables["Bot_Operator_Voice_Lease_ContractLengths"] = "Bot_Operator_Voice_Lease_ContractLengths";
    BotVariables["Bot_Operator_Voice_Lease_FacilityAccess"] = "Bot_Operator_Voice_Lease_FacilityAccess";
    BotVariables["Bot_Operator_Voice_Lease_Refunds"] = "Bot_Operator_Voice_Lease_Refunds";
    BotVariables["Bot_Operator_Voice_Lease_Prorate"] = "Bot_Operator_Voice_Lease_Prorate";
    BotVariables["Bot_Operator_Voice_Lease_Insurance"] = "Bot_Operator_Voice_Lease_Insurance";
    BotVariables["Bot_Operator_Voice_Lease_Claim"] = "Bot_Operator_Voice_Lease_Claim";
    BotVariables["Bot_Operator_Voice_Lease_Covid"] = "Bot_Operator_Voice_Lease_Covid";
    BotVariables["Bot_Operator_Voice_Lease_CutLocks"] = "Bot_Operator_Voice_Lease_CutLocks";
    BotVariables["Bot_Operator_Voice_Lease_OverLocks"] = "Bot_Operator_Voice_Lease_OverLocks";
    BotVariables["Bot_Operator_Voice_Lease_LiveInUnit"] = "Bot_Operator_Voice_Lease_LiveInUnit";
    BotVariables["Bot_Operator_Voice_Lease_Cancellation"] = "Bot_Operator_Voice_Lease_Cancellation";
    BotVariables["Bot_Operator_Voice_Lease_MoveOutPolicy"] = "Bot_Operator_Voice_Lease_MoveOutPolicy";
    BotVariables["Bot_Operator_Voice_Lease_UnitTransfer"] = "Bot_Operator_Voice_Lease_UnitTransfer";
    BotVariables["Bot_Operator_Voice_Lease_HoldUnit"] = "Bot_Operator_Voice_Lease_HoldUnit";
    BotVariables["Bot_Operator_Voice_Lease_WorkIn"] = "Bot_Operator_Voice_Lease_WorkIn";
    /* -------------------------
        SMS Workflow Variables
    ------------------------- */
    BotVariables["Bot_Operator_swivl_HasSMS"] = "Bot_Operator_swivl_HasSMS";
    /* -------------------------
        New For 1.4
    ------------------------- */
    // //Bot_Operator_Lead_hasSentEmailReceipt is a 1 if it email receipt has already been sent to improve duplicate leads DELETE ME IF 1.4 WORKS
    // Bot_User_Lead_hasSentEmailReceipt =                     "Bot_User_Lead_hasSentEmailReceipt",DELETE ME IF 1.4 WORKS 
    // //Bot_Operator_Lead_hasSentToFMS is a 1 if it has been sent to FMS to improve duplicate leads DELETE ME IF 1.4 WORKS
    // Bot_User_Lead_hasSentToFMS =                            "Bot_User_Lead_hasSentToFMS", DELETE ME IF 1.4 WORKS
    BotVariables["Bot_Operator_FMS_isLeadSent_Tag_Escalation"] = "Bot_Operator_FMS_isLeadSent_Tag_Escalation";
    BotVariables["Bot_Operator_FMS_isLeadSent_Tag_Waitlist"] = "Bot_Operator_FMS_isLeadSent_Tag_Waitlist";
    BotVariables["Bot_Operator_FMS_isLeadSent_Tag_Sales"] = "Bot_Operator_FMS_isLeadSent_Tag_Sales";
    BotVariables["Bot_Operator_FMS_isLeadSent_Tag_Service"] = "Bot_Operator_FMS_isLeadSent_Tag_Service";
    BotVariables["Bot_Operator_FMS_isLeadSent_Tag_Contact"] = "Bot_Operator_FMS_isLeadSent_Tag_Contact";
    BotVariables["Bot_Operator_FMS_isLeadSent_Tag_Problem"] = "Bot_Operator_FMS_isLeadSent_Tag_Problem";
    BotVariables["Bot_Operator_FMS_isLeadSent_Tag_Unknown"] = "Bot_Operator_FMS_isLeadSent_Tag_Unknown";
    BotVariables["Bot_Operator_FMS_isLeadSent_Persona_Potential"] = "Bot_Operator_FMS_isLeadSent_Persona_Potential";
    BotVariables["Bot_Operator_FMS_isLeadSent_Persona_Existing"] = "Bot_Operator_FMS_isLeadSent_Persona_Existing";
    BotVariables["Bot_Operator_FMS_isLeadSent_Persona_Unknown"] = "Bot_Operator_FMS_isLeadSent_Persona_Unknown";
    BotVariables["Bot_Operator_hasSingleLocation"] = "Bot_Operator_hasSingleLocation";
    // Bot_User_Review_NPSScore =                              "Bot_User_Review_NPSScore",  DELETE ME IF 1.4 WORKS
    // Bot_User_Review_NPSFeedback =                           "Bot_User_Review_NPSFeedback", DELETE ME IF 1.4 WORKS
    // Bot_User_Review_NPSTopic =                              "Bot_User_Review_NPSTopic", DELETE ME IF 1.4 WORKS
    BotVariables["Bot_Operator_Feature_MovingServices1"] = "Bot_Operator_Feature_MovingServices1";
    BotVariables["Bot_Operator_Feature_MovingServices2"] = "Bot_Operator_Feature_MovingServices2";
    BotVariables["Bot_Operator_Feature_MovingServices2_Enabled"] = "Bot_Operator_Feature_MovingServices2_Enabled";
    BotVariables["Bot_Operator_Cost_CreditCardFee1"] = "Bot_Operator_Cost_CreditCardFee1";
    BotVariables["Bot_Operator_Cost_CreditCardFee2"] = "Bot_Operator_Cost_CreditCardFee2";
    BotVariables["Bot_Operator_Cost_CreditCardFee2_Enabled"] = "Bot_Operator_Cost_CreditCardFee2_Enabled";
    BotVariables["Bot_Operator_swivl_HasGoogleReviews"] = "Bot_Operator_swivl_HasGoogleReviews";
    //CTA Variables
    BotVariables["Bot_Operator_CTA_hasCustomMessage"] = "Bot_Operator_CTA_hasCustomMessage";
    BotVariables["Bot_Operator_CTA_Message1"] = "Bot_Operator_CTA_Message1";
    BotVariables["Bot_Operator_CTA_Message2"] = "Bot_Operator_CTA_Message2";
    BotVariables["Bot_Operator_CTA_Message2_Enabled"] = "Bot_Operator_CTA_Message2_Enabled";
    BotVariables["Bot_Operator_CTA_Message3"] = "Bot_Operator_CTA_Message3";
    BotVariables["Bot_Operator_CTA_Message3_Enabled"] = "Bot_Operator_CTA_Message3_Enabled";
    BotVariables["Bot_Operator_CTA_hasURLNavigateTo"] = "Bot_Operator_CTA_hasURLNavigateTo";
    BotVariables["Bot_Operator_CTA_URLNavigateTo"] = "Bot_Operator_CTA_URLNavigateTo";
    BotVariables["Bot_Operator_CTA_URLNavigateToMessage1"] = "Bot_Operator_CTA_URLNavigateToMessage1";
    /* -------------------------
        New For 1.5
    ------------------------- */
    BotVariables["Bot_Operator_WebsiteProvider"] = "Bot_Operator_WebsiteProvider";
    BotVariables["Bot_Operator_Discount_Military1"] = "Bot_Operator_Discount_Military1";
    BotVariables["Bot_Operator_Discount_Student1"] = "Bot_Operator_Discount_Student1";
    BotVariables["Bot_Operator_Discount_Senior1"] = "Bot_Operator_Discount_Senior1";
    BotVariables["Bot_Operator_Discount_LongTerm1"] = "Bot_Operator_Discount_LongTerm1";
    BotVariables["Bot_Operator_Discount_CustomDiscount1"] = "Bot_Operator_Discount_CustomDiscount1";
    BotVariables["Bot_Operator_hasWineStorage"] = "Bot_Operator_hasWineStorage";
    BotVariables["Bot_Operator_Feature_WineStorage1"] = "Bot_Operator_Feature_WineStorage1";
    BotVariables["Bot_Operator_Feature_WineStorage2"] = "Bot_Operator_Feature_WineStorage2";
    BotVariables["Bot_Operator_Feature_WineStorage2_Enabled"] = "Bot_Operator_Feature_WineStorage2_Enabled";
    BotVariables["Bot_Operator_ChangeDueDate_Selection"] = "Bot_Operator_ChangeDueDate_Selection";
    BotVariables["Bot_Operator_Lead_EnableDuplicates"] = "Bot_Operator_Lead_EnableDuplicates";
    BotVariables["Bot_Operator_Feature_hasShred"] = "Bot_Operator_Feature_hasShred";
    BotVariables["Bot_Operator_Shred_URL"] = "Bot_Operator_Shred_URL";
    BotVariables["Bot_Operator_hasSizeGuideURL"] = "Bot_Operator_hasSizeGuideURL";
    BotVariables["Bot_Operator_hasAboutURL"] = "Bot_Operator_hasAboutURL";
    BotVariables["Bot_Operator_hasReferralProgram"] = "Bot_Operator_hasReferralProgram";
    BotVariables["Bot_Operator_ReferralProgramURL"] = "Bot_Operator_ReferralProgramURL";
    BotVariables["Bot_Operator_Feature_Referral1"] = "Bot_Operator_Feature_Referral1";
    BotVariables["Bot_Operator_Feature_Referral2"] = "Bot_Operator_Feature_Referral2";
    BotVariables["Bot_Operator_Feature_Referral2_Enabled"] = "Bot_Operator_Feature_Referral2_Enabled";
    BotVariables["Bot_Operator_ReferralName"] = "Bot_Operator_ReferralName";
    BotVariables["Bot_Operator_ReferralPhone"] = "Bot_Operator_ReferralPhone";
    BotVariables["Bot_Operator_Account_PayBillContinueAutoPay"] = "Bot_Operator_Account_PayBillContinueAutoPay";
    BotVariables["Bot_Operator_Feature_hasDriveUp"] = "Bot_Operator_Feature_hasDriveUp";
    BotVariables["Bot_Operator_Feature_DriveUp1"] = "Bot_Operator_Feature_DriveUp1";
    BotVariables["Bot_Operator_Feature_DriveUp2"] = "Bot_Operator_Feature_DriveUp2";
    BotVariables["Bot_Operator_Feature_DriveUp2_Enabled"] = "Bot_Operator_Feature_DriveUp2_Enabled";
    BotVariables["Bot_Operator_Access_AfterHour1"] = "Bot_Operator_Access_AfterHour1";
    BotVariables["Bot_Operator_Access_AfterHour2"] = "Bot_Operator_Access_AfterHour2";
    BotVariables["Bot_Operator_Access_AfterHour2_Enabled"] = "Bot_Operator_Access_AfterHour2_Enabled";
    BotVariables["Bot_Operator_Feature_ClimateControl1"] = "Bot_Operator_Feature_ClimateControl1";
    BotVariables["Bot_Operator_Feature_ClimateControl2"] = "Bot_Operator_Feature_ClimateControl2";
    BotVariables["Bot_Operator_Feature_ClimateControl2_Enabled"] = "Bot_Operator_Feature_ClimateControl2_Enabled";
    BotVariables["Bot_Operator_FMS_GateCodeChannel"] = "Bot_Operator_FMS_GateCodeChannel";
    BotVariables["Bot_Operator_FMS_GateCodeChannel_SMSMessage"] = "Bot_Operator_FMS_GateCodeChannel_SMSMessage";
    /* -------------------------
        NAVIGATE TO VARIABLES New For 1.5
    ------------------------- */
    BotVariables["Bot_Operator_NavigateTo_Holder"] = "Bot_Operator_NavigateTo_Holder";
    BotVariables["Bot_Operator_AfterNavigate_ShowInventory1"] = "Bot_Operator_AfterNavigate_ShowInventory1";
    BotVariables["Bot_Operator_AfterNavigate_ShowInventory2"] = "Bot_Operator_AfterNavigate_ShowInventory2";
    BotVariables["Bot_Operator_AfterNavigate_ShowInventory2Enabled"] = "Bot_Operator_AfterNavigate_ShowInventory2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_ShowInventory_QuestSlug"] = "Bot_Operator_AfterNavigate_ShowInventory_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SizeVisuals1"] = "Bot_Operator_AfterNavigate_SizeVisuals1";
    BotVariables["Bot_Operator_AfterNavigate_SizeVisuals2"] = "Bot_Operator_AfterNavigate_SizeVisuals2";
    BotVariables["Bot_Operator_AfterNavigate_SizeVisuals2Enabled"] = "Bot_Operator_AfterNavigate_SizeVisuals2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_SizeVisuals_QuestSlug"] = "Bot_Operator_AfterNavigate_SizeVisuals_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_PayBill1"] = "Bot_Operator_AfterNavigate_AccountLogin_PayBill1";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_PayBill2"] = "Bot_Operator_AfterNavigate_AccountLogin_PayBill2";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_PayBill2Enabled"] = "Bot_Operator_AfterNavigate_AccountLogin_PayBill2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_PayBill_QuestSlug"] = "Bot_Operator_AfterNavigate_AccountLogin_PayBill_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Autopay1"] = "Bot_Operator_AfterNavigate_AccountLogin_Autopay1";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Autopay2"] = "Bot_Operator_AfterNavigate_AccountLogin_Autopay2";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Autopay2Enabled"] = "Bot_Operator_AfterNavigate_AccountLogin_Autopay2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Autopay_QuestSlug"] = "Bot_Operator_AfterNavigate_AccountLogin_Autopay_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_CreditDebit1"] = "Bot_Operator_AfterNavigate_AccountLogin_CreditDebit1";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_CreditDebit2"] = "Bot_Operator_AfterNavigate_AccountLogin_CreditDebit2";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_CreditDebit2Enabled"] = "Bot_Operator_AfterNavigate_AccountLogin_CreditDebit2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_CreditDebit_QuestSlug"] = "Bot_Operator_AfterNavigate_AccountLogin_CreditDebit_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Reservations1"] = "Bot_Operator_AfterNavigate_AccountLogin_Reservations1";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Reservations2"] = "Bot_Operator_AfterNavigate_AccountLogin_Reservations2";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Reservations2Enabled"] = "Bot_Operator_AfterNavigate_AccountLogin_Reservations2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Reservations_QuestSlug"] = "Bot_Operator_AfterNavigate_AccountLogin_Reservations_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Password1"] = "Bot_Operator_AfterNavigate_AccountLogin_Password1";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Password2"] = "Bot_Operator_AfterNavigate_AccountLogin_Password2";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Password2Enabled"] = "Bot_Operator_AfterNavigate_AccountLogin_Password2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Password_QuestSlug"] = "Bot_Operator_AfterNavigate_AccountLogin_Password_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_UpdateContact1"] = "Bot_Operator_AfterNavigate_AccountLogin_UpdateContact1";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_UpdateContact2"] = "Bot_Operator_AfterNavigate_AccountLogin_UpdateContact2";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_UpdateContact2Enabled"] = "Bot_Operator_AfterNavigate_AccountLogin_UpdateContact2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_UpdateContact_QuestSlug"] = "Bot_Operator_AfterNavigate_AccountLogin_UpdateContact_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling1"] = "Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling1";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling2"] = "Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling2";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling2Enabled"] = "Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling_QuestSlug"] = "Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_CreateLogin1"] = "Bot_Operator_AfterNavigate_AccountLogin_CreateLogin1";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_CreateLogin2"] = "Bot_Operator_AfterNavigate_AccountLogin_CreateLogin2";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_CreateLogin2Enabled"] = "Bot_Operator_AfterNavigate_AccountLogin_CreateLogin2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_CreateLogin_QuestSlug"] = "Bot_Operator_AfterNavigate_AccountLogin_CreateLogin_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Username1"] = "Bot_Operator_AfterNavigate_AccountLogin_Username1";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Username2"] = "Bot_Operator_AfterNavigate_AccountLogin_Username2";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Username2Enabled"] = "Bot_Operator_AfterNavigate_AccountLogin_Username2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_AccountLogin_Username_QuestSlug"] = "Bot_Operator_AfterNavigate_AccountLogin_Username_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_Referral1"] = "Bot_Operator_AfterNavigate_Referral1";
    BotVariables["Bot_Operator_AfterNavigate_Referral2"] = "Bot_Operator_AfterNavigate_Referral2";
    BotVariables["Bot_Operator_AfterNavigate_Referral2Enabled"] = "Bot_Operator_AfterNavigate_Referral2Enabled";
    BotVariables["Bot_Operator_AfterNavigate_Referral_QuestSlug"] = "Bot_Operator_AfterNavigate_Referral_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_Auction1"] = "Bot_Operator_AfterNavigate_Auction1";
    BotVariables["Bot_Operator_AfterNavigate_Auction2"] = "Bot_Operator_AfterNavigate_Auction2";
    BotVariables["Bot_Operator_AfterNavigate_Auction2_Enabled"] = "Bot_Operator_AfterNavigate_Auction2_Enabled";
    BotVariables["Bot_Operator_AfterNavigate_Auction_QuestSlug"] = "Bot_Operator_AfterNavigate_Auction_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_Careers1"] = "Bot_Operator_AfterNavigate_Careers1";
    BotVariables["Bot_Operator_AfterNavigate_Careers2"] = "Bot_Operator_AfterNavigate_Careers2";
    BotVariables["Bot_Operator_AfterNavigate_Careers2_Enabled"] = "Bot_Operator_AfterNavigate_Careers2_Enabled";
    BotVariables["Bot_Operator_AfterNavigate_Careers_QuestSlug"] = "Bot_Operator_AfterNavigate_Careers_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_Insurance1"] = "Bot_Operator_AfterNavigate_Insurance1";
    BotVariables["Bot_Operator_AfterNavigate_Insurance2"] = "Bot_Operator_AfterNavigate_Insurance2";
    BotVariables["Bot_Operator_AfterNavigate_Insurance2_Enabled"] = "Bot_Operator_AfterNavigate_Insurance2_Enabled";
    BotVariables["Bot_Operator_AfterNavigate_Insurance_QuestSlug"] = "Bot_Operator_AfterNavigate_Insurance_QuestSlug";
    BotVariables["Bot_Operator_wantsProfanityEscalation"] = "Bot_Operator_wantsProfanityEscalation";
    BotVariables["Bot_Operator_wantsOneMenuView"] = "Bot_Operator_wantsOneMenuView";
    BotVariables["Bot_Operator_wantsClearStoreVariables"] = "Bot_Operator_wantsClearStoreVariables";
    BotVariables["Bot_Operator_dontUseURLToSetStore"] = "Bot_Operator_dontUseURLToSetStore";
    /* -------------------------
        Agent Quick Reply VARIABLES New For 1.5
    ------------------------- */
    BotVariables["Bot_Operator_QuickReply_Greeting"] = "Bot_Operator_QuickReply_Greeting";
    BotVariables["Bot_Operator_QuickReply_Closing"] = "Bot_Operator_QuickReply_Closing";
    BotVariables["Bot_Operator_QuickReply_Usage"] = "Bot_Operator_QuickReply_Usage";
    BotVariables["Bot_Operator_QuickReply_Storing"] = "Bot_Operator_QuickReply_Storing";
    BotVariables["Bot_Operator_QuickReply_When"] = "Bot_Operator_QuickReply_When";
    BotVariables["Bot_Operator_QuickReply_PhoneNumber1"] = "Bot_Operator_QuickReply_PhoneNumber1";
    BotVariables["Bot_Operator_QuickReply_PhoneNumber2"] = "Bot_Operator_QuickReply_PhoneNumber2";
    BotVariables["Bot_Operator_QuickReply_Reservation"] = "Bot_Operator_QuickReply_Reservation";
    BotVariables["Bot_Operator_QuickReply_WhatElse"] = "Bot_Operator_QuickReply_WhatElse";
    /* -------------------------
        Review Reply VARIABLES New For 1.6
    ------------------------- */
    BotVariables["Bot_Operator_ReviewReply_5Star"] = "Bot_Operator_ReviewReply_5Star";
    BotVariables["Bot_Operator_ReviewReply_Promoter"] = "Bot_Operator_ReviewReply_Promoter";
    BotVariables["Bot_Operator_ReviewReply_Passive"] = "Bot_Operator_ReviewReply_Passive";
    BotVariables["Bot_Operator_ReviewReply_Detractor"] = "Bot_Operator_ReviewReply_Detractor";
    BotVariables["Bot_Operator_ReviewReply_1Star"] = "Bot_Operator_ReviewReply_1Star";
    /* -------------------------
        Review Reply VARIABLES New For 1.7
    ------------------------- */
    BotVariables["Bot_Operator_ReviewReply_General"] = "Bot_Operator_ReviewReply_General";
    /* -------------------------
        New For 1.6
    ------------------------- */
    BotVariables["Bot_Operator_Temp_FMSName"] = "Bot_Operator_Temp_FMSName";
    BotVariables["Bot_Operator_Temp_FMSEmail"] = "Bot_Operator_Temp_FMSEmail";
    BotVariables["Bot_Operator_Temp_FMSPhone"] = "Bot_Operator_Temp_FMSPhone";
    BotVariables["Bot_Operator_Temp_FMSZip"] = "Bot_Operator_Temp_FMSZip";
    BotVariables["Bot_Operator_hasFMSPlus"] = "Bot_Operator_hasFMSPlus";
    BotVariables["Bot_Operator_hasCronMoveIn"] = "Bot_Operator_hasCronMoveIn";
    BotVariables["Bot_Operator_wantsCronReceipts_MoveIn"] = "Bot_Operator_wantsCronReceipts_MoveIn";
    BotVariables["Bot_Operator_hasCronMoveOut"] = "Bot_Operator_hasCronMoveOut";
    BotVariables["Bot_Operator_wantsCronReceipts_MoveOut"] = "Bot_Operator_wantsCronReceipts_MoveOut";
    BotVariables["Bot_Operator_hasCronPastDuePayment"] = "Bot_Operator_hasCronPastDuePayment";
    BotVariables["Bot_Operator_wantsCronReceipts_PastDuePayments"] = "Bot_Operator_wantsCronReceipts_PastDuePayments";
    BotVariables["Bot_Operator_hasCronPaymentMethodExpired"] = "Bot_Operator_hasCronPaymentMethodExpired";
    BotVariables["Bot_Operator_wantsCronReceipts_PaymentMethodExpired"] = "Bot_Operator_wantsCronReceipts_PaymentMethodExpired";
    BotVariables["Bot_Operator_hasCronUpcomingPayment"] = "Bot_Operator_hasCronUpcomingPayment";
    BotVariables["Bot_Operator_wantsCronReceipts_UpcomingPayment"] = "Bot_Operator_wantsCronReceipts_UpcomingPayment";
    BotVariables["Bot_Operator_hasCronUpdateContactInfo"] = "Bot_Operator_hasCronUpdateContactInfo";
    BotVariables["Bot_Operator_wantsCronReceipts_UpdateContactInfo"] = "Bot_Operator_wantsCronReceipts_UpdateContactInfo";
    BotVariables["Bot_Operator_hasCronPaymentSuccess"] = "Bot_Operator_hasCronPaymentSuccess";
    BotVariables["Bot_Operator_wantsCronReceipts_PaymentSuccess"] = "Bot_Operator_wantsCronReceipts_PaymentSuccess";
    /* -------------------------
        Agent Quick Reply VARIABLES New For 1.6
    ------------------------- */
    BotVariables["Bot_Operator_QuickReply_Move2Text"] = "Bot_Operator_QuickReply_Move2Text";
    BotVariables["Bot_Operator_QuickReply_UnderstandSize"] = "Bot_Operator_QuickReply_UnderstandSize";
    BotVariables["Bot_Operator_QuickReply_CheckInventory"] = "Bot_Operator_QuickReply_CheckInventory";
    BotVariables["Bot_Operator_QuickReply_UnderstandFeature"] = "Bot_Operator_QuickReply_UnderstandFeature";
    /* -------------------------
        FMS PLUS
    ------------------------- */
    BotVariables["Bot_Operator_FMSplus_has0_MoveIn"] = "Bot_Operator_FMSplus_has0_MoveIn";
    BotVariables["Bot_Operator_FMSplus_has0_MoveIn_Method"] = "Bot_Operator_FMSplus_has0_MoveIn_Method";
    BotVariables["Bot_Operator_FMSplus_0_MoveIn1"] = "Bot_Operator_FMSplus_0_MoveIn1";
    BotVariables["Bot_Operator_FMSplus_0_MoveIn2"] = "Bot_Operator_FMSplus_0_MoveIn2";
    BotVariables["Bot_Operator_FMSplus_0_MoveIn2_Enabled"] = "Bot_Operator_FMSplus_0_MoveIn2_Enabled";
    BotVariables["Bot_Operator_FMSplus_0_MoveIn3"] = "Bot_Operator_FMSplus_0_MoveIn3";
    BotVariables["Bot_Operator_FMSplus_0_MoveIn3_Enabled"] = "Bot_Operator_FMSplus_0_MoveIn3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp1_MoveIn"] = "Bot_Operator_FMSplus_hasp1_MoveIn";
    BotVariables["Bot_Operator_FMSplus_hasp1_MoveIn_Method"] = "Bot_Operator_FMSplus_hasp1_MoveIn_Method";
    BotVariables["Bot_Operator_FMSplus_p1_MoveIn1"] = "Bot_Operator_FMSplus_p1_MoveIn1";
    BotVariables["Bot_Operator_FMSplus_p1_MoveIn2"] = "Bot_Operator_FMSplus_p1_MoveIn2";
    BotVariables["Bot_Operator_FMSplus_p1_MoveIn2_Enabled"] = "Bot_Operator_FMSplus_p1_MoveIn2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p1_MoveIn3"] = "Bot_Operator_FMSplus_p1_MoveIn3";
    BotVariables["Bot_Operator_FMSplus_p1_MoveIn3_Enabled"] = "Bot_Operator_FMSplus_p1_MoveIn3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp3_MoveIn"] = "Bot_Operator_FMSplus_hasp3_MoveIn";
    BotVariables["Bot_Operator_FMSplus_hasp3_MoveIn_Method"] = "Bot_Operator_FMSplus_hasp3_MoveIn_Method";
    BotVariables["Bot_Operator_FMSplus_p3_MoveIn1"] = "Bot_Operator_FMSplus_p3_MoveIn1";
    BotVariables["Bot_Operator_FMSplus_p3_MoveIn2"] = "Bot_Operator_FMSplus_p3_MoveIn2";
    BotVariables["Bot_Operator_FMSplus_p3_MoveIn2_Enabled"] = "Bot_Operator_FMSplus_p3_MoveIn2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p3_MoveIn3"] = "Bot_Operator_FMSplus_p3_MoveIn3";
    BotVariables["Bot_Operator_FMSplus_p3_MoveIn3_Enabled"] = "Bot_Operator_FMSplus_p3_MoveIn3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp5_MoveIn"] = "Bot_Operator_FMSplus_hasp5_MoveIn";
    BotVariables["Bot_Operator_FMSplus_hasp5_MoveIn_Method"] = "Bot_Operator_FMSplus_hasp5_MoveIn_Method";
    BotVariables["Bot_Operator_FMSplus_p5_MoveIn1"] = "Bot_Operator_FMSplus_p5_MoveIn1";
    BotVariables["Bot_Operator_FMSplus_p5_MoveIn2"] = "Bot_Operator_FMSplus_p5_MoveIn2";
    BotVariables["Bot_Operator_FMSplus_p5_MoveIn2_Enabled"] = "Bot_Operator_FMSplus_p5_MoveIn2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p5_MoveIn3"] = "Bot_Operator_FMSplus_p5_MoveIn3";
    BotVariables["Bot_Operator_FMSplus_p5_MoveIn3_Enabled"] = "Bot_Operator_FMSplus_p5_MoveIn3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp7_MoveIn"] = "Bot_Operator_FMSplus_hasp7_MoveIn";
    BotVariables["Bot_Operator_FMSplus_hasp7_MoveIn_Method"] = "Bot_Operator_FMSplus_hasp7_MoveIn_Method";
    BotVariables["Bot_Operator_FMSplus_p7_MoveIn1"] = "Bot_Operator_FMSplus_p7_MoveIn1";
    BotVariables["Bot_Operator_FMSplus_p7_MoveIn2"] = "Bot_Operator_FMSplus_p7_MoveIn2";
    BotVariables["Bot_Operator_FMSplus_p7_MoveIn2_Enabled"] = "Bot_Operator_FMSplus_p7_MoveIn2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p7_MoveIn3"] = "Bot_Operator_FMSplus_p7_MoveIn3";
    BotVariables["Bot_Operator_FMSplus_p7_MoveIn3_Enabled"] = "Bot_Operator_FMSplus_p7_MoveIn3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp10_MoveIn"] = "Bot_Operator_FMSplus_hasp10_MoveIn";
    BotVariables["Bot_Operator_FMSplus_hasp10_MoveIn_Method"] = "Bot_Operator_FMSplus_hasp10_MoveIn_Method";
    BotVariables["Bot_Operator_FMSplus_p10_MoveIn1"] = "Bot_Operator_FMSplus_p10_MoveIn1";
    BotVariables["Bot_Operator_FMSplus_p10_MoveIn2"] = "Bot_Operator_FMSplus_p10_MoveIn2";
    BotVariables["Bot_Operator_FMSplus_p10_MoveIn2_Enabled"] = "Bot_Operator_FMSplus_p10_MoveIn2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p10_MoveIn3"] = "Bot_Operator_FMSplus_p10_MoveIn3";
    BotVariables["Bot_Operator_FMSplus_p10_MoveIn3_Enabled"] = "Bot_Operator_FMSplus_p10_MoveIn3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp14_MoveIn"] = "Bot_Operator_FMSplus_hasp14_MoveIn";
    BotVariables["Bot_Operator_FMSplus_hasp14_MoveIn_Method"] = "Bot_Operator_FMSplus_hasp14_MoveIn_Method";
    BotVariables["Bot_Operator_FMSplus_p14_MoveIn1"] = "Bot_Operator_FMSplus_p14_MoveIn1";
    BotVariables["Bot_Operator_FMSplus_p14_MoveIn2"] = "Bot_Operator_FMSplus_p14_MoveIn2";
    BotVariables["Bot_Operator_FMSplus_p14_MoveIn2_Enabled"] = "Bot_Operator_FMSplus_p14_MoveIn2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p14_MoveIn3"] = "Bot_Operator_FMSplus_p14_MoveIn3";
    BotVariables["Bot_Operator_FMSplus_p14_MoveIn3_Enabled"] = "Bot_Operator_FMSplus_p14_MoveIn3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp30_MoveIn"] = "Bot_Operator_FMSplus_hasp30_MoveIn";
    BotVariables["Bot_Operator_FMSplus_hasp30_MoveIn_Method"] = "Bot_Operator_FMSplus_hasp30_MoveIn_Method";
    BotVariables["Bot_Operator_FMSplus_p30_MoveIn1"] = "Bot_Operator_FMSplus_p30_MoveIn1";
    BotVariables["Bot_Operator_FMSplus_p30_MoveIn2"] = "Bot_Operator_FMSplus_p30_MoveIn2";
    BotVariables["Bot_Operator_FMSplus_p30_MoveIn2_Enabled"] = "Bot_Operator_FMSplus_p30_MoveIn2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p30_MoveIn3"] = "Bot_Operator_FMSplus_p30_MoveIn3";
    BotVariables["Bot_Operator_FMSplus_p30_MoveIn3_Enabled"] = "Bot_Operator_FMSplus_p30_MoveIn3_Enabled";
    BotVariables["Bot_Operator_FMSplus_has0_MoveOut"] = "Bot_Operator_FMSplus_has0_MoveOut";
    BotVariables["Bot_Operator_FMSplus_has0_MoveOut_Method"] = "Bot_Operator_FMSplus_has0_MoveOut_Method";
    BotVariables["Bot_Operator_FMSplus_0_MoveOut1"] = "Bot_Operator_FMSplus_0_MoveOut1";
    BotVariables["Bot_Operator_FMSplus_0_MoveOut2"] = "Bot_Operator_FMSplus_0_MoveOut2";
    BotVariables["Bot_Operator_FMSplus_0_MoveOut2_Enabled"] = "Bot_Operator_FMSplus_0_MoveOut2_Enabled";
    BotVariables["Bot_Operator_FMSplus_0_MoveOut3"] = "Bot_Operator_FMSplus_0_MoveOut3";
    BotVariables["Bot_Operator_FMSplus_0_MoveOut3_Enabled"] = "Bot_Operator_FMSplus_0_MoveOut3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp1_MoveOut"] = "Bot_Operator_FMSplus_hasp1_MoveOut";
    BotVariables["Bot_Operator_FMSplus_hasp1_MoveOut_Method"] = "Bot_Operator_FMSplus_hasp1_MoveOut_Method";
    BotVariables["Bot_Operator_FMSplus_p1_MoveOut1"] = "Bot_Operator_FMSplus_p1_MoveOut1";
    BotVariables["Bot_Operator_FMSplus_p1_MoveOut2"] = "Bot_Operator_FMSplus_p1_MoveOut2";
    BotVariables["Bot_Operator_FMSplus_p1_MoveOut2_Enabled"] = "Bot_Operator_FMSplus_p1_MoveOut2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p1_MoveOut3"] = "Bot_Operator_FMSplus_p1_MoveOut3";
    BotVariables["Bot_Operator_FMSplus_p1_MoveOut3_Enabled"] = "Bot_Operator_FMSplus_p1_MoveOut3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp3_MoveOut"] = "Bot_Operator_FMSplus_hasp3_MoveOut";
    BotVariables["Bot_Operator_FMSplus_hasp3_MoveOut_Method"] = "Bot_Operator_FMSplus_hasp3_MoveOut_Method";
    BotVariables["Bot_Operator_FMSplus_p3_MoveOut1"] = "Bot_Operator_FMSplus_p3_MoveOut1";
    BotVariables["Bot_Operator_FMSplus_p3_MoveOut2"] = "Bot_Operator_FMSplus_p3_MoveOut2";
    BotVariables["Bot_Operator_FMSplus_p3_MoveOut2_Enabled"] = "Bot_Operator_FMSplus_p3_MoveOut2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p3_MoveOut3"] = "Bot_Operator_FMSplus_p3_MoveOut3";
    BotVariables["Bot_Operator_FMSplus_p3_MoveOut3_Enabled"] = "Bot_Operator_FMSplus_p3_MoveOut3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp5_MoveOut"] = "Bot_Operator_FMSplus_hasp5_MoveOut";
    BotVariables["Bot_Operator_FMSplus_hasp5_MoveOut_Method"] = "Bot_Operator_FMSplus_hasp5_MoveOut_Method";
    BotVariables["Bot_Operator_FMSplus_p5_MoveOut1"] = "Bot_Operator_FMSplus_p5_MoveOut1";
    BotVariables["Bot_Operator_FMSplus_p5_MoveOut2"] = "Bot_Operator_FMSplus_p5_MoveOut2";
    BotVariables["Bot_Operator_FMSplus_p5_MoveOut2_Enabled"] = "Bot_Operator_FMSplus_p5_MoveOut2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p5_MoveOut3"] = "Bot_Operator_FMSplus_p5_MoveOut3";
    BotVariables["Bot_Operator_FMSplus_p5_MoveOut3_Enabled"] = "Bot_Operator_FMSplus_p5_MoveOut3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp7_MoveOut"] = "Bot_Operator_FMSplus_hasp7_MoveOut";
    BotVariables["Bot_Operator_FMSplus_hasp7_MoveOut_Method"] = "Bot_Operator_FMSplus_hasp7_MoveOut_Method";
    BotVariables["Bot_Operator_FMSplus_p7_MoveOut1"] = "Bot_Operator_FMSplus_p7_MoveOut1";
    BotVariables["Bot_Operator_FMSplus_p7_MoveOut2"] = "Bot_Operator_FMSplus_p7_MoveOut2";
    BotVariables["Bot_Operator_FMSplus_p7_MoveOut2_Enabled"] = "Bot_Operator_FMSplus_p7_MoveOut2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p7_MoveOut3"] = "Bot_Operator_FMSplus_p7_MoveOut3";
    BotVariables["Bot_Operator_FMSplus_p7_MoveOut3_Enabled"] = "Bot_Operator_FMSplus_p7_MoveOut3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp10_MoveOut"] = "Bot_Operator_FMSplus_hasp10_MoveOut";
    BotVariables["Bot_Operator_FMSplus_hasp10_MoveOut_Method"] = "Bot_Operator_FMSplus_hasp10_MoveOut_Method";
    BotVariables["Bot_Operator_FMSplus_p10_MoveOut1"] = "Bot_Operator_FMSplus_p10_MoveOut1";
    BotVariables["Bot_Operator_FMSplus_p10_MoveOut2"] = "Bot_Operator_FMSplus_p10_MoveOut2";
    BotVariables["Bot_Operator_FMSplus_p10_MoveOut2_Enabled"] = "Bot_Operator_FMSplus_p10_MoveOut2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p10_MoveOut3"] = "Bot_Operator_FMSplus_p10_MoveOut3";
    BotVariables["Bot_Operator_FMSplus_p10_MoveOut3_Enabled"] = "Bot_Operator_FMSplus_p10_MoveOut3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp14_MoveOut"] = "Bot_Operator_FMSplus_hasp14_MoveOut";
    BotVariables["Bot_Operator_FMSplus_hasp14_MoveOut_Method"] = "Bot_Operator_FMSplus_hasp14_MoveOut_Method";
    BotVariables["Bot_Operator_FMSplus_p14_MoveOut1"] = "Bot_Operator_FMSplus_p14_MoveOut1";
    BotVariables["Bot_Operator_FMSplus_p14_MoveOut2"] = "Bot_Operator_FMSplus_p14_MoveOut2";
    BotVariables["Bot_Operator_FMSplus_p14_MoveOut2_Enabled"] = "Bot_Operator_FMSplus_p14_MoveOut2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p14_MoveOut3"] = "Bot_Operator_FMSplus_p14_MoveOut3";
    BotVariables["Bot_Operator_FMSplus_p14_MoveOut3_Enabled"] = "Bot_Operator_FMSplus_p14_MoveOut3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp30_MoveOut"] = "Bot_Operator_FMSplus_hasp30_MoveOut";
    BotVariables["Bot_Operator_FMSplus_hasp30_MoveOut_Method"] = "Bot_Operator_FMSplus_hasp30_MoveOut_Method";
    BotVariables["Bot_Operator_FMSplus_p30_MoveOut1"] = "Bot_Operator_FMSplus_p30_MoveOut1";
    BotVariables["Bot_Operator_FMSplus_p30_MoveOut2"] = "Bot_Operator_FMSplus_p30_MoveOut2";
    BotVariables["Bot_Operator_FMSplus_p30_MoveOut2_Enabled"] = "Bot_Operator_FMSplus_p30_MoveOut2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p30_MoveOut3"] = "Bot_Operator_FMSplus_p30_MoveOut3";
    BotVariables["Bot_Operator_FMSplus_p30_MoveOut3_Enabled"] = "Bot_Operator_FMSplus_p30_MoveOut3_Enabled";
    BotVariables["Bot_Operator_FMSplus_has0_PaymentDue"] = "Bot_Operator_FMSplus_has0_PaymentDue";
    BotVariables["Bot_Operator_FMSplus_has0_PaymentDue_Method"] = "Bot_Operator_FMSplus_has0_PaymentDue_Method";
    BotVariables["Bot_Operator_FMSplus_0_PaymentDue1"] = "Bot_Operator_FMSplus_0_PaymentDue1";
    BotVariables["Bot_Operator_FMSplus_0_PaymentDue2"] = "Bot_Operator_FMSplus_0_PaymentDue2";
    BotVariables["Bot_Operator_FMSplus_0_PaymentDue2_Enabled"] = "Bot_Operator_FMSplus_0_PaymentDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_0_PaymentDue3"] = "Bot_Operator_FMSplus_0_PaymentDue3";
    BotVariables["Bot_Operator_FMSplus_0_PaymentDue3_Enabled"] = "Bot_Operator_FMSplus_0_PaymentDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasn1_PaymentDue"] = "Bot_Operator_FMSplus_hasn1_PaymentDue";
    BotVariables["Bot_Operator_FMSplus_hasn1_PaymentDue_Method"] = "Bot_Operator_FMSplus_hasn1_PaymentDue_Method";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentDue1"] = "Bot_Operator_FMSplus_n1_PaymentDue1";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentDue2"] = "Bot_Operator_FMSplus_n1_PaymentDue2";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentDue2_Enabled"] = "Bot_Operator_FMSplus_n1_PaymentDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentDue3"] = "Bot_Operator_FMSplus_n1_PaymentDue3";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentDue3_Enabled"] = "Bot_Operator_FMSplus_n1_PaymentDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasn2_PaymentDue"] = "Bot_Operator_FMSplus_hasn2_PaymentDue";
    BotVariables["Bot_Operator_FMSplus_hasn2_PaymentDue_Method"] = "Bot_Operator_FMSplus_hasn2_PaymentDue_Method";
    BotVariables["Bot_Operator_FMSplus_n2_PaymentDue1"] = "Bot_Operator_FMSplus_n2_PaymentDue1";
    BotVariables["Bot_Operator_FMSplus_n2_PaymentDue2"] = "Bot_Operator_FMSplus_n2_PaymentDue2";
    BotVariables["Bot_Operator_FMSplus_n2_PaymentDue2_Enabled"] = "Bot_Operator_FMSplus_n2_PaymentDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_n2_PaymentDue3"] = "Bot_Operator_FMSplus_n2_PaymentDue3";
    BotVariables["Bot_Operator_FMSplus_n2_PaymentDue3_Enabled"] = "Bot_Operator_FMSplus_n2_PaymentDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasn3_PaymentDue"] = "Bot_Operator_FMSplus_hasn3_PaymentDue";
    BotVariables["Bot_Operator_FMSplus_hasn3_PaymentDue_Method"] = "Bot_Operator_FMSplus_hasn3_PaymentDue_Method";
    BotVariables["Bot_Operator_FMSplus_n3_PaymentDue1"] = "Bot_Operator_FMSplus_n3_PaymentDue1";
    BotVariables["Bot_Operator_FMSplus_n3_PaymentDue2"] = "Bot_Operator_FMSplus_n3_PaymentDue2";
    BotVariables["Bot_Operator_FMSplus_n3_PaymentDue2_Enabled"] = "Bot_Operator_FMSplus_n3_PaymentDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_n3_PaymentDue3"] = "Bot_Operator_FMSplus_n3_PaymentDue3";
    BotVariables["Bot_Operator_FMSplus_n3_PaymentDue3_Enabled"] = "Bot_Operator_FMSplus_n3_PaymentDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasn5_PaymentDue"] = "Bot_Operator_FMSplus_hasn5_PaymentDue";
    BotVariables["Bot_Operator_FMSplus_hasn5_PaymentDue_Method"] = "Bot_Operator_FMSplus_hasn5_PaymentDue_Method";
    BotVariables["Bot_Operator_FMSplus_n5_PaymentDue1"] = "Bot_Operator_FMSplus_n5_PaymentDue1";
    BotVariables["Bot_Operator_FMSplus_n5_PaymentDue2"] = "Bot_Operator_FMSplus_n5_PaymentDue2";
    BotVariables["Bot_Operator_FMSplus_n5_PaymentDue2_Enabled"] = "Bot_Operator_FMSplus_n5_PaymentDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_n5_PaymentDue3"] = "Bot_Operator_FMSplus_n5_PaymentDue3";
    BotVariables["Bot_Operator_FMSplus_n5_PaymentDue3_Enabled"] = "Bot_Operator_FMSplus_n5_PaymentDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasn7_PaymentDue"] = "Bot_Operator_FMSplus_hasn7_PaymentDue";
    BotVariables["Bot_Operator_FMSplus_hasn7_PaymentDue_Method"] = "Bot_Operator_FMSplus_hasn7_PaymentDue_Method";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentDue1"] = "Bot_Operator_FMSplus_n7_PaymentDue1";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentDue2"] = "Bot_Operator_FMSplus_n7_PaymentDue2";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentDue2_Enabled"] = "Bot_Operator_FMSplus_n7_PaymentDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentDue3"] = "Bot_Operator_FMSplus_n7_PaymentDue3";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentDue3_Enabled"] = "Bot_Operator_FMSplus_n7_PaymentDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_has0_PastDue"] = "Bot_Operator_FMSplus_has0_PastDue";
    BotVariables["Bot_Operator_FMSplus_has0_PastDue_Method"] = "Bot_Operator_FMSplus_has0_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_0_PastDue1"] = "Bot_Operator_FMSplus_0_PastDue1";
    BotVariables["Bot_Operator_FMSplus_0_PastDue2"] = "Bot_Operator_FMSplus_0_PastDue2";
    BotVariables["Bot_Operator_FMSplus_0_PastDue2_Enabled"] = "Bot_Operator_FMSplus_0_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_0_PastDue3"] = "Bot_Operator_FMSplus_0_PastDue3";
    BotVariables["Bot_Operator_FMSplus_0_PastDue3_Enabled"] = "Bot_Operator_FMSplus_0_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp1_PastDue"] = "Bot_Operator_FMSplus_hasp1_PastDue";
    BotVariables["Bot_Operator_FMSplus_hasp1_PastDue_Method"] = "Bot_Operator_FMSplus_hasp1_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_p1_PastDue1"] = "Bot_Operator_FMSplus_p1_PastDue1";
    BotVariables["Bot_Operator_FMSplus_p1_PastDue2"] = "Bot_Operator_FMSplus_p1_PastDue2";
    BotVariables["Bot_Operator_FMSplus_p1_PastDue2_Enabled"] = "Bot_Operator_FMSplus_p1_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p1_PastDue3"] = "Bot_Operator_FMSplus_p1_PastDue3";
    BotVariables["Bot_Operator_FMSplus_p1_PastDue3_Enabled"] = "Bot_Operator_FMSplus_p1_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp2_PastDue"] = "Bot_Operator_FMSplus_hasp2_PastDue";
    BotVariables["Bot_Operator_FMSplus_hasp2_PastDue_Method"] = "Bot_Operator_FMSplus_hasp2_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_p2_PastDue1"] = "Bot_Operator_FMSplus_p2_PastDue1";
    BotVariables["Bot_Operator_FMSplus_p2_PastDue2"] = "Bot_Operator_FMSplus_p2_PastDue2";
    BotVariables["Bot_Operator_FMSplus_p2_PastDue2_Enabled"] = "Bot_Operator_FMSplus_p2_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p2_PastDue3"] = "Bot_Operator_FMSplus_p2_PastDue3";
    BotVariables["Bot_Operator_FMSplus_p2_PastDue3_Enabled"] = "Bot_Operator_FMSplus_p2_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp3_PastDue"] = "Bot_Operator_FMSplus_hasp3_PastDue";
    BotVariables["Bot_Operator_FMSplus_hasp3_PastDue_Method"] = "Bot_Operator_FMSplus_hasp3_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_p3_PastDue1"] = "Bot_Operator_FMSplus_p3_PastDue1";
    BotVariables["Bot_Operator_FMSplus_p3_PastDue2"] = "Bot_Operator_FMSplus_p3_PastDue2";
    BotVariables["Bot_Operator_FMSplus_p3_PastDue2_Enabled"] = "Bot_Operator_FMSplus_p3_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p3_PastDue3"] = "Bot_Operator_FMSplus_p3_PastDue3";
    BotVariables["Bot_Operator_FMSplus_p3_PastDue3_Enabled"] = "Bot_Operator_FMSplus_p3_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp5_PastDue"] = "Bot_Operator_FMSplus_hasp5_PastDue";
    BotVariables["Bot_Operator_FMSplus_hasp5_PastDue_Method"] = "Bot_Operator_FMSplus_hasp5_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_p5_PastDue1"] = "Bot_Operator_FMSplus_p5_PastDue1";
    BotVariables["Bot_Operator_FMSplus_p5_PastDue2"] = "Bot_Operator_FMSplus_p5_PastDue2";
    BotVariables["Bot_Operator_FMSplus_p5_PastDue2_Enabled"] = "Bot_Operator_FMSplus_p5_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p5_PastDue3"] = "Bot_Operator_FMSplus_p5_PastDue3";
    BotVariables["Bot_Operator_FMSplus_p5_PastDue3_Enabled"] = "Bot_Operator_FMSplus_p5_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp7_PastDue"] = "Bot_Operator_FMSplus_hasp7_PastDue";
    BotVariables["Bot_Operator_FMSplus_hasp7_PastDue_Method"] = "Bot_Operator_FMSplus_hasp7_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_p7_PastDue1"] = "Bot_Operator_FMSplus_p7_PastDue1";
    BotVariables["Bot_Operator_FMSplus_p7_PastDue2"] = "Bot_Operator_FMSplus_p7_PastDue2";
    BotVariables["Bot_Operator_FMSplus_p7_PastDue2_Enabled"] = "Bot_Operator_FMSplus_p7_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p7_PastDue3"] = "Bot_Operator_FMSplus_p7_PastDue3";
    BotVariables["Bot_Operator_FMSplus_p7_PastDue3_Enabled"] = "Bot_Operator_FMSplus_p7_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp10_PastDue"] = "Bot_Operator_FMSplus_hasp10_PastDue";
    BotVariables["Bot_Operator_FMSplus_hasp10_PastDue_Method"] = "Bot_Operator_FMSplus_hasp10_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_p10_PastDue1"] = "Bot_Operator_FMSplus_p10_PastDue1";
    BotVariables["Bot_Operator_FMSplus_p10_PastDue2"] = "Bot_Operator_FMSplus_p10_PastDue2";
    BotVariables["Bot_Operator_FMSplus_p10_PastDue2_Enabled"] = "Bot_Operator_FMSplus_p10_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p10_PastDue3"] = "Bot_Operator_FMSplus_p10_PastDue3";
    BotVariables["Bot_Operator_FMSplus_p10_PastDue3_Enabled"] = "Bot_Operator_FMSplus_p10_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp14_PastDue"] = "Bot_Operator_FMSplus_hasp14_PastDue";
    BotVariables["Bot_Operator_FMSplus_hasp14_PastDue_Method"] = "Bot_Operator_FMSplus_hasp14_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_p14_PastDue1"] = "Bot_Operator_FMSplus_p14_PastDue1";
    BotVariables["Bot_Operator_FMSplus_p14_PastDue2"] = "Bot_Operator_FMSplus_p14_PastDue2";
    BotVariables["Bot_Operator_FMSplus_p14_PastDue2_Enabled"] = "Bot_Operator_FMSplus_p14_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p14_PastDue3"] = "Bot_Operator_FMSplus_p14_PastDue3";
    BotVariables["Bot_Operator_FMSplus_p14_PastDue3_Enabled"] = "Bot_Operator_FMSplus_p14_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp30_PastDue"] = "Bot_Operator_FMSplus_hasp30_PastDue";
    BotVariables["Bot_Operator_FMSplus_hasp30_PastDue_Method"] = "Bot_Operator_FMSplus_hasp30_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_p30_PastDue1"] = "Bot_Operator_FMSplus_p30_PastDue1";
    BotVariables["Bot_Operator_FMSplus_p30_PastDue2"] = "Bot_Operator_FMSplus_p30_PastDue2";
    BotVariables["Bot_Operator_FMSplus_p30_PastDue2_Enabled"] = "Bot_Operator_FMSplus_p30_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p30_PastDue3"] = "Bot_Operator_FMSplus_p30_PastDue3";
    BotVariables["Bot_Operator_FMSplus_p30_PastDue3_Enabled"] = "Bot_Operator_FMSplus_p30_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp45_PastDue"] = "Bot_Operator_FMSplus_hasp45_PastDue";
    BotVariables["Bot_Operator_FMSplus_hasp45_PastDue_Method"] = "Bot_Operator_FMSplus_hasp45_PastDue_Method";
    BotVariables["Bot_Operator_FMSplus_p45_PastDue1"] = "Bot_Operator_FMSplus_p45_PastDue1";
    BotVariables["Bot_Operator_FMSplus_p45_PastDue2"] = "Bot_Operator_FMSplus_p45_PastDue2";
    BotVariables["Bot_Operator_FMSplus_p45_PastDue2_Enabled"] = "Bot_Operator_FMSplus_p45_PastDue2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p45_PastDue3"] = "Bot_Operator_FMSplus_p45_PastDue3";
    BotVariables["Bot_Operator_FMSplus_p45_PastDue3_Enabled"] = "Bot_Operator_FMSplus_p45_PastDue3_Enabled";
    BotVariables["Bot_Operator_FMSplus_has0_PaymentMethodExpiring"] = "Bot_Operator_FMSplus_has0_PaymentMethodExpiring";
    BotVariables["Bot_Operator_FMSplus_has0_PaymentMethodExpiring_Method"] = "Bot_Operator_FMSplus_has0_PaymentMethodExpiring_Method";
    BotVariables["Bot_Operator_FMSplus_0_PaymentMethodExpiring1"] = "Bot_Operator_FMSplus_0_PaymentMethodExpiring1";
    BotVariables["Bot_Operator_FMSplus_0_PaymentMethodExpiring2"] = "Bot_Operator_FMSplus_0_PaymentMethodExpiring2";
    BotVariables["Bot_Operator_FMSplus_0_PaymentMethodExpiring2_Enabled"] = "Bot_Operator_FMSplus_0_PaymentMethodExpiring2_Enabled";
    BotVariables["Bot_Operator_FMSplus_0_PaymentMethodExpiring3"] = "Bot_Operator_FMSplus_0_PaymentMethodExpiring3";
    BotVariables["Bot_Operator_FMSplus_0_PaymentMethodExpiring3_Enabled"] = "Bot_Operator_FMSplus_0_PaymentMethodExpiring3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasn1_PaymentMethodExpiring"] = "Bot_Operator_FMSplus_hasn1_PaymentMethodExpiring";
    BotVariables["Bot_Operator_FMSplus_hasn1_PaymentMethodExpiring_Method"] = "Bot_Operator_FMSplus_hasn1_PaymentMethodExpiring_Method";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentMethodExpiring1"] = "Bot_Operator_FMSplus_n1_PaymentMethodExpiring1";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentMethodExpiring2"] = "Bot_Operator_FMSplus_n1_PaymentMethodExpiring2";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentMethodExpiring2_Enabled"] = "Bot_Operator_FMSplus_n1_PaymentMethodExpiring2_Enabled";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentMethodExpiring3"] = "Bot_Operator_FMSplus_n1_PaymentMethodExpiring3";
    BotVariables["Bot_Operator_FMSplus_n1_PaymentMethodExpiring3_Enabled"] = "Bot_Operator_FMSplus_n1_PaymentMethodExpiring3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasn7_PaymentMethodExpiring"] = "Bot_Operator_FMSplus_hasn7_PaymentMethodExpiring";
    BotVariables["Bot_Operator_FMSplus_hasn7_PaymentMethodExpiring_Method"] = "Bot_Operator_FMSplus_hasn7_PaymentMethodExpiring_Method";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentMethodExpiring1"] = "Bot_Operator_FMSplus_n7_PaymentMethodExpiring1";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentMethodExpiring2"] = "Bot_Operator_FMSplus_n7_PaymentMethodExpiring2";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentMethodExpiring2_Enabled"] = "Bot_Operator_FMSplus_n7_PaymentMethodExpiring2_Enabled";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentMethodExpiring3"] = "Bot_Operator_FMSplus_n7_PaymentMethodExpiring3";
    BotVariables["Bot_Operator_FMSplus_n7_PaymentMethodExpiring3_Enabled"] = "Bot_Operator_FMSplus_n7_PaymentMethodExpiring3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasn14_PaymentMethodExpiring"] = "Bot_Operator_FMSplus_hasn14_PaymentMethodExpiring";
    BotVariables["Bot_Operator_FMSplus_hasn14_PaymentMethodExpiring_Method"] = "Bot_Operator_FMSplus_hasn14_PaymentMethodExpiring_Method";
    BotVariables["Bot_Operator_FMSplus_n14_PaymentMethodExpiring1"] = "Bot_Operator_FMSplus_n14_PaymentMethodExpiring1";
    BotVariables["Bot_Operator_FMSplus_n14_PaymentMethodExpiring2"] = "Bot_Operator_FMSplus_n14_PaymentMethodExpiring2";
    BotVariables["Bot_Operator_FMSplus_n14_PaymentMethodExpiring2_Enabled"] = "Bot_Operator_FMSplus_n14_PaymentMethodExpiring2_Enabled";
    BotVariables["Bot_Operator_FMSplus_n14_PaymentMethodExpiring3"] = "Bot_Operator_FMSplus_n14_PaymentMethodExpiring3";
    BotVariables["Bot_Operator_FMSplus_n14_PaymentMethodExpiring3_Enabled"] = "Bot_Operator_FMSplus_n14_PaymentMethodExpiring3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasn30_PaymentMethodExpiring"] = "Bot_Operator_FMSplus_hasn30_PaymentMethodExpiring";
    BotVariables["Bot_Operator_FMSplus_hasn30_PaymentMethodExpiring_Method"] = "Bot_Operator_FMSplus_hasn30_PaymentMethodExpiring_Method";
    BotVariables["Bot_Operator_FMSplus_n30_PaymentMethodExpiring1"] = "Bot_Operator_FMSplus_n30_PaymentMethodExpiring1";
    BotVariables["Bot_Operator_FMSplus_n30_PaymentMethodExpiring2"] = "Bot_Operator_FMSplus_n30_PaymentMethodExpiring2";
    BotVariables["Bot_Operator_FMSplus_n30_PaymentMethodExpiring2_Enabled"] = "Bot_Operator_FMSplus_n30_PaymentMethodExpiring2_Enabled";
    BotVariables["Bot_Operator_FMSplus_n30_PaymentMethodExpiring3"] = "Bot_Operator_FMSplus_n30_PaymentMethodExpiring3";
    BotVariables["Bot_Operator_FMSplus_n30_PaymentMethodExpiring3_Enabled"] = "Bot_Operator_FMSplus_n30_PaymentMethodExpiring3_Enabled";
    BotVariables["Bot_Operator_FMSplus_has0_UpdateContactInfo"] = "Bot_Operator_FMSplus_has0_UpdateContactInfo";
    BotVariables["Bot_Operator_FMSplus_has0_UpdateContactInfo_Method"] = "Bot_Operator_FMSplus_has0_UpdateContactInfo_Method";
    BotVariables["Bot_Operator_FMSplus_0_UpdateContactInfo1"] = "Bot_Operator_FMSplus_0_UpdateContactInfo1";
    BotVariables["Bot_Operator_FMSplus_0_UpdateContactInfo2"] = "Bot_Operator_FMSplus_0_UpdateContactInfo2";
    BotVariables["Bot_Operator_FMSplus_0_UpdateContactInfo2_Enabled"] = "Bot_Operator_FMSplus_0_UpdateContactInfo2_Enabled";
    BotVariables["Bot_Operator_FMSplus_0_UpdateContactInfo3"] = "Bot_Operator_FMSplus_0_UpdateContactInfo3";
    BotVariables["Bot_Operator_FMSplus_0_UpdateContactInfo3_Enabled"] = "Bot_Operator_FMSplus_0_UpdateContactInfo3_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp7_UpdateContactInfo"] = "Bot_Operator_FMSplus_hasp7_UpdateContactInfo";
    BotVariables["Bot_Operator_FMSplus_hasp7_UpdateContactInfo_Method"] = "Bot_Operator_FMSplus_hasp7_UpdateContactInfo_Method";
    BotVariables["Bot_Operator_FMSplus_p7_UpdateContactInfo1"] = "Bot_Operator_FMSplus_p7_UpdateContactInfo1";
    BotVariables["Bot_Operator_FMSplus_p7_UpdateContactInfo2"] = "Bot_Operator_FMSplus_p7_UpdateContactInfo2";
    BotVariables["Bot_Operator_FMSplus_p7_UpdateContactInfo2_Enabled"] = "Bot_Operator_FMSplus_p7_UpdateContactInfo2_Enabled";
    BotVariables["Bot_Operator_FMSplus_p7_UpdateContactInfo3"] = "Bot_Operator_FMSplus_p7_UpdateContactInfo3";
    BotVariables["Bot_Operator_FMSplus_p7_UpdateContactInfo3_Enabled"] = "Bot_Operator_FMSplus_p7_UpdateContactInfo3_Enabled";
    BotVariables["Bot_Operator_FMSplus_has0_PaymentSuccess"] = "Bot_Operator_FMSplus_has0_PaymentSuccess";
    BotVariables["Bot_Operator_FMSplus_has0_PaymentSuccess_Method"] = "Bot_Operator_FMSplus_has0_PaymentSuccess_Method";
    BotVariables["Bot_Operator_FMSplus_0_PaymentSuccess1"] = "Bot_Operator_FMSplus_0_PaymentSuccess1";
    BotVariables["Bot_Operator_FMSplus_0_PaymentSuccess2"] = "Bot_Operator_FMSplus_0_PaymentSuccess2";
    BotVariables["Bot_Operator_FMSplus_0_PaymentSuccess2_Enabled"] = "Bot_Operator_FMSplus_0_PaymentSuccess2_Enabled";
    BotVariables["Bot_Operator_FMSplus_0_PaymentSuccess3"] = "Bot_Operator_FMSplus_0_PaymentSuccess3";
    BotVariables["Bot_Operator_FMSplus_0_PaymentSuccess3_Enabled"] = "Bot_Operator_FMSplus_0_PaymentSuccess3_Enabled";
    /* -------------------------
        SMS Legal Variables
    ------------------------- */
    BotVariables["Bot_Operator_SMS_FirstMessage_Disclaimer"] = "Bot_Operator_SMS_FirstMessage_Disclaimer";
    BotVariables["Bot_Operator_PrivacyPolicyURL"] = "Bot_Operator_PrivacyPolicyURL";
    BotVariables["Bot_Operator_hasPrivacyPolicyURL"] = "Bot_Operator_hasPrivacyPolicyURL";
    /* -------------------------
        Profile Collect Settings Variables
    ------------------------- */
    BotVariables["Bot_Operator_hasAfterNavigate"] = "Bot_Operator_hasAfterNavigate";
    BotVariables["Bot_Operator_isLiveChatFirst"] = "Bot_Operator_isLiveChatFirst";
    BotVariables["Bot_Operator_LiveChatFirst_CollectProfile"] = "Bot_Operator_LiveChatFirst_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_LiveChat_Message"] = "Bot_Operator_ProfileSetting_LiveChat_Message";
    BotVariables["Bot_Operator_ProfileSetting_LiveChat_ContactMethod"] = "Bot_Operator_ProfileSetting_LiveChat_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_LiveChat_wantShortProfile"] = "Bot_Operator_ProfileSetting_LiveChat_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_LiveChat_CollectionMethod"] = "Bot_Operator_ProfileSetting_LiveChat_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_LiveChat_ConfirmProfile"] = "Bot_Operator_ProfileSetting_LiveChat_ConfirmProfile";
    BotVariables["Bot_Operator_ProfileSetting_Shopping_CollectProfile"] = "Bot_Operator_ProfileSetting_Shopping_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_Shopping_Message"] = "Bot_Operator_ProfileSetting_Shopping_Message";
    BotVariables["Bot_Operator_ProfileSetting_Shopping_ContactMethod"] = "Bot_Operator_ProfileSetting_Shopping_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_Shopping_wantShortProfile"] = "Bot_Operator_ProfileSetting_Shopping_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_Shopping_CollectionMethod"] = "Bot_Operator_ProfileSetting_Shopping_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_Shopping_ConfirmProfile"] = "Bot_Operator_ProfileSetting_Shopping_ConfirmProfile";
    BotVariables["Bot_Operator_ProfileSetting_Welcome_CollectProfile"] = "Bot_Operator_ProfileSetting_Welcome_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_Welcome_Message"] = "Bot_Operator_ProfileSetting_Welcome_Message";
    BotVariables["Bot_Operator_ProfileSetting_Welcome_ContactMethod"] = "Bot_Operator_ProfileSetting_Welcome_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_Welcome_wantShortProfile"] = "Bot_Operator_ProfileSetting_Welcome_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_Welcome_CollectionMethod"] = "Bot_Operator_ProfileSetting_Welcome_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_Welcome_ConfirmProfile"] = "Bot_Operator_ProfileSetting_Welcome_ConfirmProfile";
    BotVariables["Bot_Operator_ProfileSetting_WelcomeBack_CollectProfile"] = "Bot_Operator_ProfileSetting_WelcomeBack_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_WelcomeBack_Message"] = "Bot_Operator_ProfileSetting_WelcomeBack_Message";
    BotVariables["Bot_Operator_ProfileSetting_WelcomeBack_ContactMethod"] = "Bot_Operator_ProfileSetting_WelcomeBack_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_WelcomeBack_wantShortProfile"] = "Bot_Operator_ProfileSetting_WelcomeBack_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_WelcomeBack_CollectionMethod"] = "Bot_Operator_ProfileSetting_WelcomeBack_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_WelcomeBack_ConfirmProfile"] = "Bot_Operator_ProfileSetting_WelcomeBack_ConfirmProfile";
    BotVariables["Bot_Operator_wantsCustomerInitiatedEscalations"] = "Bot_Operator_wantsCustomerInitiatedEscalations";
    BotVariables["Bot_Operator_CustomerInitiatedEscalations_CollectProfile"] = "Bot_Operator_CustomerInitiatedEscalations_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_HumanInitiated_Message"] = "Bot_Operator_ProfileSetting_HumanInitiated_Message";
    BotVariables["Bot_Operator_ProfileSetting_HumanInitiated_ContactMethod"] = "Bot_Operator_ProfileSetting_HumanInitiated_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_HumanInitiated_wantShortProfile"] = "Bot_Operator_ProfileSetting_HumanInitiated_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_HumanInitiated_CollectionMethod"] = "Bot_Operator_ProfileSetting_HumanInitiated_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_HumanInitiated_ConfirmProfile"] = "Bot_Operator_ProfileSetting_HumanInitiated_ConfirmProfile";
    BotVariables["Bot_Operator_wantsBotInitiatedEscalations_Sales"] = "Bot_Operator_wantsBotInitiatedEscalations_Sales";
    BotVariables["Bot_Operator_BotInitiatedEscalations_Sales_CollectProfile"] = "Bot_Operator_BotInitiatedEscalations_Sales_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedSales_Message"] = "Bot_Operator_ProfileSetting_BotInititatedSales_Message";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedSales_ContactMethod"] = "Bot_Operator_ProfileSetting_BotInititatedSales_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedSales_wantShortProfile"] = "Bot_Operator_ProfileSetting_BotInititatedSales_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedSales_CollectionMethod"] = "Bot_Operator_ProfileSetting_BotInititatedSales_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedSales_ConfirmProfile"] = "Bot_Operator_ProfileSetting_BotInititatedSales_ConfirmProfile";
    BotVariables["Bot_Operator_wantsBotInitiatedEscalations_Service"] = "Bot_Operator_wantsBotInitiatedEscalations_Service";
    BotVariables["Bot_Operator_BotInitiatedEscalations_Service_CollectProfile"] = "Bot_Operator_BotInitiatedEscalations_Service_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedService_Message"] = "Bot_Operator_ProfileSetting_BotInititatedService_Message";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedService_ContactMethod"] = "Bot_Operator_ProfileSetting_BotInititatedService_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedService_wantShortProfile"] = "Bot_Operator_ProfileSetting_BotInititatedService_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedService_CollectionMethod"] = "Bot_Operator_ProfileSetting_BotInititatedService_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedService_ConfirmProfile"] = "Bot_Operator_ProfileSetting_BotInititatedService_ConfirmProfile";
    BotVariables["Bot_Operator_wantsBotInitiatedEscalations_LowConfidence"] = "Bot_Operator_wantsBotInitiatedEscalations_LowConfidence";
    BotVariables["Bot_Operator_BotInitiatedEscalations_LowConfidence_CollectProfile"] = "Bot_Operator_BotInitiatedEscalations_LowConfidence_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_LowConfidence_Message"] = "Bot_Operator_ProfileSetting_LowConfidence_Message";
    BotVariables["Bot_Operator_ProfileSetting_LowConfidence_ContactMethod"] = "Bot_Operator_ProfileSetting_LowConfidence_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_LowConfidence_wantShortProfile"] = "Bot_Operator_ProfileSetting_LowConfidence_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_LowConfidence_CollectionMethod"] = "Bot_Operator_ProfileSetting_LowConfidence_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_LowConfidence_ConfirmProfile"] = "Bot_Operator_ProfileSetting_LowConfidence_ConfirmProfile";
    BotVariables["Bot_Operator_ProfileSetting_WhatElse_CollectProfile"] = "Bot_Operator_ProfileSetting_WhatElse_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_WhatElse_Message"] = "Bot_Operator_ProfileSetting_WhatElse_Message";
    BotVariables["Bot_Operator_ProfileSetting_WhatElse_ContactMethod"] = "Bot_Operator_ProfileSetting_WhatElse_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_WhatElse_wantShortProfile"] = "Bot_Operator_ProfileSetting_WhatElse_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_WhatElse_CollectionMethod"] = "Bot_Operator_ProfileSetting_WhatElse_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_WhatElse_ConfirmProfile"] = "Bot_Operator_ProfileSetting_WhatElse_ConfirmProfile";
    /* -------------------------
        New For 1.7
    ------------------------- */
    BotVariables["Bot_GS_GettingStartedCompleted"] = "Bot_GS_GettingStartedCompleted";
    BotVariables["Bot_GS_KickOffMilestoneCompleted"] = "Bot_GS_KickOffMilestoneCompleted";
    BotVariables["Bot_GS_StoreFinderStatus"] = "Bot_GS_StoreFinderStatus";
    BotVariables["Bot_GS_MyStorageStatus"] = "Bot_GS_MyStorageStatus";
    BotVariables["Bot_GS_Milestone1Completed"] = "Bot_GS_Milestone1Completed";
    BotVariables["Bot_GS_FMSConnectStatus"] = "Bot_GS_FMSConnectStatus";
    BotVariables["Bot_GS_DesignEmbedStatus"] = "Bot_GS_DesignEmbedStatus";
    BotVariables["Bot_GS_InviteAgentsStatus"] = "Bot_GS_InviteAgentsStatus";
    BotVariables["Bot_GS_LaunchStatus"] = "Bot_GS_LaunchStatus";
    BotVariables["Bot_GS_Milestone2Completed"] = "Bot_GS_Milestone2Completed";
    BotVariables["Bot_GS_GoogleChatStatus"] = "Bot_GS_GoogleChatStatus";
    BotVariables["Bot_GS_GoogleReviewsStatus"] = "Bot_GS_GoogleReviewsStatus";
    BotVariables["Bot_GS_AutomatedTextsStatus"] = "Bot_GS_AutomatedTextsStatus";
    BotVariables["Bot_GS_PostLaunchCompleted"] = "Bot_GS_PostLaunchCompleted";
    BotVariables["Bot_GS_MonitorChatsStatus"] = "Bot_GS_MonitorChatsStatus";
    BotVariables["Bot_GS_AnalyticsStatus"] = "Bot_GS_AnalyticsStatus";
    BotVariables["Bot_Operator_hasElectricityInUnit"] = "Bot_Operator_hasElectricityInUnit";
    BotVariables["Bot_Operator_hasPayByPhone"] = "Bot_Operator_hasPayByPhone";
    BotVariables["Bot_Operator_DefaultCountry"] = "Bot_Operator_DefaultCountry";
    /* -------------------------
        Size Description
    ------------------------- */
    BotVariables["Bot_Operator_ShowSizeDescriptions"] = "Bot_Operator_ShowSizeDescriptions";
    BotVariables["Bot_SizeDescription_Small1"] = "Bot_SizeDescription_Small1";
    BotVariables["Bot_SizeDescription_Small2"] = "Bot_SizeDescription_Small2";
    BotVariables["Bot_SizeDescription_Small2_Enabled"] = "Bot_SizeDescription_Small2_Enabled";
    BotVariables["Bot_SizeDescription_Medium1"] = "Bot_SizeDescription_Medium1";
    BotVariables["Bot_SizeDescription_Medium2"] = "Bot_SizeDescription_Medium2";
    BotVariables["Bot_SizeDescription_Medium2_Enabled"] = "Bot_SizeDescription_Medium2_Enabled";
    BotVariables["Bot_SizeDescription_Large1"] = "Bot_SizeDescription_Large1";
    BotVariables["Bot_SizeDescription_Large2"] = "Bot_SizeDescription_Large2";
    BotVariables["Bot_SizeDescription_Large2_Enabled"] = "Bot_SizeDescription_Large2_Enabled";
    BotVariables["Bot_SizeDescription_ExtraLarge1"] = "Bot_SizeDescription_ExtraLarge1";
    BotVariables["Bot_SizeDescription_ExtraLarge2"] = "Bot_SizeDescription_ExtraLarge2";
    BotVariables["Bot_SizeDescription_ExtraLarge2_Enabled"] = "Bot_SizeDescription_ExtraLarge2_Enabled";
    BotVariables["Bot_SizeDescription_1Bedroom1"] = "Bot_SizeDescription_1Bedroom1";
    BotVariables["Bot_SizeDescription_1Bedroom2"] = "Bot_SizeDescription_1Bedroom2";
    BotVariables["Bot_SizeDescription_1Bedroom2_Enabled"] = "Bot_SizeDescription_1Bedroom2_Enabled";
    BotVariables["Bot_SizeDescription_2Bedroom1"] = "Bot_SizeDescription_2Bedroom1";
    BotVariables["Bot_SizeDescription_2Bedroom2"] = "Bot_SizeDescription_2Bedroom2";
    BotVariables["Bot_SizeDescription_2Bedroom2_Enabled"] = "Bot_SizeDescription_2Bedroom2_Enabled";
    BotVariables["Bot_SizeDescription_3Bedroom1"] = "Bot_SizeDescription_3Bedroom1";
    BotVariables["Bot_SizeDescription_3Bedroom2"] = "Bot_SizeDescription_3Bedroom2";
    BotVariables["Bot_SizeDescription_3Bedroom2_Enabled"] = "Bot_SizeDescription_3Bedroom2_Enabled";
    BotVariables["Bot_SizeDescription_45Bedroom1"] = "Bot_SizeDescription_45Bedroom1";
    BotVariables["Bot_SizeDescription_45Bedroom2"] = "Bot_SizeDescription_45Bedroom2";
    BotVariables["Bot_SizeDescription_45Bedroom2_Enabled"] = "Bot_SizeDescription_45Bedroom2_Enabled";
    BotVariables["Bot_SizeDescription_5x51"] = "Bot_SizeDescription_5x51";
    BotVariables["Bot_SizeDescription_5x52"] = "Bot_SizeDescription_5x52";
    BotVariables["Bot_SizeDescription_5x52_Enabled"] = "Bot_SizeDescription_5x52_Enabled";
    BotVariables["Bot_SizeDescription_5x101"] = "Bot_SizeDescription_5x101";
    BotVariables["Bot_SizeDescription_5x102"] = "Bot_SizeDescription_5x102";
    BotVariables["Bot_SizeDescription_5x102_Enabled"] = "Bot_SizeDescription_5x102_Enabled";
    BotVariables["Bot_SizeDescription_10x101"] = "Bot_SizeDescription_10x101";
    BotVariables["Bot_SizeDescription_10x102"] = "Bot_SizeDescription_10x102";
    BotVariables["Bot_SizeDescription_10x102_Enabled"] = "Bot_SizeDescription_10x102_Enabled";
    BotVariables["Bot_SizeDescription_10x151"] = "Bot_SizeDescription_10x151";
    BotVariables["Bot_SizeDescription_10x152"] = "Bot_SizeDescription_10x152";
    BotVariables["Bot_SizeDescription_10x152_Enabled"] = "Bot_SizeDescription_10x152_Enabled";
    BotVariables["Bot_SizeDescription_10x201"] = "Bot_SizeDescription_10x201";
    BotVariables["Bot_SizeDescription_10x202"] = "Bot_SizeDescription_10x202";
    BotVariables["Bot_SizeDescription_10x202_Enabled"] = "Bot_SizeDescription_10x202_Enabled";
    BotVariables["Bot_SizeDescription_10x301"] = "Bot_SizeDescription_10x301";
    BotVariables["Bot_SizeDescription_10x302"] = "Bot_SizeDescription_10x302";
    BotVariables["Bot_SizeDescription_10x302_Enabled"] = "Bot_SizeDescription_10x302_Enabled";
    BotVariables["Bot_SizeDescription_SmallVehicle1"] = "Bot_SizeDescription_SmallVehicle1";
    BotVariables["Bot_SizeDescription_SmallVehicle2"] = "Bot_SizeDescription_SmallVehicle2";
    BotVariables["Bot_SizeDescription_SmallVehicle2_Enabled"] = "Bot_SizeDescription_SmallVehicle2_Enabled";
    BotVariables["Bot_SizeDescription_Motorcycle1"] = "Bot_SizeDescription_Motorcycle1";
    BotVariables["Bot_SizeDescription_Motorcycle2"] = "Bot_SizeDescription_Motorcycle2";
    BotVariables["Bot_SizeDescription_Motorcycle2_Enabled"] = "Bot_SizeDescription_Motorcycle2_Enabled";
    BotVariables["Bot_SizeDescription_Sedan1"] = "Bot_SizeDescription_Sedan1";
    BotVariables["Bot_SizeDescription_Sedan2"] = "Bot_SizeDescription_Sedan2";
    BotVariables["Bot_SizeDescription_Sedan2_Enabled"] = "Bot_SizeDescription_Sedan2_Enabled";
    BotVariables["Bot_SizeDescription_Truck1"] = "Bot_SizeDescription_Truck1";
    BotVariables["Bot_SizeDescription_Truck2"] = "Bot_SizeDescription_Truck2";
    BotVariables["Bot_SizeDescription_Truck2_Enabled"] = "Bot_SizeDescription_Truck2_Enabled";
    BotVariables["Bot_SizeDescription_RV1"] = "Bot_SizeDescription_RV1";
    BotVariables["Bot_SizeDescription_RV2"] = "Bot_SizeDescription_RV2";
    BotVariables["Bot_SizeDescription_RV2_Enabled"] = "Bot_SizeDescription_RV2_Enabled";
    /* -------------------------
        No Agent Available Variables
    ------------------------- */
    BotVariables["Bot_LiveChat_NAASales1"] = "Bot_LiveChat_NAASales1";
    BotVariables["Bot_LiveChat_NAASales2"] = "Bot_LiveChat_NAASales2";
    BotVariables["Bot_LiveChat_NAASales2_Enabled"] = "Bot_LiveChat_NAASales2_Enabled";
    BotVariables["Bot_NAASales1"] = "Bot_NAASales1";
    BotVariables["Bot_LiveChat_NAAService1"] = "Bot_LiveChat_NAAService1";
    BotVariables["Bot_LiveChat_NAAService2"] = "Bot_LiveChat_NAAService2";
    BotVariables["Bot_LiveChat_NAAService2_Enabled"] = "Bot_LiveChat_NAAService2_Enabled";
    BotVariables["Bot_NAAService1"] = "Bot_NAAService1";
    BotVariables["Bot_OutsideBusiness1"] = "Bot_OutsideBusiness1";
    BotVariables["Bot_OutsideBusiness2"] = "Bot_OutsideBusiness2";
    BotVariables["Bot_OutsideBusiness2_Enabled"] = "Bot_OutsideBusiness2_Enabled";
    BotVariables["Bot_OutsideBusinessConfirm1"] = "Bot_OutsideBusinessConfirm1";
    /* -------------------------
        New for 1.7
    ------------------------- */
    BotVariables["Bot_Inform_PastDue1"] = "Bot_Inform_PastDue1";
    BotVariables["Bot_Inform_PastDue2"] = "Bot_Inform_PastDue2";
    BotVariables["Bot_Inform_PastDue2_Enabled"] = "Bot_Inform_PastDue2_Enabled";
    BotVariables["Bot_Inform_Inactive1"] = "Bot_Inform_Inactive1";
    BotVariables["Bot_Inform_Inactive2"] = "Bot_Inform_Inactive2";
    BotVariables["Bot_Inform_Inactive2_Enabled"] = "Bot_Inform_Inactive2_Enabled";
    BotVariables["Bot_Operator_AfterNavigate_GMB_ShowInventory_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_ShowInventory_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_PayBill_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_PayBill_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_Auction_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_Auction_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_SizeVisuals_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_SizeVisuals_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_Referral_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_Referral_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_Career_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_Career_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_Insurance_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_Insurance_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_About_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_About_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_CreditDebit_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_CreditDebit_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_AutoPay_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_AutoPay_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_Password_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_Password_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_UpdateBilling_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_UpdateBilling_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_CreateLogin_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_CreateLogin_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_Username_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_Username_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_Reservations_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_Reservations_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_AccountPayBill_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_AccountPayBill_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_UpdateContact_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_UpdateContact_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_GMB_AccountLogin_QuestSlug"] = "Bot_Operator_AfterNavigate_GMB_AccountLogin_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_ShowInventory_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_ShowInventory_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_PayBill_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_PayBill_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_Auction_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_Auction_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_SizeVisuals_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_SizeVisuals_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_Referral_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_Referral_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_Career_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_Career_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_Insurance_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_Insurance_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_About_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_About_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_CreditDebit_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_CreditDebit_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_AutoPay_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_AutoPay_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_Password_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_Password_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_UpdateBilling_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_UpdateBilling_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_CreateLogin_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_CreateLogin_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_Username_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_Username_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_Reservations_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_Reservations_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_AccountPayBill_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_AccountPayBill_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_UpdateContact_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_UpdateContact_QuestSlug";
    BotVariables["Bot_Operator_AfterNavigate_SMS_AccountLogin_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_AccountLogin_QuestSlug";
    /* -------------------------
        Some company info/important URLs vary by location
    ------------------------- */
    BotVariables["Bot_Operator_Vary_Settings"] = "Bot_Operator_Vary_Settings";
    BotVariables["Bot_Operator_Varies_LoginURL"] = "Bot_Operator_Varies_LoginURL";
    BotVariables["Bot_Operator_Varies_PayOnlineURL"] = "Bot_Operator_Varies_PayOnlineURL";
    BotVariables["Bot_Operator_Varies_SizeVisualsURL"] = "Bot_Operator_Varies_SizeVisualsURL";
    BotVariables["Bot_Operator_wantsSearchAnotherStore"] = "Bot_Operator_wantsSearchAnotherStore";
    BotVariables["Bot_Spot_AccessCode_QuestSlug"] = "Bot_Spot_AccessCode_QuestSlug";
    BotVariables["Bot_Spot_Review_QuestSlug"] = "Bot_Spot_Review_QuestSlug";
    BotVariables["Bot_Spot_PayBillOnline_QuestSlug"] = "Bot_Spot_PayBillOnline_QuestSlug";
    BotVariables["Bot_Spot_PayBillPhone_QuestSlug"] = "Bot_Spot_PayBillPhone_QuestSlug";
    BotVariables["Bot_Spot_ManageAccount_QuestSlug"] = "Bot_Spot_ManageAccount_QuestSlug";
    BotVariables["Bot_Operator_Access_UnitNumberIntegration"] = "Bot_Operator_Access_UnitNumberIntegration";
    BotVariables["Bot_Operator_Access_UnitNumber1"] = "Bot_Operator_Access_UnitNumber1";
    BotVariables["Bot_Operator_Access_UnitNumber2"] = "Bot_Operator_Access_UnitNumber2";
    BotVariables["Bot_Operator_Access_UnitNumber3"] = "Bot_Operator_Access_UnitNumber3";
    BotVariables["Bot_Operator_Access_UnitNumber3_Enabled"] = "Bot_Operator_Access_UnitNumber3_Enabled";
    BotVariables["Bot_Operator_FMS_UnitNumberChannel"] = "Bot_Operator_FMS_UnitNumberChannel";
    BotVariables["Bot_Operator_FMS_UnitNumberChannel_SMSMessage"] = "Bot_Operator_FMS_UnitNumberChannel_SMSMessage";
    BotVariables["Bot_Operator_AfterNavigate_SMS_SelectStore_QuestSlug"] = "Bot_Operator_AfterNavigate_SMS_SelectStore_QuestSlug";
    /* -------------------------
        90 day move-in option (for Copper)
    ------------------------- */
    BotVariables["Bot_Operator_FMSplus_hasp90_MoveIn"] = "Bot_Operator_FMSplus_hasp90_MoveIn";
    BotVariables["Bot_Operator_FMSplus_hasp90_MoveIn_Method"] = "Bot_Operator_FMSplus_hasp90_MoveIn_Method";
    BotVariables["Bot_Operator_FMSplus_p90_MoveIn1"] = "Bot_Operator_FMSplus_p90_MoveIn1";
    BotVariables["Bot_Operator_FMSplus_p90_MoveIn2"] = "Bot_Operator_FMSplus_p90_MoveIn2";
    BotVariables["Bot_Operator_FMSplus_p90_MoveIn2_Enabled"] = "Bot_Operator_FMSplus_p90_MoveIn2_Enabled";
    BotVariables["Bot_Operator_Feature_Padlocks"] = "Bot_Operator_Feature_Padlocks";
    BotVariables["Bot_Operator_Feature_Padlocks1"] = "Bot_Operator_Feature_Padlocks1";
    BotVariables["Bot_Operator_Feature_Padlocks2"] = "Bot_Operator_Feature_Padlocks2";
    BotVariables["Bot_Operator_InsideBusinessHours"] = "Bot_Operator_InsideBusinessHours";
    /* -------------------------
        FMS+ Review Solicitation
    ------------------------- */
    BotVariables["Bot_Operator_FMSplus_0_MoveIn_Review"] = "Bot_Operator_FMSplus_0_MoveIn_Review";
    BotVariables["Bot_Operator_FMSplus_hasp1_MoveIn_Review"] = "Bot_Operator_FMSplus_hasp1_MoveIn_Review";
    BotVariables["Bot_Operator_FMSplus_hasp3_MoveIn_Review"] = "Bot_Operator_FMSplus_hasp3_MoveIn_Review";
    BotVariables["Bot_Operator_FMSplus_hasp5_MoveIn_Review"] = "Bot_Operator_FMSplus_hasp5_MoveIn_Review";
    BotVariables["Bot_Operator_FMSplus_hasp7_MoveIn_Review"] = "Bot_Operator_FMSplus_hasp7_MoveIn_Review";
    BotVariables["Bot_Operator_FMSplus_hasp10_MoveIn_Review"] = "Bot_Operator_FMSplus_hasp10_MoveIn_Review";
    BotVariables["Bot_Operator_FMSplus_hasp14_MoveIn_Review"] = "Bot_Operator_FMSplus_hasp14_MoveIn_Review";
    BotVariables["Bot_Operator_FMSplus_hasp30_MoveIn_Review"] = "Bot_Operator_FMSplus_hasp30_MoveIn_Review";
    BotVariables["Bot_Operator_FMSplus_hasp90_MoveIn_Review"] = "Bot_Operator_FMSplus_hasp90_MoveIn_Review";
    BotVariables["Bot_Operator_FMSplus_0_MoveOut_Review"] = "Bot_Operator_FMSplus_0_MoveOut_Review";
    BotVariables["Bot_Operator_FMSplus_hasp1_MoveOut_Review"] = "Bot_Operator_FMSplus_hasp1_MoveOut_Review";
    BotVariables["Bot_Operator_FMSplus_hasp3_MoveOut_Review"] = "Bot_Operator_FMSplus_hasp3_MoveOut_Review";
    BotVariables["Bot_Operator_FMSplus_hasp5_MoveOut_Review"] = "Bot_Operator_FMSplus_hasp5_MoveOut_Review";
    BotVariables["Bot_Operator_FMSplus_hasp7_MoveOut_Review"] = "Bot_Operator_FMSplus_hasp7_MoveOut_Review";
    BotVariables["Bot_Operator_FMSplus_hasp10_MoveOut_Review"] = "Bot_Operator_FMSplus_hasp10_MoveOut_Review";
    BotVariables["Bot_Operator_FMSplus_hasp14_MoveOut_Review"] = "Bot_Operator_FMSplus_hasp14_MoveOut_Review";
    BotVariables["Bot_Operator_FMSplus_hasp30_MoveOut_Review"] = "Bot_Operator_FMSplus_hasp30_MoveOut_Review";
    BotVariables["Bot_Operator_FMS_ReviewStart1"] = "Bot_Operator_FMS_ReviewStart1";
    BotVariables["Bot_Operator_FMS_ReviewStart2"] = "Bot_Operator_FMS_ReviewStart2";
    BotVariables["Bot_Operator_FMS_ReviewStart2_Enabled"] = "Bot_Operator_FMS_ReviewStart2_Enabled";
    BotVariables["Bot_Operator_FMS_ReviewPromoter1"] = "Bot_Operator_FMS_ReviewPromoter1";
    BotVariables["Bot_Operator_FMS_ReviewPromoter2"] = "Bot_Operator_FMS_ReviewPromoter2";
    BotVariables["Bot_Operator_FMS_ReviewPromoter2_Enabled"] = "Bot_Operator_FMS_ReviewPromoter2_Enabled";
    BotVariables["Bot_Operator_FMS_ReviewPromoter3"] = "Bot_Operator_FMS_ReviewPromoter3";
    BotVariables["Bot_Operator_FMS_ReviewPromoter3_Enabled"] = "Bot_Operator_FMS_ReviewPromoter3_Enabled";
    BotVariables["Bot_Operator_FMS_ReviewPassive1"] = "Bot_Operator_FMS_ReviewPassive1";
    BotVariables["Bot_Operator_FMS_ReviewPassive2"] = "Bot_Operator_FMS_ReviewPassive2";
    BotVariables["Bot_Operator_FMS_ReviewPassive2_Enabled"] = "Bot_Operator_FMS_ReviewPassive2_Enabled";
    BotVariables["Bot_Operator_FMS_ReviewPassive3"] = "Bot_Operator_FMS_ReviewPassive3";
    BotVariables["Bot_Operator_FMS_ReviewPassive3_Enabled"] = "Bot_Operator_FMS_ReviewPassive3_Enabled";
    BotVariables["Bot_Operator_FMS_ReviewDetractor1"] = "Bot_Operator_FMS_ReviewDetractor1";
    BotVariables["Bot_Operator_FMS_ReviewDetractor2"] = "Bot_Operator_FMS_ReviewDetractor2";
    BotVariables["Bot_Operator_FMS_ReviewDetractor2_Enabled"] = "Bot_Operator_FMS_ReviewDetractor2_Enabled";
    BotVariables["Bot_Operator_FMS_ReviewDetractor3"] = "Bot_Operator_FMS_ReviewDetractor3";
    BotVariables["Bot_Operator_FMS_ReviewDetractor3_Enabled"] = "Bot_Operator_FMS_ReviewDetractor3_Enabled";
    // Abandoned Carts
    BotVariables["Bot_Operator_hasCronAbandonedCarts"] = "Bot_Operator_hasCronAbandonedCarts";
    BotVariables["Bot_Operator_wantsCronReceipts_AbandonedCarts"] = "Bot_Operator_wantsCronReceipts_AbandonedCarts";
    BotVariables["Bot_Operator_FMSplus_hasp1_AbandonedCart"] = "Bot_Operator_FMSplus_hasp1_AbandonedCart";
    BotVariables["Bot_Operator_FMSplus_hasp2_AbandonedCart"] = "Bot_Operator_FMSplus_hasp2_AbandonedCart";
    BotVariables["Bot_Operator_FMSplus_hasp3_AbandonedCart"] = "Bot_Operator_FMSplus_hasp3_AbandonedCart";
    BotVariables["Bot_Operator_FMSplus_hasp5_AbandonedCart"] = "Bot_Operator_FMSplus_hasp5_AbandonedCart";
    BotVariables["Bot_Operator_FMSplus_hasp7_AbandonedCart"] = "Bot_Operator_FMSplus_hasp7_AbandonedCart";
    BotVariables["Bot_Operator_FMSplus_hasp10_AbandonedCart"] = "Bot_Operator_FMSplus_hasp10_AbandonedCart";
    BotVariables["Bot_Operator_FMSplus_hasp14_AbandonedCart"] = "Bot_Operator_FMSplus_hasp14_AbandonedCart";
    BotVariables["Bot_Operator_FMSplus_hasp30_AbandonedCart"] = "Bot_Operator_FMSplus_hasp30_AbandonedCart";
    BotVariables["Bot_Operator_FMSplus_hasp1_AbandonedCart_Method"] = "Bot_Operator_FMSplus_hasp1_AbandonedCart_Method";
    BotVariables["Bot_Operator_FMSplus_hasp1_AbandonedCart1"] = "Bot_Operator_FMSplus_hasp1_AbandonedCart1";
    BotVariables["Bot_Operator_FMSplus_hasp1_AbandonedCart2"] = "Bot_Operator_FMSplus_hasp1_AbandonedCart2";
    BotVariables["Bot_Operator_FMSplus_hasp1_AbandonedCart2_Enabled"] = "Bot_Operator_FMSplus_hasp1_AbandonedCart2_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp2_AbandonedCart_Method"] = "Bot_Operator_FMSplus_hasp2_AbandonedCart_Method";
    BotVariables["Bot_Operator_FMSplus_hasp2_AbandonedCart1"] = "Bot_Operator_FMSplus_hasp2_AbandonedCart1";
    BotVariables["Bot_Operator_FMSplus_hasp2_AbandonedCart2"] = "Bot_Operator_FMSplus_hasp2_AbandonedCart2";
    BotVariables["Bot_Operator_FMSplus_hasp2_AbandonedCart2_Enabled"] = "Bot_Operator_FMSplus_hasp2_AbandonedCart2_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp3_AbandonedCart_Method"] = "Bot_Operator_FMSplus_hasp3_AbandonedCart_Method";
    BotVariables["Bot_Operator_FMSplus_hasp3_AbandonedCart1"] = "Bot_Operator_FMSplus_hasp3_AbandonedCart1";
    BotVariables["Bot_Operator_FMSplus_hasp3_AbandonedCart2"] = "Bot_Operator_FMSplus_hasp3_AbandonedCart2";
    BotVariables["Bot_Operator_FMSplus_hasp3_AbandonedCart2_Enabled"] = "Bot_Operator_FMSplus_hasp3_AbandonedCart2_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp5_AbandonedCart_Method"] = "Bot_Operator_FMSplus_hasp5_AbandonedCart_Method";
    BotVariables["Bot_Operator_FMSplus_hasp5_AbandonedCart1"] = "Bot_Operator_FMSplus_hasp5_AbandonedCart1";
    BotVariables["Bot_Operator_FMSplus_hasp5_AbandonedCart2"] = "Bot_Operator_FMSplus_hasp5_AbandonedCart2";
    BotVariables["Bot_Operator_FMSplus_hasp5_AbandonedCart2_Enabled"] = "Bot_Operator_FMSplus_hasp5_AbandonedCart2_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp7_AbandonedCart_Method"] = "Bot_Operator_FMSplus_hasp7_AbandonedCart_Method";
    BotVariables["Bot_Operator_FMSplus_hasp7_AbandonedCart1"] = "Bot_Operator_FMSplus_hasp7_AbandonedCart1";
    BotVariables["Bot_Operator_FMSplus_hasp7_AbandonedCart2"] = "Bot_Operator_FMSplus_hasp7_AbandonedCart2";
    BotVariables["Bot_Operator_FMSplus_hasp7_AbandonedCart2_Enabled"] = "Bot_Operator_FMSplus_hasp7_AbandonedCart2_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp10_AbandonedCart_Method"] = "Bot_Operator_FMSplus_hasp10_AbandonedCart_Method";
    BotVariables["Bot_Operator_FMSplus_hasp10_AbandonedCart1"] = "Bot_Operator_FMSplus_hasp10_AbandonedCart1";
    BotVariables["Bot_Operator_FMSplus_hasp10_AbandonedCart2"] = "Bot_Operator_FMSplus_hasp10_AbandonedCart2";
    BotVariables["Bot_Operator_FMSplus_hasp10_AbandonedCart2_Enabled"] = "Bot_Operator_FMSplus_hasp10_AbandonedCart2_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp14_AbandonedCart_Method"] = "Bot_Operator_FMSplus_hasp14_AbandonedCart_Method";
    BotVariables["Bot_Operator_FMSplus_hasp14_AbandonedCart1"] = "Bot_Operator_FMSplus_hasp14_AbandonedCart1";
    BotVariables["Bot_Operator_FMSplus_hasp14_AbandonedCart2"] = "Bot_Operator_FMSplus_hasp14_AbandonedCart2";
    BotVariables["Bot_Operator_FMSplus_hasp14_AbandonedCart2_Enabled"] = "Bot_Operator_FMSplus_hasp14_AbandonedCart2_Enabled";
    BotVariables["Bot_Operator_FMSplus_hasp30_AbandonedCart_Method"] = "Bot_Operator_FMSplus_hasp30_AbandonedCart_Method";
    BotVariables["Bot_Operator_FMSplus_hasp30_AbandonedCart1"] = "Bot_Operator_FMSplus_hasp30_AbandonedCart1";
    BotVariables["Bot_Operator_FMSplus_hasp30_AbandonedCart2"] = "Bot_Operator_FMSplus_hasp30_AbandonedCart2";
    BotVariables["Bot_Operator_FMSplus_hasp30_AbandonedCart2_Enabled"] = "Bot_Operator_FMSplus_hasp30_AbandonedCart2_Enabled";
    /* -------------------------
        CORE 2.0 Variables (LLM)
    ------------------------- */
    BotVariables["Bot_Operator_whichTier"] = "Bot_Operator_whichTier";
    BotVariables["Bot_LLM_Tone"] = "Bot_LLM_Tone";
    BotVariables["Bot_LLM_Personality"] = "Bot_LLM_Personality";
    BotVariables["Bot_LLM_isFeatures"] = "Bot_LLM_isFeatures";
    BotVariables["Bot_LLM_isAccountManagement"] = "Bot_LLM_isAccountManagement";
    BotVariables["Bot_LLM_isAccess"] = "Bot_LLM_isAccess";
    BotVariables["Bot_LLM_isIssueResolution"] = "Bot_LLM_isIssueResolution";
    BotVariables["Bot_LLM_isLease"] = "Bot_LLM_isLease";
    BotVariables["Bot_LLM_isPricing"] = "Bot_LLM_isPricing";
    BotVariables["Bot_LLM_isSizing"] = "Bot_LLM_isSizing";
    BotVariables["Bot_LLM_isUnhandled"] = "Bot_LLM_isUnhandled";
    BotVariables["Bot_Operator_DefaultLanguage"] = "Bot_Operator_DefaultLanguage";
    // add Persona Collect to Welcome, Welcome Back, and Live Chat First to cut down on Unknown personas being sent into FMS
    BotVariables["Bot_Operator_ProfileSetting_Welcome_CollectPersona"] = "Bot_Operator_ProfileSetting_Welcome_CollectPersona";
    BotVariables["Bot_Operator_ProfileSetting_WelcomeBack_CollectPersona"] = "Bot_Operator_ProfileSetting_WelcomeBack_CollectPersona";
    BotVariables["Bot_Operator_ProfileSetting_LiveChat_CollectPersona"] = "Bot_Operator_ProfileSetting_LiveChat_CollectPersona";
    /* -------------------------
        CORE 2.1 Variables
    ------------------------- */
    BotVariables["Bot_Operator_QuickReply_GoogleReview"] = "Bot_Operator_QuickReply_GoogleReview";
    BotVariables["Bot_Operator_VehicleStorage"] = "Bot_Operator_VehicleStorage";
    BotVariables["Bot_Operator_RVParking"] = "Bot_Operator_RVParking";
    BotVariables["Bot_Operator_RVParkingEnclosed"] = "Bot_Operator_RVParkingEnclosed";
    BotVariables["Bot_Operator_RVParkingCovered"] = "Bot_Operator_RVParkingCovered";
    BotVariables["Bot_Operator_BoatStorage"] = "Bot_Operator_BoatStorage";
    BotVariables["Bot_Operator_VehicleStorage1"] = "Bot_Operator_VehicleStorage1";
    BotVariables["Bot_Operator_VehicleStorage2"] = "Bot_Operator_VehicleStorage2";
    BotVariables["Bot_Operator_VehicleStorage2_Enabled"] = "Bot_Operator_VehicleStorage2_Enabled";
    BotVariables["Bot_Operator_VehicleStorageIndoor1"] = "Bot_Operator_VehicleStorageIndoor1";
    BotVariables["Bot_Operator_VehicleStorageIndoor2"] = "Bot_Operator_VehicleStorageIndoor2";
    BotVariables["Bot_Operator_VehicleStorageIndoor2_Enabled"] = "Bot_Operator_VehicleStorageIndoor2_Enabled";
    BotVariables["Bot_Operator_OutdoorParking2"] = "Bot_Operator_OutdoorParking2";
    BotVariables["Bot_Operator_OutdoorParking2_Enabled"] = "Bot_Operator_OutdoorParking2_Enabled";
    BotVariables["Bot_Operator_VehicleStorageCovered1"] = "Bot_Operator_VehicleStorageCovered1";
    BotVariables["Bot_Operator_VehicleStorageCovered2"] = "Bot_Operator_VehicleStorageCovered2";
    BotVariables["Bot_Operator_VehicleStorageCovered2_Enabled"] = "Bot_Operator_VehicleStorageCovered2_Enabled";
    BotVariables["Bot_Operator_RVParking1"] = "Bot_Operator_RVParking1";
    BotVariables["Bot_Operator_RVParking2"] = "Bot_Operator_RVParking2";
    BotVariables["Bot_Operator_RVParking2_Enabled"] = "Bot_Operator_RVParking2_Enabled";
    BotVariables["Bot_Operator_RVParkingEnclosed1"] = "Bot_Operator_RVParkingEnclosed1";
    BotVariables["Bot_Operator_RVParkingEnclosed2"] = "Bot_Operator_RVParkingEnclosed2";
    BotVariables["Bot_Operator_RVParkingEnclosed2_Enabled"] = "Bot_Operator_RVParkingEnclosed2_Enabled";
    BotVariables["Bot_Operator_RVParkingCovered1"] = "Bot_Operator_RVParkingCovered1";
    BotVariables["Bot_Operator_RVParkingCovered2"] = "Bot_Operator_RVParkingCovered2";
    BotVariables["Bot_Operator_RVParkingCovered2_Enabled"] = "Bot_Operator_RVParkingCovered2_Enabled";
    BotVariables["Bot_Operator_BoatStorage1"] = "Bot_Operator_BoatStorage1";
    BotVariables["Bot_Operator_BoatStorage2"] = "Bot_Operator_BoatStorage2";
    BotVariables["Bot_Operator_BoatStorage2_Enabled"] = "Bot_Operator_BoatStorage2_Enabled";
    BotVariables["Bot_Operator_ProfileSetting_LiveChat_SecondaryOptional"] = "Bot_Operator_ProfileSetting_LiveChat_SecondaryOptional";
    BotVariables["Bot_Operator_ProfileSetting_Shopping_SecondaryOptional"] = "Bot_Operator_ProfileSetting_Shopping_SecondaryOptional";
    BotVariables["Bot_Operator_ProfileSetting_Welcome_SecondaryOptional"] = "Bot_Operator_ProfileSetting_Welcome_SecondaryOptional";
    BotVariables["Bot_Operator_ProfileSetting_WelcomeBack_SecondaryOptional"] = "Bot_Operator_ProfileSetting_WelcomeBack_SecondaryOptional";
    BotVariables["Bot_Operator_ProfileSetting_HumanInitiated_SecondaryOptional"] = "Bot_Operator_ProfileSetting_HumanInitiated_SecondaryOptional";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedSales_SecondaryOptional"] = "Bot_Operator_ProfileSetting_BotInititatedSales_SecondaryOptional";
    BotVariables["Bot_Operator_ProfileSetting_BotInititatedService_SecondaryOptional"] = "Bot_Operator_ProfileSetting_BotInititatedService_SecondaryOptional";
    BotVariables["Bot_Operator_ProfileSetting_LowConfidence_SecondaryOptional"] = "Bot_Operator_ProfileSetting_LowConfidence_SecondaryOptional";
    BotVariables["Bot_Operator_ProfileSetting_WhatElse_SecondaryOptional"] = "Bot_Operator_ProfileSetting_WhatElse_SecondaryOptional";
    BotVariables["Bot_Operator_hasGoogleReviewIntegration"] = "Bot_Operator_hasGoogleReviewIntegration";
    BotVariables["Bot_Operator_ProfileSetting_Waitlist_CollectProfile"] = "Bot_Operator_ProfileSetting_Waitlist_CollectProfile";
    BotVariables["Bot_Operator_ProfileSetting_Waitlist_Message"] = "Bot_Operator_ProfileSetting_Waitlist_Message";
    BotVariables["Bot_Operator_ProfileSetting_Waitlist_ContactMethod"] = "Bot_Operator_ProfileSetting_Waitlist_ContactMethod";
    BotVariables["Bot_Operator_ProfileSetting_Waitlist_wantShortProfile"] = "Bot_Operator_ProfileSetting_Waitlist_wantShortProfile";
    BotVariables["Bot_Operator_ProfileSetting_Waitlist_CollectionMethod"] = "Bot_Operator_ProfileSetting_Waitlist_CollectionMethod";
    BotVariables["Bot_Operator_ProfileSetting_Waitlist_ConfirmProfile"] = "Bot_Operator_ProfileSetting_Waitlist_ConfirmProfile";
    BotVariables["Bot_Operator_ProfileSetting_Waitlist_SecondaryOptional"] = "Bot_Operator_ProfileSetting_Waitlist_SecondaryOptional";
    BotVariables["Bot_Operator_FMSplus_0_MoveIn_Referral"] = "Bot_Operator_FMSplus_0_MoveIn_Referral";
    BotVariables["Bot_Operator_FMSplus_hasp1_MoveIn_Referral"] = "Bot_Operator_FMSplus_hasp1_MoveIn_Referral";
    BotVariables["Bot_Operator_FMSplus_hasp3_MoveIn_Referral"] = "Bot_Operator_FMSplus_hasp3_MoveIn_Referral";
    BotVariables["Bot_Operator_FMSplus_hasp5_MoveIn_Referral"] = "Bot_Operator_FMSplus_hasp5_MoveIn_Referral";
    BotVariables["Bot_Operator_FMSplus_hasp7_MoveIn_Referral"] = "Bot_Operator_FMSplus_hasp7_MoveIn_Referral";
    BotVariables["Bot_Operator_FMSplus_hasp10_MoveIn_Referral"] = "Bot_Operator_FMSplus_hasp10_MoveIn_Referral";
    BotVariables["Bot_Operator_FMSplus_hasp14_MoveIn_Referral"] = "Bot_Operator_FMSplus_hasp14_MoveIn_Referral";
    BotVariables["Bot_Operator_FMSplus_hasp30_MoveIn_Referral"] = "Bot_Operator_FMSplus_hasp30_MoveIn_Referral";
    BotVariables["Bot_Operator_FMSplus_hasp90_MoveIn_Referral"] = "Bot_Operator_FMSplus_hasp90_MoveIn_Referral";
    BotVariables["Bot_Operator_FMSplus_0_MoveIn_Referral1"] = "Bot_Operator_FMSplus_0_MoveIn_Referral1";
    BotVariables["Bot_Operator_FMSplus_hasp1_MoveIn_Referral1"] = "Bot_Operator_FMSplus_hasp1_MoveIn_Referral1";
    BotVariables["Bot_Operator_FMSplus_hasp3_MoveIn_Referral1"] = "Bot_Operator_FMSplus_hasp3_MoveIn_Referral1";
    BotVariables["Bot_Operator_FMSplus_hasp5_MoveIn_Referral1"] = "Bot_Operator_FMSplus_hasp5_MoveIn_Referral1";
    BotVariables["Bot_Operator_FMSplus_hasp7_MoveIn_Referral1"] = "Bot_Operator_FMSplus_hasp7_MoveIn_Referral1";
    BotVariables["Bot_Operator_FMSplus_hasp10_MoveIn_Referral1"] = "Bot_Operator_FMSplus_hasp10_MoveIn_Referral1";
    BotVariables["Bot_Operator_FMSplus_hasp14_MoveIn_Referral1"] = "Bot_Operator_FMSplus_hasp14_MoveIn_Referral1";
    BotVariables["Bot_Operator_FMSplus_hasp30_MoveIn_Referral1"] = "Bot_Operator_FMSplus_hasp30_MoveIn_Referral1";
    BotVariables["Bot_Operator_FMSplus_hasp90_MoveIn_Referral1"] = "Bot_Operator_FMSplus_hasp90_MoveIn_Referral1";
    BotVariables["Bot_Spot_Brand_Slug"] = "Bot_Spot_Brand_Slug";
    BotVariables["Bot_Spot_Referral_Page_Title"] = "Bot_Spot_Referral_Page_Title";
    BotVariables["Bot_Spot_Referral_Page_Body"] = "Bot_Spot_Referral_Page_Body";
    BotVariables["Bot_Spot_Referral_URL"] = "Bot_Spot_Referral_URL";
    BotVariables["Bot_Spot_Referral_Share_Email_Subject"] = "Bot_Spot_Referral_Share_Email_Subject";
    BotVariables["Bot_Spot_Referral_Share_Email_Body"] = "Bot_Spot_Referral_Share_Email_Body";
    BotVariables["Bot_Spot_Referral_Share_SMS_Body"] = "Bot_Spot_Referral_Share_SMS_Body";
    BotVariables["Bot_Spot_Referral_Message1"] = "Bot_Spot_Referral_Message1";
    BotVariables["Bot_Spot_Referral_Message2_Enabled"] = "Bot_Spot_Referral_Message2_Enabled";
    BotVariables["Bot_Spot_Referral_Message2"] = "Bot_Spot_Referral_Message2";
    BotVariables["Bot_Spot_Referral_Referral_ContactMethod"] = "Bot_Spot_Referral_Referral_ContactMethod";
    BotVariables["Bot_Spot_Referral_Referral_wantShortProfile"] = "Bot_Spot_Referral_Referral_wantShortProfile";
    BotVariables["Bot_Spot_Referral_Referral_CollectionMethod"] = "Bot_Spot_Referral_Referral_CollectionMethod";
    BotVariables["Bot_Spot_Referral_Referral_SecondaryOptional"] = "Bot_Spot_Referral_Referral_SecondaryOptional";
    BotVariables["Bot_Spot_Referral_Referral_Confirm1"] = "Bot_Spot_Referral_Referral_Confirm1";
})(BotVariables || (BotVariables = {}));

var _a$2;
var RecommendedVariables = (_a$2 = {},
    _a$2[BotVariables.Bot_Has_Completed_Quick_Start] = "1",
    _a$2[BotVariables.Bot_Operator_Email] = undefined,
    _a$2[BotVariables.Bot_Operator_Name] = undefined,
    _a$2[BotVariables.Bot_Operator_Phone] = undefined,
    _a$2[BotVariables.Bot_Operator_Website] = undefined,
    _a$2[BotVariables.Bot_Operator_24HourAccess] = "0",
    _a$2[BotVariables.Bot_Operator_AboutStorageCompanyURL] = undefined,
    _a$2[BotVariables.Bot_Operator_Access_GateCode1] = "All locations have security measures, while most include passcode protected entry.",
    _a$2[BotVariables.Bot_Operator_Access_GateCode2] = "All access code issues are handled by contacting your facility or by calling #*[Company: Phone]Bot_Operator_Phone*#.",
    _a$2[BotVariables.Bot_Operator_Access_GateCode3] = undefined,
    _a$2[BotVariables.Bot_Operator_Access_GateCode3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Access_GateCodeIntegration] = undefined,
    _a$2[BotVariables.Bot_Operator_AccountLoginPage] = undefined,
    _a$2[BotVariables.Bot_Operator_AccountLoginURL] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_PayBill1] = "I can help you pay your bill online. Remember your payment is due on the first day of each month.",
    _a$2[BotVariables.Bot_Operator_Account_PayBill2] = "You can also pay by phone by calling #*[Company: Phone]Bot_Operator_Phone*#.",
    _a$2[BotVariables.Bot_Operator_Account_PayBill2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Account_PayBill3] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_PayBill3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Account_AutoPay1] = "Auto pay can be configured through your online portal/account or in person at your storage office.",
    _a$2[BotVariables.Bot_Operator_Account_AutoPay2] = "To cancel Auto pay, you can log into your online account or contact the facility you have your unit with directly to complete this cancellation.",
    _a$2[BotVariables.Bot_Operator_Account_AutoPay2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Account_CreateLogin1] = "Creating an account is fast and easy. On the My Account page, select “create account”, enter your email address as a username, and choose a secure password.",
    _a$2[BotVariables.Bot_Operator_Account_CreateLogin2] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_CreateLogin2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Account_DebtCredit1] = "The best way to see if your account has a credit or debit is to log into our online portal or call your local store manager.",
    _a$2[BotVariables.Bot_Operator_Account_DebtCredit2] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_DebtCredit2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Account_ForgotUsername1] = "If you need to reset or update your username, navigate to your login page and select the forgot username link.",
    _a$2[BotVariables.Bot_Operator_Account_ForgotUsername2] = "You will see a banner prompting you to go to your email account and follow the steps to retrieve your username.",
    _a$2[BotVariables.Bot_Operator_Account_ForgotUsername2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Account_GracePeriod1] = "You will be charged a late fee on the 5th day past the due date (or applicable to your state's laws as outlined in your lease).",
    _a$2[BotVariables.Bot_Operator_Account_GracePeriod2] = "The date of the late fee varies by state. Please contact your facility directly for more information. ",
    _a$2[BotVariables.Bot_Operator_Account_GracePeriod2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Account_Reservation1] = "The easiest way to manage your active reservations is to login to your account. You can also get an updated list of reservations by contacting your local facility.",
    _a$2[BotVariables.Bot_Operator_Account_Reservation2] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_Reservation2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Account_ResetPassword1] = "If you need to reset or update your password, navigate to your login page and select the reset password link.",
    _a$2[BotVariables.Bot_Operator_Account_ResetPassword2] = "You will see a banner prompting you to go to your email account to follow the steps to create a new password.",
    _a$2[BotVariables.Bot_Operator_Account_ResetPassword2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Account_UpdateBillingInformation1] = "To update your billing information, please login to your online account. Any updates to your personal information needs to be done in writing in-person at the facility. ",
    _a$2[BotVariables.Bot_Operator_Account_UpdateBillingInformation2] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_UpdateBillingInformation2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Account_UpdateBillingInformation3] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_UpdateBillingInformation3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Account_UpdateContactInformation1] = "You can update all of your contact information by logging in to your online account or contacting your facility directly.",
    _a$2[BotVariables.Bot_Operator_Account_UpdateContactInformation2] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_UpdateContactInformation2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Account_PastDue1] = "Your monthly rent is due on the same day each month. ",
    _a$2[BotVariables.Bot_Operator_Account_PastDue2] = "For further details, please refer to your lease or contact your storage facility. Late fees cannot be waived, and the full balance must be paid immediately to avoid foreclosure. No partial payments are accepted. Please also note that until your account is paid in full, access to your unit may be denied, your gate code access is removed, and your unit will be over-locked. ",
    _a$2[BotVariables.Bot_Operator_Account_PastDue2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterHoursAccess] = undefined,
    _a$2[BotVariables.Bot_Operator_AfterHoursEmergencyPhone] = undefined,
    _a$2[BotVariables.Bot_Operator_Appointment] = undefined,
    _a$2[BotVariables.Bot_Operator_Auctions] = undefined,
    _a$2[BotVariables.Bot_Operator_BotName] = undefined,
    _a$2[BotVariables.Bot_Operator_BusinessStorage] = undefined,
    _a$2[BotVariables.Bot_Operator_CareerURL] = "0",
    _a$2[BotVariables.Bot_Operator_CareersURL] = undefined,
    _a$2[BotVariables.Bot_Operator_ChangeDueDate1] = "We can help you update your payment date by calling the facility you are storing at and speaking with the manager.",
    _a$2[BotVariables.Bot_Operator_ChangeDueDate2] = undefined,
    _a$2[BotVariables.Bot_Operator_ChangeDueDate2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_ChangeDueDate3] = "Rent for your space is easy to remember — it’s always due on the first of each month.",
    _a$2[BotVariables.Bot_Operator_ChangeDueDate4] = undefined,
    _a$2[BotVariables.Bot_Operator_ChangeDueDate4_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_ChangeDueDate5] = "Rent for your space is easy to remember — it’s always due on the 15th of each month.",
    _a$2[BotVariables.Bot_Operator_ChangeDueDate6] = undefined,
    _a$2[BotVariables.Bot_Operator_ChangeDueDate6_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_ChangeDueDate7] = "Rent for your space is easy to remember — it’s always due on your anniversary day of each month.",
    _a$2[BotVariables.Bot_Operator_ChangeDueDate8] = undefined,
    _a$2[BotVariables.Bot_Operator_ChangeDueDate8_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_ChangeDueDate] = "0",
    _a$2[BotVariables.Bot_Operator_ClimateControlName] = "Climate Controlled",
    _a$2[BotVariables.Bot_Operator_Cost_AdminFee1] = "There is a one time admin fee of #*[Operator: Admin Fee]Bot_Operator_Lease_AdminFeeAmount*# with each rental.",
    _a$2[BotVariables.Bot_Operator_Cost_AdminFee2] = undefined,
    _a$2[BotVariables.Bot_Operator_Cost_AdminFee2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Cost_Insurance1] = "Insurance cost varies by location and size of your rental space.",
    _a$2[BotVariables.Bot_Operator_Cost_LateFee1] = "Your monthly rent is due on the stated monthly due date. Any late fees or restrictions to access varies by state according to local self storage law. Contact your local facility for specific fee information.",
    _a$2[BotVariables.Bot_Operator_Cost_LateFee2] = "We prefer you are not caught late and would be happy to set you up on automatic payments with any credit card or checking account.",
    _a$2[BotVariables.Bot_Operator_Cost_LateFee2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Cost_RateIncrease1] = "Rates do fluctuate due to various reasons such as the current market, occupancy, and availability.",
    _a$2[BotVariables.Bot_Operator_Cost_RateIncrease2] = undefined,
    _a$2[BotVariables.Bot_Operator_Cost_RateIncrease2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Cost_WebRates1] = "I can help you find the most updated pricing. ",
    _a$2[BotVariables.Bot_Operator_Cost_WebRates2] = "The pricing on our website reflects the best price we can offer our spaces at #*[Operator: Name]Bot_Operator_Name*#.",
    _a$2[BotVariables.Bot_Operator_Cost_WebRates2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_CoveredVehicleStorage] = undefined,
    _a$2[BotVariables.Bot_Operator_DeliveriesAccepted] = undefined,
    _a$2[BotVariables.Bot_Operator_DiscountCodeDescription] = undefined,
    _a$2[BotVariables.Bot_Operator_DiscountCodeDisplayName] = undefined,
    _a$2[BotVariables.Bot_Operator_DiscountCode] = undefined,
    _a$2[BotVariables.Bot_Operator_Discount_CustomDisplayName] = undefined,
    _a$2[BotVariables.Bot_Operator_Discount_Custom] = undefined,
    _a$2[BotVariables.Bot_Operator_Discount_LongTerm] = undefined,
    _a$2[BotVariables.Bot_Operator_Discount_Military] = undefined,
    _a$2[BotVariables.Bot_Operator_Discount_Senior] = undefined,
    _a$2[BotVariables.Bot_Operator_Discount_Student] = undefined,
    _a$2[BotVariables.Bot_Operator_Dollies] = undefined,
    _a$2[BotVariables.Bot_Operator_Dumpster] = undefined,
    _a$2[BotVariables.Bot_Operator_Elevators] = undefined,
    _a$2[BotVariables.Bot_Operator_Franchise] = undefined,
    _a$2[BotVariables.Bot_Operator_IndoorVehicleStorage] = undefined,
    _a$2[BotVariables.Bot_Operator_InsuranceDisplayName] = "Insurance",
    _a$2[BotVariables.Bot_Operator_InsuranceURL] = undefined,
    _a$2[BotVariables.Bot_Operator_InsuranceWebsiteURL] = undefined,
    _a$2[BotVariables.Bot_Operator_InventoryCarousel] = undefined,
    _a$2[BotVariables.Bot_Operator_Lease_Cancellation1] = "To cancel your unit, you are required to provide 10 days advanced notice.",
    _a$2[BotVariables.Bot_Operator_Lease_Cancellation2] = "It is the responsibility of the renter to cancel and remove all stored items from the space.",
    _a$2[BotVariables.Bot_Operator_Lease_Cancellation3] = "Please notify us prior to us receiving your last month's payment, and we will prorate your last month of rent (i.e., charging you only for the days you use).",
    _a$2[BotVariables.Bot_Operator_Lease_Cancellation3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Lease_Claim1] = "All tenants are required to have insurance covering their goods. Claims should be made through the tenant's insurance provider.",
    _a$2[BotVariables.Bot_Operator_Lease_Claim2] = undefined,
    _a$2[BotVariables.Bot_Operator_Lease_Claim2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Lease_ContractLengths1] = "Storage units are available on a month-to-month basis, giving you flexibility to keep your storage unit for the amount of time that makes most sense for you.",
    _a$2[BotVariables.Bot_Operator_Lease_ContractLengths2] = "Monthly rent is due on the first of the month.",
    _a$2[BotVariables.Bot_Operator_Lease_ContractLengths3] = "For your convenience, we offer many payment options including the option to pre-pay for up to six or twelve months of rent at a discount.",
    _a$2[BotVariables.Bot_Operator_Lease_ContractLengths3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Lease_ContractLengths4] = "Your lease requires seven days verbal notice before vacating. The unit must be empty with the lock removed before the end of office hours on the last day of your month. We do not prorate.",
    _a$2[BotVariables.Bot_Operator_Lease_ContractLengths4_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Lease_Covid] = "All of our offices are open and operating normally. We are following all CDC guidelines when it comes to cleaning and protection.",
    _a$2[BotVariables.Bot_Operator_Lease_CutLocks] = "Although we hope you find your key/combo before getting to that point, in most cases we can help you with your lock for a small fee. Please contact your store manager for help.",
    _a$2[BotVariables.Bot_Operator_Lease_FacilityAccess1] = "In order to access your space, your account must be in good standing.",
    _a$2[BotVariables.Bot_Operator_Lease_FacilityAccess2] = "Facility access hours vary by location.",
    _a$2[BotVariables.Bot_Operator_Lease_Insurance1] = "While losses in self storage are typically rare, unforeseen events may occur and we want to make sure you are covered in the event of a loss, as we are not liable for losses related to your stored goods.",
    _a$2[BotVariables.Bot_Operator_Lease_Insurance2] = "As such, we require that all tenants have insurance on their units. You can enroll in coverage available through our partner insurance provider or bring in evidence of an existing policy that you have which covers remotely stored goods.",
    _a$2[BotVariables.Bot_Operator_Lease_Insurance3] = "When providing your own insurance, you will need to contact the policy provider and confirm your policy does cover remotely stored goods.",
    _a$2[BotVariables.Bot_Operator_Lease_LiveInUnit1] = "As per our lease, living in a unit is not allowed. For more details, refer to your lease document.",
    _a$2[BotVariables.Bot_Operator_Lease_LiveInUnit2] = undefined,
    _a$2[BotVariables.Bot_Operator_Lease_LiveInUnit2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Lease_MoveOutPolicy1] = "To move out of your storage unit, please contact your facility directly to sign the Intent to Vacate Notice. Most states require 15 days written notice. California requires 3 days.",
    _a$2[BotVariables.Bot_Operator_Lease_MoveOutPolicy2] = "Please notify us prior to sending your last month's payment, and we will prorate your last month of rent (i.e., charging you only for the days you use).",
    _a$2[BotVariables.Bot_Operator_Lease_MoveOutPolicy3] = "On your scheduled move-out day make sure the unit is completely empty, your lock has been removed, and the facility manager has inspected the unit.",
    _a$2[BotVariables.Bot_Operator_Lease_MoveOutPolicy3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Lease_Overlock1] = "Typically, when we put a lock on your unit it's because we need to talk to you. ",
    _a$2[BotVariables.Bot_Operator_Lease_Overlock2] = "Although there could be other reasons, most often it’s simply there to discuss getting you caught up on a missed or late payment. If you have more questions, please call your local facility.",
    _a$2[BotVariables.Bot_Operator_Lease_Overlock3] = undefined,
    _a$2[BotVariables.Bot_Operator_Lease_Overlock3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Lease_Pricing1] = "We work hard to provide value for our customers through competitive pricing and by maintaining clean, safe, and secure facilities with the best customer service in the self storage industry.",
    _a$2[BotVariables.Bot_Operator_Lease_Pricing2] = "Please keep in mind that your original monthly rate is not guaranteed for the life of your rental with #*[Company: Name]Bot_Operator_Name*#.",
    _a$2[BotVariables.Bot_Operator_Lease_Pricing2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Lease_Pricing3] = "From time to time, we make adjustments to our customers’ rental rates to keep up with the rising costs associated with providing top-notch storage experience.",
    _a$2[BotVariables.Bot_Operator_Lease_Pricing3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Lease_Prorate1] = "When you are ready to vacate, 15 days written notice is required before vacating (or other state applicable vacating terms). We will prorate your last month of rent (i.e., charging you only for the days you use).",
    _a$2[BotVariables.Bot_Operator_Lease_Prorate2] = undefined,
    _a$2[BotVariables.Bot_Operator_Lease_Prorate2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Lease_Refunds1] = "Any rent that is prepaid beyond the current lease month will be refunded once you've moved out.",
    _a$2[BotVariables.Bot_Operator_Lease_Refunds2] = "All refund inquiries can be handled by contacting your local facility directly.",
    _a$2[BotVariables.Bot_Operator_Lease_Refunds2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Lease_StorableItems1] = "Storage units can be used for a wide range of items, from furniture to vehicles. In general, items that cannot be stored include anything illegal, flammable or combustible, or perishable (food-based items).",
    _a$2[BotVariables.Bot_Operator_Lease_StorableItems2] = "Examples of items that cannot be stored include food, firearms and ammunition, illegal drugs, flammable and combustible items (gas, propane tanks, and car batteries), and vehicles not in working order.",
    _a$2[BotVariables.Bot_Operator_Lease_StorableItems2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Lease_StorableItems3] = "Other than minor maintenance to a running car, storage units cannot be used as a work shop to work on a car.",
    _a$2[BotVariables.Bot_Operator_Lease_StorableItems3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Lease_UnitTransfer1] = "Once you're in your unit and decide you need more or less space, we're happy to help you find a better space. ",
    _a$2[BotVariables.Bot_Operator_Lease_UnitTransfer2] = "Come in to our office and we'll help you find a new space and make sure any unused rental credits you have move to the new unit.",
    _a$2[BotVariables.Bot_Operator_Lease_UnitTransfer2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_LiveChat] = undefined,
    _a$2[BotVariables.Bot_Operator_Lockers] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_CancelService1] = "For account information, or to cancel your account, please contact our team by calling your local storage facility.",
    _a$2[BotVariables.Bot_Operator_Account_CancelService2] = undefined,
    _a$2[BotVariables.Bot_Operator_Account_CancelService2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Move_Dolly1] = "Most of our facilities have carts that may be used at your convenience.",
    _a$2[BotVariables.Bot_Operator_Move_Dolly2] = "If you need a cart to transport your belongings, please let the facility manager know, and they will be happy to assist you.",
    _a$2[BotVariables.Bot_Operator_Move_Dolly2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Move_KeyAccessLock1] = "Most locations have security measures that include controlled access with a key required for entry.",
    _a$2[BotVariables.Bot_Operator_Move_KeyAccessLock2] = "Please note that you must provide a lock for your storage unit.",
    _a$2[BotVariables.Bot_Operator_Move_MovingSupplies1] = "Most storage facilities have move-in supplies available for purchase. So, if you need a lock, boxes, packing tape or a move-in kit, we've got you covered!",
    _a$2[BotVariables.Bot_Operator_Move_MovingSupplies2] = "Please reach out to the facility you are interested in directly for questions regarding merchandise.",
    _a$2[BotVariables.Bot_Operator_Move_MovingTruck1] = "Most of our locations have rental trucks available for reservation.",
    _a$2[BotVariables.Bot_Operator_Move_MovingTruck2] = undefined,
    _a$2[BotVariables.Bot_Operator_Move_MovingTruck2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Move_Tour1] = "For a tour of our facility, stop by during office hours.",
    _a$2[BotVariables.Bot_Operator_MovingServices] = undefined,
    _a$2[BotVariables.Bot_Operator_MovingTruck] = undefined,
    _a$2[BotVariables.Bot_Operator_Notary] = undefined,
    _a$2[BotVariables.Bot_Operator_OutdoorVehicleStorage] = undefined,
    _a$2[BotVariables.Bot_Operator_OutdoorVehicleStorage1] = "Outdoor parking spaces are typically large enough to accommodate your car, truck, boat, or RV. Rent space for your trailer, jet skis, or ATVs.",
    //[Var.Bot_Operator_OutsideBusiness_FollowUpHRs] :                undefined,
    _a$2[BotVariables.Bot_Operator_PackingSupplies] = undefined,
    _a$2[BotVariables.Bot_Operator_PayOnlineURL] = undefined,
    _a$2[BotVariables.Bot_Operator_PayOnline] = undefined,
    _a$2[BotVariables.Bot_Operator_PayByPhoneNumber] = undefined,
    _a$2[BotVariables.Bot_Operator_PreferredContactMethod] = undefined,
    _a$2[BotVariables.Bot_Operator_ProblemResolutionChannel] = undefined,
    _a$2[BotVariables.Bot_Operator_Problem_BillingDispute1] = "Your store manager will know how to help you with billing issues.",
    _a$2[BotVariables.Bot_Operator_Problem_BillingDispute2] = "Please call your facility immediately to further discuss this issue.",
    _a$2[BotVariables.Bot_Operator_Problem_BillingDispute2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Problem_DamagedItems1] = "Please call your facility to further discuss this issue.",
    _a$2[BotVariables.Bot_Operator_Problem_DamagedItems2] = "You may also want to contact your insurance provider.",
    _a$2[BotVariables.Bot_Operator_Problem_DamagedItems2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Problem_Emergency1] = "If this is a true emergency, please call 9-1-1.",
    _a$2[BotVariables.Bot_Operator_Problem_Emergency2] = "Please call your facility immediately to further discuss this issue.",
    _a$2[BotVariables.Bot_Operator_Problem_Emergency2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Problem_GetOut1] = "Please contact your on-site manager to help you with access issues.",
    _a$2[BotVariables.Bot_Operator_Problem_GetOut2] = undefined,
    _a$2[BotVariables.Bot_Operator_Problem_GetOut2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Problem_Theft1] = "Please call your facility to further discuss this issue.",
    _a$2[BotVariables.Bot_Operator_Problem_Theft2] = "You may also want to contact your insurance provider",
    _a$2[BotVariables.Bot_Operator_Problem_Theft2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Problem_WebIssue1] = "Please contact your on-site manager to help you with website issues.",
    _a$2[BotVariables.Bot_Operator_Problem_WebIssue2] = undefined,
    _a$2[BotVariables.Bot_Operator_Problem_WebIssue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Problem_LostKey1] = "If you can't find your key, your property manager can help restore access to your unit.",
    _a$2[BotVariables.Bot_Operator_Problem_LostKey2] = "Please call or visit your facility immediately to further discuss this issue.",
    _a$2[BotVariables.Bot_Operator_Problem_LostKey2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Purchase_Franchise1] = "For all business related inquiries, please contact us at #*[Company: Phone]Bot_Operator_Phone*# ",
    _a$2[BotVariables.Bot_Operator_Purchase_Franchise2] = undefined,
    _a$2[BotVariables.Bot_Operator_Purchase_Franchise2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Purchase_Identification1] = "You will need to bring your government issued ID with you to rent a unit.",
    _a$2[BotVariables.Bot_Operator_Purchase_MonthlyPayments1] = "The prices on our website reflect the regular monthly payment. Your monthly rent is due on the stated monthly due date (the day on which you rented your unit).",
    _a$2[BotVariables.Bot_Operator_Purchase_MonthlyPayments2] = undefined,
    _a$2[BotVariables.Bot_Operator_Purchase_MonthlyPayments2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Purchase_PayOnline1] = "We make it easy to pay your bill online. ",
    _a$2[BotVariables.Bot_Operator_Purchase_PayOnline2] = undefined,
    _a$2[BotVariables.Bot_Operator_Purchase_PayOnline2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Purchase_PaymentOptions1] = "Payments are monthly and can be made in-store, online, or by phone.",
    _a$2[BotVariables.Bot_Operator_Purchase_PaymentOptions2] = "In-store payments can be made with cash, check, or credit card.",
    _a$2[BotVariables.Bot_Operator_Purchase_PaymentOptions2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_SizeVisualsURL] = undefined,
    _a$2[BotVariables.Bot_Operator_StandardCeilingHeight] = "8ft",
    _a$2[BotVariables.Bot_Operator_URLFormatLocations] = undefined,
    _a$2[BotVariables.Bot_Operator_VehicleStorageGuidelines1] = "Vehicles must be driven into the storage unit, not towed or stored on blocks. Tires must be inflated and inspected for signs of dry rot.",
    _a$2[BotVariables.Bot_Operator_VehicleStorageGuidelines2] = "Current registration and proof of insurance is required. Any tags that expire while in storage should be renewed.",
    _a$2[BotVariables.Bot_Operator_VehicleStorageGuidelines3] = "No repairs or extensive maintenance may be performed inside the storage unit.",
    _a$2[BotVariables.Bot_Operator_VehicleStorageGuidelines3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_VehicleStorageGuidelines4] = "Car covers are recommended for vehicles stored outside. Remove as much gasoline from the fuel tank as possible before storing.",
    _a$2[BotVariables.Bot_Operator_VehicleStorageGuidelines4_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_swivlCRM] = "1",
    //[Var.Bot_Store_ElectricityInUnit] :                             undefined, //DELETE ME IF 1.7 works
    //[Var.Bot_Store_Elevator] :                                      undefined,//DELETE ME IF 1.7 works
    //[Var.Bot_Store_Internet] :                                      undefined,//DELETE ME IF 1.7 works
    //[Var.Bot_Store_Shelving] :                                      undefined,//DELETE ME IF 1.7 works
    _a$2[BotVariables.Bot_Operator_ClimateControlLowValue] = "55 degrees",
    _a$2[BotVariables.Bot_Operator_ClimateControlHighValue] = "80 degrees",
    _a$2[BotVariables.Bot_Operator_ClimateControl] = "1",
    _a$2[BotVariables.Bot_Operator_HumidityControl] = "0",
    _a$2[BotVariables.Bot_Operator_HumidityControlLowValue] = "10%",
    _a$2[BotVariables.Bot_Operator_HumidityControlHighValue] = "20%",
    _a$2[BotVariables.Bot_Operator_Feature_Security1] = "The security of your belongings is very important to us. That is why we design our facilities with state-of-the-art security features.",
    _a$2[BotVariables.Bot_Operator_Feature_MaintenancePest1] = "We ensure all buildings are as clean as possible. ",
    _a$2[BotVariables.Bot_Operator_Feature_MaintenancePest2] = "Our common areas are treated for pests and rodents on a regular schedule.",
    _a$2[BotVariables.Bot_Operator_Feature_MaintenancePest2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Feature_Lights1] = "Our facilities are well lit, plus most have motion-activated energy-efficient bulbs.",
    _a$2[BotVariables.Bot_Operator_Feature_Auction1] = "Most of our locations have auctions.",
    _a$2[BotVariables.Bot_Operator_Lease_HoldUnit1] = "I'm here to help you find a unit and hold the price and size. You can make a reservation online for free. ",
    _a$2[BotVariables.Bot_Operator_Lease_HoldUnit2] = undefined,
    _a$2[BotVariables.Bot_Operator_Lease_HoldUnit2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Lease_WorkIn1] = "For storage guidelines,  refer to your rental agreement for complete details of proper use of the unit.",
    _a$2[BotVariables.Bot_Operator_Lease_WorkIn2] = undefined,
    _a$2[BotVariables.Bot_Operator_Lease_WorkIn2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Lease_LateFeeAmount] = "$20",
    _a$2[BotVariables.Bot_Operator_Lease_AdminFeeAmount] = "$25",
    _a$2[BotVariables.Bot_Operator_Feature_HasRecycle] = "0",
    _a$2[BotVariables.Bot_Operator_Recycle_URL] = undefined,
    _a$2[BotVariables.Bot_Operator_swivl_SendLeadEmail] = "1",
    _a$2[BotVariables.Bot_Operator_swivl_LeadEmailList] = undefined,
    _a$2[BotVariables.Bot_Operator_swivl_CodaDocID] = undefined,
    _a$2[BotVariables.Bot_Operator_swivl_CodaTableID] = "grid-1zU0z-vygW",
    _a$2[BotVariables.Bot_Operator_TwoUnhandledBeforeEscalation] = "1",
    _a$2[BotVariables.Bot_Operator_FMS] = "0",
    // New for 1.3
    _a$2[BotVariables.Bot_Operator_WelcomeLeadCollect] = "0",
    _a$2[BotVariables.Bot_Operator_HasPreferredContactMethod] = "0",
    _a$2[BotVariables.Bot_Operator_Feature_WonAuction1] = "If you win a unit, you'll get an email (and a text if you've turned that on) and will need to contact the facility and let them know when you'll be in to pick up. You'll have up to 72 hours (48 in some auctions) to pick up your stuff.",
    _a$2[BotVariables.Bot_Operator_Feature_WonAuction2] = "You'll need to bring cash for the bid amount, cleaning deposit, and sales tax (if charged). You pay those charges directly to the storage facility, and will get the cleaning deposit back once you empty the unit. Some auctions require you to pay via credit card by calling a phone number.",
    _a$2[BotVariables.Bot_Operator_Feature_WonAuction2_Enabled] = "0",
    // New for Voice
    _a$2[BotVariables.Bot_Operator_swivl_HasVoice] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_SalesForward] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ServiceForward] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_SendPayBillText] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_PayBillText_Message] = "Thanks for choosing to pay your bill through your online portal. You can manage your account and enroll in autopay here: #*[Operator: Account Login]Bot_Operator_AccountLoginURL*#",
    _a$2[BotVariables.Bot_Operator_Voice_SendAfterHoursSalesText] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_AfterHoursSalesText_Message1] = "Thanks for using #*[Operator: Name]Bot_Operator_Name*#'s digital assistant. Select the link below and I'll help you find a space near you:",
    _a$2[BotVariables.Bot_Operator_Voice_AfterHoursSalesText_Message2] = "www.tryswivl.com/?swivlOpen=true&swivlStartOnQuest=akPuwWvSqK",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_Discount] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_GHA] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_Hours] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_Inventory] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_Location] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_MA] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_RAP] = "1",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_TTH] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_UC] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_ULT] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_UMP] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_UPP] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_USF] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_isCallForward_USS] = "0",
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_Discount] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_GHA] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_Hours] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_Inventory] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_Location] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_MA] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_RAP] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_TTH] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_UC] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_ULT] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_UMP] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_UPP] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_USF] = undefined,
    _a$2[BotVariables.Bot_Operator_Voice_ForwardNumber_USS] = undefined,
    _a$2[BotVariables.Bot_User_Voice_IsProfileSet] = "0",
    // SMS Variables
    _a$2[BotVariables.Bot_Operator_swivl_HasSMS] = "0",
    // New for 1.4
    _a$2[BotVariables.Bot_Operator_hasSingleLocation] = "0",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Persona_Existing] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Persona_Potential] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Persona_Unknown] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Tag_Contact] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Tag_Escalation] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Tag_Problem] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Tag_Sales] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Tag_Service] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Tag_Waitlist] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_isLeadSent_Tag_Unknown] = "1",
    _a$2[BotVariables.Bot_Operator_Feature_MovingServices1] = "Yes, we offer moving services for an additional fee.",
    _a$2[BotVariables.Bot_Operator_Feature_MovingServices2] = "Contact your local facility for more information.",
    _a$2[BotVariables.Bot_Operator_Feature_MovingServices2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Cost_CreditCardFee1] = "No, we currently do not charge a credit card fee if you decide to pay your bill with a card.",
    _a$2[BotVariables.Bot_Operator_Cost_CreditCardFee2] = undefined,
    _a$2[BotVariables.Bot_Operator_Cost_CreditCardFee2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_swivl_HasGoogleReviews] = "0",
    _a$2[BotVariables.Bot_Operator_CTA_hasCustomMessage] = "0",
    _a$2[BotVariables.Bot_Operator_CTA_Message2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_CTA_Message3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_CTA_URLNavigateToMessage1] = "Would you like me to navigate you to the CTA page?",
    // New Voice Defaults
    _a$2[BotVariables.Bot_Operator_Voice_Problem_GetOut] = "I'm sorry you're having access issues. I will forward your call to a teammate who can help resolve the problem.",
    _a$2[BotVariables.Bot_Operator_Voice_Problem_BillingIssue] = "I'm sorry you're having billing issues. I will forward your call to a teammate who can help resolve the problem.",
    _a$2[BotVariables.Bot_Operator_Voice_Problem_Emergency] = "I'm sorry you're experiencing issues. If this is a true emergency, please call 9-1-1. For all other issues, stay on the line. I will forward your call to a teammate now.",
    _a$2[BotVariables.Bot_Operator_Voice_Problem_LostKey] = "If you can't find your key, your property manager can help restore access to your unit. I will forward your call to a teammate who can help resolve the problem.",
    _a$2[BotVariables.Bot_Operator_Voice_Problem_Theft] = "I'm sorry you've experienced a theft at the facility. The security of your items is a top priority. Stay on the line. I will forward your call to a teammate now. You may also want to reach out to your insurance company to report a claim.",
    _a$2[BotVariables.Bot_Operator_Voice_Problem_WebIssue] = "I'm sorry you're having web issues. I will forward your call to a teammate who can help resolve the problem.",
    _a$2[BotVariables.Bot_Operator_Voice_Problem_DamageItem] = "I'm sorry your items have gotten damaged at the facility. The security of your items is a top priority. Stay on the line. I will forward your call to a teammate now. You may also want to reach out to your insurance company to report a claim.",
    _a$2[BotVariables.Bot_Operator_Voice_Account_CRUDInformation] = "We've made it simple to update all of your contact information by logging in to your online account.",
    _a$2[BotVariables.Bot_Operator_Voice_Account_Cancel] = "Ok, I understand you're ready to move out of your space. I will forward your call to a teammate now.",
    _a$2[BotVariables.Bot_Operator_Voice_Account_PayBill] = "Thanks for choosing to pay your bill through your online portal. You can manage your account and enroll in autopay here: #*[Operator: Account Login]Bot_Operator_AccountLoginURL*#",
    _a$2[BotVariables.Bot_Operator_Voice_Access_GateCode] = "All locations have security measures, while most include passcode protected entry. You can find your code by logging into your account online or wait on the line while I forward your call to a teammate now.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_Pricing] = "We work hard to provide value for our customers through competitive pricing and by maintaining clean, safe, and secure facilities with the best customer service in the self storage industry. Stay on the line, I will forward your call to a teammate now to help find a perfect space now.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_StorableItems] = "Storage units can be used for a wide range of items, from furniture to vehicles. In general, items that cannot be stored include anything illegal, flammable or combustible, or perishable (food-based items).",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_ContractLengths] = "Storage units are available on a month-to-month basis, giving you flexibility to keep your storage unit for the amount of time that makes most sense for you.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_FacilityAccess] = "In order to access your space, your account must be in good standing. Access hours varies by location.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_Refunds] = "Any rent that is prepaid beyond the current lease month will be refunded once you've moved out.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_Prorate] = "When you are ready to vacate, 15 days written notice is required before vacating (or other state applicable vacating terms). We will prorate your last month of rent (i.e., charging you only for the days you use).",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_Insurance] = "We require that all tenants have insurance on their units. You can enroll in coverage available through our partner insurance provider or bring in evidence of an existing policy that you have which covers remotely stored goods.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_Claim] = "All tenants are required to have insurance covering their goods. Claims should be made through the tenant's insurance provider.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_Covid] = "All of our offices are open and operating normally. We are following all CDC guidelines when it comes to cleaning and protection.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_CutLocks] = "Although we hope you find your key/combo before getting to that point, in most cases we can help you with your lock for a small fee. Please contact your store manager for help.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_OverLocks] = "Typically, when we put a lock on your unit it's because we need to talk to you.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_LiveInUnit] = "As per our lease, living in a unit is not allowed. For more details, refer to your lease document.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_Cancellation] = "To cancel your unit, you are required to provide 10 days advanced notice. If you are ready to move out of your space, please stay on the line and I will forward your call to a teammate now.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_MoveOutPolicy] = "To move out of your storage unit, please contact your facility directly to sign the Intent to Vacate Notice. If you are ready to move out of your space, please stay on the line and I will forward your call to a teammate now.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_UnitTransfer] = "Once you're in your unit and decide you need more or less space, we're happy to help you find a better space.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_HoldUnit] = "I'm here to help you find a unit and hold the price and size. You can make a reservation online for free.",
    _a$2[BotVariables.Bot_Operator_Voice_Lease_WorkIn] = "For storage guidelines,  refer to your rental agreement for complete details of proper use of the unit.",
    // New for 1.5
    _a$2[BotVariables.Bot_Operator_hasWineStorage] = "0",
    _a$2[BotVariables.Bot_Operator_Feature_WineStorage1] = "We offer the option to store wine in our units. Our temperature and humidity controlled units provide the perfect environment to ensure the quality and taste of your wine is preserved.",
    _a$2[BotVariables.Bot_Operator_Feature_WineStorage2] = "Whether you're a collector or simply want to store a few bottles for a special occasion, we have the perfect solution for you.",
    _a$2[BotVariables.Bot_Operator_Feature_WineStorage2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Lead_EnableDuplicates] = "0",
    _a$2[BotVariables.Bot_Operator_Feature_hasShred] = "0",
    _a$2[BotVariables.Bot_Operator_Shred_URL] = undefined,
    _a$2[BotVariables.Bot_Operator_hasAboutURL] = "0",
    _a$2[BotVariables.Bot_Operator_hasSizeGuideURL] = "0",
    _a$2[BotVariables.Bot_Operator_hasReferralProgram] = "0",
    _a$2[BotVariables.Bot_Operator_OutdoorParking1] = "Outdoor vehicle storage is a solution that keeps your car secure in an open-air setting until you're ready to hit the road again.",
    _a$2[BotVariables.Bot_Operator_Account_PayBillContinueAutoPay] = "0",
    _a$2[BotVariables.Bot_Operator_Feature_hasDriveUp] = "0",
    _a$2[BotVariables.Bot_Operator_Feature_DriveUp1] = "Drive-up storage units offer the ultimate convenience when accessing your storage unit.",
    _a$2[BotVariables.Bot_Operator_Feature_DriveUp2] = "Drive-up units give you the ability to drive your vehicle directly up to the storage unit, making it easy to move large, heavy items.",
    _a$2[BotVariables.Bot_Operator_Feature_DriveUp2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_Access_AfterHour1] = "After Hours Access is available but we do require the guest be signed up for AutoPay to take advantage.",
    _a$2[BotVariables.Bot_Operator_Access_AfterHour2] = undefined,
    _a$2[BotVariables.Bot_Operator_Access_AfterHour2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Feature_ClimateControl1] = "We recommend #*[Climate Control Name]Bot_Operator_ClimateControlName*# units when storing temperature-sensitive items like: furniture, electronics, artwork, photographs, and more.",
    _a$2[BotVariables.Bot_Operator_Feature_ClimateControl2] = undefined,
    _a$2[BotVariables.Bot_Operator_Feature_ClimateControl2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMS_GateCodeChannel] = "Both",
    _a$2[BotVariables.Bot_Operator_FMS_GateCodeChannel_SMSMessage] = "Here is your access code: #*UserAccessCode*#",
    _a$2[BotVariables.Bot_Operator_Discount_Military1] = "We offer a military discount at most of our locations. Use the code 'Military123' at checkout for 10% off your monthly bill.",
    _a$2[BotVariables.Bot_Operator_Discount_Student1] = "We offer a student discount at most of our locations. Use the code 'Student123' at checkout for 10% off your monthly bill.",
    _a$2[BotVariables.Bot_Operator_Discount_Senior1] = "We offer a senior discount at most of our locations. Use the code 'Senior123' at checkout for 10% off your monthly bill.",
    _a$2[BotVariables.Bot_Operator_Discount_CustomDiscount1] = "We offer discounts at most of our locations. Use the code 'Custom Code' at checkout for 50% off your first month.",
    _a$2[BotVariables.Bot_Operator_Discount_LongTerm1] = "We offer a discount for long terms leases at most of our locations. Use the code 'LongTerm123' at checkout for 10% off your monthly bill.",
    /* -------------------------
        NAVIGATE TO VARIABLES New For 1.5
    ------------------------- */
    _a$2[BotVariables.Bot_Operator_NavigateTo_Holder] = undefined,
    _a$2[BotVariables.Bot_Operator_AfterNavigate_ShowInventory1] = "To finish your reservation, please click on the Reserve Now button located on the right side of the page.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_ShowInventory2] = "From there, you'll be asked to fill out contact and billing information. Finally, click on the Move In button to complete your reservation.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_ShowInventory2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SizeVisuals1] = "You can use our online storage unit calculator or size guide to estimate the size of the unit you need based on the items you want to store.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SizeVisuals2] = "Once you've found the right size unit, I can help you reserve it online.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SizeVisuals2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Autopay1] = "To enroll in autopay, you will need to log in to your account and navigate to the billing or payment section.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Autopay2] = "From there, you should be able to find an option to enroll in autopay.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Autopay2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_PayBill1] = "To pay your bill, you'll need to log in to your account and navigate to the billing or payment section.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_PayBill2] = "From there, you should be able to view your current balance and payment options. You may be able to pay your bill online using a credit card, debit card, or bank account transfer.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_PayBill2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_CreditDebit1] = "To view whether your account has a credit or debit, you'll need to log in to your account and navigate to the billing or payment section.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_CreditDebit2] = "From there, you should be able to view your account balance, which will indicate whether you have a credit or debit.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_CreditDebit2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Reservations1] = "To view your reservations, you'll need to log in to your account and navigate to the reservations section.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Reservations2] = "From there, you should be able to view any upcoming or past reservations that you have made.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Reservations2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Password1] = "To reset your password, please click on the Forgot Password link located below the login form.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Password2] = "From there, enter the email address associated with your account and we'll send you an email with instructions on how to reset your password. If you have any further questions or issues, feel free to reach out to our customer support team.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Password2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateContact1] = "To update your contact information, you'll need to log in to your account and navigate to the account or profile section.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateContact2] = "From there, you should be able to view and update your contact information such as your email address, phone number, and mailing address.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateContact2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling1] = "To update your billing information, you'll need to log in to your account and navigate to the billing or payment section.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling2] = "From there, you should be able to view your current billing information and make any necessary updates.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_CreateLogin1] = "Select the option to create a new account. From there, you'll need to provide some basic information such as your name, email address, and a secure password.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_CreateLogin2] = "Once you've completed the registration process, you should receive a confirmation email to verify your account.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_CreateLogin2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Username1] = "To retrieve a forgotten username, please click on the Forgot Username link located below the login form.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Username2] = "From there, enter the email address associated with your account and we'll send you an email with your username. If you have any further questions or issues, feel free to reach out to our customer support team.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Username2Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Referral1] = "Start referring friends and family to experience the convenience and reliability of our self storage services while earning rewards along the way.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Referral2] = "",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Referral2Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Insurance1] = "Explore our coverage options to safeguard your belongings during their stay at our self storage facility.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Insurance2] = "",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Insurance2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Auction1] = "Here, you'll find a selection of items available for bidding from our self storage units. Dive into the inventory and place your bids responsibly.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Auction2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Feature_Referral1] = "Refer a friend or family member and help them with their storage needs. Your referral will be appreciated and could earn you a special offer!",
    _a$2[BotVariables.Bot_Operator_Feature_Referral2] = undefined,
    _a$2[BotVariables.Bot_Operator_Feature_Referral2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_ReferralName] = undefined,
    _a$2[BotVariables.Bot_Operator_ReferralPhone] = undefined,
    _a$2[BotVariables.Bot_Operator_wantsProfanityEscalation] = "0",
    _a$2[BotVariables.Bot_Operator_wantsOneMenuView] = "1",
    _a$2[BotVariables.Bot_Operator_wantsClearStoreVariables] = "0",
    _a$2[BotVariables.Bot_Operator_dontUseURLToSetStore] = "0",
    _a$2[BotVariables.Bot_Operator_ChangeDueDate_Selection] = "1st",
    /* -------------------------
        Agent Quick Reply VARIABLES New For 1.5
    ------------------------- */
    _a$2[BotVariables.Bot_Operator_QuickReply_Greeting] = "Thank you for choosing #*[Operator: Name]Bot_Operator_Name*#. My name is #*[Agent Name]User - Agent Name*#, how can I help you?",
    _a$2[BotVariables.Bot_Operator_QuickReply_Closing] = "Thank you for choosing #*[Operator: Name]Bot_Operator_Name*#. We appreciate your business. Have a good day.",
    _a$2[BotVariables.Bot_Operator_QuickReply_Usage] = "Have you used self-storage before?",
    _a$2[BotVariables.Bot_Operator_QuickReply_Storing] = "What will you be storing?",
    _a$2[BotVariables.Bot_Operator_QuickReply_When] = "When do you need the unit and how long will you be storing?",
    _a$2[BotVariables.Bot_Operator_QuickReply_PhoneNumber1] = "We have limited availability, if you would like I can call you and we can complete the rental over the phone.",
    _a$2[BotVariables.Bot_Operator_QuickReply_PhoneNumber2] = "What is the best number to contact you? ",
    _a$2[BotVariables.Bot_Operator_QuickReply_Reservation] = "I can reserve the unit for you at no cost, this will guarantee the unit size and price as well as the move-in special you have been offered for 7 days.",
    _a$2[BotVariables.Bot_Operator_QuickReply_WhatElse] = "Is there anything else I can assist you with? ",
    _a$2[BotVariables.Bot_Operator_QuickReply_Move2Text] = "Can I follow up via text message?",
    _a$2[BotVariables.Bot_Operator_QuickReply_UnderstandFeature] = "I can help you learn more about our facilities. What features are you wanting to know more about?",
    _a$2[BotVariables.Bot_Operator_QuickReply_UnderstandSize] = "I can help you find the right size. What are you trying to store?",
    _a$2[BotVariables.Bot_Operator_QuickReply_CheckInventory] = "I can help you find the perfect space. What are you trying to store?",
    /* -------------------------
        Review Reply VARIABLES New For 1.6
    ------------------------- */
    _a$2[BotVariables.Bot_Operator_ReviewReply_5Star] = "Thank you so much for your 5-star review! We are thrilled to hear that you had a positive experience with us. We appreciate your business and hope to continue serving you in the future.",
    _a$2[BotVariables.Bot_Operator_ReviewReply_Promoter] = "Thank you for taking the time to leave a glowing review. We’re glad to hear that you had a positive experience working with us. We strive to provide exceptional service to all of our clients and appreciate your kind words. If there’s anything else we can assist you with in the future, please don’t hesitate to reach out.",
    _a$2[BotVariables.Bot_Operator_ReviewReply_Passive] = "Thank you for taking the time to leave a review. We apologize for any inconvenience or dissatisfaction you may have experienced. We strive to provide the best service possible and we appreciate your feedback. If there is anything we can do to improve your experience, please do not hesitate to reach out to us.",
    _a$2[BotVariables.Bot_Operator_ReviewReply_Detractor] = "We’re sorry to hear that you had a negative experience with our business. We take all feedback seriously and are always looking for ways to improve our services. If you could provide us with more details about your experience, we would be happy to address any issues and work towards a resolution.Thank you for your feedback and we hope to have the opportunity to serve you better in the future.",
    _a$2[BotVariables.Bot_Operator_ReviewReply_1Star] = "We are sorry to hear that you had a negative experience with us. We take all feedback seriously and we would like to learn more about your experience so we can improve our services. Please feel free to reach out to us directly so we can address your concerns. Thank you for taking the time to share your feedback with us.",
    _a$2[BotVariables.Bot_Operator_ReviewReply_General] = "We’re glad you took the time to rate us. Your feedback is highly valued, and we’re grateful for choosing our business. Should you have any additional comments or suggestions, we’re all ears. We look forward to the opportunity to serve you again.",
    /* -------------------------
      New For 1.6
    ------------------------- */
    _a$2[BotVariables.Bot_Operator_hasAfterNavigate] = "1",
    _a$2[BotVariables.Bot_Operator_isLiveChatFirst] = "0",
    _a$2[BotVariables.Bot_Operator_LiveChatFirst_CollectProfile] = "0",
    _a$2[BotVariables.Bot_Operator_wantsCustomerInitiatedEscalations] = "1",
    _a$2[BotVariables.Bot_Operator_wantsBotInitiatedEscalations_Sales] = "0",
    _a$2[BotVariables.Bot_Operator_wantsBotInitiatedEscalations_Service] = "0",
    _a$2[BotVariables.Bot_Operator_wantsBotInitiatedEscalations_LowConfidence] = "1",
    _a$2[BotVariables.Bot_Operator_Temp_FMSName] = undefined,
    _a$2[BotVariables.Bot_Operator_Temp_FMSEmail] = undefined,
    _a$2[BotVariables.Bot_Operator_Temp_FMSPhone] = undefined,
    _a$2[BotVariables.Bot_Operator_Temp_FMSZip] = undefined,
    _a$2[BotVariables.Bot_Operator_wantsCronReceipts_MoveOut] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveIn1] = "#*[Operator: Name]Bot_Operator_Name*#: Welcome to #*StoreName*#, #*Entity personName*#! We're thrilled to have you with us. If you have any questions or need assistance as you settle in, please don't hesitate to ask our on-site staff or give us a call at #*StorePhoneNumber*#.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveIn2] = "Remember, your unit number is #*UserUnitNumber*#, and the access code for the gate is #*UserAccessCode*#.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveIn2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveIn3] = "Additionally, the following lock types are accepted at this facility: #*StoreLockTypes*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveIn3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveIn1] = "#*[Operator: Name]Bot_Operator_Name*#: Hope your move-in was smooth, #*Entity personName*#! Remember, we're here to help, so if you've got any questions about #*StoreName*# or need support, just let us know.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveIn2] = "Your feedback matters to us, so feel free to leave us a review at #*StoreGoogleReviewURL*#.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveIn2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveIn3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveIn3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveIn1] = "#*[Operator: Name]Bot_Operator_Name*#: By now, you're probably getting settled with your storage unit at #*StoreName*#, #*Entity personName*#. If you're finding you need more space or have any concerns, we're just a message away. Contact us at #*StorePhoneNumber*# or #*StoreEmail*# for immediate assistance.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveIn2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveIn2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveIn3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveIn3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveIn1] = "#*[Operator: Name]Bot_Operator_Name*#: It's been a few days since your move-in, #*Entity personName*#. We hope everything is to your satisfaction at #*StoreName*#. Feel free to share any feedback or questions you might have. Your input helps us serve you better.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveIn2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveIn2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveIn3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveIn3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveIn1] = "#*[Operator: Name]Bot_Operator_Name*#: One week with us already, #*Entity personName*#! We hope your self-storage experience at #*StoreName*# has been nothing but positive. Remember, we're here if you need anything.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveIn2] = "Also, you can manage your account and payments at #*Bot_Operator_AccountLoginURL*#.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveIn2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveIn3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveIn3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveIn1] = "#*[Operator: Name]Bot_Operator_Name*#: Ten days have flown by since you joined our self-storage community at #*StoreName*#, #*Entity personName*#. We're committed to your satisfaction, so don't hesitate to reach out for any reason.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveIn2] = "Also, your next payment will be due on #*UserPaymentDueDate*#.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveIn2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveIn3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveIn3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveIn1] = "#*[Operator: Name]Bot_Operator_Name*#: Two weeks have passed since your move-in, #*Entity personName*#. We hope you're settling in well at #*StoreName*#. If there's anything we can do to improve your experience, please let us know. Your feedback is invaluable.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveIn2] = "Also, your next payment will be due on #*UserPaymentDueDate*#. You can manage your account and payments at #*Bot_Operator_AccountLoginURL*#.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveIn2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveIn3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveIn3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveIn1] = "#*[Operator: Name]Bot_Operator_Name*#: Congratulations on your first month with us at #*StoreName*#, #*Entity personName*#! We value your trust in our services. Should you need any assistance or have suggestions, we're all ears. Your satisfaction is our top priority.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveIn2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveIn2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveIn3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveIn3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveOut1] = "#*[Operator: Name]Bot_Operator_Name*#: We noticed that you are moving out of our self-storage facility today, and we wanted to take a moment to thank you for being a valued customer.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveOut2] = "As you move out, please let our on-site staff know if you have any questions or need assistance, as we're here to help make the process as smooth as possible. In preparation for your departure, we kindly ask that you empty your unit completely and remove any personal locks. ",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveOut2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveOut3] = "Also, if you have any feedback about your experience or suggestions for improvement, please don't hesitate to share them with us. We wish you all the best in your future endeavors and hope you'll consider us again if you ever need self-storage services.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveOut3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveOut1] = "#*[Operator: Name]Bot_Operator_Name*#: We hope your move-out from #*StoreName*# went smoothly, #*Entity personName*#. Your experience with us matters. Please consider leaving us your feedback at #*StoreGoogleReviewURL*# so we can continue to improve our services.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveOut2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveOut2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveOut3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_MoveOut3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveOut1] = "#*[Operator: Name]Bot_Operator_Name*#: #*Entity personName*#, now that you've had some time since moving out from #*StoreName*#, we hope everything concluded to your satisfaction. If there's anything we could have done better, please let us know. Your feedback is invaluable.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveOut2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveOut2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveOut3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_MoveOut3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveOut1] = "#*[Operator: Name]Bot_Operator_Name*#: It's been a few days since your move-out from #*StoreName*#, #*Entity personName*#. We sincerely hope you found our services helpful. Should you need storage solutions in the future, remember you can always rejoin us easily at #*StoreWebsiteUrl*#.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveOut2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveOut2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveOut3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_MoveOut3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveOut1] = "#*[Operator: Name]Bot_Operator_Name*#: A week has passed since your move-out, #*Entity personName*#. We at #*StoreName*# miss having you as part of our community. Remember, our door is always open for your storage needs. Rejoin anytime at #*StoreWebsiteUrl*#.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveOut2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveOut2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveOut3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_MoveOut3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveOut1] = "#*[Operator: Name]Bot_Operator_Name*#: It's been ten days since your move-out from #*StoreName*#, #*Entity personName*#. If you ever need storage solutions again, remember our doors are always open; just visit #*StoreWebsiteUrl*# to see how we can assist you.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveOut2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveOut2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveOut3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_MoveOut3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveOut1] = "#*[Operator: Name]Bot_Operator_Name*#: Two weeks since your move-out from #*StoreName*#, #*Entity personName*#. We hope you're settling well into your new space.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveOut2] = "If you need storage again in the future, we would be more than happy to have you back. Visit #*StoreWebsiteUrl*# to see how we can help.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveOut2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveOut3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_MoveOut3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveOut1] = "#*[Operator: Name]Bot_Operator_Name*#: A month has flown by since your move-out from #*StoreName*#, #*Entity personName*#. We hope you're doing great! Should you ever need our services again, don't forget you can easily rejoin us at #*StoreWebsiteUrl*#. Your space is just a click away.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveOut2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveOut2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveOut3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_MoveOut3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PastDue1] = "#*[Operator: Name]Bot_Operator_Name*#: We wanted to bring to your attention that your self-storage unit payment is currently past due. As of today, your outstanding balance is #*[Account Balance]User_AccountBalance*#, which includes any late fees that have been applied. To avoid any further fees or potential loss of access to your unit, we kindly request that you make a payment as soon as possible.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PastDue2] = "We understand that life can be unpredictable, and sometimes payments can be overlooked. Our goal is to continue providing you with a secure and convenient storage solution.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PastDue3] = "Thank you for your prompt attention to this matter, and we look forward to resolving it together.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_PastDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_PastDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p1_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p2_PastDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_p2_PastDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p2_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p2_PastDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p2_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_PastDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_PastDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_PastDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p3_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_PastDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_PastDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_PastDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p5_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_PastDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_PastDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_PastDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_PastDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_PastDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_PastDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p10_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_PastDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_PastDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_PastDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p14_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_PastDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_PastDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_PastDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p30_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p45_PastDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_p45_PastDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p45_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p45_PastDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p45_PastDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentMethodExpiring1] = "#*[Operator: Name]Bot_Operator_Name*#:We hope this message finds you in good spirits. We wanted to inform you that the payment method we have on file for your self-storage unit will be expiring soon. Our records indicate that your [Credit Card Type] with the last four digits [XXXX] is set to expire on [Expiration Date].",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentMethodExpiring2] = "To ensure uninterrupted access to your unit and avoid any late fees, we kindly ask that you update your payment information at your earliest convenience.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentMethodExpiring2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentMethodExpiring3] = "Updating your payment method is quick and easy. You can log in to your account on our website [Website URL] or visit our on-site office during business hours to provide the updated information. If you need assistance with the process or have any questions, please don't hesitate to reach out to our friendly staff at [Phone Number] or [Email Address]. We're here to help. Thank you for your prompt attention to this matter, and we appreciate your continued trust in our self-storage facility.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentMethodExpiring3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_n1_PaymentMethodExpiring2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n1_PaymentMethodExpiring2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n1_PaymentMethodExpiring3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n1_PaymentMethodExpiring3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentMethodExpiring1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentMethodExpiring2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentMethodExpiring2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentMethodExpiring3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentMethodExpiring3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n14_PaymentMethodExpiring1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_n14_PaymentMethodExpiring2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n14_PaymentMethodExpiring2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n14_PaymentMethodExpiring3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n14_PaymentMethodExpiring3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n30_PaymentMethodExpiring1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_n30_PaymentMethodExpiring2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n30_PaymentMethodExpiring2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n30_PaymentMethodExpiring3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n30_PaymentMethodExpiring3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentDue1] = "#*[Operator: Name]Bot_Operator_Name*#:We hope you're doing well. This is a friendly reminder that your upcoming self-storage unit payment is due on [Due Date]. The amount due for your unit number #*[Unit Number]User_UnitNumber*# is #*[Account Balance]User_AccountBalance*#. We wanted to send this reminder to help you avoid any late fees and ensure uninterrupted access to your unit.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentDue2] = "To make the payment process as convenient as possible, you have several options: pay online through our website #*[Pay Online URL]Bot_Operator_PayOnlineURL*#, call us to make a payment over the phone, or visit our on-site office during business hours.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentDue2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentDue3] = "If you'd like to set up automatic payments to make future transactions effortless, please let us know, and we'll be happy to assist you. If you have any questions or concerns about your payment or account, please don't hesitate to reach out to our friendly staff. We appreciate your business and look forward to continuing to serve your storage needs.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentDue3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_n1_PaymentDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n1_PaymentDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n1_PaymentDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n1_PaymentDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n2_PaymentDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_n2_PaymentDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n2_PaymentDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n2_PaymentDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n2_PaymentDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n3_PaymentDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_n3_PaymentDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n3_PaymentDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n3_PaymentDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n3_PaymentDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n5_PaymentDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_n5_PaymentDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n5_PaymentDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n5_PaymentDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n5_PaymentDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentDue1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentDue2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentDue3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_n7_PaymentDue3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_UpdateContactInfo1] = "#*[Operator: Name]Bot_Operator_Name*#: We hope this message finds you well. As part of our ongoing commitment to providing excellent service and communication, we are conducting a routine check to ensure that we have the most accurate and up-to-date contact information for all our valued customers. Having current information on file allows us to keep you informed about important updates, billing reminders, and any facility-related news.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_UpdateContactInfo2] = "Please take a moment to review the contact information we currently have on file for you: Name: [Customer's Name], Mailing Address: [Customer's Address], Email Address: [Customer's Email], Phone Number: [Customer's Phone Number]",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_UpdateContactInfo2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_UpdateContactInfo3] = "If any of the information above is incorrect or has changed, kindly update your details by logging into your account on our website [Website URL] or by contacting our on-site staff at [Phone Number] or [Email Address]. Thank you for your cooperation and for choosing us as your self-storage provider. We look forward to continuing to serve your storage needs.",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_UpdateContactInfo3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_has0_UpdateContactInfo_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_UpdateContactInfo1] = "#*[Operator: Name]Bot_Operator_Name*#:",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_UpdateContactInfo2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_UpdateContactInfo2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_UpdateContactInfo3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_p7_UpdateContactInfo3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_UpdateContactInfo_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentSuccess1] = "#*[Operator: Name]Bot_Operator_Name*#: ",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentSuccess2] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentSuccess2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentSuccess3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMSplus_0_PaymentSuccess3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_hasFMSPlus] = "0",
    _a$2[BotVariables.Bot_Operator_hasCronMoveIn] = "0",
    _a$2[BotVariables.Bot_Operator_wantsCronReceipts_MoveIn] = "1",
    _a$2[BotVariables.Bot_Operator_hasCronPastDuePayment] = "0",
    _a$2[BotVariables.Bot_Operator_wantsCronReceipts_PastDuePayments] = "1",
    _a$2[BotVariables.Bot_Operator_hasCronPaymentMethodExpired] = "0",
    _a$2[BotVariables.Bot_Operator_wantsCronReceipts_PaymentMethodExpired] = "1",
    _a$2[BotVariables.Bot_Operator_hasCronUpcomingPayment] = "0",
    _a$2[BotVariables.Bot_Operator_wantsCronReceipts_UpcomingPayment] = "1",
    _a$2[BotVariables.Bot_Operator_hasCronUpdateContactInfo] = "0",
    _a$2[BotVariables.Bot_Operator_wantsCronReceipts_UpdateContactInfo] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_has0_MoveIn_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_MoveIn_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_MoveIn_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_MoveIn_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_MoveIn_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_MoveIn_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_MoveIn_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_MoveIn_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_has0_MoveOut_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_MoveOut_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_MoveOut_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_MoveOut_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_MoveOut_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_MoveOut_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_MoveOut_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_MoveOut_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_has0_PaymentDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasn1_PaymentDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasn2_PaymentDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasn3_PaymentDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasn5_PaymentDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasn7_PaymentDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_has0_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp2_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp45_PastDue_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_has0_PaymentMethodExpiring_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasn1_PaymentMethodExpiring_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasn7_PaymentMethodExpiring_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasn14_PaymentMethodExpiring_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasn30_PaymentMethodExpiring_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_has0_PaymentSuccess_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_SMS_FirstMessage_Disclaimer] = "#*[Operator: Name]Bot_Operator_Name*#: Welcome! This is your first text from us! Unfortunately, it is a gauntlet of legal disclaimers: msg & data rates may apply, msg frequency may vary. Reply HELP for help, STOP to cancel. Privacy policy: #*[Operator: Privacy Policy URL]Bot_Operator_PrivacyPolicyURL*#",
    _a$2[BotVariables.Bot_Operator_PrivacyPolicyURL] = undefined,
    _a$2[BotVariables.Bot_Operator_hasPrivacyPolicyURL] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LiveChat_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LiveChat_wantShortProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LiveChat_CollectionMethod] = "Conversational",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LiveChat_ConfirmProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LiveChat_Message] = "I’m going to try and put you in contact with one of our representatives, but first I need to collect a little bit of your information.",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Shopping_CollectProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Shopping_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Shopping_wantShortProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Shopping_CollectionMethod] = "Card",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Shopping_ConfirmProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Shopping_Message] = "Before I redirect you to your store’s inventory page, let me collect some of your information.",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Welcome_CollectProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Welcome_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Welcome_wantShortProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Welcome_CollectionMethod] = "Conversational",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Welcome_ConfirmProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Welcome_Message] = "My managers want to ensure that you're finding what you're looking for. In case we get disconnected, let me collect some of your information so that someone can reach back out.",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WelcomeBack_CollectProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WelcomeBack_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WelcomeBack_wantShortProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WelcomeBack_CollectionMethod] = "Conversational",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WelcomeBack_ConfirmProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WelcomeBack_Message] = "My managers want to ensure that you're finding what you're looking for. In case we get disconnected, let me collect some of your information so that someone can reach back out.",
    _a$2[BotVariables.Bot_Operator_CustomerInitiatedEscalations_CollectProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_HumanInitiated_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_HumanInitiated_wantShortProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_HumanInitiated_CollectionMethod] = "Card",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_HumanInitiated_ConfirmProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_HumanInitiated_Message] = "I’m going to try and put you in contact with one of our representatives, but first I need to collect a little bit of your information.",
    _a$2[BotVariables.Bot_Operator_BotInitiatedEscalations_Sales_CollectProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedSales_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedSales_wantShortProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedSales_CollectionMethod] = "Conversational",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedSales_ConfirmProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedSales_Message] = "I’m going to try and put you in contact with one of our representatives, but first I need to collect a little bit of your information.",
    _a$2[BotVariables.Bot_Operator_BotInitiatedEscalations_Service_CollectProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedService_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedService_wantShortProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedService_CollectionMethod] = "Conversational",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedService_ConfirmProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedService_Message] = "I’m going to try and put you in contact with one of our representatives, but first I need to collect a little bit of your information.",
    _a$2[BotVariables.Bot_Operator_BotInitiatedEscalations_LowConfidence_CollectProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LowConfidence_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LowConfidence_wantShortProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LowConfidence_CollectionMethod] = "Conversational",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LowConfidence_ConfirmProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LowConfidence_Message] = "Hmm I don’t quite understand what you’re asking. Let me see if a live agent is able to assist, but first let me collect some of your information.",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WhatElse_CollectProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WhatElse_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WhatElse_wantShortProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WhatElse_CollectionMethod] = "Conversational",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WhatElse_ConfirmProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WhatElse_Message] = "My managers want to ensure that you're finding what you're looking for. In case we get disconnected, let me collect some of your information so that someone can reach back out.",
    /* -------------------------
      New For 1.7
    ------------------------- */
    _a$2[BotVariables.Bot_GS_GettingStartedCompleted] = "0",
    _a$2[BotVariables.Bot_GS_KickOffMilestoneCompleted] = "0",
    _a$2[BotVariables.Bot_GS_StoreFinderStatus] = "pending",
    _a$2[BotVariables.Bot_GS_MyStorageStatus] = "pending",
    _a$2[BotVariables.Bot_GS_Milestone1Completed] = "0",
    _a$2[BotVariables.Bot_GS_FMSConnectStatus] = "pending",
    _a$2[BotVariables.Bot_GS_DesignEmbedStatus] = "pending",
    _a$2[BotVariables.Bot_GS_InviteAgentsStatus] = "pending",
    _a$2[BotVariables.Bot_GS_LaunchStatus] = "pending",
    _a$2[BotVariables.Bot_GS_Milestone2Completed] = "0",
    _a$2[BotVariables.Bot_GS_GoogleChatStatus] = "pending",
    _a$2[BotVariables.Bot_GS_GoogleReviewsStatus] = "pending",
    _a$2[BotVariables.Bot_GS_AutomatedTextsStatus] = "pending",
    _a$2[BotVariables.Bot_GS_PostLaunchCompleted] = "0",
    _a$2[BotVariables.Bot_GS_MonitorChatsStatus] = "pending",
    _a$2[BotVariables.Bot_GS_AnalyticsStatus] = "pending",
    _a$2[BotVariables.Bot_Operator_hasElectricityInUnit] = "0",
    _a$2[BotVariables.Bot_Operator_hasPayByPhone] = "0",
    _a$2[BotVariables.Bot_Operator_DefaultCountry] = "USA",
    _a$2[BotVariables.Bot_Operator_ShowSizeDescriptions] = "0",
    _a$2[BotVariables.Bot_SizeDescription_Small1] = "Our small spaces typically offers about 50 square feet of storage. This fits furnishings of a mid-sized bedroom, including a queen-sized bed, a dresser, a TV and several small to medium-sized boxes.",
    _a$2[BotVariables.Bot_SizeDescription_Small2] = "",
    _a$2[BotVariables.Bot_SizeDescription_Small2_Enabled] = "",
    _a$2[BotVariables.Bot_SizeDescription_Medium1] = "A medium space is around 100 to 150 square feet. It can typically fit the contents of a 1 bedroom home or apartment.",
    _a$2[BotVariables.Bot_SizeDescription_Medium2] = "",
    _a$2[BotVariables.Bot_SizeDescription_Medium2_Enabled] = "0",
    _a$2[BotVariables.Bot_SizeDescription_Large1] = "A large space offers around 200 square feet of storage space. It fits the contents of a multi-bedroom house, including several oversized items like a couch, a refrigerator, a washer/dryer and a dining room set or several large boxes.",
    _a$2[BotVariables.Bot_SizeDescription_Large2] = "",
    _a$2[BotVariables.Bot_SizeDescription_Large2_Enabled] = "0",
    _a$2[BotVariables.Bot_SizeDescription_ExtraLarge1] = "An extra large space offers more than 300 square feet of storage space. About the size of a two car garage, this space is ideal for homes with multiple bedroom sets and large appliances.",
    _a$2[BotVariables.Bot_SizeDescription_ExtraLarge2] = "",
    _a$2[BotVariables.Bot_SizeDescription_ExtraLarge2_Enabled] = "0",
    _a$2[BotVariables.Bot_SizeDescription_1Bedroom1] = "To store the contents of a one-bedroom apartment, we'd recommend a medium space.",
    _a$2[BotVariables.Bot_SizeDescription_1Bedroom2] = "",
    _a$2[BotVariables.Bot_SizeDescription_1Bedroom2_Enabled] = "0",
    _a$2[BotVariables.Bot_SizeDescription_2Bedroom1] = "For a two-bedroom home, we'd recommend renting a large space.",
    _a$2[BotVariables.Bot_SizeDescription_2Bedroom2] = "",
    _a$2[BotVariables.Bot_SizeDescription_2Bedroom2_Enabled] = "0",
    _a$2[BotVariables.Bot_SizeDescription_3Bedroom1] = "When storing a three-bedroom house, we recommend a large space.",
    _a$2[BotVariables.Bot_SizeDescription_3Bedroom2] = "",
    _a$2[BotVariables.Bot_SizeDescription_3Bedroom2_Enabled] = "0",
    _a$2[BotVariables.Bot_SizeDescription_45Bedroom1] = "When storing the contents of a four-bedroom house or larger, we recommend a large or extra large space. ",
    _a$2[BotVariables.Bot_SizeDescription_45Bedroom2] = "",
    _a$2[BotVariables.Bot_SizeDescription_45Bedroom2_Enabled] = "0",
    _a$2[BotVariables.Bot_SizeDescription_5x51] = "This storage unit is small but mighty! Our 5x5, approximately 25-square-foot spaces are about the size of a walk-in closet.",
    _a$2[BotVariables.Bot_SizeDescription_5x52] = "These spaces are great for holding household clutter, small furniture, and seasonal items.",
    _a$2[BotVariables.Bot_SizeDescription_5x52_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_5x101] = "This storage unit size is popular because it’s so versatile and functional. Our 5x10, approximately 50-square-foot space is about the size of a large shed.",
    _a$2[BotVariables.Bot_SizeDescription_5x102] = "These spaces are great for holding various items from a small apartment or all the furnishings of a bedroom or office.",
    _a$2[BotVariables.Bot_SizeDescription_5x102_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_10x101] = "This storage unit is not too big, not too small, but just right for bulky furniture or equipment. Our 10x10, approximately 100-square-foot spaces are about the size of half of a standard garage.",
    _a$2[BotVariables.Bot_SizeDescription_10x102] = "These spaces can fit the contents of a one-bedroom home or office.",
    _a$2[BotVariables.Bot_SizeDescription_10x102_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_10x151] = "Our 10x15, approximately 150-square-foot spaces are about the size of a large bedroom and can fit the contents of a two-bedroom home.",
    _a$2[BotVariables.Bot_SizeDescription_10x152] = "These spaces are a popular choice for small families or households. ",
    _a$2[BotVariables.Bot_SizeDescription_10x152_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_10x201] = "Our 10x20, approximately 200-square-foot spaces are about the size of a small garage and can fit the contents of a two- or three-bedroom home.",
    _a$2[BotVariables.Bot_SizeDescription_10x202] = "Perfect for those who are in between moves, staging your home for selling, or planning a big remodel.",
    _a$2[BotVariables.Bot_SizeDescription_10x202_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_10x301] = "This storage unit is about the size of a large garage. Our 10x30, approximately 300-square-foot spaces offer enough room to fit the contents of a four- or five-bedroom home.",
    _a$2[BotVariables.Bot_SizeDescription_10x302] = "Perfect for those seeking a major space solution for large household furniture, major appliances, outdoor equipment, or commercial inventory.",
    _a$2[BotVariables.Bot_SizeDescription_10x302_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_SmallVehicle1] = "Most small vehicles exceed five feet in length, so a 5x10 storage unit is the most commonly recommended size.",
    _a$2[BotVariables.Bot_SizeDescription_SmallVehicle2] = "If you're storing a small vehicle with a trailer, the trailer length is the determining factor for unit size. In most cases, we recommend storing these types of vehicles in a parking space.",
    _a$2[BotVariables.Bot_SizeDescription_SmallVehicle2_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_Motorcycle1] = "Most motorcycles exceed five feet in length, so a 5x10 storage unit is the most commonly recommended size.",
    _a$2[BotVariables.Bot_SizeDescription_Motorcycle2] = "It's possible that you could need more or less space depending on the dimension of your motorcycle. Make sure you know the dimensions of your motorcycle before making a decision.",
    _a$2[BotVariables.Bot_SizeDescription_Motorcycle2_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_Sedan1] = "10x20 units are great for many sedans, crossovers, SUVs, and minivans.",
    _a$2[BotVariables.Bot_SizeDescription_Sedan2] = "For example: Nissan Rogue, Honda Accord, Ford Explorer, Chrysler Pacifica, or other similar models.",
    _a$2[BotVariables.Bot_SizeDescription_Sedan2_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_Truck1] = "10x25 units are perfect for Toyota Tundra, Ford F-150, Chevrolet Silverado 1500, Ram 1500, or other similar models.",
    _a$2[BotVariables.Bot_SizeDescription_Truck2] = "The most common ceiling height for storage units at our locations is 8’. Certain storage units do have higher ceilings that can accommodate taller vehicles and other large items.",
    _a$2[BotVariables.Bot_SizeDescription_Truck2_Enabled] = "1",
    _a$2[BotVariables.Bot_SizeDescription_RV1] = "Recreational vehicles (RVs), trailers, large autos, and boats create incredible opportunities for big fun, but they also take up a lot of space. Outdoor storage is the best option for keeping your RV safely and conveniently parked. Work trucks, vans, and trailers are welcome too!",
    _a$2[BotVariables.Bot_SizeDescription_RV2] = "",
    _a$2[BotVariables.Bot_SizeDescription_RV2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Careers1] = "Take a look at our current job openings. If you're passionate about being part of a thriving industry, we encourage you to apply.",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Careers2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Careers2] = "",
    /* -------------------------
      New For 1.8
    ------------------------- */
    _a$2[BotVariables.Bot_LiveChat_NAASales1] = "I'm sorry, but I wasn't able to find a team member to help you. ",
    _a$2[BotVariables.Bot_LiveChat_NAASales2] = "I can have someone follow up with you. ",
    _a$2[BotVariables.Bot_LiveChat_NAASales2_Enabled] = "1",
    _a$2[BotVariables.Bot_NAASales1] = "I can forward your contact information to a team member for them to follow up.",
    _a$2[BotVariables.Bot_LiveChat_NAAService1] = "I'm sorry, but I wasn't able to find a team member to help you.",
    _a$2[BotVariables.Bot_LiveChat_NAAService2] = "I can have someone follow up with you.",
    _a$2[BotVariables.Bot_LiveChat_NAAService2_Enabled] = "1",
    _a$2[BotVariables.Bot_NAAService1] = " I can forward your contact information to a team member for them to follow up.",
    _a$2[BotVariables.Bot_OutsideBusiness1] = "Looks like my teammates are away right now.",
    _a$2[BotVariables.Bot_OutsideBusiness2] = "Once you confirm your contact information, I’ll send an email on your behalf so that someone can follow up with you.",
    _a$2[BotVariables.Bot_OutsideBusiness2_Enabled] = "1",
    _a$2[BotVariables.Bot_OutsideBusinessConfirm1] = "Thank you for confirming your information. Our team will be in touch shortly.",
    _a$2[BotVariables.Bot_Inform_PastDue1] = "My system is telling me that you have an outstanding balance. I can help you make a payment.",
    _a$2[BotVariables.Bot_Inform_PastDue2] = "",
    _a$2[BotVariables.Bot_Inform_PastDue2_Enabled] = "0",
    _a$2[BotVariables.Bot_Inform_Inactive1] = "My system is telling me that your account is inactive. I can help you make a new reservation.",
    _a$2[BotVariables.Bot_Inform_Inactive2] = "",
    _a$2[BotVariables.Bot_Inform_Inactive2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_Vary_Settings] = "0",
    _a$2[BotVariables.Bot_Operator_Varies_LoginURL] = "0",
    _a$2[BotVariables.Bot_Operator_Varies_PayOnlineURL] = "0",
    _a$2[BotVariables.Bot_Operator_Varies_SizeVisualsURL] = "0",
    _a$2[BotVariables.Bot_Operator_wantsSearchAnotherStore] = "",
    _a$2[BotVariables.Bot_Operator_Access_UnitNumberIntegration] = "0",
    _a$2[BotVariables.Bot_Operator_Access_UnitNumber1] = "Your unit number can be found in your email receipt.",
    _a$2[BotVariables.Bot_Operator_Access_UnitNumber2] = "If you aren't able to find it, please contact your facility or call #*[Company: Phone]Bot_Operator_Phone*#.",
    _a$2[BotVariables.Bot_Operator_Access_UnitNumber3] = undefined,
    _a$2[BotVariables.Bot_Operator_Access_UnitNumber3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMS_UnitNumberChannel] = "Both",
    _a$2[BotVariables.Bot_Operator_FMS_UnitNumberChannel_SMSMessage] = "Here is your unit number: #*UserUnitNumber*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp90_MoveIn] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp90_MoveIn_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_p90_MoveIn1] = "#*[Operator: Name]Bot_Operator_Name*#: It's been three months since you joined us at #*StoreName*#, #*Entity personName*# – time flies! We hope our facility continues to meet your needs.",
    _a$2[BotVariables.Bot_Operator_FMSplus_p90_MoveIn2] = "As always, your feedback is invaluable to us for ensuring the best possible experience. If you have a few moments, please consider leaving us a review by following this link: #*StoreGoogleReviewURL*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_p90_MoveIn2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_ExtraLargeUnit] = "1",
    _a$2[BotVariables.Bot_Operator_Feature_Padlocks] = "0",
    _a$2[BotVariables.Bot_Operator_Feature_Padlocks1] = "Most units have a padlock with a code that's required for entry. This code can be found in your email receipt.",
    _a$2[BotVariables.Bot_Operator_Feature_Padlocks2] = "If you're unable to find it, please call #*[Company: Phone]Bot_Operator_Phone*#.",
    _a$2[BotVariables.Bot_Operator_InsideBusinessHours] = undefined,
    /* -------------------------
        FMS+ Review Solicitation
    ------------------------- */
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveIn_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_MoveIn_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_MoveIn_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_MoveIn_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_MoveIn_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_MoveIn_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_MoveIn_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_MoveIn_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp90_MoveIn_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveOut_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_MoveOut_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_MoveOut_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_MoveOut_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_MoveOut_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_MoveOut_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_MoveOut_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_MoveOut_Review] = "0",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewStart1] = "We greatly appreciate your feedback and strive to provide the best experience for our customers.",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewStart2] = "On a scale from 1-10, how would you rate your overall experience with #*StoreName*#?",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewStart2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPromoter1] = "I'm so happy to hear that you had a great experience! Click here to be taken to our review page: #*StoreGoogleReviewURL*#",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPromoter2] = "Please choose a star rating and share a few words about your experience. Thank you!",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPromoter2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPromoter3] = undefined,
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPromoter3_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPassive1] = "I'm sorry to hear that you had just an okay experience.",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPassive2] = "We're constantly trying to get better for our customers. In your opinion, what could use the most improvement? (website, in-person experience, etc.)",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPassive2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPassive3] = "Got it. I will be sure to pass your feedback along to the #*StoreName*# team.",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewPassive3_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewDetractor1] = "I'm so sorry to hear that you weren't satisfied with your experience with our facility.",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewDetractor2] = "We're constantly trying to get better for our customers. In your opinion, what could use the most improvement? (website, in-person experience, etc.)",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewDetractor2_Enabled] = "1",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewDetractor3] = "Got it. I will be sure to pass your feedback along to the #*StoreName*# team.",
    _a$2[BotVariables.Bot_Operator_FMS_ReviewDetractor3_Enabled] = "1",
    // Abandoned Carts
    _a$2[BotVariables.Bot_Operator_hasCronAbandonedCarts] = "0",
    _a$2[BotVariables.Bot_Operator_wantsCronReceipts_AbandonedCarts] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_AbandonedCart] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp2_AbandonedCart] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_AbandonedCart] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_AbandonedCart] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_AbandonedCart] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_AbandonedCart] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_AbandonedCart] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_AbandonedCart] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_AbandonedCart_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_AbandonedCart1] = "#*[Operator: Name]Bot_Operator_Name*#: Hello! We noticed that you started reserving a storage unit but didn't complete the process. Is there anything we can help with to make your decision easier? Let's secure your space today!",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_AbandonedCart2] = "",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_AbandonedCart2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp2_AbandonedCart_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp2_AbandonedCart1] = "#*[Operator: Name]Bot_Operator_Name*#: Still thinking it over? Units are filling up fast, and we'd hate for you to miss out on the perfect space for your belongings. Complete your reservation now!",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp2_AbandonedCart2] = "",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp2_AbandonedCart2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_AbandonedCart_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_AbandonedCart1] = "#*[Operator: Name]Bot_Operator_Name*#: We're here to help make your decision easier. If you have any questions about our storage solutions or need assistance, feel free to reply to this message. Let's find the perfect unit for you.",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_AbandonedCart2] = "",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_AbandonedCart2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_AbandonedCart_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_AbandonedCart1] = "#*[Operator: Name]Bot_Operator_Name*#: Did we mention? Completing your reservation is quick and easy. In just a few clicks, you can secure peace of mind for your belongings. Let's not wait any longer to tick this off your to-do list!",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_AbandonedCart2] = "",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_AbandonedCart2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_AbandonedCart_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_AbandonedCart1] = "#*[Operator: Name]Bot_Operator_Name*#: Are you unsure about what size unit you need or have any other questions? Our team is here to offer personalized advice to help you find the perfect storage solution.",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_AbandonedCart2] = "",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_AbandonedCart2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_AbandonedCart_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_AbandonedCart1] = "#*[Operator: Name]Bot_Operator_Name*#: We understand that choosing the right storage solution can take time. Remember, we're here to provide the flexibility and support you need.",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_AbandonedCart2] = "",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_AbandonedCart2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_AbandonedCart_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_AbandonedCart1] = "#*[Operator: Name]Bot_Operator_Name*#: It looks like your storage unit reservation is still pending. We're holding it for a little while longer, just in case. If you have any last-minute questions or need assistance, we're here for you.",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_AbandonedCart2] = "",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_AbandonedCart2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_AbandonedCart_Method] = "SMS",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_AbandonedCart1] = "#*[Operator: Name]Bot_Operator_Name*#: We miss you! If you're still in need of storage, we'd love to welcome you. Also, we're always looking to improve; let us know why you hesitated. Your feedback is invaluable.",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_AbandonedCart2] = "",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_AbandonedCart2_Enabled] = "0",
    /* -------------------------
      CORE 2.0 Variables (LLM)
    ------------------------- */
    _a$2[BotVariables.Bot_Operator_whichTier] = "Foundation",
    _a$2[BotVariables.Bot_LLM_Tone] = "Professional",
    _a$2[BotVariables.Bot_LLM_Personality] = "B",
    _a$2[BotVariables.Bot_LLM_isPricing] = "0",
    _a$2[BotVariables.Bot_LLM_isFeatures] = "1",
    _a$2[BotVariables.Bot_LLM_isAccountManagement] = "0",
    _a$2[BotVariables.Bot_LLM_isAccess] = "0",
    _a$2[BotVariables.Bot_LLM_isIssueResolution] = "1",
    _a$2[BotVariables.Bot_LLM_isLease] = "0",
    _a$2[BotVariables.Bot_LLM_isSizing] = "1",
    _a$2[BotVariables.Bot_LLM_isUnhandled] = "0",
    _a$2[BotVariables.Bot_Operator_DefaultLanguage] = "English",
    // hardcoding quest IDs for quest 2.0 launch
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SizeVisuals_QuestSlug] = "w8efo1Fy0p",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_ShowInventory_QuestSlug] = "RmzidGERQG",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Autopay_QuestSlug] = "WbxFmR68yM",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_PayBill_QuestSlug] = "ZekjfE13k2",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Password_QuestSlug] = "mntccGox6J",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Username_QuestSlug] = "CbXAalmUWN",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_CreateLogin_QuestSlug] = "lCnO82iPya",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_CreditDebit_QuestSlug] = "ULcIU0QBwz",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_Reservations_QuestSlug] = "oPwwHp0djp",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling_QuestSlug] = "ccU7bxcARf",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateContact_QuestSlug] = "3fLAmUkZG8",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Careers_QuestSlug] = "D3AVYu2Vq1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Insurance_QuestSlug] = "QEqiYYcub8",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Auction_QuestSlug] = "2qaQi2fGEy",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_Referral_QuestSlug] = "T6c2fxc8rj",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_ShowInventory_QuestSlug] = "8fJBHb7jLj",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_PayBill_QuestSlug] = "LUAD88pSVM",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_Auction_QuestSlug] = "jfDCgORu1s",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_SizeVisuals_QuestSlug] = "hhMmAfECPj",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_Referral_QuestSlug] = "wXpxwZs26C",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_Career_QuestSlug] = "TAgULBLDkK",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_Insurance_QuestSlug] = "efaJK6mgGG",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_About_QuestSlug] = "lRj9oMD1ZG",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_CreditDebit_QuestSlug] = "aLPlmBri1d",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_AutoPay_QuestSlug] = "V5XhJ9XrAW",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_Password_QuestSlug] = "4AF14QePCE",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_UpdateBilling_QuestSlug] = "igfcl4wbQq",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_CreateLogin_QuestSlug] = "U1tMOer3U4",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_Username_QuestSlug] = "SqPIELJDpW",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_Reservations_QuestSlug] = "UYA8bq8co7",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_AccountPayBill_QuestSlug] = "1QaZTbpwtH",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_UpdateContact_QuestSlug] = "VZXoRDEutM",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_GMB_AccountLogin_QuestSlug] = "AS7hjC7Xr1",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_ShowInventory_QuestSlug] = "bqCsjU6rgf",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_PayBill_QuestSlug] = "0uhEW9eGrb",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_Auction_QuestSlug] = "tY8W0j8rXE",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_SizeVisuals_QuestSlug] = "MDXVSoCcnY",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_Referral_QuestSlug] = "gK0HfiXKxL",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_Career_QuestSlug] = "KDJkQgAR2m",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_Insurance_QuestSlug] = "OKQI9JJ0eh",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_About_QuestSlug] = "2MQBL6D5vd",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_CreditDebit_QuestSlug] = "a00MNRCw5J",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_AutoPay_QuestSlug] = "74FB7fbe5B",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_Password_QuestSlug] = "nSM8Oxie0O",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_UpdateBilling_QuestSlug] = "24rLVQlNo0",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_CreateLogin_QuestSlug] = "ExI1aXdvm8",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_Username_QuestSlug] = "RiSTmgZYuK",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_Reservations_QuestSlug] = "D9CJCanno4",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_AccountPayBill_QuestSlug] = "p7Zv4xALui",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_UpdateContact_QuestSlug] = "nCL6cXSaKz",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_AccountLogin_QuestSlug] = "Tps97NqDbO",
    _a$2[BotVariables.Bot_Operator_AfterNavigate_SMS_SelectStore_QuestSlug] = "lgKBW6FVbY",
    _a$2[BotVariables.Bot_Spot_AccessCode_QuestSlug] = "qKTXrg5xyS",
    _a$2[BotVariables.Bot_Spot_Review_QuestSlug] = "WWvItlNHHi",
    _a$2[BotVariables.Bot_Spot_PayBillOnline_QuestSlug] = "P3jkwGdfnN",
    _a$2[BotVariables.Bot_Spot_PayBillPhone_QuestSlug] = "BdbwuLbrEk",
    _a$2[BotVariables.Bot_Spot_ManageAccount_QuestSlug] = "EfS3A6JydG",
    // add Persona Collect to Welcome, Welcome Back, and Live Chat First to cut down on Unknown personas being sent into FMS
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Welcome_CollectPersona] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WelcomeBack_CollectPersona] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LiveChat_CollectPersona] = "0",
    /* -------------------------
      CORE 2.1 Variables
    ------------------------- */
    _a$2[BotVariables.Bot_Operator_QuickReply_GoogleReview] = "If you have a few moments, please follow this link to leave a review of my service and/or your experience with our business: #*StoreGoogleReviewURL*#",
    _a$2[BotVariables.Bot_Operator_VehicleStorage] = "0",
    _a$2[BotVariables.Bot_Operator_RVParking] = "0",
    _a$2[BotVariables.Bot_Operator_RVParkingEnclosed] = "0",
    _a$2[BotVariables.Bot_Operator_RVParkingCovered] = "0",
    _a$2[BotVariables.Bot_Operator_BoatStorage] = "0",
    _a$2[BotVariables.Bot_Operator_VehicleStorage1] = "Our vehicle storage solutions keep your car safe until you're ready to hit the road again.",
    _a$2[BotVariables.Bot_Operator_VehicleStorage2] = undefined,
    _a$2[BotVariables.Bot_Operator_VehicleStorage2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_VehicleStorageIndoor1] = "Indoor vehicle storage provides the ultimate protection for your vehicle, offering an environment to shield it from the elements and maintain its condition.",
    _a$2[BotVariables.Bot_Operator_VehicleStorageIndoor2] = undefined,
    _a$2[BotVariables.Bot_Operator_VehicleStorageIndoor2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_OutdoorParking2] = undefined,
    _a$2[BotVariables.Bot_Operator_OutdoorParking2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_VehicleStorageCovered1] = "Covered vehicle storage adds a layer of protection from the weather, like sun and rain.",
    _a$2[BotVariables.Bot_Operator_VehicleStorageCovered2] = undefined,
    _a$2[BotVariables.Bot_Operator_VehicleStorageCovered2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_RVParking1] = "Our RV parking options keep your home-on-wheels safe until you're ready for your next adventure.",
    _a$2[BotVariables.Bot_Operator_RVParking2] = undefined,
    _a$2[BotVariables.Bot_Operator_RVParking2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_RVParkingEnclosed1] = "Enclosed RV parking offers your recreational vehicle ultimate protection from the elements, ensuring it stays in top condition all year round.",
    _a$2[BotVariables.Bot_Operator_RVParkingEnclosed2] = undefined,
    _a$2[BotVariables.Bot_Operator_RVParkingEnclosed2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_RVParkingCovered1] = "Covered RV parking safeguards your recreational vehicle from sun and rain, providing peace of mind while it's not in use.",
    _a$2[BotVariables.Bot_Operator_RVParkingCovered2] = undefined,
    _a$2[BotVariables.Bot_Operator_RVParkingCovered2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_BoatStorage1] = "Our boat storage solutions keep your vessel safe until your next adventure on the water.",
    _a$2[BotVariables.Bot_Operator_BoatStorage2] = undefined,
    _a$2[BotVariables.Bot_Operator_BoatStorage2_Enabled] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LiveChat_SecondaryOptional] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Shopping_SecondaryOptional] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Welcome_SecondaryOptional] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WelcomeBack_SecondaryOptional] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_HumanInitiated_SecondaryOptional] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedSales_SecondaryOptional] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_BotInititatedService_SecondaryOptional] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_LowConfidence_SecondaryOptional] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_WhatElse_SecondaryOptional] = "0",
    _a$2[BotVariables.Bot_Operator_hasGoogleReviewIntegration] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Waitlist_CollectProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Waitlist_Message] = "Once you provide your information, I'll add you to the waitlist for this store. Someone will be in touch when units become available.",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Waitlist_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Waitlist_wantShortProfile] = "1",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Waitlist_CollectionMethod] = "Card",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Waitlist_ConfirmProfile] = "0",
    _a$2[BotVariables.Bot_Operator_ProfileSetting_Waitlist_SecondaryOptional] = "1",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveIn_Referral] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_MoveIn_Referral] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_MoveIn_Referral] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_MoveIn_Referral] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_MoveIn_Referral] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_MoveIn_Referral] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_MoveIn_Referral] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_MoveIn_Referral] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp90_MoveIn_Referral] = "0",
    _a$2[BotVariables.Bot_Operator_FMSplus_0_MoveIn_Referral1] = "Hi #*Entity personName*#, welcome to #*StoreName*#! If you're interested in earning $100 off next month's rent, follow this link: https://my.spot.is/#*Bot_Spot_Brand_Slug*#/#*StoreSpotLocationSlug*#/referral/#*userId*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp1_MoveIn_Referral1] = "Hi #*Entity personName*#, welcome to #*StoreName*#! If you're interested in earning $100 off next month's rent, follow this link: https://my.spot.is/#*Bot_Spot_Brand_Slug*#/#*StoreSpotLocationSlug*#/referral/#*userId*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp3_MoveIn_Referral1] = "Hi #*Entity personName*#! Thanks for choosing #*StoreName*# for your storage needs. If you're interested in earning $100 off next month's rent, follow this link: https://my.spot.is/#*Bot_Spot_Brand_Slug*#/#*StoreSpotLocationSlug*#/referral/#*userId*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp5_MoveIn_Referral1] = "Hi #*Entity personName*#! Thanks for choosing #*StoreName*# for your storage needs. If you're interested in earning $100 off next month's rent, follow this link: https://my.spot.is/#*Bot_Spot_Brand_Slug*#/#*StoreSpotLocationSlug*#/referral/#*userId*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp7_MoveIn_Referral1] = "Hi #*Entity personName*#! Thanks for choosing #*StoreName*# for your storage needs. If you'd like to earn $100 towards your bill that's due #*UserPaymentDueDate*#, follow this link: https://my.spot.is/#*Bot_Spot_Brand_Slug*#/#*StoreSpotLocationSlug*#/referral/#*userId*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp10_MoveIn_Referral1] = "Hi #*Entity personName*#! Thanks again for choosing #*StoreName*#. If you're interested in earning $100 off next month's rent, follow this link: https://my.spot.is/#*Bot_Spot_Brand_Slug*#/#*StoreSpotLocationSlug*#/referral/#*userId*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp14_MoveIn_Referral1] = "Hi #*Entity personName*#! Thanks again for choosing #*StoreName*#. If you're interested in earning $100 off your rent that's due in a couple weeks, follow this link: https://my.spot.is/#*Bot_Spot_Brand_Slug*#/#*StoreSpotLocationSlug*#/referral/#*userId*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp30_MoveIn_Referral1] = "Hi #*Entity personName*#! Thanks again for choosing #*StoreName*#. We hope the past month with us has gone smoothly. If you're interested in earning $100 off next month's rent, follow this link: https://my.spot.is/#*Bot_Spot_Brand_Slug*#/#*StoreSpotLocationSlug*#/referral/#*userId*#",
    _a$2[BotVariables.Bot_Operator_FMSplus_hasp90_MoveIn_Referral1] = "Hi #*Entity personName*#! Thanks again for choosing #*StoreName*#. If you have any friends or family looking for storage solutions (and you want to earn $100 off next month's rent), please follow this link: https://my.spot.is/#*Bot_Spot_Brand_Slug*#/#*StoreSpotLocationSlug*#/referral/#*userId*#",
    _a$2[BotVariables.Bot_Spot_Brand_Slug] = "",
    _a$2[BotVariables.Bot_Spot_Referral_Page_Title] = "Want $100 in credit?",
    _a$2[BotVariables.Bot_Spot_Referral_Page_Body] = "We hope you've enjoyed your experience with us! Spread the word and introduce us to your friends and family using one of the options below. If someone you refer rents a unit, you'll receive a $100 credit on your account for next month's rent.",
    _a$2[BotVariables.Bot_Spot_Referral_URL] = "#*StoreWebsiteUrl*#/?swivlOpen=true&swivlStartOnQuest=Q3i-7FL4i2",
    _a$2[BotVariables.Bot_Spot_Referral_Share_Email_Subject] = "#*Entity personName*# Recommends #*StoreName*#!",
    _a$2[BotVariables.Bot_Spot_Referral_Share_Email_Body] = "Enjoy your first month free at #*StoreName*#! If you're looking for a reliable storage solution, I highly recommend them. To take advantage of this offer, follow this link and fill out your contact information: ",
    _a$2[BotVariables.Bot_Spot_Referral_Share_SMS_Body] = "Enjoy your first month free at #*StoreName*#! If you're looking for a reliable storage solution, I highly recommend them. To take advantage of this offer, follow this link and fill out your contact information: ",
    _a$2[BotVariables.Bot_Spot_Referral_Message1] = "Your friend #*UserReferredByName*# loves #*StoreName*#. You should try us too!",
    _a$2[BotVariables.Bot_Spot_Referral_Message2_Enabled] = "1",
    _a$2[BotVariables.Bot_Spot_Referral_Message2] = "Enter your information below to receive your first month free.",
    _a$2[BotVariables.Bot_Spot_Referral_Referral_ContactMethod] = "Phone",
    _a$2[BotVariables.Bot_Spot_Referral_Referral_wantShortProfile] = "1",
    _a$2[BotVariables.Bot_Spot_Referral_Referral_CollectionMethod] = "Card",
    _a$2[BotVariables.Bot_Spot_Referral_Referral_SecondaryOptional] = "1",
    _a$2[BotVariables.Bot_Spot_Referral_Referral_Confirm1] = "Thanks! The discount will be applied within 10 business days of your move in.",
    _a$2);

var AlwaysCustom = [
    BotVariables.Bot_Operator_Email,
    BotVariables.Bot_Operator_Name,
    BotVariables.Bot_Operator_Phone
];

var Worksheet;
(function (Worksheet) {
    Worksheet["Admin"] = "admin";
    Worksheet["Example"] = "example";
    Worksheet["Issues"] = "issues";
    Worksheet["QuickStart"] = "quickstart";
    Worksheet["QuickPricing"] = "quickpricing";
    Worksheet["ImportantUrls"] = "urls";
    Worksheet["Access"] = "access";
    Worksheet["AccountManagement"] = "accountmanagement";
    Worksheet["Features"] = "features";
    Worksheet["Lease"] = "lease";
    Worksheet["CompanyInfo"] = "companyinfo";
    //ACCESS
    Worksheet["Tour"] = "Tour";
    Worksheet["KeyPadlockAccess"] = "KeyPadlockAccess";
    Worksheet["GateCode"] = "GateCode";
    //ACCOUNT MANAGEMENT
    Worksheet["PayBill"] = "PayBill";
    Worksheet["AutoPay"] = "AutoPay";
    Worksheet["ChangeDueDate"] = "ChangeDueDate";
    Worksheet["UpdateContactInformation"] = "UpdateContactInformation";
    Worksheet["ResetPassword"] = "ResetPassword";
    Worksheet["ForgotUsername"] = "ForgotUsername";
    Worksheet["UpdateBillingInformation"] = "UpdateBillingInformation";
    Worksheet["CreateLogin"] = "CreateLogin";
    Worksheet["GracePeriod"] = "GracePeriod";
    Worksheet["Reservation"] = "Reservation";
    Worksheet["CancelService"] = "CancelService";
    Worksheet["DebtCredit"] = "DebtCredit";
    Worksheet["PastDue"] = "PastDue";
    Worksheet["HoldUnit"] = "HoldUnit";
    Worksheet["AccountStatus"] = "AccountStatus";
    //FEATURES & AMENITIES
    Worksheet["StandardCeilingHeight"] = "StandardCeilingHeight";
    Worksheet["ClimateControl"] = "ClimateControl";
    Worksheet["Security"] = "Security";
    Worksheet["OutdoorParking"] = "OutdoorParking";
    Worksheet["MaintenancePest"] = "MaintenancePest";
    Worksheet["Lights"] = "Lights";
    Worksheet["PackingSupplies"] = "PackingSupplies";
    Worksheet["MovingTruck"] = "MovingTruck";
    Worksheet["Dollies"] = "Dollies";
    Worksheet["Auction"] = "Auction";
    Worksheet["Franchise"] = "Franchise";
    //ISSUE RESOLUTION
    Worksheet["GetOut"] = "GetOut";
    Worksheet["BillingDispute"] = "BillingDispute";
    Worksheet["Emergency"] = "Emergency";
    Worksheet["WebIssue"] = "WebIssue";
    Worksheet["DamagedItems"] = "DamagedItems";
    Worksheet["Theft"] = "Theft";
    Worksheet["LostKey"] = "LostKey";
    //LEASE
    Worksheet["Pricing"] = "Pricing";
    Worksheet["MonthlyPayments"] = "MonthlyPayments";
    Worksheet["PaymentOptions"] = "PaymentOptions";
    Worksheet["PayOnline"] = "PayOnline";
    Worksheet["StorableItems"] = "StorableItems";
    Worksheet["ContractLengths"] = "ContractLengths";
    Worksheet["FacilityAccess"] = "FacilityAccess";
    Worksheet["Identification"] = "Identification";
    Worksheet["Cancellation"] = "Cancellation";
    Worksheet["MoveOutPolicy"] = "MoveOutPolicy";
    Worksheet["Refunds"] = "Refunds";
    Worksheet["Prorate"] = "Prorate";
    Worksheet["Insurance"] = "Insurance";
    Worksheet["Claim"] = "Claim";
    Worksheet["Covid"] = "Covid";
    Worksheet["CutLocks"] = "CutLocks";
    Worksheet["Overlock"] = "Overlock";
    Worksheet["LiveInUnit"] = "LiveInUnit";
    Worksheet["VehicleStorageGuidelines"] = "VehicleStorageGuidelines";
    Worksheet["UnitTransfer"] = "UnitTransfer";
    Worksheet["WorkInUnit"] = "WorkInUnit";
    //PRICING
    Worksheet["AdminFee"] = "AdminFee";
    Worksheet["LateFee"] = "LateFee";
    Worksheet["RateIncrease"] = "RateIncrease";
    Worksheet["WebRates"] = "WebRates";
    Worksheet["InsuranceCost"] = "InsuranceCost";
    Worksheet["Discounts"] = "Discounts";
    //VOICE
    Worksheet["VoiceSettings"] = "VoiceSettings";
    //SMS
    Worksheet["SMSSettings"] = "SMSSettings";
    //1.4 Worksheets
    Worksheet["LeadSettings"] = "LeadSettings";
    Worksheet["MovingServices"] = "MovingServices";
    Worksheet["CreditCardFee"] = "CredCardFee";
    Worksheet["CTAMessage"] = "CTAMessage";
    //1.5 Worksheets
    Worksheet["WineStorage"] = "WineStorage";
    Worksheet["Referral"] = "Referral";
    Worksheet["DriveUp"] = "DriveUp";
    Worksheet["AfterHoursAccess"] = "AfterHoursAccess";
    Worksheet["ShowInventory"] = "ShowInventory";
    Worksheet["SizeVisuals"] = "SizeVisuals";
    Worksheet["AgentQuickReply"] = "AgentQuickReply";
    //1.6 Worksheets
    Worksheet["ReviewReply"] = "ReviewReply";
    Worksheet["EscalationSettings"] = "EscalationSettings";
    Worksheet["CronMoveIn"] = "CronMoveIn";
    Worksheet["CronMoveOut"] = "CronMoveOut";
    Worksheet["CronPaymentDue"] = "CronPaymentDue";
    Worksheet["CronUpdateContactInfo"] = "CronUpdateContactInfo";
    Worksheet["CronPaymentPastDue"] = "CronPaymentPastDue";
    Worksheet["CronPaymentMethodExpiring"] = "CronPaymentMethodExpiring";
    Worksheet["CronPaymentSuccess"] = "PaymentSuccess";
    //1.7 Worksheets
    Worksheet["ProfileSettings"] = "ProfileSettings";
    Worksheet["GetStarted"] = "GetStarted";
    Worksheet["SizeDescriptions"] = "SizeDescriptions";
    Worksheet["Careers"] = "Careers";
    Worksheet["UnitNumber"] = "UnitNumber";
    Worksheet["CronAbandonedCarts"] = "CronAbandonedCarts";
    Worksheet["CronReviewSolicitations"] = "CronReviewSolicitations";
    //2.0 Worksheets
    Worksheet["LLMSettings"] = "LLMSettings";
    //2.1 Worksheets
    Worksheet["VehicleStorage"] = "VehicleStorage";
    Worksheet["VehicleStorageIndoor"] = "VehicleStorageIndoor";
    Worksheet["VehicleStorageCovered"] = "VehicleStorageCovered";
    Worksheet["RVParking"] = "RVParking";
    Worksheet["RVParkingEnclosed"] = "RVParkingEnclosed";
    Worksheet["RVParkingCovered"] = "RVParkingCovered";
    Worksheet["BoatStorage"] = "BoatStorage";
    Worksheet["CronReferrals"] = "CronReferrals";
    Worksheet["SpotReferrals"] = "SpotReferrals";
})(Worksheet || (Worksheet = {}));

var Opp;
(function (Opp) {
    Opp["EQUAL"] = "==";
    Opp["NOT_EQUAL"] = "!=";
})(Opp || (Opp = {}));
var WorksheetStatus;
(function (WorksheetStatus) {
    WorksheetStatus["COMPLETE"] = "Complete";
    WorksheetStatus["NEEDS_REVIEW"] = "Needs Review";
})(WorksheetStatus || (WorksheetStatus = {}));

var WorksheetsEditHistoryAction;
(function (WorksheetsEditHistoryAction) {
    // EditedWorksheet = 'Edited Worksheet',
    WorksheetsEditHistoryAction["MarkedAsComplete"] = "Marked As Complete";
    WorksheetsEditHistoryAction["MarkedAsIncomplete"] = "Marked As Incomplete";
})(WorksheetsEditHistoryAction || (WorksheetsEditHistoryAction = {}));

var EmailTemplates = [
    {
        name: 'fms-contact-information-review',
        templateDisplayName: 'FMS+: Contact Information Review',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            storephone: {
                fieldName: 'StorePhone',
                displayName: 'Store Phone',
                defaultVariableOrValue: "#*" + StoreVars.StorePhoneNumber + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            userunitsize: {
                fieldName: 'UserUnitSize',
                displayName: 'User Unit Size',
                defaultVariableOrValue: "#*" + UserVars.User_UnitSize + "*#"
            },
            updatecontactinformationurl: {
                fieldName: 'UpdateContactInformationURL',
                displayName: 'Update Contact Information URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true&swivlStartOnQuest=#*" + BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateContact_QuestSlug + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-gate-code',
        templateDisplayName: 'FMS+: Gate Code',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            useraccesscode: {
                fieldName: 'UserAccessCode',
                displayName: 'Access/Gate Code',
                defaultVariableOrValue: "#*" + UserVars.User_AccessCode + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-unit-number',
        templateDisplayName: 'FMS+: Unit Number',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            }
        }
    },
    {
        name: 'fms-generic',
        templateDisplayName: 'FMS+: Generic',
        mergeFields: {
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-move-in',
        templateDisplayName: 'FMS+: Move-In',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            userunitsize: {
                fieldName: 'UserUnitSize',
                displayName: 'User Unit Size',
                defaultVariableOrValue: "#*" + UserVars.User_UnitSize + "*#"
            },
            useraccesscode: {
                fieldName: 'UserAccessCode',
                displayName: 'Access/Gate Code',
                defaultVariableOrValue: "#*" + UserVars.User_AccessCode + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-move-out',
        templateDisplayName: 'FMS+: Move-Out',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            userunitsize: {
                fieldName: 'UserUnitSize',
                displayName: 'User Unit Size',
                defaultVariableOrValue: "#*" + UserVars.User_UnitSize + "*#"
            },
            useraccesscode: {
                fieldName: 'UserAccessCode',
                displayName: 'Access/Gate Code',
                defaultVariableOrValue: "#*" + UserVars.User_AccessCode + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-payment-method-expiring',
        templateDisplayName: 'FMS+: Payment Method Expiring',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            storephone: {
                fieldName: 'StorePhone',
                displayName: 'Store Phone',
                defaultVariableOrValue: "#*" + StoreVars.StorePhoneNumber + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            userunitsize: {
                fieldName: 'UserUnitSize',
                displayName: 'User Unit Size',
                defaultVariableOrValue: "#*" + UserVars.User_UnitSize + "*#"
            },
            updatepaymentmethodurl: {
                fieldName: 'UpdatePaymentMethodURL',
                displayName: 'Update Payment MethodURL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true&swivlStartOnQuest=#*" + BotVariables.Bot_Operator_AfterNavigate_AccountLogin_UpdateBilling_QuestSlug + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-payment-past-due',
        templateDisplayName: 'FMS+: Payment Past Due',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            userunitsize: {
                fieldName: 'UserUnitSize',
                displayName: 'User Unit Size',
                defaultVariableOrValue: "#*" + UserVars.User_UnitSize + "*#"
            },
            balancedue: {
                fieldName: 'BalanceDue',
                displayName: 'Balance Due',
                defaultVariableOrValue: "#*" + UserVars.User_AccountBalance + "*#"
            },
            payonlineurl: {
                fieldName: 'PayOnlineURL',
                displayName: 'Pay Online URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true&swivlStartOnQuest=#*" + BotVariables.Bot_Operator_AfterNavigate_AccountLogin_PayBill_QuestSlug + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-payment-reminder',
        templateDisplayName: 'FMS+: Payment Reminder',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            userunitsize: {
                fieldName: 'UserUnitSize',
                displayName: 'User Unit Size',
                defaultVariableOrValue: "#*" + UserVars.User_UnitSize + "*#"
            },
            balancedue: {
                fieldName: 'BalanceDue',
                displayName: 'Balance Due',
                defaultVariableOrValue: "#*" + UserVars.User_AccountBalance + "*#"
            },
            payonlineurl: {
                fieldName: 'PayOnlineURL',
                displayName: 'Pay Online URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true&swivlStartOnQuest=#*" + BotVariables.Bot_Operator_AfterNavigate_AccountLogin_PayBill_QuestSlug + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-payment-success',
        templateDisplayName: 'FMS+: Payment Success',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            userunitsize: {
                fieldName: 'UserUnitSize',
                displayName: 'User Unit Size',
                defaultVariableOrValue: "#*" + UserVars.User_UnitSize + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-review-solicitation-gated',
        templateDisplayName: 'FMS+: Review Solicitation (Gated)',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            reviewdetractorurl: {
                fieldName: 'ReviewDetractorURL',
                displayName: 'Review Detractor URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true&swivlStartOnQuest=#*" + BotVariables.Bot_Spot_Review_QuestSlug + "*#"
            },
            reviewpromoterurl: {
                fieldName: 'ReviewPromoterURL',
                displayName: 'Review Promoter URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreGoogleReviewURL + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-review-solicitation-non-gated',
        templateDisplayName: 'FMS+: Review Solicitation (Non Gated)',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            reviewsolicitationurl: {
                fieldName: 'ReviewSolicitationURL',
                displayName: 'Review Solicitation URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreGoogleReviewURL + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'rating-solicitation-move-in',
        templateDisplayName: 'Rating Solicitation: Move-in',
        //Need to edit
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            reviewdetractorurl: {
                fieldName: 'ReviewDetractorURL',
                displayName: 'Review Detractor URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true&swivlStartOnQuest=#*" + BotVariables.Bot_Spot_Review_QuestSlug + "*#"
            },
            reviewpromoterurl: {
                fieldName: 'ReviewPromoterURL',
                displayName: 'Review Promoter URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreGoogleReviewURL + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'receipt-detractor-rating',
        templateDisplayName: 'Receipt: Detractor Rating',
        //Need to edit
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            userreviewnpsfeedback: {
                fieldName: 'UserReviewNPSFeedback',
                displayName: 'User Review NPS Feedback',
                defaultVariableOrValue: "#*" + UserVars.User_Review_NPSFeedback + "*#"
            },
            userreviewnpsscore: {
                fieldName: 'UserReviewNPSScore',
                displayName: 'User Review NPS Score',
                defaultVariableOrValue: "#*" + UserVars.User_Review_NPSScore + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            userpostalcode: {
                fieldName: 'UserPostalCode',
                displayName: 'User Postal Code',
                defaultVariableOrValue: "#*" + UserVars.User_Zip + "*#"
            },
            usercurrenturl: {
                fieldName: 'UserCurrentURL',
                displayName: 'User Current URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#"
            },
            transcripturl: {
                fieldName: 'TranscriptURL',
                displayName: 'Transcript URL',
                defaultVariableOrValue: "https://swivl.studio/transcript/#*" + UserVars.User_Id + "*#"
            },
            conversationurl: {
                fieldName: 'ConversationURL',
                displayName: 'Conversation URL',
                defaultVariableOrValue: "https://swivl.studio/conversations/#*" + UserVars.User_Id + "*#"
            },
            storeemail: {
                fieldName: 'StoreEmail',
                displayName: 'Store Email',
                defaultVariableOrValue: "#*" + StoreVars.StoreEmail + "*#"
            },
            storedmemail: {
                fieldName: 'StoreDMEmail',
                displayName: 'Store DM Email',
                defaultVariableOrValue: "#*" + StoreVars.StoreDMEmail + "*#"
            },
            operatoremaillist: {
                fieldName: 'OperatorEmailList',
                displayName: 'Operator Email List',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_swivl_LeadEmailList + "*#"
            }
        }
    },
    {
        name: 'receipt-fms-general',
        templateDisplayName: 'Receipt: FMS General',
        //Need to edit
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            userpostalcode: {
                fieldName: 'UserPostalCode',
                displayName: 'User Postal Code',
                defaultVariableOrValue: "#*" + UserVars.User_Zip + "*#"
            },
            usercurrenturl: {
                fieldName: 'UserCurrentURL',
                displayName: 'User Current URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#"
            },
            userquestion: {
                fieldName: 'UserQuestion',
                displayName: 'User Question',
                defaultVariableOrValue: "#*" + UserVars.User_LastIntent + "*#"
            },
            userpersona: {
                fieldName: 'UserPersona',
                displayName: 'User Persona',
                defaultVariableOrValue: "#*" + UserVars.User_Persona + "*#"
            },
            userfmsleadstatus: {
                fieldName: 'UserFMSLeadStatus',
                displayName: 'User FMS Lead Status',
                defaultVariableOrValue: "#*" + UserVars.User_FMSLeadStatus + "*#"
            },
            // userfmserror is helpful, but maybe just for us
            storefmsid: {
                fieldName: 'StoreFMSID',
                displayName: 'Store FMS ID',
                defaultVariableOrValue: "#*" + StoreVars.StoreId + "*#"
            },
            transcripturl: {
                fieldName: 'TranscriptURL',
                displayName: 'Transcript URL',
                defaultVariableOrValue: "https://swivl.studio/transcript/#*" + UserVars.User_Id + "*#"
            },
            conversationurl: {
                fieldName: 'ConversationURL',
                displayName: 'Conversation URL',
                defaultVariableOrValue: "https://swivl.studio/conversations/#*" + UserVars.User_Id + "*#"
            },
            storeemail: {
                fieldName: 'StoreEmail',
                displayName: 'Store Email',
                defaultVariableOrValue: "#*" + StoreVars.StoreEmail + "*#"
            },
            storedmemail: {
                fieldName: 'StoreDMEmail',
                displayName: 'Store DM Email',
                defaultVariableOrValue: "#*" + StoreVars.StoreDMEmail + "*#"
            },
            operatoremaillist: {
                fieldName: 'OperatorEmailList',
                displayName: 'Operator Email List',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_swivl_LeadEmailList + "*#"
            }
        }
    },
    {
        name: 'receipt-lead-fms-fail',
        templateDisplayName: 'Receipt: Lead FMS Fail',
        //Need to edit
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            fmstype: {
                fieldName: 'FMSType',
                displayName: 'FMS',
                defaultVariableOrValue: "#*" + StoreVars.StoreFMSType + "*#"
            },
            storefmsid: {
                fieldName: 'StoreFMSID',
                displayName: 'Store FMS ID',
                defaultVariableOrValue: "#*" + StoreVars.StoreId + "*#"
            },
            userfmserror: {
                fieldName: 'UserFMSError',
                displayName: 'User FMS Error',
                defaultVariableOrValue: "#*" + UserVars.User_FMS_Error + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            userpostalcode: {
                fieldName: 'UserPostalCode',
                displayName: 'User Postal Code',
                defaultVariableOrValue: "#*" + UserVars.User_Zip + "*#"
            },
            usercurrenturl: {
                fieldName: 'UserCurrentURL',
                displayName: 'User Current URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#"
            },
            userquestion: {
                fieldName: 'UserQuestion',
                displayName: 'User Question',
                defaultVariableOrValue: "#*" + UserVars.User_LastIntent + "*#"
            },
            userpersona: {
                fieldName: 'UserPersona',
                displayName: 'User Persona',
                defaultVariableOrValue: "#*" + UserVars.User_Persona + "*#"
            },
            transcripturl: {
                fieldName: 'TranscriptURL',
                displayName: 'Transcript URL',
                defaultVariableOrValue: "https://swivl.studio/transcript/#*" + UserVars.User_Id + "*#"
            },
            conversationurl: {
                fieldName: 'ConversationURL',
                displayName: 'Conversation URL',
                defaultVariableOrValue: "https://swivl.studio/conversations/#*" + UserVars.User_Id + "*#"
            },
            storeemail: {
                fieldName: 'StoreEmail',
                displayName: 'Store Email',
                defaultVariableOrValue: "#*" + StoreVars.StoreEmail + "*#"
            },
            storedmemail: {
                fieldName: 'StoreDMEmail',
                displayName: 'Store DM Email',
                defaultVariableOrValue: "#*" + StoreVars.StoreDMEmail + "*#"
            },
            operatoremaillist: {
                fieldName: 'OperatorEmailList',
                displayName: 'Operator Email List',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_swivl_LeadEmailList + "*#"
            },
            spacedimensions: {
                fieldName: 'SpaceDimensions',
                displayName: 'Space Dimensions',
                defaultVariableOrValue: "#*" + StorageVars.SpaceDimensions + "*#"
            },
            spacerate: {
                fieldName: 'SpaceRate',
                displayName: 'Space Rate',
                defaultVariableOrValue: "#*" + StorageVars.SpaceRate + "*#"
            },
            spaceid: {
                fieldName: 'SpaceID',
                displayName: 'Space ID',
                defaultVariableOrValue: "#*" + StorageVars.SpaceId + "*#"
            }
        }
    },
    {
        name: 'receipt-lead-fms-success',
        templateDisplayName: 'Receipt: Lead FMS Success',
        //Need to edit
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            fmstype: {
                fieldName: 'FMSType',
                displayName: 'FMS',
                defaultVariableOrValue: "#*" + StoreVars.StoreFMSType + "*#"
            },
            storefmsid: {
                fieldName: 'StoreFMSID',
                displayName: 'Store FMS ID',
                defaultVariableOrValue: "#*" + StoreVars.StoreId + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            userpostalcode: {
                fieldName: 'UserPostalCode',
                displayName: 'User Postal Code',
                defaultVariableOrValue: "#*" + UserVars.User_Zip + "*#"
            },
            usercurrenturl: {
                fieldName: 'UserCurrentURL',
                displayName: 'User Current URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#"
            },
            userquestion: {
                fieldName: 'UserQuestion',
                displayName: 'User Question',
                defaultVariableOrValue: "#*" + UserVars.User_LastIntent + "*#"
            },
            userpersona: {
                fieldName: 'UserPersona',
                displayName: 'User Persona',
                defaultVariableOrValue: "#*" + UserVars.User_Persona + "*#"
            },
            transcripturl: {
                fieldName: 'TranscriptURL',
                displayName: 'Transcript URL',
                defaultVariableOrValue: "https://swivl.studio/transcript/#*" + UserVars.User_Id + "*#"
            },
            conversationurl: {
                fieldName: 'ConversationURL',
                displayName: 'Conversation URL',
                defaultVariableOrValue: "https://swivl.studio/conversations/#*" + UserVars.User_Id + "*#"
            },
            storeemail: {
                fieldName: 'StoreEmail',
                displayName: 'Store Email',
                defaultVariableOrValue: "#*" + StoreVars.StoreEmail + "*#"
            },
            storedmemail: {
                fieldName: 'StoreDMEmail',
                displayName: 'Store DM Email',
                defaultVariableOrValue: "#*" + StoreVars.StoreDMEmail + "*#"
            },
            operatoremaillist: {
                fieldName: 'OperatorEmailList',
                displayName: 'Operator Email List',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_swivl_LeadEmailList + "*#"
            },
            spacedimensions: {
                fieldName: 'SpaceDimensions',
                displayName: 'Space Dimensions',
                defaultVariableOrValue: "#*" + StorageVars.SpaceDimensions + "*#"
            },
            spacerate: {
                fieldName: 'SpaceRate',
                displayName: 'Space Rate',
                defaultVariableOrValue: "#*" + StorageVars.SpaceRate + "*#"
            },
            spaceid: {
                fieldName: 'SpaceID',
                displayName: 'Space ID',
                defaultVariableOrValue: "#*" + StorageVars.SpaceId + "*#"
            }
        }
    },
    {
        name: 'swivlstudio-workflow-gate-code',
        templateDisplayName: 'Gate Code Email',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            useraccesscode: {
                fieldName: 'UserAccessCode',
                displayName: 'Access/Gate Code',
                defaultVariableOrValue: "#*" + UserVars.User_AccessCode + "*#"
            }
        }
    },
    {
        name: 'upcoming-payment-reminder',
        templateDisplayName: 'Upcoming Payment Reminder',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            userunitsize: {
                fieldName: 'UserUnitSize',
                displayName: 'User Unit Size',
                defaultVariableOrValue: "#*" + UserVars.User_UnitSize + "*#"
            },
            balancedue: {
                fieldName: 'BalanceDue',
                displayName: 'Balance Due',
                defaultVariableOrValue: "#*" + UserVars.User_AccountBalance + "*#"
            },
            payonlineurl: {
                fieldName: 'PayOnlineURL',
                displayName: 'Pay Online URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true&swivlStartOnQuest=#*" + BotVariables.Bot_Operator_AfterNavigate_AccountLogin_PayBill_QuestSlug + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-abandoned-cart',
        templateDisplayName: 'FMS+: Abandoned Cart',
        mergeFields: {
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            spacedimensions: {
                fieldName: 'SpaceDimensions',
                displayName: 'Space Dimensions',
                defaultVariableOrValue: "#*" + StorageVars.SpaceDimensions + "*#"
            },
            spacerate: {
                fieldName: 'SpaceRate',
                displayName: 'Space Rate',
                defaultVariableOrValue: "#*" + StorageVars.SpaceRate + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            finishreservationurl: {
                fieldName: 'FinishReservationURL',
                displayName: 'Finish Reservation URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true&swivlStartOnQuest=RmzidGERQG" // 💎 After: Show Inventory
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-referral',
        templateDisplayName: 'FMS+: Referral',
        mergeFields: {
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            pagetitle: {
                fieldName: 'Bot_Spot_Referral_Page_Title',
                displayName: 'Page Title',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Spot_Referral_Page_Title + "*#"
            },
            pagebody: {
                fieldName: 'Bot_Spot_Referral_Page_Body',
                displayName: 'Page Body',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Spot_Referral_Page_Body + "*#"
            },
            brandslug: {
                fieldName: 'Bot_Spot_Brand_Slug',
                displayName: 'spot Brand',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Spot_Brand_Slug + "*#"
            },
            userid: {
                fieldName: 'userId',
                displayName: 'User ID',
                defaultVariableOrValue: "#*" + UserVars.User_Id + "*#"
            },
            emailsubject: {
                fieldName: 'Bot_Spot_Referral_Share_Email_Subject',
                displayName: 'Email Subject',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Spot_Referral_Share_Email_Subject + "*#"
            },
            emailbody: {
                fieldName: 'Bot_Spot_Referral_Share_Email_Body',
                displayName: 'Email Body',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Spot_Referral_Share_Email_Body + "*#"
            },
            spotlocation: {
                fieldName: 'StoreSpotLocationSlug',
                displayName: 'spot Location',
                defaultVariableOrValue: "#*" + StoreVars.StoreSpotLocationSlug + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    },
    {
        name: 'fms-account-balance',
        templateDisplayName: 'FMS+: Account Balance',
        mergeFields: {
            fullname: {
                fieldName: 'FULLNAME',
                displayName: 'Full Name',
                defaultVariableOrValue: "#*" + UserVars.User_Name + "*#"
            },
            operatorname: {
                fieldName: 'OperatorName',
                displayName: 'Operator Name',
                defaultVariableOrValue: "#*" + BotVariables.Bot_Operator_Name + "*#"
            },
            userphone: {
                fieldName: 'UserPhone',
                displayName: 'User Phone',
                defaultVariableOrValue: "#*" + UserVars.User_Phone + "*#"
            },
            useremail: {
                fieldName: 'UserEmail',
                displayName: 'User Email',
                defaultVariableOrValue: "#*" + UserVars.User_Email + "*#"
            },
            storename: {
                fieldName: 'StoreName',
                displayName: 'Store Name',
                defaultVariableOrValue: "#*" + StoreVars.StoreName + "*#"
            },
            storeaddress: {
                fieldName: 'StoreAddress',
                displayName: 'Store Address',
                defaultVariableOrValue: "#*" + StoreVars.StoreAddressLine1 + "*#"
            },
            storecity: {
                fieldName: 'StoreCity',
                displayName: 'Store City',
                defaultVariableOrValue: "#*" + StoreVars.StoreCity + "*#"
            },
            storestate: {
                fieldName: 'StoreState',
                displayName: 'Store State',
                defaultVariableOrValue: "#*" + StoreVars.StoreState + "*#"
            },
            storepostalcode: {
                fieldName: 'StorePostalCode',
                displayName: 'Store Postal Code',
                defaultVariableOrValue: "#*" + StoreVars.StorePostalCode + "*#"
            },
            userunitnumber: {
                fieldName: 'UserUnitNumber',
                displayName: 'User Unit Number',
                defaultVariableOrValue: "#*" + UserVars.User_UnitNumber + "*#"
            },
            userunitsize: {
                fieldName: 'UserUnitSize',
                displayName: 'User Unit Size',
                defaultVariableOrValue: "#*" + UserVars.User_UnitSize + "*#"
            },
            balancedue: {
                fieldName: 'BalanceDue',
                displayName: 'Balance Due',
                defaultVariableOrValue: "#*" + UserVars.User_AccountBalance + "*#"
            },
            payonlineurl: {
                fieldName: 'PayOnlineURL',
                displayName: 'Pay Online URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true&swivlStartOnQuest=#*" + BotVariables.Bot_Operator_AfterNavigate_AccountLogin_PayBill_QuestSlug + "*#"
            },
            chatwithusurl: {
                fieldName: 'ChatWithUsURL',
                displayName: 'Chat With Us URL',
                defaultVariableOrValue: "#*" + StoreVars.StoreWebsiteUrl + "*#/?swivlOpen=true"
            }
        }
    }
];

var _a$3;
var FMSTenantCrons;
(function (FMSTenantCrons) {
    FMSTenantCrons["MoveIn"] = "Move In";
    FMSTenantCrons["MoveOut"] = "Move Out";
    FMSTenantCrons["MoveInPlusOne"] = "Move In Plus One";
    FMSTenantCrons["MoveInPlus90"] = "Move In Plus 90";
    FMSTenantCrons["AutoPay"] = "Auto Pay";
    FMSTenantCrons["PaymentDue"] = "Payment Due";
    FMSTenantCrons["PaymentPastDue"] = "Payment Past Due";
    FMSTenantCrons["PaymentLate"] = "Payment Late";
    FMSTenantCrons["OutOfDateContactInfo"] = "Out of Date Contact Info";
    FMSTenantCrons["OutOfDateBillingInfo"] = "Out of Date Billing Info";
    FMSTenantCrons["ExpiringPaymentMethod"] = "Expiring Payment Method";
})(FMSTenantCrons || (FMSTenantCrons = {}));
var FMSCronNamesMap = (_a$3 = {},
    _a$3[FMSTenantCrons.MoveIn] = {
        quest: '💎 FMS Automation: Move - In Start',
        questSlug: 'fms-automation-move-in',
        smsGroupSlug: 'fms-automation-move-in',
        group: 'FMS Automation: Move - In'
    },
    _a$3[FMSTenantCrons.MoveInPlusOne] = {
        quest: '💎 FMS Automation: Move In Plus One Start',
        questSlug: 'fms-automation-move-in-plus-one',
        smsGroupSlug: 'fms-automation-move-in-plus-one',
        group: 'FMS Automation: Move In Plus One'
    },
    _a$3[FMSTenantCrons.MoveInPlus90] = {
        quest: '💎 FMS Automation: Move In Plus 90 Start',
        questSlug: 'fms-automation-move-in-plus-90',
        smsGroupSlug: 'fms-automation-move-in-plus-90',
        group: 'FMS Automation: Move In Plus 90'
    },
    _a$3[FMSTenantCrons.MoveOut] = {
        quest: '💎 FMS Automation: Move - Out Start',
        questSlug: 'fms-automation-move-out',
        smsGroupSlug: 'fms-automation-move-out',
        group: 'FMS Automation: Move - Out'
    },
    _a$3[FMSTenantCrons.AutoPay] = {
        quest: '💎 FMS Automation: Auto Pay Upcoming Start',
        questSlug: 'fms-automation-auto-pay-upcoming',
        smsGroupSlug: 'fms-automation-auto-pay-upcoming',
        group: 'FMS Automation: Auto Pay Upcoming'
    },
    _a$3[FMSTenantCrons.PaymentDue] = {
        quest: '💎 FMS Automation: Payment Due Upcoming Start',
        questSlug: 'fms-automation-payment-due-upcoming',
        smsGroupSlug: 'fms-automation-payment-due-upcoming',
        group: 'FMS Automation: Payment Due Upcoming'
    },
    _a$3[FMSTenantCrons.PaymentPastDue] = {
        quest: '💎 FMS Automation: Payment Past Due Start',
        questSlug: 'fms-automation-payment-past-due',
        smsGroupSlug: 'fms-automation-payment-past-due',
        group: 'FMS Automation: Payment Past Due'
    },
    _a$3[FMSTenantCrons.PaymentLate] = {
        quest: '💎 FMS Automation: Late Payment Start',
        questSlug: 'fms-automation-late-payment',
        smsGroupSlug: 'fms-automation-late-payment',
        group: 'FMS Automation: Late Payment'
    },
    _a$3[FMSTenantCrons.OutOfDateContactInfo] = {
        quest: '💎 FMS Automation: Confirm Contact Info Start',
        questSlug: 'fms-automation-confirm-contact-info',
        smsGroupSlug: 'fms-automation-confirm-contact-info',
        group: 'FMS Automation: Confirm Contact Info'
    },
    _a$3[FMSTenantCrons.OutOfDateBillingInfo] = {
        quest: '💎 FMS Automation: Confirm Billing Info Start',
        questSlug: 'fms-automation-confirm-billing-info',
        smsGroupSlug: 'fms-automation-confirm-billing-info',
        group: 'FMS Automation: Confirm Billing Info'
    },
    _a$3[FMSTenantCrons.ExpiringPaymentMethod] = {
        quest: '💎 FMS Automation: Expiring Payment Method Upcoming Start',
        questSlug: 'fms-automation-expiring-payment-method-upcoming',
        smsGroupSlug: 'fms-automation-expiring-payment-method-upcoming',
        group: 'FMS Automation: Expiring Payment Method Upcoming'
    },
    _a$3);
// FMS Automation: Auto Pay Upcoming Start
// FMS Automation: Payment Due Upcoming Start
// FMS Automation: Payment Past Due Start
// FMS Automation: Late Payment Start
// FMS Automation: Payment Successful Start
// FMS Automation: Confirm Contact Info Start
// FMS Automation: Confirm Billing Info Start
// FMS Automation: Expiring Payment Method Upcoming Start
var CronEnvironment;
(function (CronEnvironment) {
    CronEnvironment["PRODUCTION"] = "PRODUCTION";
    CronEnvironment["STAGING"] = "STAGING";
    CronEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
})(CronEnvironment || (CronEnvironment = {}));
var FMSCronErrorScope;
(function (FMSCronErrorScope) {
    FMSCronErrorScope["LOCATION"] = "location";
    FMSCronErrorScope["TENANT"] = "tenant";
})(FMSCronErrorScope || (FMSCronErrorScope = {}));

var ReviewPlatform;
(function (ReviewPlatform) {
    ReviewPlatform["GOOGLE"] = "google";
    ReviewPlatform["YELP"] = "yelp";
    ReviewPlatform["SPOT"] = "spot";
})(ReviewPlatform || (ReviewPlatform = {}));
var ReviewReplyPlatform;
(function (ReviewReplyPlatform) {
    ReviewReplyPlatform["GOOGLE"] = "google";
    ReviewReplyPlatform["YELP"] = "yelp";
    ReviewReplyPlatform["SWIVL"] = "swivl";
})(ReviewReplyPlatform || (ReviewReplyPlatform = {}));
var ReviewHistoryEventType;
(function (ReviewHistoryEventType) {
    ReviewHistoryEventType["CREATED"] = "created";
    ReviewHistoryEventType["TEXT_UPDATED"] = "text_updated";
    ReviewHistoryEventType["REPLY_CREATED_OUTSIDE_SWIVL"] = "reply created outside swivl";
    ReviewHistoryEventType["REPLY_UPDATED_OUTSIDE_SWIVL"] = "reply updated outside swivl";
    ReviewHistoryEventType["REPLY_REMOVED_OUTSIDE_SWIVL"] = "reply removed outside swivl";
    ReviewHistoryEventType["REPLY_CREATED"] = "reply created";
    ReviewHistoryEventType["REPLY_UPDATED"] = "reply updated";
    ReviewHistoryEventType["REPLY_REMOVED"] = "reply removed";
})(ReviewHistoryEventType || (ReviewHistoryEventType = {}));

// Note this should be moved to the lib
var SpotDataButtonStyle;
(function (SpotDataButtonStyle) {
    SpotDataButtonStyle["PRIMARY"] = "PRIMARY";
    SpotDataButtonStyle["ACCENT"] = "ACCENT";
})(SpotDataButtonStyle || (SpotDataButtonStyle = {}));

var CoreType;
(function (CoreType) {
    CoreType["HOOVER"] = "hoover";
    CoreType["STORAGE"] = "storage";
    CoreType["CANNABIS"] = "cannabis";
    CoreType["MULTIFAMILY"] = "multifamily";
    CoreType["MMP"] = "mmp";
    CoreType["HUMACH"] = "humach";
    CoreType["SPORTS_LAB"] = "sports_lab";
    CoreType["CAMPGROUND"] = "campground";
    CoreType["PHYSICIAN"] = "physician";
    CoreType["SMARTSCOOT"] = "smartscoot";
})(CoreType || (CoreType = {}));

var ShoppingFunnel00Table = {
    id: 'shoppingfunnel-00',
    name: 'Shopping Funnel 00',
    description: 'This table measure conversion rate for when a chat user is shown an inventory carousel.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'START'
        },
        c04: {
            name: 'Operator Has Inventory Carousel'
        },
        c05: {
            name: 'User Wants Vehicle Storage'
        },
        c06: {
            name: 'Show Inventory'
        },
        c07: {
            name: 'Unit Selected'
        },
        c08: {
            name: 'Phone is Set'
        },
        c09: {
            name: 'Phone Collected'
        },
        c10: {
            name: 'No Units Available'
        },
        c11: {
            name: 'Search Different Store'
        }
    }
};

var PayBill00Table = {
    id: 'paybill-00',
    name: 'Pay Bill Funnel 00',
    description: 'This table contains data regarding how many people we navigate to online bill pay.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Pay Bill Start'
        },
        c04: {
            name: 'Pay by Phone'
        },
        c05: {
            name: 'Pay Online'
        },
        c06: {
            name: 'Navigate to Login'
        },
        c07: {
            name: 'Navigate to Online Bill Pay Page'
        }
    }
};

var CTA00Table = {
    id: 'cta-00',
    name: 'CTA 00',
    description: 'This table contains data regarding how many people engage with the CTA on mobile v desktop.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Desktop Start'
        },
        c04: {
            name: 'Mobile Start'
        }
    }
};

var GettingStartedMenu00Table = {
    id: 'getting-started-menu-00',
    name: 'Getting Started Menu 00',
    description: 'This table contains data regarding how people engage with the getting started menus.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Potential: Find Storage Near Me/Show All Spaces'
        },
        c04: {
            name: 'Potential: Features & Amenities'
        },
        c05: {
            name: 'Potential: Size Options'
        },
        c06: {
            name: 'Potential: Our Pricing'
        },
        c07: {
            name: "Potential: I'm an existing customer"
        },
        c08: {
            name: 'Potential 2: Start'
        },
        c09: {
            name: 'Potential 2: Find Storage Near Me'
        },
        c10: {
            name: 'Potential 2: Payment Options'
        },
        c11: {
            name: 'Potential 2: Leases'
        },
        c12: {
            name: 'Potential 2: Discounts'
        },
        c13: {
            name: 'Potential 2: Chat with an Agent'
        },
        c14: {
            name: 'Potential 2: Contact CS'
        },
        c15: {
            name: 'Existing: Make Payment'
        },
        c16: {
            name: 'Existing: Manage My Account'
        },
        c17: {
            name: 'Existing: Get Store Hours'
        },
        c18: {
            name: 'Existing: Get Gate Code'
        },
        c19: {
            name: 'Existing 2: Start'
        },
        c20: {
            name: 'Existing 2: Make Payment'
        },
        c21: {
            name: 'Existing 2: Provide Referral'
        },
        c22: {
            name: 'Existing 2: Give Feedback'
        },
        c23: {
            name: 'Existing 2: Chat with an Agent'
        },
        c24: {
            name: 'Existing 2: Contact CS'
        },
        c25: {
            name: 'Potential: Start'
        },
        c26: {
            name: 'Existing: Start'
        },
        c27: {
            name: 'Existing: Get Account Balance'
        }
    }
};

var Feedback00Table = {
    id: 'feedback-00',
    name: 'Feedback 00',
    description: 'This table contains data regarding feedback.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Experiment Type'
        },
        c04: {
            name: 'Rating Value'
        },
        c05: {
            name: 'Promoter Start'
        },
        c06: {
            name: 'Passive Start'
        },
        c07: {
            name: 'Detractor Start'
        },
        c08: {
            name: 'Has Google Review URL'
        },
        c09: {
            name: 'GR - Sure'
        },
        c10: {
            name: 'GR - No thanks'
        },
        c11: {
            name: 'Topic - Most Helpful'
        },
        c12: {
            name: 'Topic - Least Helpful'
        },
        c13: {
            name: 'Open Value'
        }
    }
};

var MyStorage00Table = {
    id: 'my-storage-00',
    name: 'My Storage 00',
    description: 'This table contains data regarding how many people engage with content in My Storage.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'CTA Messages'
        },
        c04: {
            name: 'Tour'
        },
        c05: {
            name: 'Key Access/Lock'
        },
        c06: {
            name: 'Gate Code'
        },
        c07: {
            name: 'After Hours Access'
        },
        c08: {
            name: 'Pay Bill'
        },
        c09: {
            name: 'Auto Pay'
        },
        c10: {
            name: 'Change Due Date'
        },
        c11: {
            name: 'Update Contact Info'
        },
        c12: {
            name: 'Reset Password'
        },
        c13: {
            name: 'Forgot Username'
        },
        c14: {
            name: 'Update Billing Info'
        },
        c15: {
            name: 'Create Login'
        },
        c16: {
            name: 'Grace Period'
        },
        c17: {
            name: 'Reservation'
        },
        c18: {
            name: 'Cancel Service'
        },
        c19: {
            name: 'Past Due'
        },
        c20: {
            name: 'Hold Unit'
        },
        c21: {
            name: 'Standard Ceiling Height'
        },
        c22: {
            name: 'Climate Control'
        },
        c23: {
            name: 'Security'
        },
        c24: {
            name: 'Outdoor Parking'
        },
        c25: {
            name: 'Drive Up Units'
        },
        c26: {
            name: 'Maintenance Pest'
        },
        c27: {
            name: 'Lights'
        },
        c28: {
            name: 'Packing Supplies'
        },
        c29: {
            name: 'Moving Truck'
        },
        c30: {
            name: 'Moving Services'
        },
        c31: {
            name: 'Dollies'
        },
        c32: {
            name: 'Auctions'
        },
        c33: {
            name: 'Auction Winners'
        },
        c34: {
            name: 'Franchise'
        },
        c35: {
            name: 'Wine Storage'
        },
        c36: {
            name: 'Get Out'
        },
        c37: {
            name: 'Billing Dispute'
        },
        c38: {
            name: 'Emergency'
        },
        c39: {
            name: 'Web Issue'
        },
        c40: {
            name: 'Damaged Items'
        },
        c41: {
            name: 'Theft'
        },
        c42: {
            name: 'Lost Key'
        },
        c43: {
            name: 'Pricing'
        },
        c44: {
            name: 'Purchase Payment Options'
        },
        c45: {
            name: 'Pay Online'
        },
        c46: {
            name: 'Storable Items'
        },
        c47: {
            name: 'Contract Lengths'
        },
        c48: {
            name: 'Facility Access'
        },
        c49: {
            name: 'Identification'
        },
        c50: {
            name: 'Cancellation'
        },
        c51: {
            name: 'Move Out Policy'
        },
        c52: {
            name: 'Refunds'
        },
        c53: {
            name: 'Prorate'
        },
        c54: {
            name: 'Lease: Insurance'
        },
        c55: {
            name: 'Claim'
        },
        c56: {
            name: 'Covid'
        },
        c57: {
            name: 'Cut Locks'
        },
        c58: {
            name: 'Overlock'
        },
        c59: {
            name: 'Live In Unit'
        },
        c60: {
            name: 'Vehicle Storage Guidelines'
        },
        c61: {
            name: 'Unit Transfer'
        },
        c62: {
            name: 'Work In Unit'
        },
        c63: {
            name: 'Admin Fee'
        },
        c64: {
            name: 'Late Fee'
        },
        c65: {
            name: 'Rate Increase'
        },
        c66: {
            name: 'Web Rates'
        },
        c67: {
            name: 'Insurance Cost'
        },
        c68: {
            name: 'Credit Card Fee'
        },
        c69: {
            name: 'Referral'
        },
        c70: {
            name: 'Account Balance'
        },
        c71: {
            name: 'Payment Issue'
        },
        c72: {
            name: 'Payment Extension'
        },
        c73: {
            name: 'Partial Payment'
        },
        c74: {
            name: 'Payment History'
        },
        c75: {
            name: 'Billing Dispute'
        }
    }
};

var ProfileCollect00Table = {
    id: 'profile-collect-00',
    name: 'Profile Collect 00',
    description: 'This table contains data regarding the profile collect funnel.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Journey Start'
        },
        c04: {
            name: 'Funnel',
            variable: UserVars.User_ProfileCollect_Holder
        },
        c05: {
            name: 'Funnel Start'
        },
        c06: {
            name: 'Completed Profile'
        },
        c07: {
            name: 'Profile Length'
        },
        c08: {
            name: 'Primary Contact Method'
        },
        c09: {
            name: 'Collection Type'
        },
        c10: {
            name: 'Collection Start'
        },
        c11: {
            name: 'Name Unknown'
        },
        c12: {
            name: 'Name Collected'
        },
        c13: {
            name: 'Email Unknown'
        },
        c14: {
            name: 'Email Collected'
        },
        c15: {
            name: 'Phone Unknown'
        },
        c16: {
            name: 'Phone Collected'
        },
        c17: {
            name: 'Card Saved'
        }
    }
};

var PersonaCollect00Table = {
    id: 'persona-collect-00',
    name: 'Persona Collect 00',
    description: 'This table contains data regarding the persona collect funnel.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Journey Start'
        },
        c04: {
            name: 'Funnel',
            variable: UserVars.User_ProfileCollect_Holder
        },
        c05: {
            name: 'Funnel Start'
        },
        c06: {
            name: 'Persona Uknown'
        },
        c07: {
            name: 'Persona Collected'
        },
        c08: {
            name: 'Persona Known'
        }
    }
};

var FMS00Table = {
    id: 'fms-00',
    name: 'FMS 00',
    description: 'This table contains data regarding FMS integration success.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'FMS Start'
        },
        c04: {
            name: 'Facility ID Set'
        },
        c05: {
            name: 'Facility ID Not Set'
        },
        c06: {
            name: 'Facility ID Collected'
        },
        c07: {
            name: 'FMS Lead Status'
        },
        c08: {
            name: 'Not Sent to FMS'
        },
        c09: {
            name: 'Tag'
        },
        c10: {
            name: 'Persona'
        },
        c11: {
            name: 'Tenant Found'
        },
        c12: {
            name: 'FMS Error'
        }
    }
};

var Discounts00Table = {
    id: 'discounts-00',
    name: 'Discounts 00',
    description: 'This table contains data regarding discounts.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Intent Start'
        },
        c04: {
            name: 'General Start'
        },
        c05: {
            name: 'Custom Start'
        },
        c06: {
            name: 'Military Start'
        },
        c07: {
            name: 'Student Start'
        },
        c08: {
            name: 'Senior Start'
        },
        c09: {
            name: 'Long Term Lease Start'
        }
    }
};

var FMSPlusMoveIn00Table = {
    id: 'fms-plus-move-in-00',
    name: 'FMS+ Move In 00',
    description: 'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Move In workflows.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Tenant ID',
            variable: UserVars.User_TenantId
        },
        c04: {
            name: 'Day of move-in SMS'
        },
        c05: {
            name: '1 day after move-in SMS'
        },
        c06: {
            name: '3 days after move-in SMS'
        },
        c07: {
            name: '5 days after move-in SMS'
        },
        c08: {
            name: '7 days after move-in SMS'
        },
        c09: {
            name: '10 days after move-in SMS'
        },
        c10: {
            name: '14 days after move-in SMS'
        },
        c11: {
            name: '30 days after move-in SMS'
        },
        c12: {
            name: 'Day of move-in Email'
        },
        c13: {
            name: '1 day after move-in Email'
        },
        c14: {
            name: '3 days after move-in Email'
        },
        c15: {
            name: '5 days after move-in Email'
        },
        c16: {
            name: '7 days after move-in Email'
        },
        c17: {
            name: '10 days after move-in Email'
        },
        c18: {
            name: '14 days after move-in Email'
        },
        c19: {
            name: '30 days after move-in Email'
        },
        c20: {
            name: '90 days after move-in SMS'
        },
        c21: {
            name: '90 days after move-in Email'
        }
    }
};

var FMSPlusMoveOut00Table = {
    id: 'fms-plus-move-out-00',
    name: 'FMS+ Move Out 00',
    description: 'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Move Out workflows.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Tenant ID',
            variable: UserVars.User_TenantId
        },
        c04: {
            name: 'Day of move-out SMS'
        },
        c05: {
            name: '1 day after move-out SMS'
        },
        c06: {
            name: '3 days after move-out SMS'
        },
        c07: {
            name: '5 days after move-out SMS'
        },
        c08: {
            name: '7 days after move-out SMS'
        },
        c09: {
            name: '10 days after move-out SMS'
        },
        c10: {
            name: '14 days after move-out SMS'
        },
        c11: {
            name: '30 days after move-out SMS'
        },
        c12: {
            name: 'Day of move-out Email'
        },
        c13: {
            name: '1 day after move-out Email'
        },
        c14: {
            name: '3 days after move-out Email'
        },
        c15: {
            name: '5 days after move-out Email'
        },
        c16: {
            name: '7 days after move-out Email'
        },
        c17: {
            name: '10 days after move-out Email'
        },
        c18: {
            name: '14 days after move-out Email'
        },
        c19: {
            name: '30 days after move-out Email'
        }
    }
};

var FMSPlusPastDue00Table = {
    id: 'fms-plus-past-due-00',
    name: 'FMS+ Past Due 00',
    description: 'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Past Due workflows.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Tenant ID',
            variable: UserVars.User_TenantId
        },
        c04: {
            name: 'Account Balance',
            variable: UserVars.User_AccountBalance
        },
        c05: {
            name: 'Day that payment is due SMS'
        },
        c06: {
            name: '1 day after past due SMS'
        },
        c07: {
            name: '2 days after past due SMS'
        },
        c08: {
            name: '3 days after past due SMS'
        },
        c09: {
            name: '5 days after past due SMS'
        },
        c10: {
            name: '7 days after past due SMS'
        },
        c11: {
            name: '10 days after past due SMS'
        },
        c12: {
            name: '14 days after past due SMS'
        },
        c13: {
            name: '30 days after past due SMS'
        },
        c14: {
            name: '45 days after past due SMS'
        },
        c15: {
            name: 'Day that payment is due Email'
        },
        c16: {
            name: '1 day after past due Email'
        },
        c17: {
            name: '2 days after past due Email'
        },
        c18: {
            name: '3 days after past due Email'
        },
        c19: {
            name: '5 days after past due Email'
        },
        c20: {
            name: '7 days after past due Email'
        },
        c21: {
            name: '10 days after past due Email'
        },
        c22: {
            name: '14 days after past due Email'
        },
        c23: {
            name: '30 days after past due Email'
        },
        c24: {
            name: '45 days after past due Email'
        }
    }
};

var FMSPlusPaymentMethodExpiring00Table = {
    id: 'fms-plus-payment-method-expiring-00',
    name: 'FMS+ Payment Method Expiring 00',
    description: 'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Method Expiring workflows.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Tenant ID',
            variable: UserVars.User_TenantId
        },
        c04: {
            name: '30 days before expiration SMS'
        },
        c05: {
            name: '14 days before expiration SMS'
        },
        c06: {
            name: '7 days before expiration SMS'
        },
        c07: {
            name: '1 day before expiration SMS'
        },
        c08: {
            name: 'Day of expiration SMS'
        },
        c09: {
            name: '30 days before expiration Email'
        },
        c10: {
            name: '14 days before expiration Email'
        },
        c11: {
            name: '7 days before expiration Email'
        },
        c12: {
            name: '1 day before expiration Email'
        },
        c13: {
            name: 'Day of expiration Email'
        }
    }
};

var FMSPlusPaymentSuccess00Table = {
    id: 'fms-plus-payment-success-00',
    name: 'FMS+ Payment Success 00',
    description: 'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Success workflows.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Tenant ID',
            variable: UserVars.User_TenantId
        },
        c04: {
            name: 'As soon as payment is confirmed SMS'
        },
        c05: {
            name: 'As soon as payment is confirmed Email'
        }
    }
};

var FMSPlusUpcomingPayment00Table = {
    id: 'fms-plus-upcoming-payment-00',
    name: 'FMS+ Upcoming Payment 00',
    description: 'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Due workflows.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Tenant ID',
            variable: UserVars.User_TenantId
        },
        c04: {
            name: 'Account Balance',
            variable: UserVars.User_AccountBalance
        },
        c05: {
            name: '7 days before payment is due SMS'
        },
        c06: {
            name: '5 days before payment is due SMS'
        },
        c07: {
            name: '3 days before payment is due SMS'
        },
        c08: {
            name: '2 days before payment is due SMS'
        },
        c09: {
            name: '1 day before payment is due SMS'
        },
        c10: {
            name: 'Day that payment is due SMS'
        },
        c11: {
            name: '7 days before payment is due Email'
        },
        c12: {
            name: '5 days before payment is due Email'
        },
        c13: {
            name: '3 days before payment is due Email'
        },
        c14: {
            name: '2 days before payment is due Email'
        },
        c15: {
            name: '1 day before payment is due Email'
        },
        c16: {
            name: 'Day that payment is due Email'
        }
    }
};

var FMSPlusUpdateContactInfo00Table = {
    id: 'fms-plus-update-contact-info-00',
    name: 'FMS+ Update Contact Info 00',
    description: 'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Update Contact Info workflows.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Tenant ID',
            variable: UserVars.User_TenantId
        },
        c04: {
            name: '6 months since the last time we asked SMS'
        },
        c05: {
            name: '7 day follow-up SMS'
        },
        c06: {
            name: '6 months since the last time we asked Email'
        },
        c07: {
            name: '7 day follow-up Email'
        }
    }
};

var GateCode00Table = {
    id: 'gatecode-00',
    name: 'Gate Code 00',
    description: 'This table contains data around the gate code integration.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Start'
        },
        c04: {
            name: 'Get Tenant'
        },
        c05: {
            name: 'User Found'
        },
        c06: {
            name: 'Gate Code Found'
        },
        c07: {
            name: 'Account Past Due'
        },
        c08: {
            name: 'Account Inactive'
        },
        c09: {
            name: 'SMS Sent'
        },
        c10: {
            name: 'SMS Invalid Phone Number'
        },
        c11: {
            name: 'Email Sent'
        },
        c12: {
            name: 'Account Active'
        },
        c13: {
            name: 'Account Unknown'
        },
        c14: {
            name: 'Account "ELSE"'
        }
    }
};

var GoogleChatLinks00Table = {
    id: 'google-chat-links-00',
    name: 'Google Chat Links 00',
    description: 'This table contains data regarding how many people were shown and clicked URLs in Google Chat',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Referral Program Shown'
        },
        c04: {
            name: 'Google Review Shown'
        },
        c05: {
            name: 'Auction Website Shown'
        },
        c06: {
            name: 'About Storage Company Shown'
        },
        c07: {
            name: 'Careers Shown'
        },
        c08: {
            name: 'Size Visuals Shown'
        },
        c09: {
            name: 'Pay Online - Autopay Shown'
        },
        c10: {
            name: 'Pay Online - Pay Bill Shown'
        },
        c11: {
            name: 'Account Login - Credit Debit Shown'
        },
        c12: {
            name: 'Account Login - Autopay Shown'
        },
        c13: {
            name: 'Account Login - Password Reset Shown'
        },
        c14: {
            name: 'Account Login - Update Billing Info Shown'
        },
        c15: {
            name: 'Account Login - Create Login Shown'
        },
        c16: {
            name: 'Account Login - Username Shown'
        },
        c17: {
            name: 'Account Login - Reservations Shown'
        },
        c18: {
            name: 'Account Login - Pay Bill Shown'
        },
        c19: {
            name: 'Account Login - Update Contact Info Shown'
        },
        c20: {
            name: 'Insurance Website Shown'
        },
        c21: {
            name: 'Inventory Shown'
        },
        c22: {
            name: 'Vehicle Inventory Shown' // same as inventory link for now
        },
        c23: {
            name: 'Referral Program Clicked'
        },
        c24: {
            name: 'Google Review Clicked'
        },
        c25: {
            name: 'Auction Website Clicked'
        },
        c26: {
            name: 'About Storage Company Clicked'
        },
        c27: {
            name: 'Careers Clicked'
        },
        c28: {
            name: 'Size Visuals Clicked'
        },
        c29: {
            name: 'Pay Online - Autopay Clicked'
        },
        c30: {
            name: 'Pay Online - Pay Bill Clicked'
        },
        c31: {
            name: 'Account Login - Credit Debit Clicked'
        },
        c32: {
            name: 'Account Login - Autopay Clicked'
        },
        c33: {
            name: 'Account Login - Password Reset Clicked'
        },
        c34: {
            name: 'Account Login - Update Billing Info Clicked'
        },
        c35: {
            name: 'Account Login - Create Login Clicked'
        },
        c36: {
            name: 'Account Login - Username Clicked'
        },
        c37: {
            name: 'Account Login - Reservations Clicked'
        },
        c38: {
            name: 'Account Login - Pay Bill Clicked'
        },
        c39: {
            name: 'Account Login - Update Contact Info Clicked'
        },
        c40: {
            name: 'Insurance Website Clicked'
        },
        c41: {
            name: 'Inventory Clicked'
        },
        c42: {
            name: 'Vehicle Inventory Clicked' // same as inventory link for now
        }
    }
};

var SizeDescriptions00Table = {
    id: 'sizedescriptions-00',
    name: 'Size Descriptions 00',
    description: 'This table contains data around size descriptions in My Storage.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Small'
        },
        c04: {
            name: 'Medium'
        },
        c05: {
            name: 'Large'
        },
        c06: {
            name: 'Extra Large'
        },
        c07: {
            name: '1 Bedroom'
        },
        c08: {
            name: '2 Bedrooms'
        },
        c09: {
            name: '3 Bedrooms'
        },
        c10: {
            name: '4-5 Bedrooms'
        },
        c11: {
            name: '5x5'
        },
        c12: {
            name: '5x10'
        },
        c13: {
            name: '10x10'
        },
        c14: {
            name: '10x15'
        },
        c15: {
            name: '10x20'
        },
        c16: {
            name: '10x30'
        },
        c17: {
            name: 'Small Vehicle'
        },
        c18: {
            name: 'Motorcycle'
        },
        c19: {
            name: 'Sedan'
        },
        c20: {
            name: 'Truck'
        },
        c21: {
            name: 'RV'
        }
    }
};

var SMSLinks00Table = {
    id: 'sms-links-00',
    name: 'SMS Links 00',
    description: 'This table contains data regarding how many people were shown and clicked URLs via SMS',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Referral Program Shown'
        },
        c04: {
            name: 'Google Review Shown'
        },
        c05: {
            name: 'Auction Website Shown'
        },
        c06: {
            name: 'About Storage Company Shown'
        },
        c07: {
            name: 'Careers Shown'
        },
        c08: {
            name: 'Size Visuals Shown'
        },
        c09: {
            name: 'Pay Online - Autopay Shown'
        },
        c10: {
            name: 'Pay Online - Pay Bill Shown'
        },
        c11: {
            name: 'Account Login - Credit Debit Shown'
        },
        c12: {
            name: 'Account Login - Autopay Shown'
        },
        c13: {
            name: 'Account Login - Password Reset Shown'
        },
        c14: {
            name: 'Account Login - Update Billing Info Shown'
        },
        c15: {
            name: 'Account Login - Create Login Shown'
        },
        c16: {
            name: 'Account Login - Username Shown'
        },
        c17: {
            name: 'Account Login - Reservations Shown'
        },
        c18: {
            name: 'Account Login - Pay Bill Shown'
        },
        c19: {
            name: 'Account Login - Update Contact Info Shown'
        },
        c20: {
            name: 'Insurance Website Shown'
        },
        c21: {
            name: 'Inventory Shown'
        },
        c22: {
            name: 'Vehicle Inventory Shown' // same as inventory link for now
        },
        c23: {
            name: 'Referral Program Clicked'
        },
        c24: {
            name: 'Google Review Clicked'
        },
        c25: {
            name: 'Auction Website Clicked'
        },
        c26: {
            name: 'About Storage Company Clicked'
        },
        c27: {
            name: 'Careers Clicked'
        },
        c28: {
            name: 'Size Visuals Clicked'
        },
        c29: {
            name: 'Pay Online - Autopay Clicked'
        },
        c30: {
            name: 'Pay Online - Pay Bill Clicked'
        },
        c31: {
            name: 'Account Login - Credit Debit Clicked'
        },
        c32: {
            name: 'Account Login - Autopay Clicked'
        },
        c33: {
            name: 'Account Login - Password Reset Clicked'
        },
        c34: {
            name: 'Account Login - Update Billing Info Clicked'
        },
        c35: {
            name: 'Account Login - Create Login Clicked'
        },
        c36: {
            name: 'Account Login - Username Clicked'
        },
        c37: {
            name: 'Account Login - Reservations Clicked'
        },
        c38: {
            name: 'Account Login - Pay Bill Clicked'
        },
        c39: {
            name: 'Account Login - Update Contact Info Clicked'
        },
        c40: {
            name: 'Insurance Website Clicked'
        },
        c41: {
            name: 'Inventory Clicked'
        },
        c42: {
            name: 'Vehicle Inventory Clicked' // same as inventory link for now
        },
        c43: {
            name: 'SELECT Store Shown'
        },
        c44: {
            name: 'SELECT Store Clicked'
        },
        c45: {
            name: 'Account Login - Cancel Service Shown'
        },
        c46: {
            name: 'Account Login - Cancel Service Clicked'
        }
    }
};

var UnitNumber00Table = {
    id: 'unitnumber-00',
    name: 'Unit Number 00',
    description: 'This table contains data around the unit number integration.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Start'
        },
        c04: {
            name: 'Get Tenant'
        },
        c05: {
            name: 'User Found'
        },
        c06: {
            name: 'Unit Number Found'
        },
        c07: {
            name: 'Account Past Due'
        },
        c08: {
            name: 'Account Inactive'
        },
        c09: {
            name: 'SMS Sent'
        },
        c10: {
            name: 'SMS Invalid Phone Number'
        },
        c11: {
            name: 'Email Sent'
        },
        c12: {
            name: 'Account Active'
        },
        c13: {
            name: 'Account Unknown'
        },
        c14: {
            name: 'Account "ELSE"'
        }
    }
};

var FMSPlusAbandonedCarts00Table = {
    id: 'fms-plus-abandoned-carts-00',
    name: 'FMS+ Abandoned Carts 00',
    description: 'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Abandoned Carts workflows.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Tenant ID',
            variable: UserVars.User_TenantId // will we have this?
        },
        c04: {
            name: 'User ID',
            variable: UserVars.User_Id
        },
        c05: {
            name: '1 day after lead is created SMS'
        },
        c06: {
            name: '2 days after lead is created SMS'
        },
        c07: {
            name: '3 days after lead is created SMS'
        },
        c08: {
            name: '5 days after lead is created SMS'
        },
        c09: {
            name: '7 days after lead is created SMS'
        },
        c10: {
            name: '10 days after lead is created SMS'
        },
        c11: {
            name: '14 days after lead is created SMS'
        },
        c12: {
            name: '30 days after lead is created SMS'
        },
        c13: {
            name: '1 day after lead is created Email'
        },
        c14: {
            name: '2 days after lead is created Email'
        },
        c15: {
            name: '3 days after lead is created Email'
        },
        c16: {
            name: '5 days after lead is created Email'
        },
        c17: {
            name: '7 days after lead is created Email'
        },
        c18: {
            name: '10 days after lead is created Email'
        },
        c19: {
            name: '14 days after lead is created Email'
        },
        c20: {
            name: '30 days after lead is created Email'
        }
    }
};

var UnhandledsDuringProfileCollect00Table = {
    id: 'unhandleds-during-profile-collect-00',
    name: 'Unhandleds During Profile Collect 00',
    description: 'This table contains unhandled utterances while we were asking users for their information',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'User ID',
            variable: UserVars.User_Id
        },
        c04: {
            name: 'Store Name',
            variable: StoreVars.StoreName
        },
        c05: {
            name: 'Last Input' // cannot find this var in the code but I can type it in swivlStudio
        }
    }
};

var AccountBalance00Table = {
    id: 'account-balance-00',
    name: 'Account Balance 00',
    description: 'This table contains data around the account balance integration.',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Facility Name',
            variable: StoreVars.StoreName
        },
        c04: {
            name: 'Location Number',
            variable: StoreVars.StoreLocationNumber
        },
        c05: {
            name: 'Start'
        },
        c06: {
            name: 'Get Tenant Started'
        },
        c07: {
            name: 'Tenant Found'
        },
        c08: {
            name: 'Account Balance Found'
        },
        c09: {
            name: 'Account Status Active'
        },
        c10: {
            name: 'Account Status Inactive'
        },
        c11: {
            name: 'Account Status Unknown'
        },
        c12: {
            name: 'Account Status Else'
        },
        c13: {
            name: 'SMS Sent'
        },
        c14: {
            name: 'SMS Invalid Phone Number'
        },
        c15: {
            name: 'Email Sent'
        },
        c16: {
            name: 'LLM Used'
        }
    }
};

var MyStorage01Table = {
    id: 'my-storage-01',
    name: 'My Storage 01',
    description: 'This table contains data regarding how many people engage with content in My Storage (continued).',
    core: CoreType.STORAGE,
    // bot:"all",
    mapping: {
        c01: {
            name: 'Operator Name',
            variable: BotVariables.Bot_Operator_Name
        },
        c02: {
            name: 'Facility ID',
            variable: StoreVars.StoreId
        },
        c03: {
            name: 'Get Lease'
        },
        c04: {
            name: 'Manage Insurance'
        },
        c05: {
            name: 'Unit Size'
        },
        c06: {
            name: 'Multiple Accounts'
        },
        c07: {
            name: 'Account Login Issues'
        },
        c08: {
            name: 'Account General Management'
        },
        c09: {
            name: 'Unit Number'
        },
        c10: {
            name: 'Navigate to Account Login'
        }
    }
};

var _a$4;
var AllTables = (_a$4 = {},
    _a$4[ShoppingFunnel00Table.id] = ShoppingFunnel00Table,
    _a$4[ProfileCollect00Table.id] = ProfileCollect00Table,
    _a$4[PayBill00Table.id] = PayBill00Table,
    _a$4[GettingStartedMenu00Table.id] = GettingStartedMenu00Table,
    _a$4[Feedback00Table.id] = Feedback00Table,
    _a$4[CTA00Table.id] = CTA00Table,
    _a$4[PersonaCollect00Table.id] = PersonaCollect00Table,
    _a$4[MyStorage00Table.id] = MyStorage00Table,
    _a$4[FMS00Table.id] = FMS00Table,
    _a$4[Discounts00Table.id] = Discounts00Table,
    _a$4[FMSPlusMoveIn00Table.id] = FMSPlusMoveIn00Table,
    _a$4[FMSPlusMoveOut00Table.id] = FMSPlusMoveOut00Table,
    _a$4[FMSPlusPastDue00Table.id] = FMSPlusPastDue00Table,
    _a$4[FMSPlusPaymentMethodExpiring00Table.id] = FMSPlusPaymentMethodExpiring00Table,
    _a$4[FMSPlusPaymentSuccess00Table.id] = FMSPlusPaymentSuccess00Table,
    _a$4[FMSPlusUpcomingPayment00Table.id] = FMSPlusUpcomingPayment00Table,
    _a$4[FMSPlusUpdateContactInfo00Table.id] = FMSPlusUpdateContactInfo00Table,
    _a$4[GateCode00Table.id] = GateCode00Table,
    _a$4[GoogleChatLinks00Table.id] = GoogleChatLinks00Table,
    _a$4[SizeDescriptions00Table.id] = SizeDescriptions00Table,
    _a$4[SMSLinks00Table.id] = SMSLinks00Table,
    _a$4[UnitNumber00Table.id] = UnitNumber00Table,
    _a$4[FMSPlusAbandonedCarts00Table.id] = FMSPlusAbandonedCarts00Table,
    _a$4[UnhandledsDuringProfileCollect00Table.id] = UnhandledsDuringProfileCollect00Table,
    _a$4[AccountBalance00Table.id] = AccountBalance00Table,
    _a$4[MyStorage01Table.id] = MyStorage01Table
// [ChucksTestTable.id]: ChucksTestTable,
// [ChucksOtherTestTable.id]: ChucksOtherTestTable,
// [GMBSessionTable.id]: GMBSessionTable  // I am removing this since we dont need to see them in the lists
,
    _a$4);

var NodeType;
(function (NodeType) {
    NodeType["Array"] = "array";
    NodeType["Action"] = "action";
    NodeType["Analytics"] = "analytics";
    NodeType["Buttons"] = "buttons";
    NodeType["Carousel"] = "carousel";
    NodeType["Command"] = "command";
    NodeType["Continue"] = "continue";
    NodeType["CRM"] = "crm";
    NodeType["DateAndTime"] = "dateAndTime";
    NodeType["Email"] = "email";
    NodeType["Experiment"] = "experiment";
    NodeType["ExperimentEnd"] = "experimentEnd";
    NodeType["Escalation"] = "escalation";
    NodeType["Finish"] = "finish";
    NodeType["Hubspot"] = "hubspot";
    NodeType["Input"] = "input";
    NodeType["Increment"] = "increment";
    NodeType["Logic"] = "logic";
    NodeType["Media"] = "media";
    NodeType["Message"] = "message";
    NodeType["MultiSelect"] = "multiSelect";
    NodeType["NLP"] = "nlp";
    NodeType["Notification"] = "notification";
    NodeType["OpenOrClose"] = "openOrClose";
    NodeType["PastMessages"] = "pastMessages";
    NodeType["ProfileCollect"] = "profileCollect";
    NodeType["Quest"] = "quest";
    NodeType["Random"] = "random";
    NodeType["Route"] = "route";
    NodeType["RouterStart"] = "routerStart";
    NodeType["Save"] = "save";
    NodeType["Sentiment"] = "sentiment";
    NodeType["Slack"] = "slack";
    NodeType["SMS"] = "SMS";
    NodeType["SMSGroup"] = "SMSGroup";
    NodeType["Start"] = "start";
    NodeType["URL"] = "url";
    // StoreInfo            = "storeInfo"    ,
    NodeType["StoreLead"] = "storeLead";
    NodeType["StoreFinderLookup"] = "storeFinderLookup";
    NodeType["SpacePicker"] = "spacePicker";
    NodeType["StoreAccessCode"] = "storeAccessCode";
    NodeType["StoreGetTenant"] = "storeGetTenant";
    NodeType["TypingIndicator"] = "typingIndicator";
    NodeType["TableSaveRow"] = "tableSaveRow";
    NodeType["Voice"] = "voice";
    NodeType["LLM"] = "llm";
})(NodeType || (NodeType = {}));
var VoiceNodeCommandType;
(function (VoiceNodeCommandType) {
    // PAUSE = 'pause',
    VoiceNodeCommandType["HANGUP"] = "hangup";
    VoiceNodeCommandType["FORWARD"] = "forward";
    VoiceNodeCommandType["CALL"] = "call";
    VoiceNodeCommandType["MESSAGE"] = "message";
    // GATHER = 'gather'
})(VoiceNodeCommandType || (VoiceNodeCommandType = {}));

var InheritanceStatus;
(function (InheritanceStatus) {
    InheritanceStatus["IS_PARENT"] = "parent";
    InheritanceStatus["IS_CHILD"] = "child";
    InheritanceStatus["NONE"] = "none";
})(InheritanceStatus || (InheritanceStatus = {}));
var UNASSIGNED_TO_JOURNEY_SLUG = 'unassigned';
var QuestType;
(function (QuestType) {
    QuestType["NORMAL"] = "normal";
    QuestType["MATRIX"] = "matrix";
    QuestType["ROUTER"] = "router";
    QuestType["DEFAULT_UNHANDLED"] = "default unhandled";
    QuestType["VOICE_ROUTER"] = "voice router";
    QuestType["GMB_ROUTER"] = "GMB router";
})(QuestType || (QuestType = {}));
var JourneyType;
(function (JourneyType) {
    JourneyType["NORMAL"] = "normal";
    JourneyType["QUICK_REPLIES"] = "quick replies";
    JourneyType["VOICE"] = "voice";
})(JourneyType || (JourneyType = {}));

var UnitStandard;
(function (UnitStandard) {
    UnitStandard["METRIC"] = "metric";
    UnitStandard["IMPERIAL"] = "imperial";
})(UnitStandard || (UnitStandard = {}));

var _a$5;
var CountryCode;
(function (CountryCode) {
    CountryCode["US"] = "US";
    CountryCode["CA"] = "CA";
    CountryCode["AF"] = "AF";
    CountryCode["AL"] = "AL";
    CountryCode["DZ"] = "DZ";
    CountryCode["AS"] = "AS";
    CountryCode["AD"] = "AD";
    CountryCode["AO"] = "AO";
    CountryCode["AI"] = "AI";
    CountryCode["AQ"] = "AQ";
    CountryCode["AG"] = "AG";
    CountryCode["AR"] = "AR";
    CountryCode["AM"] = "AM";
    CountryCode["AW"] = "AW";
    CountryCode["AU"] = "AU";
    CountryCode["AT"] = "AT";
    CountryCode["AZ"] = "AZ";
    CountryCode["BS"] = "BS";
    CountryCode["BH"] = "BH";
    CountryCode["BD"] = "BD";
    CountryCode["BB"] = "BB";
    CountryCode["BY"] = "BY";
    CountryCode["BE"] = "BE";
    CountryCode["BZ"] = "BZ";
    CountryCode["BJ"] = "BJ";
    CountryCode["BM"] = "BM";
    CountryCode["BT"] = "BT";
    CountryCode["BO"] = "BO";
    CountryCode["BQ"] = "BQ";
    CountryCode["BA"] = "BA";
    CountryCode["BW"] = "BW";
    CountryCode["BV"] = "BV";
    CountryCode["BR"] = "BR";
    CountryCode["IO"] = "IO";
    CountryCode["BN"] = "BN";
    CountryCode["BG"] = "BG";
    CountryCode["BF"] = "BF";
    CountryCode["BI"] = "BI";
    CountryCode["CV"] = "CV";
    CountryCode["KH"] = "KH";
    CountryCode["CM"] = "CM";
    CountryCode["KY"] = "KY";
    CountryCode["CF"] = "CF";
    CountryCode["TD"] = "TD";
    CountryCode["CL"] = "CL";
    CountryCode["CN"] = "CN";
    CountryCode["CX"] = "CX";
    CountryCode["CC"] = "CC";
    CountryCode["CO"] = "CO";
    CountryCode["KM"] = "KM";
    CountryCode["CD"] = "CD";
    CountryCode["CG"] = "CG";
    CountryCode["CK"] = "CK";
    CountryCode["CR"] = "CR";
    CountryCode["HR"] = "HR";
    CountryCode["CU"] = "CU";
    CountryCode["CW"] = "CW";
    CountryCode["CY"] = "CY";
    CountryCode["CZ"] = "CZ";
    CountryCode["CI"] = "CI";
    CountryCode["DK"] = "DK";
    CountryCode["DJ"] = "DJ";
    CountryCode["DM"] = "DM";
    CountryCode["DO"] = "DO";
    CountryCode["EC"] = "EC";
    CountryCode["EG"] = "EG";
    CountryCode["SV"] = "SV";
    CountryCode["GQ"] = "GQ";
    CountryCode["ER"] = "ER";
    CountryCode["EE"] = "EE";
    CountryCode["SZ"] = "SZ";
    CountryCode["ET"] = "ET";
    CountryCode["FK"] = "FK";
    CountryCode["FO"] = "FO";
    CountryCode["FJ"] = "FJ";
    CountryCode["FI"] = "FI";
    CountryCode["FR"] = "FR";
    CountryCode["GF"] = "GF";
    CountryCode["PF"] = "PF";
    CountryCode["TF"] = "TF";
    CountryCode["GA"] = "GA";
    CountryCode["GM"] = "GM";
    CountryCode["GE"] = "GE";
    CountryCode["DE"] = "DE";
    CountryCode["GH"] = "GH";
    CountryCode["GI"] = "GI";
    CountryCode["GR"] = "GR";
    CountryCode["GL"] = "GL";
    CountryCode["GD"] = "GD";
    CountryCode["GP"] = "GP";
    CountryCode["GU"] = "GU";
    CountryCode["GT"] = "GT";
    CountryCode["GG"] = "GG";
    CountryCode["GN"] = "GN";
    CountryCode["GW"] = "GW";
    CountryCode["GY"] = "GY";
    CountryCode["HT"] = "HT";
    CountryCode["HM"] = "HM";
    CountryCode["VA"] = "VA";
    CountryCode["HN"] = "HN";
    CountryCode["HK"] = "HK";
    CountryCode["HU"] = "HU";
    CountryCode["IS"] = "IS";
    CountryCode["IN"] = "IN";
    CountryCode["ID"] = "ID";
    CountryCode["IR"] = "IR";
    CountryCode["IQ"] = "IQ";
    CountryCode["IE"] = "IE";
    CountryCode["IM"] = "IM";
    CountryCode["IL"] = "IL";
    CountryCode["IT"] = "IT";
    CountryCode["JM"] = "JM";
    CountryCode["JP"] = "JP";
    CountryCode["JE"] = "JE";
    CountryCode["JO"] = "JO";
    CountryCode["KZ"] = "KZ";
    CountryCode["KE"] = "KE";
    CountryCode["KI"] = "KI";
    CountryCode["KP"] = "KP";
    CountryCode["KR"] = "KR";
    CountryCode["KW"] = "KW";
    CountryCode["KG"] = "KG";
    CountryCode["LA"] = "LA";
    CountryCode["LV"] = "LV";
    CountryCode["LB"] = "LB";
    CountryCode["LS"] = "LS";
    CountryCode["LR"] = "LR";
    CountryCode["LY"] = "LY";
    CountryCode["LI"] = "LI";
    CountryCode["LT"] = "LT";
    CountryCode["LU"] = "LU";
    CountryCode["MO"] = "MO";
    CountryCode["MG"] = "MG";
    CountryCode["MW"] = "MW";
    CountryCode["MY"] = "MY";
    CountryCode["MV"] = "MV";
    CountryCode["ML"] = "ML";
    CountryCode["MT"] = "MT";
    CountryCode["MH"] = "MH";
    CountryCode["MQ"] = "MQ";
    CountryCode["MR"] = "MR";
    CountryCode["MU"] = "MU";
    CountryCode["YT"] = "YT";
    CountryCode["MX"] = "MX";
    CountryCode["FM"] = "FM";
    CountryCode["MD"] = "MD";
    CountryCode["MC"] = "MC";
    CountryCode["MN"] = "MN";
    CountryCode["ME"] = "ME";
    CountryCode["MS"] = "MS";
    CountryCode["MA"] = "MA";
    CountryCode["MZ"] = "MZ";
    CountryCode["MM"] = "MM";
    CountryCode["NA"] = "NA";
    CountryCode["NR"] = "NR";
    CountryCode["NP"] = "NP";
    CountryCode["NL"] = "NL";
    CountryCode["NC"] = "NC";
    CountryCode["NZ"] = "NZ";
    CountryCode["NI"] = "NI";
    CountryCode["NE"] = "NE";
    CountryCode["NG"] = "NG";
    CountryCode["NU"] = "NU";
    CountryCode["NF"] = "NF";
    CountryCode["MP"] = "MP";
    CountryCode["NO"] = "NO";
    CountryCode["OM"] = "OM";
    CountryCode["PK"] = "PK";
    CountryCode["PW"] = "PW";
    CountryCode["PS"] = "PS";
    CountryCode["PA"] = "PA";
    CountryCode["PG"] = "PG";
    CountryCode["PY"] = "PY";
    CountryCode["PE"] = "PE";
    CountryCode["PH"] = "PH";
    CountryCode["PN"] = "PN";
    CountryCode["PL"] = "PL";
    CountryCode["PT"] = "PT";
    CountryCode["PR"] = "PR";
    CountryCode["QA"] = "QA";
    CountryCode["MK"] = "MK";
    CountryCode["RO"] = "RO";
    CountryCode["RU"] = "RU";
    CountryCode["RW"] = "RW";
    CountryCode["RE"] = "RE";
    CountryCode["BL"] = "BL";
    CountryCode["SH"] = "SH";
    CountryCode["KN"] = "KN";
    CountryCode["LC"] = "LC";
    CountryCode["MF"] = "MF";
    CountryCode["PM"] = "PM";
    CountryCode["VC"] = "VC";
    CountryCode["WS"] = "WS";
    CountryCode["SM"] = "SM";
    CountryCode["ST"] = "ST";
    CountryCode["SA"] = "SA";
    CountryCode["SN"] = "SN";
    CountryCode["RS"] = "RS";
    CountryCode["SC"] = "SC";
    CountryCode["SL"] = "SL";
    CountryCode["SG"] = "SG";
    CountryCode["SX"] = "SX";
    CountryCode["SK"] = "SK";
    CountryCode["SI"] = "SI";
    CountryCode["SB"] = "SB";
    CountryCode["SO"] = "SO";
    CountryCode["ZA"] = "ZA";
    CountryCode["GS"] = "GS";
    CountryCode["SS"] = "SS";
    CountryCode["ES"] = "ES";
    CountryCode["LK"] = "LK";
    CountryCode["SD"] = "SD";
    CountryCode["SR"] = "SR";
    CountryCode["SJ"] = "SJ";
    CountryCode["SE"] = "SE";
    CountryCode["CH"] = "CH";
    CountryCode["SY"] = "SY";
    CountryCode["TW"] = "TW";
    CountryCode["TJ"] = "TJ";
    CountryCode["TZ"] = "TZ";
    CountryCode["TH"] = "TH";
    CountryCode["TL"] = "TL";
    CountryCode["TG"] = "TG";
    CountryCode["TK"] = "TK";
    CountryCode["TO"] = "TO";
    CountryCode["TT"] = "TT";
    CountryCode["TN"] = "TN";
    CountryCode["TR"] = "TR";
    CountryCode["TM"] = "TM";
    CountryCode["TC"] = "TC";
    CountryCode["TV"] = "TV";
    CountryCode["UG"] = "UG";
    CountryCode["UA"] = "UA";
    CountryCode["AE"] = "AE";
    CountryCode["GB"] = "GB";
    CountryCode["UM"] = "UM";
    CountryCode["UY"] = "UY";
    CountryCode["UZ"] = "UZ";
    CountryCode["VU"] = "VU";
    CountryCode["VE"] = "VE";
    CountryCode["VN"] = "VN";
    CountryCode["VG"] = "VG";
    CountryCode["VI"] = "VI";
    CountryCode["WF"] = "WF";
    CountryCode["EH"] = "EH";
    CountryCode["YE"] = "YE";
    CountryCode["ZM"] = "ZM";
    CountryCode["ZW"] = "ZW";
    CountryCode["AX"] = "AX";
})(CountryCode || (CountryCode = {}));
var CountryCodeMap = (_a$5 = {},
    _a$5[CountryCode.US] = { code: 'US', code3: 'USA', name: 'USA', number: '840' },
    _a$5[CountryCode.CA] = { code: 'CA', code3: 'CAN', name: 'Canada', number: '124' },
    _a$5[CountryCode.AF] = { code: 'AF', code3: 'AFG', name: 'Afghanistan', number: '004' },
    _a$5[CountryCode.AL] = { code: 'AL', code3: 'ALB', name: 'Albania', number: '008' },
    _a$5[CountryCode.DZ] = { code: 'DZ', code3: 'DZA', name: 'Algeria', number: '012' },
    _a$5[CountryCode.AS] = { code: 'AS', code3: 'ASM', name: 'American Samoa', number: '016' },
    _a$5[CountryCode.AD] = { code: 'AD', code3: 'AND', name: 'Andorra', number: '020' },
    _a$5[CountryCode.AO] = { code: 'AO', code3: 'AGO', name: 'Angola', number: '024' },
    _a$5[CountryCode.AI] = { code: 'AI', code3: 'AIA', name: 'Anguilla', number: '660' },
    _a$5[CountryCode.AQ] = { code: 'AQ', code3: 'ATA', name: 'Antarctica', number: '010' },
    _a$5[CountryCode.AG] = { code: 'AG', code3: 'ATG', name: 'Antigua and Barbuda', number: '028' },
    _a$5[CountryCode.AR] = { code: 'AR', code3: 'ARG', name: 'Argentina', number: '032' },
    _a$5[CountryCode.AM] = { code: 'AM', code3: 'ARM', name: 'Armenia', number: '051' },
    _a$5[CountryCode.AW] = { code: 'AW', code3: 'ABW', name: 'Aruba', number: '533' },
    _a$5[CountryCode.AU] = { code: 'AU', code3: 'AUS', name: 'Australia', number: '036' },
    _a$5[CountryCode.AT] = { code: 'AT', code3: 'AUT', name: 'Austria', number: '040' },
    _a$5[CountryCode.AZ] = { code: 'AZ', code3: 'AZE', name: 'Azerbaijan', number: '031' },
    _a$5[CountryCode.BS] = { code: 'BS', code3: 'BHS', name: 'Bahamas (the)', number: '044' },
    _a$5[CountryCode.BH] = { code: 'BH', code3: 'BHR', name: 'Bahrain', number: '048' },
    _a$5[CountryCode.BD] = { code: 'BD', code3: 'BGD', name: 'Bangladesh', number: '050' },
    _a$5[CountryCode.BB] = { code: 'BB', code3: 'BRB', name: 'Barbados', number: '052' },
    _a$5[CountryCode.BY] = { code: 'BY', code3: 'BLR', name: 'Belarus', number: '112' },
    _a$5[CountryCode.BE] = { code: 'BE', code3: 'BEL', name: 'Belgium', number: '056' },
    _a$5[CountryCode.BZ] = { code: 'BZ', code3: 'BLZ', name: 'Belize', number: '084' },
    _a$5[CountryCode.BJ] = { code: 'BJ', code3: 'BEN', name: 'Benin', number: '204' },
    _a$5[CountryCode.BM] = { code: 'BM', code3: 'BMU', name: 'Bermuda', number: '060' },
    _a$5[CountryCode.BT] = { code: 'BT', code3: 'BTN', name: 'Bhutan', number: '064' },
    _a$5[CountryCode.BO] = {
        code: 'BO',
        code3: 'BOL',
        name: 'Bolivia (Plurinational State of)',
        number: '068'
    },
    _a$5[CountryCode.BQ] = {
        code: 'BQ',
        code3: 'BES',
        name: 'Bonaire, Sint Eustatius and Saba',
        number: '535'
    },
    _a$5[CountryCode.BA] = { code: 'BA', code3: 'BIH', name: 'Bosnia and Herzegovina', number: '070' },
    _a$5[CountryCode.BW] = { code: 'BW', code3: 'BWA', name: 'Botswana', number: '072' },
    _a$5[CountryCode.BV] = { code: 'BV', code3: 'BVT', name: 'Bouvet Island', number: '074' },
    _a$5[CountryCode.BR] = { code: 'BR', code3: 'BRA', name: 'Brazil', number: '076' },
    _a$5[CountryCode.IO] = {
        code: 'IO',
        code3: 'IOT',
        name: 'British Indian Ocean Territory (the)',
        number: '086'
    },
    _a$5[CountryCode.BN] = { code: 'BN', code3: 'BRN', name: 'Brunei Darussalam', number: '096' },
    _a$5[CountryCode.BG] = { code: 'BG', code3: 'BGR', name: 'Bulgaria', number: '100' },
    _a$5[CountryCode.BF] = { code: 'BF', code3: 'BFA', name: 'Burkina Faso', number: '854' },
    _a$5[CountryCode.BI] = { code: 'BI', code3: 'BDI', name: 'Burundi', number: '108' },
    _a$5[CountryCode.CV] = { code: 'CV', code3: 'CPV', name: 'Cabo Verde', number: '132' },
    _a$5[CountryCode.KH] = { code: 'KH', code3: 'KHM', name: 'Cambodia', number: '116' },
    _a$5[CountryCode.CM] = { code: 'CM', code3: 'CMR', name: 'Cameroon', number: '120' },
    _a$5[CountryCode.KY] = { code: 'KY', code3: 'CYM', name: 'Cayman Islands (the)', number: '136' },
    _a$5[CountryCode.CF] = {
        code: 'CF',
        code3: 'CAF',
        name: 'Central African Republic (the)',
        number: '140'
    },
    _a$5[CountryCode.TD] = { code: 'TD', code3: 'TCD', name: 'Chad', number: '148' },
    _a$5[CountryCode.CL] = { code: 'CL', code3: 'CHL', name: 'Chile', number: '152' },
    _a$5[CountryCode.CN] = { code: 'CN', code3: 'CHN', name: 'China', number: '156' },
    _a$5[CountryCode.CX] = { code: 'CX', code3: 'CXR', name: 'Christmas Island', number: '162' },
    _a$5[CountryCode.CC] = {
        code: 'CC',
        code3: 'CCK',
        name: 'Cocos (Keeling) Islands (the)',
        number: '166'
    },
    _a$5[CountryCode.CO] = { code: 'CO', code3: 'COL', name: 'Colombia', number: '170' },
    _a$5[CountryCode.KM] = { code: 'KM', code3: 'COM', name: 'Comoros (the)', number: '174' },
    _a$5[CountryCode.CD] = {
        code: 'CD',
        code3: 'COD',
        name: 'Congo (the Democratic Republic of the)',
        number: '180'
    },
    _a$5[CountryCode.CG] = { code: 'CG', code3: 'COG', name: 'Congo (the)', number: '178' },
    _a$5[CountryCode.CK] = { code: 'CK', code3: 'COK', name: 'Cook Islands (the)', number: '184' },
    _a$5[CountryCode.CR] = { code: 'CR', code3: 'CRI', name: 'Costa Rica', number: '188' },
    _a$5[CountryCode.HR] = { code: 'HR', code3: 'HRV', name: 'Croatia', number: '191' },
    _a$5[CountryCode.CU] = { code: 'CU', code3: 'CUB', name: 'Cuba', number: '192' },
    _a$5[CountryCode.CW] = { code: 'CW', code3: 'CUW', name: 'Curaçao', number: '531' },
    _a$5[CountryCode.CY] = { code: 'CY', code3: 'CYP', name: 'Cyprus', number: '196' },
    _a$5[CountryCode.CZ] = { code: 'CZ', code3: 'CZE', name: 'Czechia', number: '203' },
    _a$5[CountryCode.CI] = { code: 'CI', code3: 'CIV', name: "Côte d'Ivoire", number: '384' },
    _a$5[CountryCode.DK] = { code: 'DK', code3: 'DNK', name: 'Denmark', number: '208' },
    _a$5[CountryCode.DJ] = { code: 'DJ', code3: 'DJI', name: 'Djibouti', number: '262' },
    _a$5[CountryCode.DM] = { code: 'DM', code3: 'DMA', name: 'Dominica', number: '212' },
    _a$5[CountryCode.DO] = { code: 'DO', code3: 'DOM', name: 'Dominican Republic (the)', number: '214' },
    _a$5[CountryCode.EC] = { code: 'EC', code3: 'ECU', name: 'Ecuador', number: '218' },
    _a$5[CountryCode.EG] = { code: 'EG', code3: 'EGY', name: 'Egypt', number: '818' },
    _a$5[CountryCode.SV] = { code: 'SV', code3: 'SLV', name: 'El Salvador', number: '222' },
    _a$5[CountryCode.GQ] = { code: 'GQ', code3: 'GNQ', name: 'Equatorial Guinea', number: '226' },
    _a$5[CountryCode.ER] = { code: 'ER', code3: 'ERI', name: 'Eritrea', number: '232' },
    _a$5[CountryCode.EE] = { code: 'EE', code3: 'EST', name: 'Estonia', number: '233' },
    _a$5[CountryCode.SZ] = { code: 'SZ', code3: 'SWZ', name: 'Eswatini', number: '748' },
    _a$5[CountryCode.ET] = { code: 'ET', code3: 'ETH', name: 'Ethiopia', number: '231' },
    _a$5[CountryCode.FK] = {
        code: 'FK',
        code3: 'FLK',
        name: 'Falkland Islands (the) [Malvinas]',
        number: '238'
    },
    _a$5[CountryCode.FO] = { code: 'FO', code3: 'FRO', name: 'Faroe Islands (the)', number: '234' },
    _a$5[CountryCode.FJ] = { code: 'FJ', code3: 'FJI', name: 'Fiji', number: '242' },
    _a$5[CountryCode.FI] = { code: 'FI', code3: 'FIN', name: 'Finland', number: '246' },
    _a$5[CountryCode.FR] = { code: 'FR', code3: 'FRA', name: 'France', number: '250' },
    _a$5[CountryCode.GF] = { code: 'GF', code3: 'GUF', name: 'French Guiana', number: '254' },
    _a$5[CountryCode.PF] = { code: 'PF', code3: 'PYF', name: 'French Polynesia', number: '258' },
    _a$5[CountryCode.TF] = {
        code: 'TF',
        code3: 'ATF',
        name: 'French Southern Territories (the)',
        number: '260'
    },
    _a$5[CountryCode.GA] = { code: 'GA', code3: 'GAB', name: 'Gabon', number: '266' },
    _a$5[CountryCode.GM] = { code: 'GM', code3: 'GMB', name: 'Gambia (the)', number: '270' },
    _a$5[CountryCode.GE] = { code: 'GE', code3: 'GEO', name: 'Georgia', number: '268' },
    _a$5[CountryCode.DE] = { code: 'DE', code3: 'DEU', name: 'Germany', number: '276' },
    _a$5[CountryCode.GH] = { code: 'GH', code3: 'GHA', name: 'Ghana', number: '288' },
    _a$5[CountryCode.GI] = { code: 'GI', code3: 'GIB', name: 'Gibraltar', number: '292' },
    _a$5[CountryCode.GR] = { code: 'GR', code3: 'GRC', name: 'Greece', number: '300' },
    _a$5[CountryCode.GL] = { code: 'GL', code3: 'GRL', name: 'Greenland', number: '304' },
    _a$5[CountryCode.GD] = { code: 'GD', code3: 'GRD', name: 'Grenada', number: '308' },
    _a$5[CountryCode.GP] = { code: 'GP', code3: 'GLP', name: 'Guadeloupe', number: '312' },
    _a$5[CountryCode.GU] = { code: 'GU', code3: 'GUM', name: 'Guam', number: '316' },
    _a$5[CountryCode.GT] = { code: 'GT', code3: 'GTM', name: 'Guatemala', number: '320' },
    _a$5[CountryCode.GG] = { code: 'GG', code3: 'GGY', name: 'Guernsey', number: '831' },
    _a$5[CountryCode.GN] = { code: 'GN', code3: 'GIN', name: 'Guinea', number: '324' },
    _a$5[CountryCode.GW] = { code: 'GW', code3: 'GNB', name: 'Guinea-Bissau', number: '624' },
    _a$5[CountryCode.GY] = { code: 'GY', code3: 'GUY', name: 'Guyana', number: '328' },
    _a$5[CountryCode.HT] = { code: 'HT', code3: 'HTI', name: 'Haiti', number: '332' },
    _a$5[CountryCode.HM] = {
        code: 'HM',
        code3: 'HMD',
        name: 'Heard Island and McDonald Islands',
        number: '334'
    },
    _a$5[CountryCode.VA] = { code: 'VA', code3: 'VAT', name: 'Holy See (the)', number: '336' },
    _a$5[CountryCode.HN] = { code: 'HN', code3: 'HND', name: 'Honduras', number: '340' },
    _a$5[CountryCode.HK] = { code: 'HK', code3: 'HKG', name: 'Hong Kong', number: '344' },
    _a$5[CountryCode.HU] = { code: 'HU', code3: 'HUN', name: 'Hungary', number: '348' },
    _a$5[CountryCode.IS] = { code: 'IS', code3: 'ISL', name: 'Iceland', number: '352' },
    _a$5[CountryCode.IN] = { code: 'IN', code3: 'IND', name: 'India', number: '356' },
    _a$5[CountryCode.ID] = { code: 'ID', code3: 'IDN', name: 'Indonesia', number: '360' },
    _a$5[CountryCode.IR] = { code: 'IR', code3: 'IRN', name: 'Iran (Islamic Republic of)', number: '364' },
    _a$5[CountryCode.IQ] = { code: 'IQ', code3: 'IRQ', name: 'Iraq', number: '368' },
    _a$5[CountryCode.IE] = { code: 'IE', code3: 'IRL', name: 'Ireland', number: '372' },
    _a$5[CountryCode.IM] = { code: 'IM', code3: 'IMN', name: 'Isle of Man', number: '833' },
    _a$5[CountryCode.IL] = { code: 'IL', code3: 'ISR', name: 'Israel', number: '376' },
    _a$5[CountryCode.IT] = { code: 'IT', code3: 'ITA', name: 'Italy', number: '380' },
    _a$5[CountryCode.JM] = { code: 'JM', code3: 'JAM', name: 'Jamaica', number: '388' },
    _a$5[CountryCode.JP] = { code: 'JP', code3: 'JPN', name: 'Japan', number: '392' },
    _a$5[CountryCode.JE] = { code: 'JE', code3: 'JEY', name: 'Jersey', number: '832' },
    _a$5[CountryCode.JO] = { code: 'JO', code3: 'JOR', name: 'Jordan', number: '400' },
    _a$5[CountryCode.KZ] = { code: 'KZ', code3: 'KAZ', name: 'Kazakhstan', number: '398' },
    _a$5[CountryCode.KE] = { code: 'KE', code3: 'KEN', name: 'Kenya', number: '404' },
    _a$5[CountryCode.KI] = { code: 'KI', code3: 'KIR', name: 'Kiribati', number: '296' },
    _a$5[CountryCode.KP] = {
        code: 'KP',
        code3: 'PRK',
        name: "Korea (the Democratic People's Republic of)",
        number: '408'
    },
    _a$5[CountryCode.KR] = { code: 'KR', code3: 'KOR', name: 'Korea (the Republic of)', number: '410' },
    _a$5[CountryCode.KW] = { code: 'KW', code3: 'KWT', name: 'Kuwait', number: '414' },
    _a$5[CountryCode.KG] = { code: 'KG', code3: 'KGZ', name: 'Kyrgyzstan', number: '417' },
    _a$5[CountryCode.LA] = {
        code: 'LA',
        code3: 'LAO',
        name: "Lao People's Democratic Republic (the)",
        number: '418'
    },
    _a$5[CountryCode.LV] = { code: 'LV', code3: 'LVA', name: 'Latvia', number: '428' },
    _a$5[CountryCode.LB] = { code: 'LB', code3: 'LBN', name: 'Lebanon', number: '422' },
    _a$5[CountryCode.LS] = { code: 'LS', code3: 'LSO', name: 'Lesotho', number: '426' },
    _a$5[CountryCode.LR] = { code: 'LR', code3: 'LBR', name: 'Liberia', number: '430' },
    _a$5[CountryCode.LY] = { code: 'LY', code3: 'LBY', name: 'Libya', number: '434' },
    _a$5[CountryCode.LI] = { code: 'LI', code3: 'LIE', name: 'Liechtenstein', number: '438' },
    _a$5[CountryCode.LT] = { code: 'LT', code3: 'LTU', name: 'Lithuania', number: '440' },
    _a$5[CountryCode.LU] = { code: 'LU', code3: 'LUX', name: 'Luxembourg', number: '442' },
    _a$5[CountryCode.MO] = { code: 'MO', code3: 'MAC', name: 'Macao', number: '446' },
    _a$5[CountryCode.MG] = { code: 'MG', code3: 'MDG', name: 'Madagascar', number: '450' },
    _a$5[CountryCode.MW] = { code: 'MW', code3: 'MWI', name: 'Malawi', number: '454' },
    _a$5[CountryCode.MY] = { code: 'MY', code3: 'MYS', name: 'Malaysia', number: '458' },
    _a$5[CountryCode.MV] = { code: 'MV', code3: 'MDV', name: 'Maldives', number: '462' },
    _a$5[CountryCode.ML] = { code: 'ML', code3: 'MLI', name: 'Mali', number: '466' },
    _a$5[CountryCode.MT] = { code: 'MT', code3: 'MLT', name: 'Malta', number: '470' },
    _a$5[CountryCode.MH] = { code: 'MH', code3: 'MHL', name: 'Marshall Islands (the)', number: '584' },
    _a$5[CountryCode.MQ] = { code: 'MQ', code3: 'MTQ', name: 'Martinique', number: '474' },
    _a$5[CountryCode.MR] = { code: 'MR', code3: 'MRT', name: 'Mauritania', number: '478' },
    _a$5[CountryCode.MU] = { code: 'MU', code3: 'MUS', name: 'Mauritius', number: '480' },
    _a$5[CountryCode.YT] = { code: 'YT', code3: 'MYT', name: 'Mayotte', number: '175' },
    _a$5[CountryCode.MX] = { code: 'MX', code3: 'MEX', name: 'Mexico', number: '484' },
    _a$5[CountryCode.FM] = {
        code: 'FM',
        code3: 'FSM',
        name: 'Micronesia (Federated States of)',
        number: '583'
    },
    _a$5[CountryCode.MD] = { code: 'MD', code3: 'MDA', name: 'Moldova (the Republic of)', number: '498' },
    _a$5[CountryCode.MC] = { code: 'MC', code3: 'MCO', name: 'Monaco', number: '492' },
    _a$5[CountryCode.MN] = { code: 'MN', code3: 'MNG', name: 'Mongolia', number: '496' },
    _a$5[CountryCode.ME] = { code: 'ME', code3: 'MNE', name: 'Montenegro', number: '499' },
    _a$5[CountryCode.MS] = { code: 'MS', code3: 'MSR', name: 'Montserrat', number: '500' },
    _a$5[CountryCode.MA] = { code: 'MA', code3: 'MAR', name: 'Morocco', number: '504' },
    _a$5[CountryCode.MZ] = { code: 'MZ', code3: 'MOZ', name: 'Mozambique', number: '508' },
    _a$5[CountryCode.MM] = { code: 'MM', code3: 'MMR', name: 'Myanmar', number: '104' },
    _a$5[CountryCode.NA] = { code: 'NA', code3: 'NAM', name: 'Namibia', number: '516' },
    _a$5[CountryCode.NR] = { code: 'NR', code3: 'NRU', name: 'Nauru', number: '520' },
    _a$5[CountryCode.NP] = { code: 'NP', code3: 'NPL', name: 'Nepal', number: '524' },
    _a$5[CountryCode.NL] = { code: 'NL', code3: 'NLD', name: 'Netherlands (the)', number: '528' },
    _a$5[CountryCode.NC] = { code: 'NC', code3: 'NCL', name: 'New Caledonia', number: '540' },
    _a$5[CountryCode.NZ] = { code: 'NZ', code3: 'NZL', name: 'New Zealand', number: '554' },
    _a$5[CountryCode.NI] = { code: 'NI', code3: 'NIC', name: 'Nicaragua', number: '558' },
    _a$5[CountryCode.NE] = { code: 'NE', code3: 'NER', name: 'Niger (the)', number: '562' },
    _a$5[CountryCode.NG] = { code: 'NG', code3: 'NGA', name: 'Nigeria', number: '566' },
    _a$5[CountryCode.NU] = { code: 'NU', code3: 'NIU', name: 'Niue', number: '570' },
    _a$5[CountryCode.NF] = { code: 'NF', code3: 'NFK', name: 'Norfolk Island', number: '574' },
    _a$5[CountryCode.MP] = {
        code: 'MP',
        code3: 'MNP',
        name: 'Northern Mariana Islands (the)',
        number: '580'
    },
    _a$5[CountryCode.NO] = { code: 'NO', code3: 'NOR', name: 'Norway', number: '578' },
    _a$5[CountryCode.OM] = { code: 'OM', code3: 'OMN', name: 'Oman', number: '512' },
    _a$5[CountryCode.PK] = { code: 'PK', code3: 'PAK', name: 'Pakistan', number: '586' },
    _a$5[CountryCode.PW] = { code: 'PW', code3: 'PLW', name: 'Palau', number: '585' },
    _a$5[CountryCode.PS] = { code: 'PS', code3: 'PSE', name: 'Palestine, State of', number: '275' },
    _a$5[CountryCode.PA] = { code: 'PA', code3: 'PAN', name: 'Panama', number: '591' },
    _a$5[CountryCode.PG] = { code: 'PG', code3: 'PNG', name: 'Papua New Guinea', number: '598' },
    _a$5[CountryCode.PY] = { code: 'PY', code3: 'PRY', name: 'Paraguay', number: '600' },
    _a$5[CountryCode.PE] = { code: 'PE', code3: 'PER', name: 'Peru', number: '604' },
    _a$5[CountryCode.PH] = { code: 'PH', code3: 'PHL', name: 'Philippines (the)', number: '608' },
    _a$5[CountryCode.PN] = { code: 'PN', code3: 'PCN', name: 'Pitcairn', number: '612' },
    _a$5[CountryCode.PL] = { code: 'PL', code3: 'POL', name: 'Poland', number: '616' },
    _a$5[CountryCode.PT] = { code: 'PT', code3: 'PRT', name: 'Portugal', number: '620' },
    _a$5[CountryCode.PR] = { code: 'PR', code3: 'PRI', name: 'Puerto Rico', number: '630' },
    _a$5[CountryCode.QA] = { code: 'QA', code3: 'QAT', name: 'Qatar', number: '634' },
    _a$5[CountryCode.MK] = {
        code: 'MK',
        code3: 'MKD',
        name: 'Republic of North Macedonia',
        number: '807'
    },
    _a$5[CountryCode.RO] = { code: 'RO', code3: 'ROU', name: 'Romania', number: '642' },
    _a$5[CountryCode.RU] = { code: 'RU', code3: 'RUS', name: 'Russian Federation (the)', number: '643' },
    _a$5[CountryCode.RW] = { code: 'RW', code3: 'RWA', name: 'Rwanda', number: '646' },
    _a$5[CountryCode.RE] = { code: 'RE', code3: 'REU', name: 'Réunion', number: '638' },
    _a$5[CountryCode.BL] = { code: 'BL', code3: 'BLM', name: 'Saint Barthélemy', number: '652' },
    _a$5[CountryCode.SH] = {
        code: 'SH',
        code3: 'SHN',
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        number: '654'
    },
    _a$5[CountryCode.KN] = { code: 'KN', code3: 'KNA', name: 'Saint Kitts and Nevis', number: '659' },
    _a$5[CountryCode.LC] = { code: 'LC', code3: 'LCA', name: 'Saint Lucia', number: '662' },
    _a$5[CountryCode.MF] = { code: 'MF', code3: 'MAF', name: 'Saint Martin (French part)', number: '663' },
    _a$5[CountryCode.PM] = { code: 'PM', code3: 'SPM', name: 'Saint Pierre and Miquelon', number: '666' },
    _a$5[CountryCode.VC] = {
        code: 'VC',
        code3: 'VCT',
        name: 'Saint Vincent and the Grenadines',
        number: '670'
    },
    _a$5[CountryCode.WS] = { code: 'WS', code3: 'WSM', name: 'Samoa', number: '882' },
    _a$5[CountryCode.SM] = { code: 'SM', code3: 'SMR', name: 'San Marino', number: '674' },
    _a$5[CountryCode.ST] = { code: 'ST', code3: 'STP', name: 'Sao Tome and Principe', number: '678' },
    _a$5[CountryCode.SA] = { code: 'SA', code3: 'SAU', name: 'Saudi Arabia', number: '682' },
    _a$5[CountryCode.SN] = { code: 'SN', code3: 'SEN', name: 'Senegal', number: '686' },
    _a$5[CountryCode.RS] = { code: 'RS', code3: 'SRB', name: 'Serbia', number: '688' },
    _a$5[CountryCode.SC] = { code: 'SC', code3: 'SYC', name: 'Seychelles', number: '690' },
    _a$5[CountryCode.SL] = { code: 'SL', code3: 'SLE', name: 'Sierra Leone', number: '694' },
    _a$5[CountryCode.SG] = { code: 'SG', code3: 'SGP', name: 'Singapore', number: '702' },
    _a$5[CountryCode.SX] = { code: 'SX', code3: 'SXM', name: 'Sint Maarten (Dutch part)', number: '534' },
    _a$5[CountryCode.SK] = { code: 'SK', code3: 'SVK', name: 'Slovakia', number: '703' },
    _a$5[CountryCode.SI] = { code: 'SI', code3: 'SVN', name: 'Slovenia', number: '705' },
    _a$5[CountryCode.SB] = { code: 'SB', code3: 'SLB', name: 'Solomon Islands', number: '090' },
    _a$5[CountryCode.SO] = { code: 'SO', code3: 'SOM', name: 'Somalia', number: '706' },
    _a$5[CountryCode.ZA] = { code: 'ZA', code3: 'ZAF', name: 'South Africa', number: '710' },
    _a$5[CountryCode.GS] = {
        code: 'GS',
        code3: 'SGS',
        name: 'South Georgia and the South Sandwich Islands',
        number: '239'
    },
    _a$5[CountryCode.SS] = { code: 'SS', code3: 'SSD', name: 'South Sudan', number: '728' },
    _a$5[CountryCode.ES] = { code: 'ES', code3: 'ESP', name: 'Spain', number: '724' },
    _a$5[CountryCode.LK] = { code: 'LK', code3: 'LKA', name: 'Sri Lanka', number: '144' },
    _a$5[CountryCode.SD] = { code: 'SD', code3: 'SDN', name: 'Sudan (the)', number: '729' },
    _a$5[CountryCode.SR] = { code: 'SR', code3: 'SUR', name: 'Suriname', number: '740' },
    _a$5[CountryCode.SJ] = { code: 'SJ', code3: 'SJM', name: 'Svalbard and Jan Mayen', number: '744' },
    _a$5[CountryCode.SE] = { code: 'SE', code3: 'SWE', name: 'Sweden', number: '752' },
    _a$5[CountryCode.CH] = { code: 'CH', code3: 'CHE', name: 'Switzerland', number: '756' },
    _a$5[CountryCode.SY] = { code: 'SY', code3: 'SYR', name: 'Syrian Arab Republic', number: '760' },
    _a$5[CountryCode.TW] = { code: 'TW', code3: 'TWN', name: 'Taiwan', number: '158' },
    _a$5[CountryCode.TJ] = { code: 'TJ', code3: 'TJK', name: 'Tajikistan', number: '762' },
    _a$5[CountryCode.TZ] = {
        code: 'TZ',
        code3: 'TZA',
        name: 'Tanzania, United Republic of',
        number: '834'
    },
    _a$5[CountryCode.TH] = { code: 'TH', code3: 'THA', name: 'Thailand', number: '764' },
    _a$5[CountryCode.TL] = { code: 'TL', code3: 'TLS', name: 'Timor-Leste', number: '626' },
    _a$5[CountryCode.TG] = { code: 'TG', code3: 'TGO', name: 'Togo', number: '768' },
    _a$5[CountryCode.TK] = { code: 'TK', code3: 'TKL', name: 'Tokelau', number: '772' },
    _a$5[CountryCode.TO] = { code: 'TO', code3: 'TON', name: 'Tonga', number: '776' },
    _a$5[CountryCode.TT] = { code: 'TT', code3: 'TTO', name: 'Trinidad and Tobago', number: '780' },
    _a$5[CountryCode.TN] = { code: 'TN', code3: 'TUN', name: 'Tunisia', number: '788' },
    _a$5[CountryCode.TR] = { code: 'TR', code3: 'TUR', name: 'Turkey', number: '792' },
    _a$5[CountryCode.TM] = { code: 'TM', code3: 'TKM', name: 'Turkmenistan', number: '795' },
    _a$5[CountryCode.TC] = {
        code: 'TC',
        code3: 'TCA',
        name: 'Turks and Caicos Islands (the)',
        number: '796'
    },
    _a$5[CountryCode.TV] = { code: 'TV', code3: 'TUV', name: 'Tuvalu', number: '798' },
    _a$5[CountryCode.UG] = { code: 'UG', code3: 'UGA', name: 'Uganda', number: '800' },
    _a$5[CountryCode.UA] = { code: 'UA', code3: 'UKR', name: 'Ukraine', number: '804' },
    _a$5[CountryCode.AE] = { code: 'AE', code3: 'ARE', name: 'United Arab Emirates (the)', number: '784' },
    _a$5[CountryCode.GB] = {
        code: 'GB',
        code3: 'GBR',
        name: 'United Kingdom of Great Britain and Northern Ireland (the)',
        number: '826'
    },
    _a$5[CountryCode.UM] = {
        code: 'UM',
        code3: 'UMI',
        name: 'United States Minor Outlying Islands (the)',
        number: '581'
    },
    _a$5[CountryCode.UY] = { code: 'UY', code3: 'URY', name: 'Uruguay', number: '858' },
    _a$5[CountryCode.UZ] = { code: 'UZ', code3: 'UZB', name: 'Uzbekistan', number: '860' },
    _a$5[CountryCode.VU] = { code: 'VU', code3: 'VUT', name: 'Vanuatu', number: '548' },
    _a$5[CountryCode.VE] = {
        code: 'VE',
        code3: 'VEN',
        name: 'Venezuela (Bolivarian Republic of)',
        number: '862'
    },
    _a$5[CountryCode.VN] = { code: 'VN', code3: 'VNM', name: 'Viet Nam', number: '704' },
    _a$5[CountryCode.VG] = { code: 'VG', code3: 'VGB', name: 'Virgin Islands (British)', number: '092' },
    _a$5[CountryCode.VI] = { code: 'VI', code3: 'VIR', name: 'Virgin Islands (U.S.)', number: '850' },
    _a$5[CountryCode.WF] = { code: 'WF', code3: 'WLF', name: 'Wallis and Futuna', number: '876' },
    _a$5[CountryCode.EH] = { code: 'EH', code3: 'ESH', name: 'Western Sahara', number: '732' },
    _a$5[CountryCode.YE] = { code: 'YE', code3: 'YEM', name: 'Yemen', number: '887' },
    _a$5[CountryCode.ZM] = { code: 'ZM', code3: 'ZMB', name: 'Zambia', number: '894' },
    _a$5[CountryCode.ZW] = { code: 'ZW', code3: 'ZWE', name: 'Zimbabwe', number: '716' },
    _a$5[CountryCode.AX] = { code: 'AX', code3: 'ALA', name: 'Åland Islands', number: '248' },
    _a$5);

var Language;
(function (Language) {
    Language["AA"] = "aa";
    Language["AB"] = "ab";
    Language["AE"] = "ae";
    Language["AF"] = "af";
    Language["AK"] = "ak";
    Language["AM"] = "am";
    Language["AN"] = "an";
    Language["AR"] = "ar";
    Language["AS"] = "as";
    Language["AV"] = "av";
    Language["AY"] = "ay";
    Language["AZ"] = "az";
    Language["BA"] = "ba";
    Language["BE"] = "be";
    Language["BG"] = "bg";
    Language["BI"] = "bi";
    Language["BM"] = "bm";
    Language["BN"] = "bn";
    Language["BO"] = "bo";
    Language["BR"] = "br";
    Language["BS"] = "bs";
    Language["CA"] = "ca";
    Language["CE"] = "ce";
    Language["CH"] = "ch";
    Language["CO"] = "co";
    Language["CR"] = "cr";
    Language["CS"] = "cs";
    Language["CU"] = "cu";
    Language["CV"] = "cv";
    Language["CY"] = "cy";
    Language["DA"] = "da";
    Language["DE"] = "de";
    Language["DV"] = "dv";
    Language["DZ"] = "dz";
    Language["EE"] = "ee";
    Language["EL"] = "el";
    Language["EN"] = "en";
    Language["EO"] = "eo";
    Language["ES"] = "es";
    Language["ET"] = "et";
    Language["EU"] = "eu";
    Language["FA"] = "fa";
    Language["FF"] = "ff";
    Language["FI"] = "fi";
    Language["FJ"] = "fj";
    Language["FO"] = "fo";
    Language["FR"] = "fr";
    Language["FY"] = "fy";
    Language["GA"] = "ga";
    Language["GD"] = "gd";
    Language["GL"] = "gl";
    Language["GN"] = "gn";
    Language["GU"] = "gu";
    Language["GV"] = "gv";
    Language["HA"] = "ha";
    Language["HE"] = "he";
    Language["HI"] = "hi";
    Language["HO"] = "ho";
    Language["HR"] = "hr";
    Language["HT"] = "ht";
    Language["HU"] = "hu";
    Language["HY"] = "hy";
    Language["HZ"] = "hz";
    Language["IA"] = "ia";
    Language["ID"] = "id";
    Language["IE"] = "ie";
    Language["IG"] = "ig";
    Language["II"] = "ii";
    Language["IK"] = "ik";
    Language["IO"] = "io";
    Language["IS"] = "is";
    Language["IT"] = "it";
    Language["IU"] = "iu";
    Language["JA"] = "ja";
    Language["JV"] = "jv";
    Language["KA"] = "ka";
    Language["KG"] = "kg";
    Language["KI"] = "ki";
    Language["KJ"] = "kj";
    Language["KK"] = "kk";
    Language["KL"] = "kl";
    Language["KM"] = "km";
    Language["KN"] = "kn";
    Language["KO"] = "ko";
    Language["KR"] = "kr";
    Language["KS"] = "ks";
    Language["KU"] = "ku";
    Language["KV"] = "kv";
    Language["KW"] = "kw";
    Language["KY"] = "ky";
    Language["LA"] = "la";
    Language["LB"] = "lb";
    Language["LG"] = "lg";
    Language["LI"] = "li";
    Language["LN"] = "ln";
    Language["LO"] = "lo";
    Language["LT"] = "lt";
    Language["LU"] = "lu";
    Language["LV"] = "lv";
    Language["MG"] = "mg";
    Language["MH"] = "mh";
    Language["MI"] = "mi";
    Language["MK"] = "mk";
    Language["ML"] = "ml";
    Language["MN"] = "mn";
    Language["MR"] = "mr";
    Language["MS"] = "ms";
    Language["MT"] = "mt";
    Language["MY"] = "my";
    Language["NA"] = "na";
    Language["NB"] = "nb";
    Language["ND"] = "nd";
    Language["NE"] = "ne";
    Language["NG"] = "ng";
    Language["NL"] = "nl";
    Language["NN"] = "nn";
    Language["NO"] = "no";
    Language["NR"] = "nr";
    Language["NV"] = "nv";
    Language["NY"] = "ny";
    Language["OC"] = "oc";
    Language["OJ"] = "oj";
    Language["OM"] = "om";
    Language["OR"] = "or";
    Language["OS"] = "os";
    Language["PA"] = "pa";
    Language["PI"] = "pi";
    Language["PL"] = "pl";
    Language["PS"] = "ps";
    Language["PT"] = "pt";
    Language["QU"] = "qu";
    Language["RM"] = "rm";
    Language["RN"] = "rn";
    Language["RO"] = "ro";
    Language["RU"] = "ru";
    Language["RW"] = "rw";
    Language["SA"] = "sa";
    Language["SC"] = "sc";
    Language["SD"] = "sd";
    Language["SE"] = "se";
    Language["SG"] = "sg";
    Language["SI"] = "si";
    Language["SK"] = "sk";
    Language["SL"] = "sl";
    Language["SM"] = "sm";
    Language["SN"] = "sn";
    Language["SO"] = "so";
    Language["SQ"] = "sq";
    Language["SR"] = "sr";
    Language["SS"] = "ss";
    Language["ST"] = "st";
    Language["SU"] = "su";
    Language["SV"] = "sv";
    Language["SW"] = "sw";
    Language["TA"] = "ta";
    Language["TE"] = "te";
    Language["TG"] = "tg";
    Language["TH"] = "th";
    Language["TI"] = "ti";
    Language["TK"] = "tk";
    Language["TL"] = "tl";
    Language["TN"] = "tn";
    Language["TO"] = "to";
    Language["TR"] = "tr";
    Language["TS"] = "ts";
    Language["TT"] = "tt";
    Language["TW"] = "tw";
    Language["TY"] = "ty";
    Language["UG"] = "ug";
    Language["UK"] = "uk";
    Language["UR"] = "ur";
    Language["UZ"] = "uz";
    Language["VE"] = "ve";
    Language["VI"] = "vi";
    Language["VO"] = "vo";
    Language["WA"] = "wa";
    Language["WO"] = "wo";
    Language["XH"] = "xh";
    Language["YI"] = "yi";
    Language["YO"] = "yo";
    Language["ZA"] = "za";
    Language["ZH"] = "zh";
    Language["ZU"] = "zu";
})(Language || (Language = {}));
// export const LanguageMap = {
//   aa: {
//     name: 'Afar',
//     nativeName: 'Afaraf',
//   },
//   ab: {
//     name: 'Abkhaz',
//     nativeName: 'аҧсуа бызшәа',
//   },
//   ae: {
//     name: 'Avestan',
//     nativeName: 'avesta',
//   },
//   af: {
//     name: 'Afrikaans',
//     nativeName: 'Afrikaans',
//   },
//   ak: {
//     name: 'Akan',
//     nativeName: 'Akan',
//   },
//   am: {
//     name: 'Amharic',
//     nativeName: 'አማርኛ',
//   },
//   an: {
//     name: 'Aragonese',
//     nativeName: 'aragonés',
//   },
//   ar: {
//     name: 'Arabic',
//     nativeName: 'اَلْعَرَبِيَّةُ',
//   },
//   as: {
//     name: 'Assamese',
//     nativeName: 'অসমীয়া',
//   },
//   av: {
//     name: 'Avaric',
//     nativeName: 'авар мацӀ',
//   },
//   ay: {
//     name: 'Aymara',
//     nativeName: 'aymar aru',
//   },
//   az: {
//     name: 'Azerbaijani',
//     nativeName: 'azərbaycan dili',
//   },
//   ba: {
//     name: 'Bashkir',
//     nativeName: 'башҡорт теле',
//   },
//   be: {
//     name: 'Belarusian',
//     nativeName: 'беларуская мова',
//   },
//   bg: {
//     name: 'Bulgarian',
//     nativeName: 'български език',
//   },
//   bi: {
//     name: 'Bislama',
//     nativeName: 'Bislama',
//   },
//   bm: {
//     name: 'Bambara',
//     nativeName: 'bamanankan',
//   },
//   bn: {
//     name: 'Bengali',
//     nativeName: 'বাংলা',
//   },
//   bo: {
//     name: 'Tibetan',
//     nativeName: 'བོད་ཡིག',
//   },
//   br: {
//     name: 'Breton',
//     nativeName: 'brezhoneg',
//   },
//   bs: {
//     name: 'Bosnian',
//     nativeName: 'bosanski jezik',
//   },
//   ca: {
//     name: 'Catalan',
//     nativeName: 'Català',
//   },
//   ce: {
//     name: 'Chechen',
//     nativeName: 'нохчийн мотт',
//   },
//   ch: {
//     name: 'Chamorro',
//     nativeName: 'Chamoru',
//   },
//   co: {
//     name: 'Corsican',
//     nativeName: 'corsu',
//   },
//   cr: {
//     name: 'Cree',
//     nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ',
//   },
//   cs: {
//     name: 'Czech',
//     nativeName: 'čeština',
//   },
//   cu: {
//     name: 'Old Church Slavonic',
//     nativeName: 'ѩзыкъ словѣньскъ',
//   },
//   cv: {
//     name: 'Chuvash',
//     nativeName: 'чӑваш чӗлхи',
//   },
//   cy: {
//     name: 'Welsh',
//     nativeName: 'Cymraeg',
//   },
//   da: {
//     name: 'Danish',
//     nativeName: 'dansk',
//   },
//   de: {
//     name: 'German',
//     nativeName: 'Deutsch',
//   },
//   dv: {
//     name: 'Divehi',
//     nativeName: 'ދިވެހި',
//   },
//   dz: {
//     name: 'Dzongkha',
//     nativeName: 'རྫོང་ཁ',
//   },
//   ee: {
//     name: 'Ewe',
//     nativeName: 'Eʋegbe',
//   },
//   el: {
//     name: 'Greek',
//     nativeName: 'Ελληνικά',
//   },
//   en: {
//     name: 'English',
//     nativeName: 'English',
//   },
//   eo: {
//     name: 'Esperanto',
//     nativeName: 'Esperanto',
//   },
//   es: {
//     name: 'Spanish',
//     nativeName: 'Español',
//   },
//   et: {
//     name: 'Estonian',
//     nativeName: 'eesti',
//   },
//   eu: {
//     name: 'Basque',
//     nativeName: 'euskara',
//   },
//   fa: {
//     name: 'Persian',
//     nativeName: 'فارسی',
//   },
//   ff: {
//     name: 'Fula',
//     nativeName: 'Fulfulde',
//   },
//   fi: {
//     name: 'Finnish',
//     nativeName: 'suomi',
//   },
//   fj: {
//     name: 'Fijian',
//     nativeName: 'vosa Vakaviti',
//   },
//   fo: {
//     name: 'Faroese',
//     nativeName: 'føroyskt',
//   },
//   fr: {
//     name: 'French',
//     nativeName: 'Français',
//   },
//   fy: {
//     name: 'Western Frisian',
//     nativeName: 'Frysk',
//   },
//   ga: {
//     name: 'Irish',
//     nativeName: 'Gaeilge',
//   },
//   gd: {
//     name: 'Scottish Gaelic',
//     nativeName: 'Gàidhlig',
//   },
//   gl: {
//     name: 'Galician',
//     nativeName: 'galego',
//   },
//   gn: {
//     name: 'Guaraní',
//     nativeName: "Avañe'ẽ",
//   },
//   gu: {
//     name: 'Gujarati',
//     nativeName: 'ગુજરાતી',
//   },
//   gv: {
//     name: 'Manx',
//     nativeName: 'Gaelg',
//   },
//   ha: {
//     name: 'Hausa',
//     nativeName: 'هَوُسَ',
//   },
//   he: {
//     name: 'Hebrew',
//     nativeName: 'עברית',
//   },
//   hi: {
//     name: 'Hindi',
//     nativeName: 'हिन्दी',
//   },
//   ho: {
//     name: 'Hiri Motu',
//     nativeName: 'Hiri Motu',
//   },
//   hr: {
//     name: 'Croatian',
//     nativeName: 'Hrvatski',
//   },
//   ht: {
//     name: 'Haitian',
//     nativeName: 'Kreyòl ayisyen',
//   },
//   hu: {
//     name: 'Hungarian',
//     nativeName: 'magyar',
//   },
//   hy: {
//     name: 'Armenian',
//     nativeName: 'Հայերեն',
//   },
//   hz: {
//     name: 'Herero',
//     nativeName: 'Otjiherero',
//   },
//   ia: {
//     name: 'Interlingua',
//     nativeName: 'Interlingua',
//   },
//   id: {
//     name: 'Indonesian',
//     nativeName: 'Bahasa Indonesia',
//   },
//   ie: {
//     name: 'Interlingue',
//     nativeName: 'Interlingue',
//   },
//   ig: {
//     name: 'Igbo',
//     nativeName: 'Asụsụ Igbo',
//   },
//   ii: {
//     name: 'Nuosu',
//     nativeName: 'ꆈꌠ꒿ Nuosuhxop',
//   },
//   ik: {
//     name: 'Inupiaq',
//     nativeName: 'Iñupiaq',
//   },
//   io: {
//     name: 'Ido',
//     nativeName: 'Ido',
//   },
//   is: {
//     name: 'Icelandic',
//     nativeName: 'Íslenska',
//   },
//   it: {
//     name: 'Italian',
//     nativeName: 'Italiano',
//   },
//   iu: {
//     name: 'Inuktitut',
//     nativeName: 'ᐃᓄᒃᑎᑐᑦ',
//   },
//   ja: {
//     name: 'Japanese',
//     nativeName: '日本語',
//   },
//   jv: {
//     name: 'Javanese',
//     nativeName: 'basa Jawa',
//   },
//   ka: {
//     name: 'Georgian',
//     nativeName: 'ქართული',
//   },
//   kg: {
//     name: 'Kongo',
//     nativeName: 'Kikongo',
//   },
//   ki: {
//     name: 'Kikuyu',
//     nativeName: 'Gĩkũyũ',
//   },
//   kj: {
//     name: 'Kwanyama',
//     nativeName: 'Kuanyama',
//   },
//   kk: {
//     name: 'Kazakh',
//     nativeName: 'қазақ тілі',
//   },
//   kl: {
//     name: 'Kalaallisut',
//     nativeName: 'kalaallisut',
//   },
//   km: {
//     name: 'Khmer',
//     nativeName: 'ខេមរភាសា',
//   },
//   kn: {
//     name: 'Kannada',
//     nativeName: 'ಕನ್ನಡ',
//   },
//   ko: {
//     name: 'Korean',
//     nativeName: '한국어',
//   },
//   kr: {
//     name: 'Kanuri',
//     nativeName: 'Kanuri',
//   },
//   ks: {
//     name: 'Kashmiri',
//     nativeName: 'कश्मीरी',
//   },
//   ku: {
//     name: 'Kurdish',
//     nativeName: 'Kurdî',
//   },
//   kv: {
//     name: 'Komi',
//     nativeName: 'коми кыв',
//   },
//   kw: {
//     name: 'Cornish',
//     nativeName: 'Kernewek',
//   },
//   ky: {
//     name: 'Kyrgyz',
//     nativeName: 'Кыргызча',
//   },
//   la: {
//     name: 'Latin',
//     nativeName: 'latine',
//   },
//   lb: {
//     name: 'Luxembourgish',
//     nativeName: 'Lëtzebuergesch',
//   },
//   lg: {
//     name: 'Ganda',
//     nativeName: 'Luganda',
//   },
//   li: {
//     name: 'Limburgish',
//     nativeName: 'Limburgs',
//   },
//   ln: {
//     name: 'Lingala',
//     nativeName: 'Lingála',
//   },
//   lo: {
//     name: 'Lao',
//     nativeName: 'ພາສາລາວ',
//   },
//   lt: {
//     name: 'Lithuanian',
//     nativeName: 'lietuvių kalba',
//   },
//   lu: {
//     name: 'Luba-Katanga',
//     nativeName: 'Kiluba',
//   },
//   lv: {
//     name: 'Latvian',
//     nativeName: 'latviešu valoda',
//   },
//   mg: {
//     name: 'Malagasy',
//     nativeName: 'fiteny malagasy',
//   },
//   mh: {
//     name: 'Marshallese',
//     nativeName: 'Kajin M̧ajeļ',
//   },
//   mi: {
//     name: 'Māori',
//     nativeName: 'te reo Māori',
//   },
//   mk: {
//     name: 'Macedonian',
//     nativeName: 'македонски јазик',
//   },
//   ml: {
//     name: 'Malayalam',
//     nativeName: 'മലയാളം',
//   },
//   mn: {
//     name: 'Mongolian',
//     nativeName: 'Монгол хэл',
//   },
//   mr: {
//     name: 'Marathi',
//     nativeName: 'मराठी',
//   },
//   ms: {
//     name: 'Malay',
//     nativeName: 'Bahasa Melayu',
//   },
//   mt: {
//     name: 'Maltese',
//     nativeName: 'Malti',
//   },
//   my: {
//     name: 'Burmese',
//     nativeName: 'ဗမာစာ',
//   },
//   na: {
//     name: 'Nauru',
//     nativeName: 'Dorerin Naoero',
//   },
//   nb: {
//     name: 'Norwegian Bokmål',
//     nativeName: 'Norsk bokmål',
//   },
//   nd: {
//     name: 'Northern Ndebele',
//     nativeName: 'isiNdebele',
//   },
//   ne: {
//     name: 'Nepali',
//     nativeName: 'नेपाली',
//   },
//   ng: {
//     name: 'Ndonga',
//     nativeName: 'Owambo',
//   },
//   nl: {
//     name: 'Dutch',
//     nativeName: 'Nederlands',
//   },
//   nn: {
//     name: 'Norwegian Nynorsk',
//     nativeName: 'Norsk nynorsk',
//   },
//   no: {
//     name: 'Norwegian',
//     nativeName: 'Norsk',
//   },
//   nr: {
//     name: 'Southern Ndebele',
//     nativeName: 'isiNdebele',
//   },
//   nv: {
//     name: 'Navajo',
//     nativeName: 'Diné bizaad',
//   },
//   ny: {
//     name: 'Chichewa',
//     nativeName: 'chiCheŵa',
//   },
//   oc: {
//     name: 'Occitan',
//     nativeName: 'occitan',
//   },
//   oj: {
//     name: 'Ojibwe',
//     nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
//   },
//   om: {
//     name: 'Oromo',
//     nativeName: 'Afaan Oromoo',
//   },
//   or: {
//     name: 'Oriya',
//     nativeName: 'ଓଡ଼ିଆ',
//   },
//   os: {
//     name: 'Ossetian',
//     nativeName: 'ирон æвзаг',
//   },
//   pa: {
//     name: 'Panjabi',
//     nativeName: 'ਪੰਜਾਬੀ',
//   },
//   pi: {
//     name: 'Pāli',
//     nativeName: 'पाऴि',
//   },
//   pl: {
//     name: 'Polish',
//     nativeName: 'Polski',
//   },
//   ps: {
//     name: 'Pashto',
//     nativeName: 'پښتو',
//   },
//   pt: {
//     name: 'Portuguese',
//     nativeName: 'Português',
//   },
//   qu: {
//     name: 'Quechua',
//     nativeName: 'Runa Simi',
//   },
//   rm: {
//     name: 'Romansh',
//     nativeName: 'rumantsch grischun',
//   },
//   rn: {
//     name: 'Kirundi',
//     nativeName: 'Ikirundi',
//   },
//   ro: {
//     name: 'Romanian',
//     nativeName: 'Română',
//   },
//   ru: {
//     name: 'Russian',
//     nativeName: 'Русский',
//   },
//   rw: {
//     name: 'Kinyarwanda',
//     nativeName: 'Ikinyarwanda',
//   },
//   sa: {
//     name: 'Sanskrit',
//     nativeName: 'संस्कृतम्',
//   },
//   sc: {
//     name: 'Sardinian',
//     nativeName: 'sardu',
//   },
//   sd: {
//     name: 'Sindhi',
//     nativeName: 'सिन्धी',
//   },
//   se: {
//     name: 'Northern Sami',
//     nativeName: 'Davvisámegiella',
//   },
//   sg: {
//     name: 'Sango',
//     nativeName: 'yângâ tî sängö',
//   },
//   si: {
//     name: 'Sinhala',
//     nativeName: 'සිංහල',
//   },
//   sk: {
//     name: 'Slovak',
//     nativeName: 'slovenčina',
//   },
//   sl: {
//     name: 'Slovenian',
//     nativeName: 'slovenščina',
//   },
//   sm: {
//     name: 'Samoan',
//     nativeName: "gagana fa'a Samoa",
//   },
//   sn: {
//     name: 'Shona',
//     nativeName: 'chiShona',
//   },
//   so: {
//     name: 'Somali',
//     nativeName: 'Soomaaliga',
//   },
//   sq: {
//     name: 'Albanian',
//     nativeName: 'Shqip',
//   },
//   sr: {
//     name: 'Serbian',
//     nativeName: 'српски језик',
//   },
//   ss: {
//     name: 'Swati',
//     nativeName: 'SiSwati',
//   },
//   st: {
//     name: 'Southern Sotho',
//     nativeName: 'Sesotho',
//   },
//   su: {
//     name: 'Sundanese',
//     nativeName: 'Basa Sunda',
//   },
//   sv: {
//     name: 'Swedish',
//     nativeName: 'Svenska',
//   },
//   sw: {
//     name: 'Swahili',
//     nativeName: 'Kiswahili',
//   },
//   ta: {
//     name: 'Tamil',
//     nativeName: 'தமிழ்',
//   },
//   te: {
//     name: 'Telugu',
//     nativeName: 'తెలుగు',
//   },
//   tg: {
//     name: 'Tajik',
//     nativeName: 'тоҷикӣ',
//   },
//   th: {
//     name: 'Thai',
//     nativeName: 'ไทย',
//   },
//   ti: {
//     name: 'Tigrinya',
//     nativeName: 'ትግርኛ',
//   },
//   tk: {
//     name: 'Turkmen',
//     nativeName: 'Türkmençe',
//   },
//   tl: {
//     name: 'Tagalog',
//     nativeName: 'Wikang Tagalog',
//   },
//   tn: {
//     name: 'Tswana',
//     nativeName: 'Setswana',
//   },
//   to: {
//     name: 'Tonga',
//     nativeName: 'faka Tonga',
//   },
//   tr: {
//     name: 'Turkish',
//     nativeName: 'Türkçe',
//   },
//   ts: {
//     name: 'Tsonga',
//     nativeName: 'Xitsonga',
//   },
//   tt: {
//     name: 'Tatar',
//     nativeName: 'татар теле',
//   },
//   tw: {
//     name: 'Twi',
//     nativeName: 'Twi',
//   },
//   ty: {
//     name: 'Tahitian',
//     nativeName: 'Reo Tahiti',
//   },
//   ug: {
//     name: 'Uyghur',
//     nativeName: 'ئۇيغۇرچە‎',
//   },
//   uk: {
//     name: 'Ukrainian',
//     nativeName: 'Українська',
//   },
//   ur: {
//     name: 'Urdu',
//     nativeName: 'اردو',
//   },
//   uz: {
//     name: 'Uzbek',
//     nativeName: 'Ўзбек',
//   },
//   ve: {
//     name: 'Venda',
//     nativeName: 'Tshivenḓa',
//   },
//   vi: {
//     name: 'Vietnamese',
//     nativeName: 'Tiếng Việt',
//   },
//   vo: {
//     name: 'Volapük',
//     nativeName: 'Volapük',
//   },
//   wa: {
//     name: 'Walloon',
//     nativeName: 'walon',
//   },
//   wo: {
//     name: 'Wolof',
//     nativeName: 'Wollof',
//   },
//   xh: {
//     name: 'Xhosa',
//     nativeName: 'isiXhosa',
//   },
//   yi: {
//     name: 'Yiddish',
//     nativeName: 'ייִדיש',
//   },
//   yo: {
//     name: 'Yoruba',
//     nativeName: 'Yorùbá',
//   },
//   za: {
//     name: 'Zhuang',
//     nativeName: 'Saɯ cueŋƅ',
//   },
//   zh: {
//     name: 'Chinese',
//     nativeName: '中文',
//   },
//   zu: {
//     name: 'Zulu',
//     nativeName: 'isiZulu',
//   },
// };

var BrainType;
(function (BrainType) {
    BrainType["NLP"] = "NLP";
    BrainType["LLM"] = "LLM";
})(BrainType || (BrainType = {}));
function isNLPBrain(brain) {
    return brain.type === BrainType.NLP;
}
function isLLMBrain(brain) {
    return brain.type === BrainType.LLM;
}
var NLPBrainActionType;
(function (NLPBrainActionType) {
    // DEFAULT = 'default',
    NLPBrainActionType["QUEST"] = "quest";
    NLPBrainActionType["BRAIN"] = "brain";
})(NLPBrainActionType || (NLPBrainActionType = {}));

var BrainResultEventType;
(function (BrainResultEventType) {
    BrainResultEventType["TRIGGERED"] = "TRIGGERED";
    BrainResultEventType["BRAIN_LOADED"] = "BRAIN_LOADED";
    BrainResultEventType["QUERIED_NLP"] = "QUERIED_NLP";
    BrainResultEventType["PROMPTED_LLM"] = "PROMPTED_LLM";
    BrainResultEventType["ERROR_LOOP"] = "ERROR_LOOP";
    BrainResultEventType["ERROR"] = "ERROR";
    BrainResultEventType["MISSING_GOTO"] = "MISSING_GOTO";
    BrainResultEventType["INTENT_TRIGGERED"] = "INTENT_TRIGGERED";
    BrainResultEventType["UNHANDLED_TRIGGERED"] = "UNHANDLED_TRIGGERED";
    BrainResultEventType["ENTITIES_SAVED"] = "ENTITIES_SAVED";
    BrainResultEventType["SENT_TO_BRAIN"] = "SENT_TO_BRAIN";
    BrainResultEventType["SENT_TO_QUEST"] = "SENT_TO_QUEST";
})(BrainResultEventType || (BrainResultEventType = {}));

var InheritedValuesType;
(function (InheritedValuesType) {
    InheritedValuesType["VARIABLE_IDS_AND_NAMES"] = "VARIABLE_IDS_AND_NAMES";
    InheritedValuesType["VARIABLE_VALUES"] = "VARIABLE_VALUES";
})(InheritedValuesType || (InheritedValuesType = {}));

var VarKey;
(function (VarKey) {
    VarKey["PERSON_NAME"] = "Entity personName";
    VarKey["EMAIL"] = "Entity email";
    VarKey["PHONENUMBER"] = "Entity phonenumber";
    VarKey["USER_ADDRESS_LINE_1"] = "UserAddressLine1";
    VarKey["USER_ADDRESS_LINE_2"] = "UserAddressLine2";
    VarKey["USER_CITY"] = "UserCity";
    VarKey["USER_STATE"] = "UserState";
    VarKey["USER_ZIP"] = "UserZip";
    VarKey["USER_LAST_INTENT"] = "UserLastIntent";
    VarKey["USER_COUNTRY_CODE"] = "UserCountryCode";
    VarKey["USER_HAS_COMPLETED_PROFILE"] = "UserHasCompletedProfile";
    VarKey["USER_HAS_CONFIRMED_PROFILE"] = "UserHasConfirmedProfile";
    VarKey["USER_HAS_SHORT_PROFILE"] = "User_HasShortProfile";
    VarKey["USER_ANSWERING_MACHINE"] = "UserAnsweringMachine";
    VarKey["USER_PERSONA"] = "UserPersona";
    VarKey["USER_HAS_UNHANDLED"] = "UserHasUnhandled";
    VarKey["USER_ACCOUNT_TYPE"] = "UserAccountType";
    VarKey["USER_CRM_ID"] = "UserCRMId";
    VarKey["USER_CRM_STATUS"] = "UserCRMStatus";
    VarKey["USER_LAST_AGENT_NAME"] = "UserLastAgentName";
    VarKey["USER_LEADHAS_SENT_EMAIL_RECEIPT"] = "UserLeadhasSentEmailReceipt";
    VarKey["USER_LEADHAS_SENT_TO_FMS"] = "UserLeadhasSentToFMS";
    VarKey["USER_REVIEW_NPS_SCORE"] = "UserReviewNPSScore";
    VarKey["USER_REVIEW_NPS_FEEDBACK"] = "UserReviewNPSFeedback";
    VarKey["USER_REVIEW_NPS_TOPIC"] = "UserReviewNPSTopic";
    VarKey["USER_TEMPORARY_FMSID"] = "UserTemporaryFMSID";
    VarKey["USER_REVIEW_FEEDBACK_PERSONA"] = "UserReviewFeedbackPersona";
    VarKey["USERHAS_SEEN_FEATURE_MENU"] = "UserhasSeenFeatureMenu";
    VarKey["USERHAS_SEEN_INVENTORY_MENU"] = "UserhasSeenInventoryMenu";
    VarKey["USERHAS_SEEN_ANYTHING_ELSE_MENU"] = "UserhasSeenAnythingElseMenu";
    VarKey["USERHAS_SEEN_COST_MENU"] = "UserhasSeenCostMenu";
    VarKey["USERHAS_SEEN_CONTACT_MENU"] = "UserhasSeenContactMenu";
    VarKey["USERHAS_SEEN_SIZE_MENU"] = "UserhasSeenSizeMenu";
    VarKey["USERHAS_SEEN_PROBLEM_MENU"] = "UserhasSeenProblemMenu";
    VarKey["USERHAS_SEEN_ACCOUNT_MENU"] = "UserhasSeenAccountMenu";
    VarKey["USERHAS_SEEN_CHANGE_ACCOUNT_MENU"] = "UserhasSeenChangeAccountMenu";
    VarKey["USERHAS_SEEN_ACCOUNT_LOGIN_MENU"] = "UserhasSeenAccountLoginMenu";
    VarKey["USERHAS_SEEN_PURCHASE_PROCESS_MENU"] = "UserhasSeenPurchaseProcessMenu";
    VarKey["USERHAS_SEEN_LEASE_TERMS_MENU"] = "UserhasSeenLeaseTermsMenu";
    VarKey["USERHAS_SEEN_MOVE_MENU"] = "UserhasSeenMoveMenu";
    VarKey["USERHAS_SEEN_GS_EXISTING_MENU"] = "UserhasSeenGSExistingMenu";
    VarKey["USERHAS_SEEN_GS_POTENTIAL_MENU"] = "UserhasSeenGSPotentialMenu";
    VarKey["USERHAS_SEEN_SMS_DISCLAIMER"] = "UserhasSeenSMSDisclaimer";
    VarKey["USER_CRON_RECEIPT_TYPE"] = "UserCronReceiptType";
    VarKey["USER_AFTER_NAVIGATE_HOLDER"] = "UserAfterNavigateHolder";
    VarKey["USER_PROFILE_COLLECT_HOLDER"] = "UserProfileCollectHolder";
    VarKey["USER_PREVIOUS_CHANNEL_HOLDER"] = "UserPreviousChannelHolder";
    VarKey["USER_WANT_TO_SEARCH_ANOTHER_STORE"] = "User_WantToSearchAnotherStore";
    VarKey["USER_HAS_PROVIDED_FEEDBACK"] = "User_hasProvidedFeedback";
    VarKey["USER_IS_UPDATING_PROFILE"] = "User_isUpdatingProfile";
    VarKey["USER_SELECTED_STORE_FROM_SMS"] = "User_selectedStoreFromSMS";
    VarKey["USER_TENANT_ID"] = "UserTenantId";
    VarKey["USER_FMS_ERROR"] = "UserFMSError";
    VarKey["USER_LEAD_STATUS"] = "UserLeadStatus";
    VarKey["USER_EMAIL_TYPE"] = "UserEmailType";
    VarKey["USER_EMAIL_RECEIPT_TYPE"] = "UserEmailReceiptType";
    VarKey["USER_ACCESS_CODE"] = "UserAccessCode";
    VarKey["USER_ACCOUNT_STATUS"] = "UserAccountStatus";
    VarKey["USER_ACCOUNT_PAYMENT_STATUS"] = "UserAccountPaymentStatus";
    VarKey["USER_PAYMENT_DUE_DATE"] = "UserPaymentDueDate";
    VarKey["USER_AUTO_PAY_ENABLED"] = "UserAutoPayEnabled";
    VarKey["USER_DAYS_PAST_DUE"] = "UserDaysPastDue";
    VarKey["USER_WANTS_TO_STORE_VEHICLE"] = "UserWantsToStoreVehicle";
    VarKey["USER_WANT_TO_SHOP_BY_PRICE"] = "UserWantToShopByPrice";
    VarKey["USER_FILTER_FEATURES"] = "UserFilterFeatures";
    VarKey["USER_FILTER_SIZE"] = "UserFilterSize";
    VarKey["USER_NOTES"] = "UserNotes";
    VarKey["USER_UNIT_NUMBER"] = "UserUnitNumber";
    VarKey["USER_UNIT_SIZE"] = "UserUnitSize";
    VarKey["USER_UNIT_FEATURES"] = "UserUnitFeatures";
    VarKey["USER_ACCOUNT_BALANCE"] = "User_AccountBalance";
    VarKey["USER_IN_ABANDONED_CART_WORKFLOW"] = "UserinAbandonedCartWorkflow";
    VarKey["USER_INTERRUPTED_PROFILE_COLLECT"] = "UserInterruptedProfileCollect";
    VarKey["USER_IS_MOBILE"] = "UserIsMobile";
    VarKey["USER_REFERRED_BY"] = "UserReferredBy";
    VarKey["USER_REFERRED_BY_NAME"] = "UserReferredByName";
    VarKey["User_Sentiment"] = "User_Sentiment";
    VarKey["User_SentimentScore"] = "User_SentimentScore";
    VarKey["STORE_LOCATION_NUMBER"] = "StoreLocationNumber";
    VarKey["STORE_ID"] = "StoreId";
    VarKey["STORE_FMS_INTEGRATION_ID"] = "StoreFMSIntegrationId";
    VarKey["STORE_FMS_TYPE"] = "StoreFMSType";
    VarKey["STORE_NAME"] = "StoreName";
    VarKey["STORE_ADDRESS_LINE_1"] = "StoreAddressLine1";
    VarKey["STORE_CITY"] = "StoreCity";
    VarKey["STORE_STATE"] = "StoreState";
    VarKey["STORE_POSTAL_CODE"] = "StorePostalCode";
    VarKey["STORE_PHONE_NUMBER"] = "StorePhoneNumber";
    VarKey["STORE_PAY_BY_PHONE_NUMBER"] = "StorePayByPhoneNumber";
    VarKey["STORE_AFTER_HOURS_PHONE_NUMBER"] = "StoreAfterHoursPhoneNumber";
    VarKey["STORE_EMAIL"] = "StoreEmail";
    VarKey["STORE_DM_NAME"] = "StoreDMName";
    VarKey["STORE_DM_EMAIL"] = "StoreDMEmail";
    VarKey["STORE_WEBSITE_URL"] = "StoreWebsiteUrl";
    VarKey["STORE_URL_LOOKUP_PATTERN"] = "StoreUrlLookupPattern";
    VarKey["STORE_PHOTO_URL"] = "StorePhotoURL";
    VarKey["STORE_WALLET_PASS_URL"] = "StoreWalletPassURL";
    VarKey["STORE_PAYMENT_URL"] = "StorePaymentURL";
    VarKey["STORE_MAP_URL"] = "StoreMapURL";
    VarKey["STORE_OFFICE_HOURS"] = "StoreOfficeHours";
    VarKey["STORE_ACCESS_HOURS"] = "StoreAccessHours";
    VarKey["STORE_CALL_CENTER_HOURS"] = "StoreCallCenterHours";
    VarKey["STORE_PAYMENT_OPTIONS"] = "StorePaymentOptions";
    VarKey["STORE_RV_STORAGE"] = "StoreRVStorage";
    VarKey["STORE_SMALL_VEHICLE_STORAGE"] = "StoreSmallVehicleStorage";
    VarKey["STORE_TRAILER_STORAGE"] = "StoreTrailerStorage";
    VarKey["STORE_DELIVERIES_ACCEPTED"] = "StoreDeliveriesAccepted";
    VarKey["STORE_VIDEO_SURVEILLANCE"] = "StoreVideoSurveillance";
    VarKey["STORE_SECURITY_AMENITIES"] = "StoreSecurityAmenities";
    VarKey["STORE_DRIVE_UP_UNITS"] = "StoreDriveUpUnits";
    VarKey["STORE_CLIMATE_CONTROLLED_UNITS"] = "StoreClimateControlledUnits";
    VarKey["STORE_HEATED_UNITS"] = "StoreHeatedUnits";
    VarKey["STORE_OFFICE_SPACE"] = "StoreOfficeSpace";
    VarKey["STORE_CONFERENCE_ROOM"] = "StoreConferenceRoom";
    VarKey["STORE_TRUCK_RENTALS"] = "StoreTruckRentals";
    VarKey["STORE_TWENTY_FOUR_HOUR_ACCESS"] = "StoreTwentyFourHourAccess";
    VarKey["STORE_LOCKERS_AVAILABLE"] = "StoreLockersAvailable";
    VarKey["STORE_LOCK_TYPES"] = "StoreLockTypes";
    VarKey["STORE_TRUCK_TYPES"] = "StoreTruckTypes";
    VarKey["STORE_PARKING_TYPE"] = "StoreParkingType";
    VarKey["STORE_LOADING_AREA_TYPE"] = "StoreLoadingAreaType";
    VarKey["STORE_LEAD_UNIT_ID"] = "StoreLeadUnitId";
    VarKey["STORE_APPOINTMENT_AVAILABLE"] = "StoreAppointmentAvailable";
    VarKey["STORE_GOOGLE_REVIEW_URL"] = "StoreGoogleReviewURL";
    VarKey["STORE_CLIMATE_CONTROL_DISPLAY_NAME"] = "StoreClimateControlDisplayName";
    VarKey["STORE_INSURANCE_DISPLAY_NAME"] = "StoreInsuranceDisplayName";
    VarKey["STORE_HAS_ELEVATOR"] = "StoreHasElevator";
    VarKey["STORE_HAS_WINE_STORAGE"] = "StoreHasWineStorage";
    VarKey["STORE_HAS_GUN_STORAGE"] = "StoreHasGunStorage";
    VarKey["STORE_GOOGLE_PLACE_ID"] = "StoreGooglePlaceId";
    VarKey["STORE_GOOGLE_ACCOUNT_AND_LOCATION_NAME"] = "StoreGoogleAccountAndLocationName";
    VarKey["STORE_HAS_BOAT_STORAGE"] = "StoreHasBoatStorage";
    VarKey["STORE_BRAND_ID"] = "StoreBrandId";
    VarKey["STORE_COUNTRY_CODE"] = "StoreCountryCode";
    VarKey["STORE_ONLY_SHOW_UNIT_DIMENSIONS"] = "StoreOnlyShowUnitDimensions";
    VarKey["STORE_SPOT_LOCATION_SLUG"] = "StoreSpotLocationSlug";
    VarKey["STORE_SPOT_LINK_SLUG"] = "StoreSpotLinkSlug";
    VarKey["SPACE_ID"] = "SpaceId";
    VarKey["SPACE_NAME"] = "SpaceName";
    VarKey["SPACE_DIMENSIONS"] = "SpaceDimensions";
    VarKey["SPACE_RATE"] = "SpaceRate";
    VarKey["SPACE_HAS_CLIMATE_CONTROL"] = "SpaceHasClimateControl";
    VarKey["SPACE_IS_INSIDE"] = "SpaceIsInside";
    VarKey["SPACE_IS_UPPER_STACK"] = "SpaceIsUpperStack";
    VarKey["SPACE_IS_LOWER_STACK"] = "SpaceIsLowerStack";
    VarKey["SPACE_HAS_POWER"] = "SpaceHasPower";
    VarKey["SPACE_FLOOR"] = "SpaceFloor";
    VarKey["SPACE_IS_PARKING"] = "SpaceIsParking";
    VarKey["SPACE_IS_DRIVE_UP"] = "SpaceIsDriveUp";
    VarKey["SPACE_HAS_ELEVATOR_ACCESS"] = "SpaceHasElevatorAccess";
    VarKey["SPACE_HAS_ALARM"] = "SpaceHasAlarm";
    VarKey["SPACE_FEATURES"] = "SpaceFeatures";
})(VarKey || (VarKey = {}));

var VariableType;
(function (VariableType) {
    VariableType["STRING"] = "STRING";
    VariableType["ARRAY"] = "ARRAY";
})(VariableType || (VariableType = {}));
var VariableScope;
(function (VariableScope) {
    VariableScope["BOT"] = "BOT";
    VariableScope["WORKSHEET"] = "WORKSHEET";
    VariableScope["USER"] = "USER";
    VariableScope["LOCATION"] = "LOCATION";
    VariableScope["SPACE"] = "SPACE";
    VariableScope["CUSTOM"] = "CUSTOM";
})(VariableScope || (VariableScope = {}));

var VariableDefenitions = [
    {
        id: 'Entity personName',
        varName: 'PERSON_NAME',
        name: 'User - Name',
        shortName: 'Name',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'Entity email',
        varName: 'EMAIL',
        name: 'User - Email',
        shortName: 'Email',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'Entity phonenumber',
        varName: 'PHONENUMBER',
        name: 'User - Phone Number',
        shortName: 'Phone Number',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserAddressLine1',
        varName: 'USER_ADDRESS_LINE_1',
        name: 'User - Address Line 1',
        shortName: 'Address Line 1',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserAddressLine2',
        varName: 'USER_ADDRESS_LINE_2',
        name: 'User - Address Line 2',
        shortName: 'Address Line 2',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserCity',
        varName: 'USER_CITY',
        name: 'User - City',
        shortName: 'City',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserState',
        varName: 'USER_STATE',
        name: 'User - State',
        shortName: 'State',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserZip',
        varName: 'USER_ZIP',
        name: 'User - Zip',
        shortName: 'Zip',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserLastIntent',
        varName: 'USER_LAST_INTENT',
        name: 'User - Last Intent',
        shortName: 'Last Intent',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserCountryCode',
        varName: 'USER_COUNTRY_CODE',
        name: 'User - Country Code',
        shortName: 'Country Code',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserHasCompletedProfile',
        varName: 'USER_HAS_COMPLETED_PROFILE',
        name: 'User - Has Completed Profile?',
        shortName: 'Has Completed Profile?',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserHasConfirmedProfile',
        varName: 'USER_HAS_CONFIRMED_PROFILE',
        name: 'User - Has Confirmed Profile?',
        shortName: 'Has Confirmed Profile',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'User_HasShortProfile',
        varName: 'USER_HAS_SHORT_PROFILE',
        name: 'User - Has Short Profile',
        shortName: 'Has Short Profile',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserAnsweringMachine',
        varName: 'USER_ANSWERING_MACHINE',
        name: 'User - Answering Machine',
        shortName: 'Answering Machine',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserPersona',
        varName: 'USER_PERSONA',
        name: 'User - Persona',
        shortName: 'Persona',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserHasUnhandled',
        varName: 'USER_HAS_UNHANDLED',
        name: 'User - Has Unhandled',
        shortName: 'Has Unhandled',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserAccountType',
        varName: 'USER_ACCOUNT_TYPE',
        name: 'User - Account Type',
        shortName: 'Account Type',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserCRMId',
        varName: 'USER_CRM_ID',
        name: 'User - CRM Id',
        shortName: 'CRM Id',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserCRMStatus',
        varName: 'USER_CRM_STATUS',
        name: 'User - CRM Status',
        shortName: 'CRM Status',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserLastAgentName',
        varName: 'USER_LAST_AGENT_NAME',
        name: 'User - Last Agent Name',
        shortName: 'Last Agent Name',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserLeadhasSentEmailReceipt',
        varName: 'USER_LEADHAS_SENT_EMAIL_RECEIPT',
        name: 'User - Lead Has Sent Email Receipt',
        shortName: 'Lead Has Sent Email Receipt',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserLeadhasSentToFMS',
        varName: 'USER_LEADHAS_SENT_TO_FMS',
        name: 'User - Lead Has Sent To FMS',
        shortName: 'Lead Has Sent To FMS',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserReviewNPSScore',
        varName: 'USER_REVIEW_NPS_SCORE',
        name: 'User - Review NPS Score',
        shortName: 'Review NPS Score',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserReviewNPSFeedback',
        varName: 'USER_REVIEW_NPS_FEEDBACK',
        name: 'User - Review NPS Feedback',
        shortName: 'Review NPS Feedback',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserReviewNPSTopic',
        varName: 'USER_REVIEW_NPS_TOPIC',
        name: 'User - Review NPS Topic',
        shortName: 'Review NPS Topic',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserTemporaryFMSID',
        varName: 'USER_TEMPORARY_FMSID',
        name: 'User - Temporary FMS ID',
        shortName: 'Temporary FMS ID',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserReviewFeedbackPersona',
        varName: 'USER_REVIEW_FEEDBACK_PERSONA',
        name: 'User - Review NPS Persona',
        shortName: 'Review NPS Persona',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenFeatureMenu',
        varName: 'USERHAS_SEEN_FEATURE_MENU',
        name: 'User - hasSeen Feature Menu',
        shortName: 'hasSeen Feature Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenInventoryMenu',
        varName: 'USERHAS_SEEN_INVENTORY_MENU',
        name: 'User - hasSeen Inventory Menu',
        shortName: 'hasSeen Inventory Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenAnythingElseMenu',
        varName: 'USERHAS_SEEN_ANYTHING_ELSE_MENU',
        name: 'User - hasSeen AnythingElse Menu',
        shortName: 'hasSeen AnythingElse Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenCostMenu',
        varName: 'USERHAS_SEEN_COST_MENU',
        name: 'User - hasSeen Cost Menu',
        shortName: 'hasSeen Cost Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenContactMenu',
        varName: 'USERHAS_SEEN_CONTACT_MENU',
        name: 'User - hasSeen Contact Menu',
        shortName: 'hasSeen Contact Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenSizeMenu',
        varName: 'USERHAS_SEEN_SIZE_MENU',
        name: 'User - hasSeen Size Menu',
        shortName: 'hasSeen Size Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenProblemMenu',
        varName: 'USERHAS_SEEN_PROBLEM_MENU',
        name: 'User - hasSeen Problem Menu',
        shortName: 'hasSeen Problem Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenAccountMenu',
        varName: 'USERHAS_SEEN_ACCOUNT_MENU',
        name: 'User - hasSeen Account Menu',
        shortName: 'hasSeen Account Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenChangeAccountMenu',
        varName: 'USERHAS_SEEN_CHANGE_ACCOUNT_MENU',
        name: 'User - hasSeen ChangeAccount Menu',
        shortName: 'hasSeen ChangeAccount Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenAccountLoginMenu',
        varName: 'USERHAS_SEEN_ACCOUNT_LOGIN_MENU',
        name: 'User - hasSeen AccountLogin Menu',
        shortName: 'hasSeen AccountLogin Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenPurchaseProcessMenu',
        varName: 'USERHAS_SEEN_PURCHASE_PROCESS_MENU',
        name: 'User - hasSeen PurchaseProcess Menu',
        shortName: 'hasSeen PurchaseProcess Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenLeaseTermsMenu',
        varName: 'USERHAS_SEEN_LEASE_TERMS_MENU',
        name: 'User - hasSeen LeaseTerms Menu',
        shortName: 'hasSeen LeaseTerms Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenMoveMenu',
        varName: 'USERHAS_SEEN_MOVE_MENU',
        name: 'User - hasSeen Move Menu',
        shortName: 'hasSeen Move Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenGSExistingMenu',
        varName: 'USERHAS_SEEN_GS_EXISTING_MENU',
        name: 'User - hasSeen GSExisting Menu',
        shortName: 'hasSeen GSExisting Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenGSPotentialMenu',
        varName: 'USERHAS_SEEN_GS_POTENTIAL_MENU',
        name: 'User - hasSeen GSPotential Menu',
        shortName: 'hasSeen GSPotential Menu',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserhasSeenSMSDisclaimer',
        varName: 'USERHAS_SEEN_SMS_DISCLAIMER',
        name: 'User - hasSeen SMS Disclaimer',
        shortName: 'hasSeen SMS Disclaimer',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserCronReceiptType',
        varName: 'USER_CRON_RECEIPT_TYPE',
        name: 'User - Cron Receipt Type',
        shortName: 'Cron Receipt Type',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserAfterNavigateHolder',
        varName: 'USER_AFTER_NAVIGATE_HOLDER',
        name: 'User - After Navigate Holder',
        shortName: 'After Navigate Holder',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserProfileCollectHolder',
        varName: 'USER_PROFILE_COLLECT_HOLDER',
        name: 'User - Profile Collect Holder',
        shortName: 'Profile Collect Holder',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserPreviousChannelHolder',
        varName: 'USER_PREVIOUS_CHANNEL_HOLDER',
        name: 'User - Previous Channel Holder',
        shortName: 'Previous Channel Holder',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'User_WantToSearchAnotherStore',
        varName: 'USER_WANT_TO_SEARCH_ANOTHER_STORE',
        name: 'User - Wants to Search Another Store',
        shortName: 'Wants to Search Another Store',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'User_hasProvidedFeedback',
        varName: 'USER_HAS_PROVIDED_FEEDBACK',
        name: 'User - Has Provided Feedback',
        shortName: 'Has Provided Feedback',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'User_isUpdatingProfile',
        varName: 'USER_IS_UPDATING_PROFILE',
        name: 'User - Is Updating Profile',
        shortName: 'Is Updating Profile',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'User_selectedStoreFromSMS',
        varName: 'USER_SELECTED_STORE_FROM_SMS',
        name: 'User - Selected Store From SMS',
        shortName: 'Selected Store From SMS',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserTenantId',
        varName: 'USER_TENANT_ID',
        name: 'User - Tenant Id',
        shortName: 'Tenant Id',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserFMSError',
        varName: 'USER_FMS_ERROR',
        name: 'User - FMS Error',
        shortName: 'FMS Error',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserLeadStatus',
        varName: 'USER_LEAD_STATUS',
        name: 'User - FMS Lead Status',
        shortName: 'FMS Lead Status',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserEmailType',
        varName: 'USER_EMAIL_TYPE',
        name: 'User - Email Type',
        shortName: 'Email Type',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserEmailReceiptType',
        varName: 'USER_EMAIL_RECEIPT_TYPE',
        name: 'User - Email Receipt Type',
        shortName: 'Email Receipt Type',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserAccessCode',
        varName: 'USER_ACCESS_CODE',
        name: 'User - Access Code',
        shortName: 'Access Code',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserAccountStatus',
        varName: 'USER_ACCOUNT_STATUS',
        name: 'User - Account Status',
        shortName: 'Account Status',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserAccountPaymentStatus',
        varName: 'USER_ACCOUNT_PAYMENT_STATUS',
        name: 'User - Account Payment Status',
        shortName: 'Account Payment Status',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserPaymentDueDate',
        varName: 'USER_PAYMENT_DUE_DATE',
        name: 'User - Payment Due Date',
        shortName: 'Payment Due Date',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserAutoPayEnabled',
        varName: 'USER_AUTO_PAY_ENABLED',
        name: 'User - Auto Pay Enabled',
        shortName: 'Auto Pay Enabled',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserDaysPastDue',
        varName: 'USER_DAYS_PAST_DUE',
        name: 'User - Days Past Due',
        shortName: 'Days Past Due',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserWantsToStoreVehicle',
        varName: 'USER_WANTS_TO_STORE_VEHICLE',
        name: 'User - Wants to Store Vehicle?',
        shortName: 'Wants to Store Vehicle?',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserWantToShopByPrice',
        varName: 'USER_WANT_TO_SHOP_BY_PRICE',
        name: 'User - Wants to Shop by Price?',
        shortName: 'Wants to Shop by Price?',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserFilterFeatures',
        varName: 'USER_FILTER_FEATURES',
        name: 'User - Filter Features',
        shortName: 'Filter Features',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserFilterSize',
        varName: 'USER_FILTER_SIZE',
        name: 'User - Filter Size',
        shortName: 'Filter Size',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserNotes',
        varName: 'USER_NOTES',
        name: 'User - Notes',
        shortName: 'Notes',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserUnitNumber',
        varName: 'USER_UNIT_NUMBER',
        name: 'User - Unit Number',
        shortName: 'Unit Number',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserUnitSize',
        varName: 'USER_UNIT_SIZE',
        name: 'User - Unit Size',
        shortName: 'Unit Size',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserUnitFeatures',
        varName: 'USER_UNIT_FEATURES',
        name: 'User - Unit Features',
        shortName: 'Unit Features',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'User_AccountBalance',
        varName: 'USER_ACCOUNT_BALANCE',
        name: 'User - Account Balance',
        shortName: 'Account Balance',
        description: '',
        scope: VariableScope.USER
    },
    {
        id: 'UserinAbandonedCartWorkflow',
        varName: 'USER_IN_ABANDONED_CART_WORKFLOW',
        name: 'User - In Abandoned Cart Workflow',
        shortName: 'In Abandoned Cart Workflow',
        description: 'The user is currently in the abandoned cart workflow.',
        scope: VariableScope.USER
    },
    {
        id: 'UserInterruptedProfileCollect',
        varName: 'USER_INTERRUPTED_PROFILE_COLLECT',
        name: 'User - Interrupted Profile Collect',
        shortName: 'Interrupted Profile Collect',
        description: 'The user sent a message while we were trying to collect their information.',
        scope: VariableScope.USER
    },
    {
        id: 'UserIsMobile',
        varName: 'USER_IS_MOBILE',
        name: 'User - Is Mobile',
        shortName: 'Is Mobile',
        description: 'The user is chating on a mobile device.',
        scope: VariableScope.USER
    },
    {
        id: 'UserReferredBy',
        varName: 'USER_REFERRED_BY',
        name: 'User - Referred by',
        shortName: 'Referred',
        description: 'The user ID of the referring tenant.',
        scope: VariableScope.USER
    },
    {
        id: 'UserReferredByName',
        varName: 'USER_REFERRED_BY_NAME',
        name: 'User - Referred by Name',
        shortName: 'Referred Name',
        description: 'The name of the referring tenant.',
        scope: VariableScope.USER
    },
    {
        id: UserVars.User_Sentiment,
        varName: UserVars.User_Sentiment,
        name: 'User - Sentiment',
        shortName: 'Sentiment',
        description: 'The sentiment of the score positive, negative etc.',
        scope: VariableScope.USER
    },
    {
        id: UserVars.User_SentimentScore,
        varName: UserVars.User_SentimentScore,
        name: 'User - Sentiment Score',
        shortName: 'Sentiment Score',
        description: 'The sentiment of the score  as a scalar.',
        scope: VariableScope.USER
    },
    {
        id: 'StoreLocationNumber',
        varName: 'STORE_LOCATION_NUMBER',
        name: 'Store - Location Number',
        shortName: 'Store - Location Number',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreId',
        varName: 'STORE_ID',
        name: 'Store - FMS Facility Id',
        shortName: 'Store - FMS Facility Id',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreFMSIntegrationId',
        varName: 'STORE_FMS_INTEGRATION_ID',
        name: 'Store - FMS Integration Id',
        shortName: 'Store - FMS Integration Id',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreFMSType',
        varName: 'STORE_FMS_TYPE',
        name: 'Store - FMS Type',
        shortName: 'Store - FMS Type',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreName',
        varName: 'STORE_NAME',
        name: 'Store - Name',
        shortName: 'Store - Name',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreAddressLine1',
        varName: 'STORE_ADDRESS_LINE_1',
        name: 'Store - Address Line 1',
        shortName: 'Store - Address Line 1',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreCity',
        varName: 'STORE_CITY',
        name: 'Store - City',
        shortName: 'Store - City',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreState',
        varName: 'STORE_STATE',
        name: 'Store - State',
        shortName: 'Store - State',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StorePostalCode',
        varName: 'STORE_POSTAL_CODE',
        name: 'Store - Postal Code',
        shortName: 'Store - Postal Code',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StorePhoneNumber',
        varName: 'STORE_PHONE_NUMBER',
        name: 'Store - Phone Number',
        shortName: 'Store - Phone Number',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StorePayByPhoneNumber',
        varName: 'STORE_PAY_BY_PHONE_NUMBER',
        name: 'Store - Pay by Phone Number',
        shortName: 'Store - Pay by Phone Number',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreAfterHoursPhoneNumber',
        varName: 'STORE_AFTER_HOURS_PHONE_NUMBER',
        name: 'Store - After Hours Phone Number',
        shortName: 'Store - After Hours Phone Number',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreEmail',
        varName: 'STORE_EMAIL',
        name: 'Store - Email',
        shortName: 'Store - Email',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreDMName',
        varName: 'STORE_DM_NAME',
        name: 'Store - DM Name',
        shortName: 'Store - DM Name',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreDMEmail',
        varName: 'STORE_DM_EMAIL',
        name: 'Store - DM Email',
        shortName: 'Store - DM Email',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreWebsiteUrl',
        varName: 'STORE_WEBSITE_URL',
        name: 'Store - Location URL',
        shortName: 'Store - Location URL',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreUrlLookupPattern',
        varName: 'STORE_URL_LOOKUP_PATTERN',
        name: 'Store - URL Lookup Pattern',
        shortName: 'Store - URL Lookup Pattern',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StorePhotoURL',
        varName: 'STORE_PHOTO_URL',
        name: 'Store - Photo URL',
        shortName: 'Store - Photo URL',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreWalletPassURL',
        varName: 'STORE_WALLET_PASS_URL',
        name: 'Store - Wallet URL',
        shortName: 'Store - Wallet URL',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StorePaymentURL',
        varName: 'STORE_PAYMENT_URL',
        name: 'Store - Payment URL',
        shortName: 'Store - Payment URL',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreMapURL',
        varName: 'STORE_MAP_URL',
        name: 'Store - Map URL',
        shortName: 'Store - Map URL',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreOfficeHours',
        varName: 'STORE_OFFICE_HOURS',
        name: 'Store - Office Hours',
        shortName: 'Store - Office Hours',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreAccessHours',
        varName: 'STORE_ACCESS_HOURS',
        name: 'Store - Access Hours',
        shortName: 'Store - Access Hours',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreCallCenterHours',
        varName: 'STORE_CALL_CENTER_HOURS',
        name: 'Store - Call Center Hours',
        shortName: 'Store - Call Center Hours',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StorePaymentOptions',
        varName: 'STORE_PAYMENT_OPTIONS',
        name: 'Store - Payment Options',
        shortName: 'Store - Payment Options',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreRVStorage',
        varName: 'STORE_RV_STORAGE',
        name: 'Store - RV Storage',
        shortName: 'Store - RV Storage',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreSmallVehicleStorage',
        varName: 'STORE_SMALL_VEHICLE_STORAGE',
        name: 'Store - Small Vehicle Storage',
        shortName: 'Store - Small Vehicle Storage',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreTrailerStorage',
        varName: 'STORE_TRAILER_STORAGE',
        name: 'Store - Trailer Storage',
        shortName: 'Store - Trailer Storage',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreDeliveriesAccepted',
        varName: 'STORE_DELIVERIES_ACCEPTED',
        name: 'Store - Deliveries Accepted',
        shortName: 'Store - Deliveries Accepted',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreVideoSurveillance',
        varName: 'STORE_VIDEO_SURVEILLANCE',
        name: 'Store - Video Surveillance',
        shortName: 'Store - Video Surveillance',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreSecurityAmenities',
        varName: 'STORE_SECURITY_AMENITIES',
        name: 'Store - Security Amenities',
        shortName: 'Store - Security Amenities',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreDriveUpUnits',
        varName: 'STORE_DRIVE_UP_UNITS',
        name: 'Store - Drive-Up Units',
        shortName: 'Store - Drive-Up Units',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreClimateControlledUnits',
        varName: 'STORE_CLIMATE_CONTROLLED_UNITS',
        name: 'Store - Climate Controlled Units',
        shortName: 'Store - Climate Controlled Units',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreHeatedUnits',
        varName: 'STORE_HEATED_UNITS',
        name: 'Store - Heated Units',
        shortName: 'Store - Heated Units',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreOfficeSpace',
        varName: 'STORE_OFFICE_SPACE',
        name: 'Store - Office Space',
        shortName: 'Store - Office Space',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreConferenceRoom',
        varName: 'STORE_CONFERENCE_ROOM',
        name: 'Store - Conference Room',
        shortName: 'Store - Conference Room',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreTruckRentals',
        varName: 'STORE_TRUCK_RENTALS',
        name: 'Store - Truck Rentals',
        shortName: 'Store - Truck Rentals',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreTwentyFourHourAccess',
        varName: 'STORE_TWENTY_FOUR_HOUR_ACCESS',
        name: 'Store - 24 Hour Access',
        shortName: 'Store - 24 Hour Access',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreLockersAvailable',
        varName: 'STORE_LOCKERS_AVAILABLE',
        name: 'Store - Lockers Available',
        shortName: 'Store - Lockers Available',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreLockTypes',
        varName: 'STORE_LOCK_TYPES',
        name: 'Store - Lock Type',
        shortName: 'Store - Lock Type',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreTruckTypes',
        varName: 'STORE_TRUCK_TYPES',
        name: 'Store - Truck Type',
        shortName: 'Store - Truck Type',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreParkingType',
        varName: 'STORE_PARKING_TYPE',
        name: 'Store - Parking Type',
        shortName: 'Store - Parking Type',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreLoadingAreaType',
        varName: 'STORE_LOADING_AREA_TYPE',
        name: 'Store - Loading Area Type',
        shortName: 'Store - Loading Area Type',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreLeadUnitId',
        varName: 'STORE_LEAD_UNIT_ID',
        name: 'Store - Lead Unit Id',
        shortName: 'Store - Lead Unit Id',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreAppointmentAvailable',
        varName: 'STORE_APPOINTMENT_AVAILABLE',
        name: 'Store - Appointment Available',
        shortName: 'Store - Appointment Available',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreGoogleReviewURL',
        varName: 'STORE_GOOGLE_REVIEW_URL',
        name: 'Store - Google Review URL',
        shortName: 'Store - Google Review URL',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreClimateControlDisplayName',
        varName: 'STORE_CLIMATE_CONTROL_DISPLAY_NAME',
        name: 'Store - Climate Control Display Name',
        shortName: 'Store - Climate Control Display Name',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreInsuranceDisplayName',
        varName: 'STORE_INSURANCE_DISPLAY_NAME',
        name: 'Store - Insurance Display Name ',
        shortName: 'Store - Insurance Display Name ',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreHasElevator',
        varName: 'STORE_HAS_ELEVATOR',
        name: 'Store - Has Elevator',
        shortName: 'Store - Has Elevator',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreHasWineStorage',
        varName: 'STORE_HAS_WINE_STORAGE',
        name: 'Store - Has Wine Storage',
        shortName: 'Store - Has Wine Storage',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreHasGunStorage',
        varName: 'STORE_HAS_GUN_STORAGE',
        name: 'Store - Has Gun Storage',
        shortName: 'Store - Has Gun Storage',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreGooglePlaceId',
        varName: 'STORE_GOOGLE_PLACE_ID',
        name: 'Store - Google Place Id',
        shortName: 'Store - Google Place Id',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreGoogleAccountAndLocationName',
        varName: 'STORE_GOOGLE_ACCOUNT_AND_LOCATION_NAME',
        name: 'Store - Google Account and Location Name',
        shortName: 'Store - Google Account and Location Name',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreHasBoatStorage',
        varName: 'STORE_HAS_BOAT_STORAGE',
        name: 'Store - Has Boat Storage',
        shortName: 'Store - Has Boat Storage',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreBrandId',
        varName: 'STORE_BRAND_ID',
        name: 'Store - Brand Id',
        shortName: 'Store - Brand Id',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreCountryCode',
        varName: 'STORE_COUNTRY_CODE',
        name: 'Store - Country Code',
        shortName: 'Store - Country Code',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreOnlyShowUnitDimensions',
        varName: 'STORE_ONLY_SHOW_UNIT_DIMENSIONS',
        name: 'Store - Only Show Unit Dimensions',
        shortName: 'Store - Only Show Unit Dimensions',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreSpotLocationSlug',
        varName: 'STORE_SPOT_LOCATION_SLUG',
        name: 'Store - Spot Location Slug',
        shortName: 'Store - Spot Location Slug',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'StoreSpotLinkSlug',
        varName: 'STORE_SPOT_LINK_SLUG',
        name: 'Store - Spot Link Slug',
        shortName: 'Store - Spot Link Slug',
        description: '',
        scope: VariableScope.LOCATION
    },
    {
        id: 'SpaceId',
        varName: 'SPACE_ID',
        name: 'Space - Id',
        shortName: 'Id',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceName',
        varName: 'SPACE_NAME',
        name: 'Space - Name',
        shortName: 'Name',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceDimensions',
        varName: 'SPACE_DIMENSIONS',
        name: 'Space - Dimensions',
        shortName: 'Dimensions',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceRate',
        varName: 'SPACE_RATE',
        name: 'Space - Rate',
        shortName: 'Rate',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceHasClimateControl',
        varName: 'SPACE_HAS_CLIMATE_CONTROL',
        name: 'Space - Climate Controlled',
        shortName: 'Climate Controlled',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceIsInside',
        varName: 'SPACE_IS_INSIDE',
        name: 'Space - Indoor',
        shortName: 'Indoor',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceIsUpperStack',
        varName: 'SPACE_IS_UPPER_STACK',
        name: 'Space - Upper Stack',
        shortName: 'Upper Stack',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceIsLowerStack',
        varName: 'SPACE_IS_LOWER_STACK',
        name: 'Space - Lower Stack',
        shortName: 'Lower Stack',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceHasPower',
        varName: 'SPACE_HAS_POWER',
        name: 'Space - Has Power',
        shortName: 'Has Power',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceFloor',
        varName: 'SPACE_FLOOR',
        name: 'Space - Floor #',
        shortName: 'Floor #',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceIsParking',
        varName: 'SPACE_IS_PARKING',
        name: 'Space - Is Parking',
        shortName: 'Is Parking',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceIsDriveUp',
        varName: 'SPACE_IS_DRIVE_UP',
        name: 'Space - Drive Up',
        shortName: 'Drive Up',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceHasElevatorAccess',
        varName: 'SPACE_HAS_ELEVATOR_ACCESS',
        name: 'Space - Has Elevator Access',
        shortName: 'Has Elevator Access',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceHasAlarm',
        varName: 'SPACE_HAS_ALARM',
        name: 'Space - Has Alarm',
        shortName: 'Has Alarm',
        description: '',
        scope: VariableScope.SPACE
    },
    {
        id: 'SpaceFeatures',
        varName: 'SPACE_FEATURES',
        name: 'Space - Features',
        shortName: 'Features',
        description: '',
        scope: VariableScope.SPACE
    }
];

export { RandomToken, ShortId, isAuth, isFrame, VariableDefenitions, ConvertMessageToGPTLine$$1 as ConvertMessageToGPTLine, ArrayHelper, EmbedConfigForBot, DefaultEmbedConfig, EmbedCSS, MessageType, isMessageInvisibile, isMessageType, SenderOrRecipientType, isSenderOrRecipientType, isSenderOrRecipient, ActionTakenType, isActionTakenType, isActionTaken, isMessage, isAuthPayload, ActionType, isActionType, isActionInterface, isActionTakenPayload, isButtonsPayload, isCreateUserAndStartConversationPayload, isStartConversationPayload, TakeoverEventType, isTakeoverEventPayload, isTextPayload, TypingPayloadActionType, isTypingPayload, isValidMessagePayload, isCarouselPayloadCard, isCarouselPayload, createCarouselPayloadCard, createCarouselMessage, MediaPayloadMediaType, isMediaPayload, createMediaMessage, CommandPayloadCommandType, isCommandPayload, createCommandMessage, isMultiSelectPayload, createMultiSelectMessage, ProfileCollectStatus, isProfileCollectPayload, createProfileCollectMessage, MilesToMeters, isLocationPickerPayload, createLocationPickerMessage, isSpacePickerPayload, createSpacePickerMessage, createVoiceMessage, createBaseMessage, createAuthMessage, createActionTaken, createActionTakenMessage, createButtonsMessage, createCreateUserAndStartConversationMessage, createStartConversationMessage, createTakeoverEventMessage, createTextMessage, createTypingMessage, ApiError, CreateSuccessMessage, PromptType, PromptStackItemType, ConversationQueryType, UserVars, StoreVars, DefaultBotVariables, StorageVars, SpaceVars, EscalationPlatform, EscalationStatus, EscalationErrorType, EscalationHistoryEvent, EscalationSlackMessageType, TrainingState, stringTokenizer, defaultTokenizer, UserTakeoverChannel, ServerEnvironment, ServerContext, DayOfWeek, HourOfDay, SMSGroupAnalyticsEventType, SMSGroupType, FMSType, SpaceType, SpaceFeature, SpaceTags, DefaultSpacePickerFeatureDisplayNames, SpaceInterfaceToSpaceVariables, SpaceVariablesToSpaceInterface, AccessCodeRequestResponseStatus, TenantAccountStatus, TenantAccountPaymentStatus, GetTenantResponseStatus, FMSCreateLeadStatus, TaskStatus, StoreFinderTableType, StoreFinderTableColumnType, LookupTableType, LookupTableColumnType, CRMLiteRowStatus, EmailTemplates, FMSTenantCrons, FMSCronNamesMap, CronEnvironment, FMSCronErrorScope, ReviewPlatform, ReviewReplyPlatform, ReviewHistoryEventType, SpotDataButtonStyle, CoreType, AllTables, NodeType, VoiceNodeCommandType, InheritanceStatus, UNASSIGNED_TO_JOURNEY_SLUG, QuestType, JourneyType, UnitStandard, CountryCode, CountryCodeMap, Language, BrainType, isNLPBrain, isLLMBrain, NLPBrainActionType, BrainResultEventType, InheritedValuesType, VarKey, VariableType, VariableScope };
//# sourceMappingURL=swivl-lib.js.map
